(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var sheet = require('@emotion/sheet');
var stylis = require('stylis');
var weakMemoize = require('@emotion/weak-memoize');
var memoize = require('@emotion/memoize');

function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }

var weakMemoize__default = /*#__PURE__*/_interopDefault(weakMemoize);
var memoize__default = /*#__PURE__*/_interopDefault(memoize);

var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = stylis.peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (stylis.token(character)) {
      break;
    }

    stylis.next();
  }

  return stylis.slice(begin, stylis.position);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (stylis.token(character)) {
      case 0:
        // &\f
        if (character === 38 && stylis.peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(stylis.position - 1, points, index);
        break;

      case 2:
        parsed[index] += stylis.delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = stylis.peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += stylis.from(character);
    }
  } while (character = stylis.next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return stylis.dealloc(toRules(stylis.alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule' || cache.compat) return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses) {
      var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
      //
      // considering this input:
      // .a {
      //   .b /* comm */ {}
      //   color: hotpink;
      // }
      // we get output corresponding to this:
      // .a {
      //   & {
      //     /* comm */
      //     color: hotpink;
      //   }
      //   .b {}
      // }

      var commentContainer = isNested ? element.parent.children : // global rule at the root level
      children;

      for (var i = commentContainer.length - 1; i >= 0; i--) {
        var node = commentContainer[i];

        if (node.line < element.line) {
          break;
        } // it is quite weird but comments are *usually* put at `column: element.column - 1`
        // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
        // this will also match inputs like this:
        // .a {
        //   /* comm */
        //   .b {}
        // }
        //
        // but that is fine
        //
        // it would be the easiest to change the placement of the comment to be the first child of the rule:
        // .a {
        //   .b { /* comm */ }
        // }
        // with such inputs we wouldn't have to search for the comment at all
        // TODO: consider changing this comment placement in the next major version


        if (node.column < element.column) {
          if (isIgnoringComment(node)) {
            return;
          }

          break;
        }
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

/* eslint-disable no-fallthrough */

function prefix(value, length) {
  switch (stylis.hash(value, length)) {
    // color-adjust
    case 5103:
      return stylis.WEBKIT + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return stylis.WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return stylis.WEBKIT + value + stylis.MOZ + value + stylis.MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return stylis.WEBKIT + value + stylis.MS + value + value;
    // order

    case 6165:
      return stylis.WEBKIT + value + stylis.MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return stylis.WEBKIT + value + stylis.replace(value, /(\w+).+(:[^]+)/, stylis.WEBKIT + 'box-$1$2' + stylis.MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return stylis.WEBKIT + value + stylis.MS + 'flex-item-' + stylis.replace(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return stylis.WEBKIT + value + stylis.MS + 'flex-line-pack' + stylis.replace(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return stylis.WEBKIT + value + stylis.MS + stylis.replace(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return stylis.WEBKIT + value + stylis.MS + stylis.replace(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return stylis.WEBKIT + 'box-' + stylis.replace(value, '-grow', '') + stylis.WEBKIT + value + stylis.MS + stylis.replace(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return stylis.WEBKIT + stylis.replace(value, /([^-])(transform)/g, '$1' + stylis.WEBKIT + '$2') + value;
    // cursor

    case 6187:
      return stylis.replace(stylis.replace(stylis.replace(value, /(zoom-|grab)/, stylis.WEBKIT + '$1'), /(image-set)/, stylis.WEBKIT + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return stylis.replace(value, /(image-set\([^]*)/, stylis.WEBKIT + '$1' + '$`$1');
    // justify-content

    case 4968:
      return stylis.replace(stylis.replace(value, /(.+:)(flex-)?(.*)/, stylis.WEBKIT + 'box-pack:$3' + stylis.MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + stylis.WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return stylis.replace(value, /(.+)-inline(.+)/, stylis.WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (stylis.strlen(value) - 1 - length > 6) switch (stylis.charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (stylis.charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return stylis.replace(value, /(.+:)(.+)-([^]+)/, '$1' + stylis.WEBKIT + '$2-$3' + '$1' + stylis.MOZ + (stylis.charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~stylis.indexof(value, 'stretch') ? prefix(stylis.replace(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (stylis.charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (stylis.charat(value, stylis.strlen(value) - 3 - (~stylis.indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return stylis.replace(value, ':', ':' + stylis.WEBKIT) + value;
        // (inline-)?fl(e)x

        case 101:
          return stylis.replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + stylis.WEBKIT + (stylis.charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + stylis.WEBKIT + '$2$3' + '$1' + stylis.MS + '$2box$3') + value;
      }

      break;
    // writing-mode

    case 5936:
      switch (stylis.charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return stylis.WEBKIT + value + stylis.MS + stylis.replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return stylis.WEBKIT + value + stylis.MS + stylis.replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return stylis.WEBKIT + value + stylis.MS + stylis.replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }

      return stylis.WEBKIT + value + stylis.MS + value + value;
  }

  return value;
}

var prefixer = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case stylis.DECLARATION:
      element["return"] = prefix(element.value, element.length);
      break;

    case stylis.KEYFRAMES:
      return stylis.serialize([stylis.copy(element, {
        value: stylis.replace(element.value, '@', '@' + stylis.WEBKIT)
      })], callback);

    case stylis.RULESET:
      if (element.length) return stylis.combine(element.props, function (value) {
        switch (stylis.match(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return stylis.serialize([stylis.copy(element, {
              props: [stylis.replace(value, /:(read-\w+)/, ':' + stylis.MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return stylis.serialize([stylis.copy(element, {
              props: [stylis.replace(value, /:(plac\w+)/, ':' + stylis.WEBKIT + 'input-$1')]
            }), stylis.copy(element, {
              props: [stylis.replace(value, /:(plac\w+)/, ':' + stylis.MOZ + '$1')]
            }), stylis.copy(element, {
              props: [stylis.replace(value, /:(plac\w+)/, stylis.MS + 'input-$1')]
            })], callback);
        }

        return '';
      });
  }
};

var isBrowser = typeof document !== 'undefined';
var getServerStylisCache = isBrowser ? undefined : weakMemoize__default["default"](function () {
  return memoize__default["default"](function () {
    var cache = {};
    return function (name) {
      return cache[name];
    };
  });
});
var defaultStylisPlugins = [prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if ("production" !== 'production' && !key) {
    throw new Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\n" + "If multiple caches share the same key they might \"fight\" for each other's style elements.");
  }

  if (isBrowser && key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  if ("production" !== 'production') {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var inserted = {};
  var container;
  var nodesToHydrate = [];

  if (isBrowser) {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if ("production" !== 'production') {
    omnipresentPlugins.push(createUnsafeSelectorsAlarm({
      get compat() {
        return cache.compat;
      }

    }), incorrectImportAlarm);
  }

  if (isBrowser) {
    var currentSheet;
    var finalizingPlugins = [stylis.stringify, "production" !== 'production' ? function (element) {
      if (!element.root) {
        if (element["return"]) {
          currentSheet.insert(element["return"]);
        } else if (element.value && element.type !== stylis.COMMENT) {
          // insert empty rule in non-production environments
          // so @emotion/jest can grab `key` from the (JS)DOM for caches without any rules inserted yet
          currentSheet.insert(element.value + "{}");
        }
      }
    } : stylis.rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = stylis.middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis$1 = function stylis$1(styles) {
      return stylis.serialize(stylis.compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if ("production" !== 'production' && serialized.map !== undefined) {
        currentSheet = {
          insert: function insert(rule) {
            sheet.insert(rule + serialized.map);
          }
        };
      }

      stylis$1(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  } else {
    var _finalizingPlugins = [stylis.stringify];

    var _serializer = stylis.middleware(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));

    var _stylis = function _stylis(styles) {
      return stylis.serialize(stylis.compile(styles), _serializer);
    }; // $FlowFixMe


    var serverStylisCache = getServerStylisCache(stylisPlugins)(key);

    var getRules = function getRules(selector, serialized) {
      var name = serialized.name;

      if (serverStylisCache[name] === undefined) {
        serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      }

      return serverStylisCache[name];
    };

    _insert = function _insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      var rules = getRules(selector, serialized);

      if (cache.compat === undefined) {
        // in regular mode, we don't set the styles on the inserted cache
        // since we don't need to and that would be wasting memory
        // we return them so that they are rendered in a style tag
        if (shouldCache) {
          cache.inserted[name] = true;
        }

        if ( // using === development instead of !== production
        // because if people do ssr in tests, the source maps showing up would be annoying
        "production" === 'development' && serialized.map !== undefined) {
          return rules + serialized.map;
        }

        return rules;
      } else {
        // in compat mode, we put the styles on the inserted cache so
        // that emotion-server can pull out the styles
        // except when we don't want to cache it which was in Global but now
        // is nowhere but we don't want to do a major right now
        // and just in case we're going to leave the case here
        // it's also not affecting client side bundle size
        // so it's really not a big deal
        if (shouldCache) {
          cache.inserted[name] = rules;
        } else {
          return rules;
        }
      }
    };
  }

  var cache = {
    key: key,
    sheet: new sheet.StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

exports["default"] = createCache;

},{"@emotion/memoize":13,"@emotion/sheet":19,"@emotion/weak-memoize":28,"stylis":31}],2:[function(require,module,exports){
'use strict';

if ("production" === "production") {
  module.exports = require("./emotion-cache.cjs.prod.js");
} else {
  module.exports = require("./emotion-cache.cjs.dev.js");
}

},{"./emotion-cache.cjs.dev.js":1,"./emotion-cache.cjs.prod.js":3}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var sheet = require('@emotion/sheet');
var stylis = require('stylis');
var weakMemoize = require('@emotion/weak-memoize');
var memoize = require('@emotion/memoize');

function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }

var weakMemoize__default = /*#__PURE__*/_interopDefault(weakMemoize);
var memoize__default = /*#__PURE__*/_interopDefault(memoize);

var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = stylis.peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (stylis.token(character)) {
      break;
    }

    stylis.next();
  }

  return stylis.slice(begin, stylis.position);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (stylis.token(character)) {
      case 0:
        // &\f
        if (character === 38 && stylis.peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(stylis.position - 1, points, index);
        break;

      case 2:
        parsed[index] += stylis.delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = stylis.peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += stylis.from(character);
    }
  } while (character = stylis.next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return stylis.dealloc(toRules(stylis.alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};

/* eslint-disable no-fallthrough */

function prefix(value, length) {
  switch (stylis.hash(value, length)) {
    // color-adjust
    case 5103:
      return stylis.WEBKIT + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return stylis.WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return stylis.WEBKIT + value + stylis.MOZ + value + stylis.MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return stylis.WEBKIT + value + stylis.MS + value + value;
    // order

    case 6165:
      return stylis.WEBKIT + value + stylis.MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return stylis.WEBKIT + value + stylis.replace(value, /(\w+).+(:[^]+)/, stylis.WEBKIT + 'box-$1$2' + stylis.MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return stylis.WEBKIT + value + stylis.MS + 'flex-item-' + stylis.replace(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return stylis.WEBKIT + value + stylis.MS + 'flex-line-pack' + stylis.replace(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return stylis.WEBKIT + value + stylis.MS + stylis.replace(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return stylis.WEBKIT + value + stylis.MS + stylis.replace(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return stylis.WEBKIT + 'box-' + stylis.replace(value, '-grow', '') + stylis.WEBKIT + value + stylis.MS + stylis.replace(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return stylis.WEBKIT + stylis.replace(value, /([^-])(transform)/g, '$1' + stylis.WEBKIT + '$2') + value;
    // cursor

    case 6187:
      return stylis.replace(stylis.replace(stylis.replace(value, /(zoom-|grab)/, stylis.WEBKIT + '$1'), /(image-set)/, stylis.WEBKIT + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return stylis.replace(value, /(image-set\([^]*)/, stylis.WEBKIT + '$1' + '$`$1');
    // justify-content

    case 4968:
      return stylis.replace(stylis.replace(value, /(.+:)(flex-)?(.*)/, stylis.WEBKIT + 'box-pack:$3' + stylis.MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + stylis.WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return stylis.replace(value, /(.+)-inline(.+)/, stylis.WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (stylis.strlen(value) - 1 - length > 6) switch (stylis.charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (stylis.charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return stylis.replace(value, /(.+:)(.+)-([^]+)/, '$1' + stylis.WEBKIT + '$2-$3' + '$1' + stylis.MOZ + (stylis.charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~stylis.indexof(value, 'stretch') ? prefix(stylis.replace(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (stylis.charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (stylis.charat(value, stylis.strlen(value) - 3 - (~stylis.indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return stylis.replace(value, ':', ':' + stylis.WEBKIT) + value;
        // (inline-)?fl(e)x

        case 101:
          return stylis.replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + stylis.WEBKIT + (stylis.charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + stylis.WEBKIT + '$2$3' + '$1' + stylis.MS + '$2box$3') + value;
      }

      break;
    // writing-mode

    case 5936:
      switch (stylis.charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return stylis.WEBKIT + value + stylis.MS + stylis.replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return stylis.WEBKIT + value + stylis.MS + stylis.replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return stylis.WEBKIT + value + stylis.MS + stylis.replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }

      return stylis.WEBKIT + value + stylis.MS + value + value;
  }

  return value;
}

var prefixer = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case stylis.DECLARATION:
      element["return"] = prefix(element.value, element.length);
      break;

    case stylis.KEYFRAMES:
      return stylis.serialize([stylis.copy(element, {
        value: stylis.replace(element.value, '@', '@' + stylis.WEBKIT)
      })], callback);

    case stylis.RULESET:
      if (element.length) return stylis.combine(element.props, function (value) {
        switch (stylis.match(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return stylis.serialize([stylis.copy(element, {
              props: [stylis.replace(value, /:(read-\w+)/, ':' + stylis.MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return stylis.serialize([stylis.copy(element, {
              props: [stylis.replace(value, /:(plac\w+)/, ':' + stylis.WEBKIT + 'input-$1')]
            }), stylis.copy(element, {
              props: [stylis.replace(value, /:(plac\w+)/, ':' + stylis.MOZ + '$1')]
            }), stylis.copy(element, {
              props: [stylis.replace(value, /:(plac\w+)/, stylis.MS + 'input-$1')]
            })], callback);
        }

        return '';
      });
  }
};

var isBrowser = typeof document !== 'undefined';
var getServerStylisCache = isBrowser ? undefined : weakMemoize__default["default"](function () {
  return memoize__default["default"](function () {
    var cache = {};
    return function (name) {
      return cache[name];
    };
  });
});
var defaultStylisPlugins = [prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if (isBrowser && key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  var inserted = {};
  var container;
  var nodesToHydrate = [];

  if (isBrowser) {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (isBrowser) {
    var currentSheet;
    var finalizingPlugins = [stylis.stringify, stylis.rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = stylis.middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis$1 = function stylis$1(styles) {
      return stylis.serialize(stylis.compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      stylis$1(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  } else {
    var _finalizingPlugins = [stylis.stringify];

    var _serializer = stylis.middleware(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));

    var _stylis = function _stylis(styles) {
      return stylis.serialize(stylis.compile(styles), _serializer);
    }; // $FlowFixMe


    var serverStylisCache = getServerStylisCache(stylisPlugins)(key);

    var getRules = function getRules(selector, serialized) {
      var name = serialized.name;

      if (serverStylisCache[name] === undefined) {
        serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      }

      return serverStylisCache[name];
    };

    _insert = function _insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      var rules = getRules(selector, serialized);

      if (cache.compat === undefined) {
        // in regular mode, we don't set the styles on the inserted cache
        // since we don't need to and that would be wasting memory
        // we return them so that they are rendered in a style tag
        if (shouldCache) {
          cache.inserted[name] = true;
        }

        return rules;
      } else {
        // in compat mode, we put the styles on the inserted cache so
        // that emotion-server can pull out the styles
        // except when we don't want to cache it which was in Global but now
        // is nowhere but we don't want to do a major right now
        // and just in case we're going to leave the case here
        // it's also not affecting client side bundle size
        // so it's really not a big deal
        if (shouldCache) {
          cache.inserted[name] = rules;
        } else {
          return rules;
        }
      }
    };
  }

  var cache = {
    key: key,
    sheet: new sheet.StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

exports["default"] = createCache;

},{"@emotion/memoize":13,"@emotion/sheet":19,"@emotion/weak-memoize":28,"stylis":31}],4:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var createCache = require('@emotion/cache');
var serialize = require('@emotion/serialize');
var utils = require('@emotion/utils');

function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }

var createCache__default = /*#__PURE__*/_interopDefault(createCache);

function insertWithoutScoping(cache, serialized) {
  if (cache.inserted[serialized.name] === undefined) {
    return cache.insert('', serialized, cache.sheet, true);
  }
}

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = utils.getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var createEmotion = function createEmotion(options) {
  var cache = createCache__default['default'](options); // $FlowFixMe

  cache.sheet.speedy = function (value) {
    if ("production" !== 'production' && this.ctr !== 0) {
      throw new Error('speedy must be changed before any rules are inserted');
    }

    this.isSpeedy = value;
  };

  cache.compat = true;

  var css = function css() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = serialize.serializeStyles(args, cache.registered, undefined);
    utils.insertStyles(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var keyframes = function keyframes() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var serialized = serialize.serializeStyles(args, cache.registered);
    var animation = "animation-" + serialized.name;
    insertWithoutScoping(cache, {
      name: serialized.name,
      styles: "@keyframes " + animation + "{" + serialized.styles + "}"
    });
    return animation;
  };

  var injectGlobal = function injectGlobal() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    var serialized = serialize.serializeStyles(args, cache.registered);
    insertWithoutScoping(cache, serialized);
  };

  var cx = function cx() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return merge(cache.registered, css, classnames(args));
  };

  return {
    css: css,
    cx: cx,
    injectGlobal: injectGlobal,
    keyframes: keyframes,
    hydrate: function hydrate(ids) {
      ids.forEach(function (key) {
        cache.inserted[key] = true;
      });
    },
    flush: function flush() {
      cache.registered = {};
      cache.inserted = {};
      cache.sheet.flush();
    },
    // $FlowFixMe
    sheet: cache.sheet,
    cache: cache,
    getRegisteredStyles: utils.getRegisteredStyles.bind(null, cache.registered),
    merge: merge.bind(null, cache.registered, css)
  };
};

var classnames = function classnames(args) {
  var cls = '';

  for (var i = 0; i < args.length; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

exports.default = createEmotion;

},{"@emotion/cache":2,"@emotion/serialize":16,"@emotion/utils":25}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var createCache = require("@emotion/cache"), serialize = require("@emotion/serialize"), utils = require("@emotion/utils");

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}

var createCache__default = _interopDefault(createCache);

function insertWithoutScoping(cache, serialized) {
  if (void 0 === cache.inserted[serialized.name]) return cache.insert("", serialized, cache.sheet, !0);
}

function merge(registered, css, className) {
  var registeredStyles = [], rawClassName = utils.getRegisteredStyles(registered, registeredStyles, className);
  return registeredStyles.length < 2 ? className : rawClassName + css(registeredStyles);
}

var createEmotion = function(options) {
  var cache = createCache__default.default(options);
  cache.sheet.speedy = function(value) {
    this.isSpeedy = value;
  }, cache.compat = !0;
  var css = function() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
    var serialized = serialize.serializeStyles(args, cache.registered, void 0);
    return utils.insertStyles(cache, serialized, !1), cache.key + "-" + serialized.name;
  };
  return {
    css: css,
    cx: function() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) args[_key4] = arguments[_key4];
      return merge(cache.registered, css, classnames(args));
    },
    injectGlobal: function() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) args[_key3] = arguments[_key3];
      var serialized = serialize.serializeStyles(args, cache.registered);
      insertWithoutScoping(cache, serialized);
    },
    keyframes: function() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) args[_key2] = arguments[_key2];
      var serialized = serialize.serializeStyles(args, cache.registered), animation = "animation-" + serialized.name;
      return insertWithoutScoping(cache, {
        name: serialized.name,
        styles: "@keyframes " + animation + "{" + serialized.styles + "}"
      }), animation;
    },
    hydrate: function(ids) {
      ids.forEach((function(key) {
        cache.inserted[key] = !0;
      }));
    },
    flush: function() {
      cache.registered = {}, cache.inserted = {}, cache.sheet.flush();
    },
    sheet: cache.sheet,
    cache: cache,
    getRegisteredStyles: utils.getRegisteredStyles.bind(null, cache.registered),
    merge: merge.bind(null, cache.registered, css)
  };
}, classnames = function classnames(args) {
  for (var cls = "", i = 0; i < args.length; i++) {
    var arg = args[i];
    if (null != arg) {
      var toAdd = void 0;
      switch (typeof arg) {
       case "boolean":
        break;

       case "object":
        if (Array.isArray(arg)) toAdd = classnames(arg); else for (var k in toAdd = "", 
        arg) arg[k] && k && (toAdd && (toAdd += " "), toAdd += k);
        break;

       default:
        toAdd = arg;
      }
      toAdd && (cls && (cls += " "), cls += toAdd);
    }
  }
  return cls;
};

exports.default = createEmotion;

},{"@emotion/cache":2,"@emotion/serialize":16,"@emotion/utils":25}],6:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('@emotion/cache');
require('@emotion/serialize');
require('@emotion/utils');
var createInstance_dist_emotionCssCreateInstance = require('../create-instance/dist/emotion-css-create-instance.cjs.dev.js');

var _createEmotion = createInstance_dist_emotionCssCreateInstance['default']({
  key: 'css'
}),
    flush = _createEmotion.flush,
    hydrate = _createEmotion.hydrate,
    cx = _createEmotion.cx,
    merge = _createEmotion.merge,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    css = _createEmotion.css,
    sheet = _createEmotion.sheet,
    cache = _createEmotion.cache;

exports.cache = cache;
exports.css = css;
exports.cx = cx;
exports.flush = flush;
exports.getRegisteredStyles = getRegisteredStyles;
exports.hydrate = hydrate;
exports.injectGlobal = injectGlobal;
exports.keyframes = keyframes;
exports.merge = merge;
exports.sheet = sheet;

},{"../create-instance/dist/emotion-css-create-instance.cjs.dev.js":4,"@emotion/cache":2,"@emotion/serialize":16,"@emotion/utils":25}],7:[function(require,module,exports){
'use strict';

if ("production" === "production") {
  module.exports = require("./emotion-css.cjs.prod.js");
} else {
  module.exports = require("./emotion-css.cjs.dev.js");
}

},{"./emotion-css.cjs.dev.js":6,"./emotion-css.cjs.prod.js":8}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), require("@emotion/cache"), require("@emotion/serialize"), require("@emotion/utils");

var createInstance_dist_emotionCssCreateInstance = require("../create-instance/dist/emotion-css-create-instance.cjs.prod.js"), _createEmotion = createInstance_dist_emotionCssCreateInstance.default({
  key: "css"
}), flush = _createEmotion.flush, hydrate = _createEmotion.hydrate, cx = _createEmotion.cx, merge = _createEmotion.merge, getRegisteredStyles = _createEmotion.getRegisteredStyles, injectGlobal = _createEmotion.injectGlobal, keyframes = _createEmotion.keyframes, css = _createEmotion.css, sheet = _createEmotion.sheet, cache = _createEmotion.cache;

exports.cache = cache, exports.css = css, exports.cx = cx, exports.flush = flush, 
exports.getRegisteredStyles = getRegisteredStyles, exports.hydrate = hydrate, exports.injectGlobal = injectGlobal, 
exports.keyframes = keyframes, exports.merge = merge, exports.sheet = sheet;

},{"../create-instance/dist/emotion-css-create-instance.cjs.prod.js":5,"@emotion/cache":2,"@emotion/serialize":16,"@emotion/utils":25}],9:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

exports["default"] = murmur2;

},{}],10:[function(require,module,exports){
'use strict';

if ("production" === "production") {
  module.exports = require("./emotion-hash.cjs.prod.js");
} else {
  module.exports = require("./emotion-hash.cjs.dev.js");
}

},{"./emotion-hash.cjs.dev.js":9,"./emotion-hash.cjs.prod.js":11}],11:[function(require,module,exports){
arguments[4][9][0].apply(exports,arguments)
},{"dup":9}],12:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

exports["default"] = memoize;

},{}],13:[function(require,module,exports){
'use strict';

if ("production" === "production") {
  module.exports = require("./emotion-memoize.cjs.prod.js");
} else {
  module.exports = require("./emotion-memoize.cjs.dev.js");
}

},{"./emotion-memoize.cjs.dev.js":12,"./emotion-memoize.cjs.prod.js":14}],14:[function(require,module,exports){
arguments[4][12][0].apply(exports,arguments)
},{"dup":12}],15:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var hashString = require('@emotion/hash');
var unitless = require('@emotion/unitless');
var memoize = require('@emotion/memoize');

function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }

var hashString__default = /*#__PURE__*/_interopDefault(hashString);
var unitless__default = /*#__PURE__*/_interopDefault(unitless);
var memoize__default = /*#__PURE__*/_interopDefault(memoize);

var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */memoize__default["default"](function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitless__default["default"][key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if ("production" !== 'production') {
  var contentValuePattern = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
  var contentValues = ['normal', 'none', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue(key, value);

    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

var noComponentSelectorMessage = 'Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.';

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if ("production" !== 'production' && interpolation.toString() === 'NO_COMPONENT_SELECTOR') {
      throw new Error(noComponentSelectorMessage);
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if ("production" !== 'production' && interpolation.map !== undefined) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if ("production" !== 'production') {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        break;
      }

    case 'string':
      if ("production" !== 'production') {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });

        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
          throw new Error(noComponentSelectorMessage);
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if ("production" !== 'production' && _key === 'undefined') {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if ("production" !== 'production') {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if ("production" !== 'production' && strings[0] === undefined) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if ("production" !== 'production' && strings[i] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  if ("production" !== 'production') {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = hashString__default["default"](styles) + identifierName;

  if ("production" !== 'production') {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};

exports.serializeStyles = serializeStyles;

},{"@emotion/hash":10,"@emotion/memoize":13,"@emotion/unitless":22}],16:[function(require,module,exports){
'use strict';

if ("production" === "production") {
  module.exports = require("./emotion-serialize.cjs.prod.js");
} else {
  module.exports = require("./emotion-serialize.cjs.dev.js");
}

},{"./emotion-serialize.cjs.dev.js":15,"./emotion-serialize.cjs.prod.js":17}],17:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var hashString = require('@emotion/hash');
var unitless = require('@emotion/unitless');
var memoize = require('@emotion/memoize');

function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }

var hashString__default = /*#__PURE__*/_interopDefault(hashString);
var unitless__default = /*#__PURE__*/_interopDefault(unitless);
var memoize__default = /*#__PURE__*/_interopDefault(memoize);

var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */memoize__default["default"](function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitless__default["default"][key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

var noComponentSelectorMessage = 'Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.';

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        }

        break;
      }
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' &&         "production" !== 'production') {
          throw new Error(noComponentSelectorMessage);
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {

      styles += strings[i];
    }
  }


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = hashString__default["default"](styles) + identifierName;

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};

exports.serializeStyles = serializeStyles;

},{"@emotion/hash":10,"@emotion/memoize":13,"@emotion/unitless":22}],18:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if ("production" !== 'production') {
      var isImportRule = rule.charCodeAt(0) === 64 && rule.charCodeAt(1) === 105;

      if (isImportRule && this._alreadyInsertedOrderInsensitiveRule) {
        // this would only cause problem in speedy mode
        // but we don't want enabling speedy to affect the observable behavior
        // so we report this error at all times
        console.error("You're attempting to insert the following rule:\n" + rule + '\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules.');
      }
      this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !isImportRule;
    }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if ("production" !== 'production' && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(rule)) {
          console.error("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    if ("production" !== 'production') {
      this._alreadyInsertedOrderInsensitiveRule = false;
    }
  };

  return StyleSheet;
}();

exports.StyleSheet = StyleSheet;

},{}],19:[function(require,module,exports){
'use strict';

if ("production" === "production") {
  module.exports = require("./emotion-sheet.cjs.prod.js");
} else {
  module.exports = require("./emotion-sheet.cjs.dev.js");
}

},{"./emotion-sheet.cjs.dev.js":18,"./emotion-sheet.cjs.prod.js":20}],20:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ?         "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();

exports.StyleSheet = StyleSheet;

},{}],21:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

exports["default"] = unitlessKeys;

},{}],22:[function(require,module,exports){
'use strict';

if ("production" === "production") {
  module.exports = require("./emotion-unitless.cjs.prod.js");
} else {
  module.exports = require("./emotion-unitless.cjs.dev.js");
}

},{"./emotion-unitless.cjs.dev.js":21,"./emotion-unitless.cjs.prod.js":23}],23:[function(require,module,exports){
arguments[4][21][0].apply(exports,arguments)
},{"dup":21}],24:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var isBrowser = typeof document !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var stylesForSSR = '';
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      if (!isBrowser && maybeStyles !== undefined) {
        stylesForSSR += maybeStyles;
      }

      current = current.next;
    } while (current !== undefined);

    if (!isBrowser && stylesForSSR.length !== 0) {
      return stylesForSSR;
    }
  }
};

exports.getRegisteredStyles = getRegisteredStyles;
exports.insertStyles = insertStyles;
exports.registerStyles = registerStyles;

},{}],25:[function(require,module,exports){
'use strict';

if ("production" === "production") {
  module.exports = require("./emotion-utils.cjs.prod.js");
} else {
  module.exports = require("./emotion-utils.cjs.dev.js");
}

},{"./emotion-utils.cjs.dev.js":24,"./emotion-utils.cjs.prod.js":26}],26:[function(require,module,exports){
arguments[4][24][0].apply(exports,arguments)
},{"dup":24}],27:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

exports["default"] = weakMemoize;

},{}],28:[function(require,module,exports){
'use strict';

if ("production" === "production") {
  module.exports = require("./emotion-weak-memoize.cjs.prod.js");
} else {
  module.exports = require("./emotion-weak-memoize.cjs.dev.js");
}

},{"./emotion-weak-memoize.cjs.dev.js":27,"./emotion-weak-memoize.cjs.prod.js":29}],29:[function(require,module,exports){
arguments[4][27][0].apply(exports,arguments)
},{"dup":27}],30:[function(require,module,exports){
/*!
 * jQuery JavaScript Library v2.1.4
 * http://jquery.com/
 *
 * Includes Sizzle.js
 * http://sizzlejs.com/
 *
 * Copyright 2005, 2014 jQuery Foundation, Inc. and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2015-04-28T16:01Z
 */

(function( global, factory ) {

	if ( typeof module === "object" && typeof module.exports === "object" ) {
		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Support: Firefox 18+
// Can't be in strict mode, several libs including ASP.NET trace
// the stack via arguments.caller.callee and Firefox dies if
// you try to trace through "use strict" call chains. (#13335)
//

var arr = [];

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var support = {};



var
	// Use the correct document accordingly with window argument (sandbox)
	document = window.document,

	version = "2.1.4",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {
		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android<4.1
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

	// Matches dashed string for camelizing
	rmsPrefix = /^-ms-/,
	rdashAlpha = /-([\da-z])/gi,

	// Used by jQuery.camelCase as callback to replace()
	fcamelCase = function( all, letter ) {
		return letter.toUpperCase();
	};

jQuery.fn = jQuery.prototype = {
	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// Start with an empty selector
	selector: "",

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {
		return num != null ?

			// Return just the one element from the set
			( num < 0 ? this[ num + this.length ] : this[ num ] ) :

			// Return all the elements in a clean array
			slice.call( this );
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;
		ret.context = this.context;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	// (You can seed the arguments with an array of args, but this is
	// only used internally.)
	each: function( callback, args ) {
		return jQuery.each( this, callback, args );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map(this, function( elem, i ) {
			return callback.call( elem, i, elem );
		}));
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[j] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor(null);
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[0] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !jQuery.isFunction(target) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {
		// Only deal with non-null/undefined values
		if ( (options = arguments[ i ]) != null ) {
			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject(copy) || (copyIsArray = jQuery.isArray(copy)) ) ) {
					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && jQuery.isArray(src) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject(src) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend({
	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isFunction: function( obj ) {
		return jQuery.type(obj) === "function";
	},

	isArray: Array.isArray,

	isWindow: function( obj ) {
		return obj != null && obj === obj.window;
	},

	isNumeric: function( obj ) {
		// parseFloat NaNs numeric-cast false positives (null|true|false|"")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		// adding 1 corrects loss of precision from parseFloat (#15100)
		return !jQuery.isArray( obj ) && (obj - parseFloat( obj ) + 1) >= 0;
	},

	isPlainObject: function( obj ) {
		// Not plain objects:
		// - Any object or value whose internal [[Class]] property is not "[object Object]"
		// - DOM nodes
		// - window
		if ( jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
			return false;
		}

		if ( obj.constructor &&
				!hasOwn.call( obj.constructor.prototype, "isPrototypeOf" ) ) {
			return false;
		}

		// If the function hasn't returned already, we're confident that
		// |obj| is a plain object, created by {} or constructed with new Object
		return true;
	},

	isEmptyObject: function( obj ) {
		var name;
		for ( name in obj ) {
			return false;
		}
		return true;
	},

	type: function( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
		// Support: Android<4.0, iOS<6 (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call(obj) ] || "object" :
			typeof obj;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		var script,
			indirect = eval;

		code = jQuery.trim( code );

		if ( code ) {
			// If the code includes a valid, prologue position
			// strict mode pragma, execute code by injecting a
			// script tag into the document.
			if ( code.indexOf("use strict") === 1 ) {
				script = document.createElement("script");
				script.text = code;
				document.head.appendChild( script ).parentNode.removeChild( script );
			} else {
			// Otherwise, avoid the DOM node creation, insertion
			// and removal by using an indirect global eval
				indirect( code );
			}
		}
	},

	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE9-11+
	// Microsoft forgot to hump their vendor prefix (#9572)
	camelCase: function( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	},

	nodeName: function( elem, name ) {
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	},

	// args is for internal usage only
	each: function( obj, callback, args ) {
		var value,
			i = 0,
			length = obj.length,
			isArray = isArraylike( obj );

		if ( args ) {
			if ( isArray ) {
				for ( ; i < length; i++ ) {
					value = callback.apply( obj[ i ], args );

					if ( value === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					value = callback.apply( obj[ i ], args );

					if ( value === false ) {
						break;
					}
				}
			}

		// A special, fast, case for the most common use of each
		} else {
			if ( isArray ) {
				for ( ; i < length; i++ ) {
					value = callback.call( obj[ i ], i, obj[ i ] );

					if ( value === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					value = callback.call( obj[ i ], i, obj[ i ] );

					if ( value === false ) {
						break;
					}
				}
			}
		}

		return obj;
	},

	// Support: Android<4.1
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArraylike( Object(arr) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var value,
			i = 0,
			length = elems.length,
			isArray = isArraylike( elems ),
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArray ) {
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// Bind a function to a context, optionally partially applying any
	// arguments.
	proxy: function( fn, context ) {
		var tmp, args, proxy;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !jQuery.isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	},

	now: Date.now,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
});

// Populate the class2type map
jQuery.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function(i, name) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
});

function isArraylike( obj ) {

	// Support: iOS 8.2 (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = "length" in obj && obj.length,
		type = jQuery.type( obj );

	if ( type === "function" || jQuery.isWindow( obj ) ) {
		return false;
	}

	if ( obj.nodeType === 1 && length ) {
		return true;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.2.0-pre
 * http://sizzlejs.com/
 *
 * Copyright 2008, 2014 jQuery Foundation, Inc. and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2014-12-16
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// General-purpose constants
	MAX_NEGATIVE = 1 << 31,

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// http://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// Whitespace characters http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",
	// http://www.w3.org/TR/css3-syntax/#characters
	characterEncoding = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",

	// Loosely modeled on CSS identifier characters
	// An unquoted value should be a CSS identifier http://www.w3.org/TR/css3-selectors/#attribute-selectors
	// Proper syntax: http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = characterEncoding.replace( "w", "w#" ),

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + characterEncoding + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + characterEncoding + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + characterEncoding + ")" ),
		"CLASS": new RegExp( "^\\.(" + characterEncoding + ")" ),
		"TAG": new RegExp( "^(" + characterEncoding.replace( "w", "w*" ) + ")" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,
	rescape = /'|\\/g,

	// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	};

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var match, elem, m, nodeType,
		// QSA vars
		i, groups, old, nid, newContext, newSelector;

	if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
		setDocument( context );
	}

	context = context || document;
	results = results || [];
	nodeType = context.nodeType;

	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	if ( !seed && documentIsHTML ) {

		// Try to shortcut find operations when possible (e.g., not under DocumentFragment)
		if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
			// Speed-up: Sizzle("#ID")
			if ( (m = match[1]) ) {
				if ( nodeType === 9 ) {
					elem = context.getElementById( m );
					// Check parentNode to catch when Blackberry 4.6 returns
					// nodes that are no longer in the document (jQuery #6963)
					if ( elem && elem.parentNode ) {
						// Handle the case where IE, Opera, and Webkit return items
						// by name instead of ID
						if ( elem.id === m ) {
							results.push( elem );
							return results;
						}
					} else {
						return results;
					}
				} else {
					// Context is not a document
					if ( context.ownerDocument && (elem = context.ownerDocument.getElementById( m )) &&
						contains( context, elem ) && elem.id === m ) {
						results.push( elem );
						return results;
					}
				}

			// Speed-up: Sizzle("TAG")
			} else if ( match[2] ) {
				push.apply( results, context.getElementsByTagName( selector ) );
				return results;

			// Speed-up: Sizzle(".CLASS")
			} else if ( (m = match[3]) && support.getElementsByClassName ) {
				push.apply( results, context.getElementsByClassName( m ) );
				return results;
			}
		}

		// QSA path
		if ( support.qsa && (!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
			nid = old = expando;
			newContext = context;
			newSelector = nodeType !== 1 && selector;

			// qSA works strangely on Element-rooted queries
			// We can work around this by specifying an extra ID on the root
			// and working up from there (Thanks to Andrew Dupont for the technique)
			// IE 8 doesn't work on object elements
			if ( nodeType === 1 && context.nodeName.toLowerCase() !== "object" ) {
				groups = tokenize( selector );

				if ( (old = context.getAttribute("id")) ) {
					nid = old.replace( rescape, "\\$&" );
				} else {
					context.setAttribute( "id", nid );
				}
				nid = "[id='" + nid + "'] ";

				i = groups.length;
				while ( i-- ) {
					groups[i] = nid + toSelector( groups[i] );
				}
				newContext = rsibling.test( selector ) && testContext( context.parentNode ) || context;
				newSelector = groups.join(",");
			}

			if ( newSelector ) {
				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch(qsaError) {
				} finally {
					if ( !old ) {
						context.removeAttribute("id");
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {Function(string, Object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created div and expects a boolean result
 */
function assert( fn ) {
	var div = document.createElement("div");

	try {
		return !!fn( div );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( div.parentNode ) {
			div.parentNode.removeChild( div );
		}
		// release memory in IE
		div = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = attrs.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			( ~b.sourceIndex || MAX_NEGATIVE ) -
			( ~a.sourceIndex || MAX_NEGATIVE );

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, parent,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// If no document and documentElement is available, return
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Set our document
	document = doc;
	docElem = doc.documentElement;
	parent = doc.defaultView;

	// Support: IE>8
	// If iframe document is assigned to "document" variable and if iframe has been reloaded,
	// IE will throw "permission denied" error when accessing "document" variable, see jQuery #13936
	// IE6-8 do not support the defaultView property so parent will be undefined
	if ( parent && parent !== parent.top ) {
		// IE11 does not have attachEvent, so all must suffer
		if ( parent.addEventListener ) {
			parent.addEventListener( "unload", unloadHandler, false );
		} else if ( parent.attachEvent ) {
			parent.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Support tests
	---------------------------------------------------------------------- */
	documentIsHTML = !isXML( doc );

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( div ) {
		div.className = "i";
		return !div.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( div ) {
		div.appendChild( doc.createComment("") );
		return !div.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( doc.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( div ) {
		docElem.appendChild( div ).id = expando;
		return !doc.getElementsByName || !doc.getElementsByName( expando ).length;
	});

	// ID find and filter
	if ( support.getById ) {
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var m = context.getElementById( id );
				// Check parentNode to catch when Blackberry 4.6 returns
				// nodes that are no longer in the document #6963
				return m && m.parentNode ? [ m ] : [];
			}
		};
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
	} else {
		// Support: IE6/7
		// getElementById is not reliable as a find shortcut
		delete Expr.find["ID"];

		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See http://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( doc.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( div ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// http://bugs.jquery.com/ticket/12359
			docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\f]' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( div.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !div.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.2+, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.7+
			if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !div.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibing-combinator selector` fails
			if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( div ) {
			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = doc.createElement("input");
			input.setAttribute( "type", "hidden" );
			div.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( div.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( !div.querySelectorAll(":enabled").length ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			div.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( div ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( div, "div" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( div, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully does not implement inclusive descendent
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === doc || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === doc || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === doc ? -1 :
				b === doc ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return doc;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, outerCache, node, diff, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) {
										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {
							// Seek `elem` from a previously-cached index
							outerCache = parent[ expando ] || (parent[ expando ] = {});
							cache = outerCache[ type ] || [];
							nodeIndex = cache[0] === dirruns && cache[1];
							diff = cache[0] === dirruns && cache[2];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									outerCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						// Use previously-cached element index if available
						} else if ( useCache && (cache = (elem[ expando ] || (elem[ expando ] = {}))[ type ]) && cache[0] === dirruns ) {
							diff = cache[1];

						// xml :nth-child(...) or :nth-last-child(...) or :nth(-last)?-of-type(...)
						} else {
							// Use the same loop as above to seek `elem` from the start
							while ( (node = ++nodeIndex && node && node[ dir ] ||
								(diff = nodeIndex = 0) || start.pop()) ) {

								if ( ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) && ++diff ) {
									// Cache the index of each encountered element
									if ( useCache ) {
										(node[ expando ] || (node[ expando ] = {}))[ type ] = [ dirruns, diff ];
									}

									if ( node === elem ) {
										break;
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": function( elem ) {
			return elem.disabled === false;
		},

		"disabled": function( elem ) {
			return elem.disabled === true;
		},

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		checkNonElements = base && dir === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from dir caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});
						if ( (oldCache = outerCache[ dir ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							outerCache[ dir ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context !== document && context;
			}

			// Add elements passing elementMatchers directly to results
			// Keep `i` a string if there are no elements so `matchedCount` will be "00" below
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context, xml ) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// Apply set filters to unmatched elements
			matchedCount += i;
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is no seed and only one group
	if ( match.length === 1 ) {

		// Take a shortcut and set the context if the root selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				support.getById && context.nodeType === 9 && documentIsHTML &&
				Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( div1 ) {
	// Should return 1, but returns 4 (following)
	return div1.compareDocumentPosition( document.createElement("div") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( div ) {
	div.innerHTML = "<a href='#'></a>";
	return div.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( div ) {
	div.innerHTML = "<input/>";
	div.firstChild.setAttribute( "value", "" );
	return div.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( div ) {
	return div.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;
jQuery.expr[":"] = jQuery.expr.pseudos;
jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;



var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = (/^<(\w+)\s*\/?>(?:<\/\1>|)$/);



var risSimple = /^.[^:#\[\.,]*$/;

// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( jQuery.isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			/* jshint -W018 */
			return !!qualifier.call( elem, i, elem ) !== not;
		});

	}

	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		});

	}

	if ( typeof qualifier === "string" ) {
		if ( risSimple.test( qualifier ) ) {
			return jQuery.filter( qualifier, elements, not );
		}

		qualifier = jQuery.filter( qualifier, elements );
	}

	return jQuery.grep( elements, function( elem ) {
		return ( indexOf.call( qualifier, elem ) >= 0 ) !== not;
	});
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	return elems.length === 1 && elem.nodeType === 1 ?
		jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
		jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		}));
};

jQuery.fn.extend({
	find: function( selector ) {
		var i,
			len = this.length,
			ret = [],
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter(function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			}) );
		}

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		// Needed because $( selector, context ) becomes $( context ).find( selector )
		ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
		ret.selector = this.selector ? this.selector + " " + selector : selector;
		return ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow(this, selector || [], false) );
	},
	not: function( selector ) {
		return this.pushStack( winnow(this, selector || [], true) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
});


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,

	init = jQuery.fn.init = function( selector, context ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[0] === "<" && selector[ selector.length - 1 ] === ">" && selector.length >= 3 ) {
				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && (match[1] || !context) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[1] ) {
					context = context instanceof jQuery ? context[0] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[1],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[1] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {
							// Properties of context are called as methods if possible
							if ( jQuery.isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[2] );

					// Support: Blackberry 4.6
					// gEBID returns nodes no longer in the document (#6963)
					if ( elem && elem.parentNode ) {
						// Inject the element directly into the jQuery object
						this.length = 1;
						this[0] = elem;
					}

					this.context = document;
					this.selector = selector;
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || rootjQuery ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this.context = this[0] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( jQuery.isFunction( selector ) ) {
			return typeof rootjQuery.ready !== "undefined" ?
				rootjQuery.ready( selector ) :
				// Execute immediately if ready is not present
				selector( jQuery );
		}

		if ( selector.selector !== undefined ) {
			this.selector = selector.selector;
			this.context = selector.context;
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.extend({
	dir: function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;

		while ( (elem = elem[ dir ]) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	},

	sibling: function( n, elem ) {
		var matched = [];

		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}

		return matched;
	}
});

jQuery.fn.extend({
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter(function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[i] ) ) {
					return true;
				}
			}
		});
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
				jQuery( selectors, context || this.context ) :
				0;

		for ( ; i < l; i++ ) {
			for ( cur = this[i]; cur && cur !== context; cur = cur.parentNode ) {
				// Always skip document fragments
				if ( cur.nodeType < 11 && (pos ?
					pos.index(cur) > -1 :

					// Don't pass non-elements to Sizzle
					cur.nodeType === 1 &&
						jQuery.find.matchesSelector(cur, selectors)) ) {

					matched.push( cur );
					break;
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.unique( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.unique(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter(selector)
		);
	}
});

function sibling( cur, dir ) {
	while ( (cur = cur[dir]) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each({
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return jQuery.dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return jQuery.dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return jQuery.dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return jQuery.dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return jQuery.dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return jQuery.dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return jQuery.sibling( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return jQuery.sibling( elem.firstChild );
	},
	contents: function( elem ) {
		return elem.contentDocument || jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {
			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.unique( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
});
var rnotwhite = (/\S+/g);



// String to Object options format cache
var optionsCache = {};

// Convert String-formatted options into Object-formatted ones and store in cache
function createOptions( options ) {
	var object = optionsCache[ options ] = {};
	jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	});
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		( optionsCache[ options ] || createOptions( options ) ) :
		jQuery.extend( {}, options );

	var // Last fire value (for non-forgettable lists)
		memory,
		// Flag to know if list was already fired
		fired,
		// Flag to know if list is currently firing
		firing,
		// First callback to fire (used internally by add and fireWith)
		firingStart,
		// End of the loop when firing
		firingLength,
		// Index of currently firing callback (modified by remove if needed)
		firingIndex,
		// Actual callback list
		list = [],
		// Stack of fire calls for repeatable lists
		stack = !options.once && [],
		// Fire callbacks
		fire = function( data ) {
			memory = options.memory && data;
			fired = true;
			firingIndex = firingStart || 0;
			firingStart = 0;
			firingLength = list.length;
			firing = true;
			for ( ; list && firingIndex < firingLength; firingIndex++ ) {
				if ( list[ firingIndex ].apply( data[ 0 ], data[ 1 ] ) === false && options.stopOnFalse ) {
					memory = false; // To prevent further calls using add
					break;
				}
			}
			firing = false;
			if ( list ) {
				if ( stack ) {
					if ( stack.length ) {
						fire( stack.shift() );
					}
				} else if ( memory ) {
					list = [];
				} else {
					self.disable();
				}
			}
		},
		// Actual Callbacks object
		self = {
			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {
					// First, we save the current length
					var start = list.length;
					(function add( args ) {
						jQuery.each( args, function( _, arg ) {
							var type = jQuery.type( arg );
							if ( type === "function" ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && type !== "string" ) {
								// Inspect recursively
								add( arg );
							}
						});
					})( arguments );
					// Do we need to add the callbacks to the
					// current firing batch?
					if ( firing ) {
						firingLength = list.length;
					// With memory, if we're not firing then
					// we should call right away
					} else if ( memory ) {
						firingStart = start;
						fire( memory );
					}
				}
				return this;
			},
			// Remove a callback from the list
			remove: function() {
				if ( list ) {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
							// Handle firing indexes
							if ( firing ) {
								if ( index <= firingLength ) {
									firingLength--;
								}
								if ( index <= firingIndex ) {
									firingIndex--;
								}
							}
						}
					});
				}
				return this;
			},
			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ? jQuery.inArray( fn, list ) > -1 : !!( list && list.length );
			},
			// Remove all callbacks from the list
			empty: function() {
				list = [];
				firingLength = 0;
				return this;
			},
			// Have the list do nothing anymore
			disable: function() {
				list = stack = memory = undefined;
				return this;
			},
			// Is it disabled?
			disabled: function() {
				return !list;
			},
			// Lock the list in its current state
			lock: function() {
				stack = undefined;
				if ( !memory ) {
					self.disable();
				}
				return this;
			},
			// Is it locked?
			locked: function() {
				return !stack;
			},
			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( list && ( !fired || stack ) ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					if ( firing ) {
						stack.push( args );
					} else {
						fire( args );
					}
				}
				return this;
			},
			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},
			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


jQuery.extend({

	Deferred: function( func ) {
		var tuples = [
				// action, add listener, listener list, final state
				[ "resolve", "done", jQuery.Callbacks("once memory"), "resolved" ],
				[ "reject", "fail", jQuery.Callbacks("once memory"), "rejected" ],
				[ "notify", "progress", jQuery.Callbacks("memory") ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				then: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;
					return jQuery.Deferred(function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {
							var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];
							// deferred[ done | fail | progress ] for forwarding actions to newDefer
							deferred[ tuple[1] ](function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && jQuery.isFunction( returned.promise ) ) {
									returned.promise()
										.done( newDefer.resolve )
										.fail( newDefer.reject )
										.progress( newDefer.notify );
								} else {
									newDefer[ tuple[ 0 ] + "With" ]( this === promise ? newDefer.promise() : this, fn ? [ returned ] : arguments );
								}
							});
						});
						fns = null;
					}).promise();
				},
				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Keep pipe for back-compat
		promise.pipe = promise.then;

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 3 ];

			// promise[ done | fail | progress ] = list.add
			promise[ tuple[1] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(function() {
					// state = [ resolved | rejected ]
					state = stateString;

				// [ reject_list | resolve_list ].disable; progress_list.lock
				}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
			}

			// deferred[ resolve | reject | notify ]
			deferred[ tuple[0] ] = function() {
				deferred[ tuple[0] + "With" ]( this === deferred ? promise : this, arguments );
				return this;
			};
			deferred[ tuple[0] + "With" ] = list.fireWith;
		});

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( subordinate /* , ..., subordinateN */ ) {
		var i = 0,
			resolveValues = slice.call( arguments ),
			length = resolveValues.length,

			// the count of uncompleted subordinates
			remaining = length !== 1 || ( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,

			// the master Deferred. If resolveValues consist of only a single Deferred, just use that.
			deferred = remaining === 1 ? subordinate : jQuery.Deferred(),

			// Update function for both resolve and progress values
			updateFunc = function( i, contexts, values ) {
				return function( value ) {
					contexts[ i ] = this;
					values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( values === progressValues ) {
						deferred.notifyWith( contexts, values );
					} else if ( !( --remaining ) ) {
						deferred.resolveWith( contexts, values );
					}
				};
			},

			progressValues, progressContexts, resolveContexts;

		// Add listeners to Deferred subordinates; treat others as resolved
		if ( length > 1 ) {
			progressValues = new Array( length );
			progressContexts = new Array( length );
			resolveContexts = new Array( length );
			for ( ; i < length; i++ ) {
				if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
					resolveValues[ i ].promise()
						.done( updateFunc( i, resolveContexts, resolveValues ) )
						.fail( deferred.reject )
						.progress( updateFunc( i, progressContexts, progressValues ) );
				} else {
					--remaining;
				}
			}
		}

		// If we're not waiting on anything, resolve the master
		if ( !remaining ) {
			deferred.resolveWith( resolveContexts, resolveValues );
		}

		return deferred.promise();
	}
});


// The deferred used on DOM ready
var readyList;

jQuery.fn.ready = function( fn ) {
	// Add the callback
	jQuery.ready.promise().done( fn );

	return this;
};

jQuery.extend({
	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Hold (or release) the ready event
	holdReady: function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	},

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );

		// Trigger any bound ready events
		if ( jQuery.fn.triggerHandler ) {
			jQuery( document ).triggerHandler( "ready" );
			jQuery( document ).off( "ready" );
		}
	}
});

/**
 * The ready event handler and self cleanup method
 */
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed, false );
	window.removeEventListener( "load", completed, false );
	jQuery.ready();
}

jQuery.ready.promise = function( obj ) {
	if ( !readyList ) {

		readyList = jQuery.Deferred();

		// Catch cases where $(document).ready() is called after the browser event has already occurred.
		// We once tried to use readyState "interactive" here, but it caused issues like the one
		// discovered by ChrisS here: http://bugs.jquery.com/ticket/12282#comment:15
		if ( document.readyState === "complete" ) {
			// Handle it asynchronously to allow scripts the opportunity to delay ready
			setTimeout( jQuery.ready );

		} else {

			// Use the handy event callback
			document.addEventListener( "DOMContentLoaded", completed, false );

			// A fallback to window.onload, that will always work
			window.addEventListener( "load", completed, false );
		}
	}
	return readyList.promise( obj );
};

// Kick off the DOM ready check even if the user does not
jQuery.ready.promise();




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = jQuery.access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( jQuery.type( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			jQuery.access( elems, fn, i, key[i], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !jQuery.isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {
			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn( elems[i], key, raw ? value : value.call( elems[i], i, fn( elems[i], key ) ) );
			}
		}
	}

	return chainable ?
		elems :

		// Gets
		bulk ?
			fn.call( elems ) :
			len ? fn( elems[0], key ) : emptyGet;
};


/**
 * Determines whether an object can have data
 */
jQuery.acceptData = function( owner ) {
	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	/* jshint -W018 */
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};


function Data() {
	// Support: Android<4,
	// Old WebKit does not have Object.preventExtensions/freeze method,
	// return new empty object instead with no [[set]] accessor
	Object.defineProperty( this.cache = {}, 0, {
		get: function() {
			return {};
		}
	});

	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;
Data.accepts = jQuery.acceptData;

Data.prototype = {
	key: function( owner ) {
		// We can accept data for non-element nodes in modern browsers,
		// but we should not, see #8335.
		// Always return the key for a frozen object.
		if ( !Data.accepts( owner ) ) {
			return 0;
		}

		var descriptor = {},
			// Check if the owner object already has a cache key
			unlock = owner[ this.expando ];

		// If not, create one
		if ( !unlock ) {
			unlock = Data.uid++;

			// Secure it in a non-enumerable, non-writable property
			try {
				descriptor[ this.expando ] = { value: unlock };
				Object.defineProperties( owner, descriptor );

			// Support: Android<4
			// Fallback to a less secure definition
			} catch ( e ) {
				descriptor[ this.expando ] = unlock;
				jQuery.extend( owner, descriptor );
			}
		}

		// Ensure the cache object
		if ( !this.cache[ unlock ] ) {
			this.cache[ unlock ] = {};
		}

		return unlock;
	},
	set: function( owner, data, value ) {
		var prop,
			// There may be an unlock assigned to this node,
			// if there is no entry for this "owner", create one inline
			// and set the unlock as though an owner entry had always existed
			unlock = this.key( owner ),
			cache = this.cache[ unlock ];

		// Handle: [ owner, key, value ] args
		if ( typeof data === "string" ) {
			cache[ data ] = value;

		// Handle: [ owner, { properties } ] args
		} else {
			// Fresh assignments by object are shallow copied
			if ( jQuery.isEmptyObject( cache ) ) {
				jQuery.extend( this.cache[ unlock ], data );
			// Otherwise, copy the properties one-by-one to the cache object
			} else {
				for ( prop in data ) {
					cache[ prop ] = data[ prop ];
				}
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		// Either a valid cache is found, or will be created.
		// New caches will be created and the unlock returned,
		// allowing direct access to the newly created
		// empty data object. A valid owner object must be provided.
		var cache = this.cache[ this.key( owner ) ];

		return key === undefined ?
			cache : cache[ key ];
	},
	access: function( owner, key, value ) {
		var stored;
		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				((key && typeof key === "string") && value === undefined) ) {

			stored = this.get( owner, key );

			return stored !== undefined ?
				stored : this.get( owner, jQuery.camelCase(key) );
		}

		// [*]When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i, name, camel,
			unlock = this.key( owner ),
			cache = this.cache[ unlock ];

		if ( key === undefined ) {
			this.cache[ unlock ] = {};

		} else {
			// Support array or space separated string of keys
			if ( jQuery.isArray( key ) ) {
				// If "name" is an array of keys...
				// When data is initially created, via ("key", "val") signature,
				// keys will be converted to camelCase.
				// Since there is no way to tell _how_ a key was added, remove
				// both plain key and camelCase key. #12786
				// This will only penalize the array argument path.
				name = key.concat( key.map( jQuery.camelCase ) );
			} else {
				camel = jQuery.camelCase( key );
				// Try the string as a key before any manipulation
				if ( key in cache ) {
					name = [ key, camel ];
				} else {
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					name = camel;
					name = name in cache ?
						[ name ] : ( name.match( rnotwhite ) || [] );
				}
			}

			i = name.length;
			while ( i-- ) {
				delete cache[ name[ i ] ];
			}
		}
	},
	hasData: function( owner ) {
		return !jQuery.isEmptyObject(
			this.cache[ owner[ this.expando ] ] || {}
		);
	},
	discard: function( owner ) {
		if ( owner[ this.expando ] ) {
			delete this.cache[ owner[ this.expando ] ];
		}
	}
};
var data_priv = new Data();

var data_user = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /([A-Z])/g;

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$1" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = data === "true" ? true :
					data === "false" ? false :
					data === "null" ? null :
					// Only convert to a number if it doesn't change the string
					+data + "" === data ? +data :
					rbrace.test( data ) ? jQuery.parseJSON( data ) :
					data;
			} catch( e ) {}

			// Make sure we set the data so it isn't changed later
			data_user.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend({
	hasData: function( elem ) {
		return data_user.hasData( elem ) || data_priv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return data_user.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		data_user.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to data_priv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return data_priv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		data_priv.remove( elem, name );
	}
});

jQuery.fn.extend({
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = data_user.get( elem );

				if ( elem.nodeType === 1 && !data_priv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE11+
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = jQuery.camelCase( name.slice(5) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					data_priv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each(function() {
				data_user.set( this, key );
			});
		}

		return access( this, function( value ) {
			var data,
				camelKey = jQuery.camelCase( key );

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {
				// Attempt to get data from the cache
				// with the key as-is
				data = data_user.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to get data from the cache
				// with the key camelized
				data = data_user.get( elem, camelKey );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, camelKey, undefined );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each(function() {
				// First, attempt to store a copy or reference of any
				// data that might've been store with a camelCased key.
				var data = data_user.get( this, camelKey );

				// For HTML5 data-* attribute interop, we have to
				// store property names with dashes in a camelCase form.
				// This might not apply to all properties...*
				data_user.set( this, camelKey, value );

				// *... In the case of properties that might _actually_
				// have dashes, we need to also store a copy of that
				// unchanged property.
				if ( key.indexOf("-") !== -1 && data !== undefined ) {
					data_user.set( this, key, value );
				}
			});
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each(function() {
			data_user.remove( this, key );
		});
	}
});


jQuery.extend({
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = data_priv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || jQuery.isArray( data ) ) {
					queue = data_priv.access( elem, type, jQuery.makeArray(data) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return data_priv.get( elem, key ) || data_priv.access( elem, key, {
			empty: jQuery.Callbacks("once memory").add(function() {
				data_priv.remove( elem, [ type + "queue", key ] );
			})
		});
	}
});

jQuery.fn.extend({
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[0], type );
		}

		return data === undefined ?
			this :
			this.each(function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[0] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			});
	},
	dequeue: function( type ) {
		return this.each(function() {
			jQuery.dequeue( this, type );
		});
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},
	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = data_priv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
});
var pnum = (/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/).source;

var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHidden = function( elem, el ) {
		// isHidden might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;
		return jQuery.css( elem, "display" ) === "none" || !jQuery.contains( elem.ownerDocument, elem );
	};

var rcheckableType = (/^(?:checkbox|radio)$/i);



(function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Safari<=5.1
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Safari<=5.1, Android<4.2
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE<=11+
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
})();
var strundefined = typeof undefined;



support.focusinBubbles = "onfocusin" in window;


var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu)|click/,
	rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)$/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = data_priv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !(events = elemData.events) ) {
			events = elemData.events = {};
		}
		if ( !(eventHandle = elemData.handle) ) {
			eventHandle = elemData.handle = function( e ) {
				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== strundefined && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnotwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[t] ) || [];
			type = origType = tmp[1];
			namespaces = ( tmp[2] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend({
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join(".")
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !(handlers = events[ type ]) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup || special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle, false );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = data_priv.hasData( elem ) && data_priv.get( elem );

		if ( !elemData || !(events = elemData.events) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnotwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[t] ) || [];
			type = origType = tmp[1];
			namespaces = ( tmp[2] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[2] && new RegExp( "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector || selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown || special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			delete elemData.handle;
			data_priv.remove( elem, "events" );
		}
	},

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split(".") : [];

		cur = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf(".") >= 0 ) {
			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split(".");
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf(":") < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join(".");
		event.namespace_re = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === (elem.ownerDocument || document) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( (cur = eventPath[i++]) && !event.isPropagationStopped() ) {

			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( data_priv.get( cur, "events" ) || {} )[ event.type ] && data_priv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && jQuery.acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( (!special._default || special._default.apply( eventPath.pop(), data ) === false) &&
				jQuery.acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;
					elem[ type ]();
					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	dispatch: function( event ) {

		// Make a writable jQuery.Event from the native event object
		event = jQuery.event.fix( event );

		var i, j, ret, matched, handleObj,
			handlerQueue = [],
			args = slice.call( arguments ),
			handlers = ( data_priv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[0] = event;
		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( (matched = handlerQueue[ i++ ]) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( (handleObj = matched.handlers[ j++ ]) && !event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.namespace_re || event.namespace_re.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( (jQuery.event.special[ handleObj.origType ] || {}).handle || handleObj.handler )
							.apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( (event.result = ret) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, matches, sel, handleObj,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		// Black-hole SVG <use> instance trees (#13180)
		// Avoid non-left-click bubbling in Firefox (#3861)
		if ( delegateCount && cur.nodeType && (!event.button || event.type !== "click") ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.disabled !== true || event.type !== "click" ) {
					matches = [];
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matches[ sel ] === undefined ) {
							matches[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) >= 0 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matches[ sel ] ) {
							matches.push( handleObj );
						}
					}
					if ( matches.length ) {
						handlerQueue.push({ elem: cur, handlers: matches });
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		if ( delegateCount < handlers.length ) {
			handlerQueue.push({ elem: this, handlers: handlers.slice( delegateCount ) });
		}

		return handlerQueue;
	},

	// Includes some event props shared by KeyEvent and MouseEvent
	props: "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),

	fixHooks: {},

	keyHooks: {
		props: "char charCode key keyCode".split(" "),
		filter: function( event, original ) {

			// Add which for key events
			if ( event.which == null ) {
				event.which = original.charCode != null ? original.charCode : original.keyCode;
			}

			return event;
		}
	},

	mouseHooks: {
		props: "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
		filter: function( event, original ) {
			var eventDoc, doc, body,
				button = original.button;

			// Calculate pageX/Y if missing and clientX/Y available
			if ( event.pageX == null && original.clientX != null ) {
				eventDoc = event.target.ownerDocument || document;
				doc = eventDoc.documentElement;
				body = eventDoc.body;

				event.pageX = original.clientX + ( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) - ( doc && doc.clientLeft || body && body.clientLeft || 0 );
				event.pageY = original.clientY + ( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) - ( doc && doc.clientTop  || body && body.clientTop  || 0 );
			}

			// Add which for click: 1 === left; 2 === middle; 3 === right
			// Note: button is not normalized, so don't use it
			if ( !event.which && button !== undefined ) {
				event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
			}

			return event;
		}
	},

	fix: function( event ) {
		if ( event[ jQuery.expando ] ) {
			return event;
		}

		// Create a writable copy of the event object and normalize some properties
		var i, prop, copy,
			type = event.type,
			originalEvent = event,
			fixHook = this.fixHooks[ type ];

		if ( !fixHook ) {
			this.fixHooks[ type ] = fixHook =
				rmouseEvent.test( type ) ? this.mouseHooks :
				rkeyEvent.test( type ) ? this.keyHooks :
				{};
		}
		copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;

		event = new jQuery.Event( originalEvent );

		i = copy.length;
		while ( i-- ) {
			prop = copy[ i ];
			event[ prop ] = originalEvent[ prop ];
		}

		// Support: Cordova 2.5 (WebKit) (#13255)
		// All events should have a target; Cordova deviceready doesn't
		if ( !event.target ) {
			event.target = document;
		}

		// Support: Safari 6.0+, Chrome<28
		// Target should not be a text node (#504, #13143)
		if ( event.target.nodeType === 3 ) {
			event.target = event.target.parentNode;
		}

		return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
	},

	special: {
		load: {
			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {
			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {
			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return jQuery.nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	},

	simulate: function( type, elem, event, bubble ) {
		// Piggyback on a donor event to simulate a different one.
		// Fake originalEvent to avoid donor's stopPropagation, but if the
		// simulated event prevents default then we do the same on the donor.
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true,
				originalEvent: {}
			}
		);
		if ( bubble ) {
			jQuery.event.trigger( e, null, elem );
		} else {
			jQuery.event.dispatch.call( elem, e );
		}
		if ( e.isDefaultPrevented() ) {
			event.preventDefault();
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle, false );
	}
};

jQuery.Event = function( src, props ) {
	// Allow instantiation without the 'new' keyword
	if ( !(this instanceof jQuery.Event) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&
				// Support: Android<4.0
				src.returnValue === false ?
			returnTrue :
			returnFalse;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || jQuery.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && e.preventDefault ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && e.stopPropagation ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && e.stopImmediatePropagation ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Create mouseenter/leave events using mouseover/out and event-time checks
// Support: Chrome 15+
jQuery.each({
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mousenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || (related !== target && !jQuery.contains( target, related )) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
});

// Support: Firefox, Chrome, Safari
// Create "bubbling" focus and blur events
if ( !support.focusinBubbles ) {
	jQuery.each({ focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ), true );
			};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = data_priv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				data_priv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = data_priv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					data_priv.remove( doc, fix );

				} else {
					data_priv.access( doc, fix, attaches );
				}
			}
		};
	});
}

jQuery.fn.extend({

	on: function( types, selector, data, fn, /*INTERNAL*/ one ) {
		var origFn, type;

		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				this.on( type, selector, data, types[ type ], one );
			}
			return this;
		}

		if ( data == null && fn == null ) {
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return this;
		}

		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return this.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		});
	},
	one: function( types, selector, data, fn ) {
		return this.on( types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {
			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {
			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {
			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each(function() {
			jQuery.event.remove( this, types, fn, selector );
		});
	},

	trigger: function( type, data ) {
		return this.each(function() {
			jQuery.event.trigger( type, data, this );
		});
	},
	triggerHandler: function( type, data ) {
		var elem = this[0];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
});


var
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
	rtagName = /<([\w:]+)/,
	rhtml = /<|&#?\w+;/,
	rnoInnerhtml = /<(?:script|style|link)/i,
	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rscriptType = /^$|\/(?:java|ecma)script/i,
	rscriptTypeMasked = /^true\/(.*)/,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,

	// We have to close these tags to support XHTML (#13200)
	wrapMap = {

		// Support: IE9
		option: [ 1, "<select multiple='multiple'>", "</select>" ],

		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

		_default: [ 0, "", "" ]
	};

// Support: IE9
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: 1.x compatibility
// Manipulating tables requires a tbody
function manipulationTarget( elem, content ) {
	return jQuery.nodeName( elem, "table" ) &&
		jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?

		elem.getElementsByTagName("tbody")[0] ||
			elem.appendChild( elem.ownerDocument.createElement("tbody") ) :
		elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	var match = rscriptTypeMasked.exec( elem.type );

	if ( match ) {
		elem.type = match[ 1 ];
	} else {
		elem.removeAttribute("type");
	}

	return elem;
}

// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		data_priv.set(
			elems[ i ], "globalEval", !refElements || data_priv.get( refElements[ i ], "globalEval" )
		);
	}
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( data_priv.hasData( src ) ) {
		pdataOld = data_priv.access( src );
		pdataCur = data_priv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( data_user.hasData( src ) ) {
		udataOld = data_user.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		data_user.set( dest, udataCur );
	}
}

function getAll( context, tag ) {
	var ret = context.getElementsByTagName ? context.getElementsByTagName( tag || "*" ) :
			context.querySelectorAll ? context.querySelectorAll( tag || "*" ) :
			[];

	return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
		jQuery.merge( [ context ], ret ) :
		ret;
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

jQuery.extend({
	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	buildFragment: function( elems, context, scripts, selection ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;

		for ( ; i < l; i++ ) {
			elem = elems[ i ];

			if ( elem || elem === 0 ) {

				// Add nodes directly
				if ( jQuery.type( elem ) === "object" ) {
					// Support: QtWebKit, PhantomJS
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );

				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement("div") );

					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + elem.replace( rxhtmlTag, "<$1></$2>" ) + wrap[ 2 ];

					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}

					// Support: QtWebKit, PhantomJS
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );

					// Remember the top-level container
					tmp = fragment.firstChild;

					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}

		// Remove wrapper from fragment
		fragment.textContent = "";

		i = 0;
		while ( (elem = nodes[ i++ ]) ) {

			// #4087 - If origin and destination elements are the same, and this is
			// that element, do not do anything
			if ( selection && jQuery.inArray( elem, selection ) !== -1 ) {
				continue;
			}

			contains = jQuery.contains( elem.ownerDocument, elem );

			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );

			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}

			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( (elem = tmp[ j++ ]) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}

		return fragment;
	},

	cleanData: function( elems ) {
		var data, elem, type, key,
			special = jQuery.event.special,
			i = 0;

		for ( ; (elem = elems[ i ]) !== undefined; i++ ) {
			if ( jQuery.acceptData( elem ) ) {
				key = elem[ data_priv.expando ];

				if ( key && (data = data_priv.cache[ key ]) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}
					if ( data_priv.cache[ key ] ) {
						// Discard any remaining `private` data
						delete data_priv.cache[ key ];
					}
				}
			}
			// Discard any remaining `user` data
			delete data_user.cache[ elem[ data_user.expando ] ];
		}
	}
});

jQuery.fn.extend({
	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each(function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				});
		}, null, value, arguments.length );
	},

	append: function() {
		return this.domManip( arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		});
	},

	prepend: function() {
		return this.domManip( arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		});
	},

	before: function() {
		return this.domManip( arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		});
	},

	after: function() {
		return this.domManip( arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		});
	},

	remove: function( selector, keepData /* Internal Use Only */ ) {
		var elem,
			elems = selector ? jQuery.filter( selector, this ) : this,
			i = 0;

		for ( ; (elem = elems[i]) != null; i++ ) {
			if ( !keepData && elem.nodeType === 1 ) {
				jQuery.cleanData( getAll( elem ) );
			}

			if ( elem.parentNode ) {
				if ( keepData && jQuery.contains( elem.ownerDocument, elem ) ) {
					setGlobalEval( getAll( elem, "script" ) );
				}
				elem.parentNode.removeChild( elem );
			}
		}

		return this;
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; (elem = this[i]) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map(function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		});
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = value.replace( rxhtmlTag, "<$1></$2>" );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var arg = arguments[ 0 ];

		// Make the changes, replacing each context element with the new content
		this.domManip( arguments, function( elem ) {
			arg = this.parentNode;

			jQuery.cleanData( getAll( this ) );

			if ( arg ) {
				arg.replaceChild( elem, this );
			}
		});

		// Force removal if there was no new content (e.g., from empty arguments)
		return arg && (arg.length || arg.nodeType) ? this : this.remove();
	},

	detach: function( selector ) {
		return this.remove( selector, true );
	},

	domManip: function( args, callback ) {

		// Flatten any nested arrays
		args = concat.apply( [], args );

		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = this.length,
			set = this,
			iNoClone = l - 1,
			value = args[ 0 ],
			isFunction = jQuery.isFunction( value );

		// We can't cloneNode fragments that contain checked, in WebKit
		if ( isFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return this.each(function( index ) {
				var self = set.eq( index );
				if ( isFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				self.domManip( args, callback );
			});
		}

		if ( l ) {
			fragment = jQuery.buildFragment( args, this[ 0 ].ownerDocument, false, this );
			first = fragment.firstChild;

			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}

			if ( first ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;

				// Use the original fragment for the last item instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;

					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );

						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
							// Support: QtWebKit
							// jQuery.merge because push.apply(_, arraylike) throws
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}

					callback.call( this[ i ], node, i );
				}

				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;

					// Reenable scripts
					jQuery.map( scripts, restoreScript );

					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!data_priv.access( node, "globalEval" ) && jQuery.contains( doc, node ) ) {

							if ( node.src ) {
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								jQuery.globalEval( node.textContent.replace( rcleanScript, "" ) );
							}
						}
					}
				}
			}
		}

		return this;
	}
});

jQuery.each({
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: QtWebKit
			// .get() because push.apply(_, arraylike) throws
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
});


var iframe,
	elemdisplay = {};

/**
 * Retrieve the actual display of a element
 * @param {String} name nodeName of the element
 * @param {Object} doc Document object
 */
// Called only from within defaultDisplay
function actualDisplay( name, doc ) {
	var style,
		elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),

		// getDefaultComputedStyle might be reliably used only on attached element
		display = window.getDefaultComputedStyle && ( style = window.getDefaultComputedStyle( elem[ 0 ] ) ) ?

			// Use of this method is a temporary fix (more like optimization) until something better comes along,
			// since it was removed from specification and supported only in FF
			style.display : jQuery.css( elem[ 0 ], "display" );

	// We don't have any data stored on the element,
	// so use "detach" method as fast way to get rid of the element
	elem.detach();

	return display;
}

/**
 * Try to determine the default display value of an element
 * @param {String} nodeName
 */
function defaultDisplay( nodeName ) {
	var doc = document,
		display = elemdisplay[ nodeName ];

	if ( !display ) {
		display = actualDisplay( nodeName, doc );

		// If the simple way fails, read from inside an iframe
		if ( display === "none" || !display ) {

			// Use the already-created iframe if possible
			iframe = (iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" )).appendTo( doc.documentElement );

			// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
			doc = iframe[ 0 ].contentDocument;

			// Support: IE
			doc.write();
			doc.close();

			display = actualDisplay( nodeName, doc );
			iframe.detach();
		}

		// Store the correct default display
		elemdisplay[ nodeName ] = display;
	}

	return display;
}
var rmargin = (/^margin/);

var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {
		// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		if ( elem.ownerDocument.defaultView.opener ) {
			return elem.ownerDocument.defaultView.getComputedStyle( elem, null );
		}

		return window.getComputedStyle( elem, null );
	};



function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		style = elem.style;

	computed = computed || getStyles( elem );

	// Support: IE9
	// getPropertyValue is only needed for .css('filter') (#12537)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];
	}

	if ( computed ) {

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// Support: iOS < 6
		// A tribute to the "awesome hack by Dean Edwards"
		// iOS < 6 (at least) returns percentage for a larger set of values, but width seems to be reliably pixels
		// this is against the CSSOM draft spec: http://dev.w3.org/csswg/cssom/#resolved-values
		if ( rnumnonpx.test( ret ) && rmargin.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?
		// Support: IE
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {
	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {
				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return (this.get = hookFn).apply( this, arguments );
		}
	};
}


(function() {
	var pixelPositionVal, boxSizingReliableVal,
		docElem = document.documentElement,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	if ( !div.style ) {
		return;
	}

	// Support: IE9-11+
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	container.style.cssText = "border:0;width:0;height:0;top:0;left:-9999px;margin-top:1px;" +
		"position:absolute";
	container.appendChild( div );

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computePixelPositionAndBoxSizingReliable() {
		div.style.cssText =
			// Support: Firefox<29, Android 2.3
			// Vendor-prefix box-sizing
			"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;" +
			"box-sizing:border-box;display:block;margin-top:1%;top:1%;" +
			"border:1px;padding:1px;width:4px;position:absolute";
		div.innerHTML = "";
		docElem.appendChild( container );

		var divStyle = window.getComputedStyle( div, null );
		pixelPositionVal = divStyle.top !== "1%";
		boxSizingReliableVal = divStyle.width === "4px";

		docElem.removeChild( container );
	}

	// Support: node.js jsdom
	// Don't assume that getComputedStyle is a property of the global object
	if ( window.getComputedStyle ) {
		jQuery.extend( support, {
			pixelPosition: function() {

				// This test is executed only once but we still do memoizing
				// since we can use the boxSizingReliable pre-computing.
				// No need to check if the test was already performed, though.
				computePixelPositionAndBoxSizingReliable();
				return pixelPositionVal;
			},
			boxSizingReliable: function() {
				if ( boxSizingReliableVal == null ) {
					computePixelPositionAndBoxSizingReliable();
				}
				return boxSizingReliableVal;
			},
			reliableMarginRight: function() {

				// Support: Android 2.3
				// Check if div with explicit width and no margin-right incorrectly
				// gets computed margin-right based on width of container. (#3333)
				// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
				// This support function is only executed once so no memoizing is needed.
				var ret,
					marginDiv = div.appendChild( document.createElement( "div" ) );

				// Reset CSS: box-sizing; display; margin; border; padding
				marginDiv.style.cssText = div.style.cssText =
					// Support: Firefox<29, Android 2.3
					// Vendor-prefix box-sizing
					"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" +
					"box-sizing:content-box;display:block;margin:0;border:0;padding:0";
				marginDiv.style.marginRight = marginDiv.style.width = "0";
				div.style.width = "1px";
				docElem.appendChild( container );

				ret = !parseFloat( window.getComputedStyle( marginDiv, null ).marginRight );

				docElem.removeChild( container );
				div.removeChild( marginDiv );

				return ret;
			}
		});
	}
})();


// A method for quickly swapping in/out CSS properties to get correct calculations.
jQuery.swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var
	// Swappable if display is none or starts with table except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rnumsplit = new RegExp( "^(" + pnum + ")(.*)$", "i" ),
	rrelNum = new RegExp( "^([+-])=(" + pnum + ")", "i" ),

	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "O", "Moz", "ms" ];

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( style, name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in style ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[0].toUpperCase() + name.slice(1),
		origName = name,
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in style ) {
			return name;
		}
	}

	return origName;
}

function setPositiveNumber( elem, value, subtract ) {
	var matches = rnumsplit.exec( value );
	return matches ?
		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 1 ] - ( subtract || 0 ) ) + ( matches[ 2 ] || "px" ) :
		value;
}

function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	var i = extra === ( isBorderBox ? "border" : "content" ) ?
		// If we already have the right measurement, avoid augmentation
		4 :
		// Otherwise initialize for horizontal or vertical properties
		name === "width" ? 1 : 0,

		val = 0;

	for ( ; i < 4; i += 2 ) {
		// Both box models exclude margin, so add it if we want it
		if ( extra === "margin" ) {
			val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
		}

		if ( isBorderBox ) {
			// border-box includes padding, so remove it if we want content
			if ( extra === "content" ) {
				val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// At this point, extra isn't border nor margin, so remove border
			if ( extra !== "margin" ) {
				val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		} else {
			// At this point, extra isn't content, so add padding
			val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// At this point, extra isn't content nor padding, so add border
			if ( extra !== "padding" ) {
				val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	return val;
}

function getWidthOrHeight( elem, name, extra ) {

	// Start with offset property, which is equivalent to the border-box value
	var valueIsBorderBox = true,
		val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
		styles = getStyles( elem ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

	// Some non-html elements return undefined for offsetWidth, so check for null/undefined
	// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
	// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
	if ( val <= 0 || val == null ) {
		// Fall back to computed then uncomputed css if necessary
		val = curCSS( elem, name, styles );
		if ( val < 0 || val == null ) {
			val = elem.style[ name ];
		}

		// Computed unit is not pixels. Stop here and return.
		if ( rnumnonpx.test(val) ) {
			return val;
		}

		// Check for style in case a browser which returns unreliable values
		// for getComputedStyle silently falls back to the reliable elem.style
		valueIsBorderBox = isBorderBox &&
			( support.boxSizingReliable() || val === elem.style[ name ] );

		// Normalize "", auto, and prepare for extra
		val = parseFloat( val ) || 0;
	}

	// Use the active box-sizing model to add/subtract irrelevant styles
	return ( val +
		augmentWidthOrHeight(
			elem,
			name,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles
		)
	) + "px";
}

function showHide( elements, show ) {
	var display, elem, hidden,
		values = [],
		index = 0,
		length = elements.length;

	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		values[ index ] = data_priv.get( elem, "olddisplay" );
		display = elem.style.display;
		if ( show ) {
			// Reset the inline display of this element to learn if it is
			// being hidden by cascaded rules or not
			if ( !values[ index ] && display === "none" ) {
				elem.style.display = "";
			}

			// Set elements which have been overridden with display: none
			// in a stylesheet to whatever the default browser style is
			// for such an element
			if ( elem.style.display === "" && isHidden( elem ) ) {
				values[ index ] = data_priv.access( elem, "olddisplay", defaultDisplay(elem.nodeName) );
			}
		} else {
			hidden = isHidden( elem );

			if ( display !== "none" || !hidden ) {
				data_priv.set( elem, "olddisplay", hidden ? display : jQuery.css( elem, "display" ) );
			}
		}
	}

	// Set the display of most of the elements in a second loop
	// to avoid the constant reflow
	for ( index = 0; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}
		if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
			elem.style.display = show ? values[ index ] || "" : "none";
		}
	}

	return elements;
}

jQuery.extend({

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {
		"float": "cssFloat"
	},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = jQuery.camelCase( name ),
			style = elem.style;

		name = jQuery.cssProps[ origName ] || ( jQuery.cssProps[ origName ] = vendorPropName( style, origName ) );

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && (ret = rrelNum.exec( value )) ) {
				value = ( ret[1] + 1 ) * ret[2] + parseFloat( jQuery.css( elem, name ) );
				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number, add 'px' to the (except for certain CSS properties)
			if ( type === "number" && !jQuery.cssNumber[ origName ] ) {
				value += "px";
			}

			// Support: IE9-11+
			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !("set" in hooks) || (value = hooks.set( elem, value, extra )) !== undefined ) {
				style[ name ] = value;
			}

		} else {
			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks && (ret = hooks.get( elem, false, extra )) !== undefined ) {
				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = jQuery.camelCase( name );

		// Make sure that we're working with the right name
		name = jQuery.cssProps[ origName ] || ( jQuery.cssProps[ origName ] = vendorPropName( elem.style, origName ) );

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || jQuery.isNumeric( num ) ? num || 0 : val;
		}
		return val;
	}
});

jQuery.each([ "height", "width" ], function( i, name ) {
	jQuery.cssHooks[ name ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) && elem.offsetWidth === 0 ?
					jQuery.swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, name, extra );
					}) :
					getWidthOrHeight( elem, name, extra );
			}
		},

		set: function( elem, value, extra ) {
			var styles = extra && getStyles( elem );
			return setPositiveNumber( elem, value, extra ?
				augmentWidthOrHeight(
					elem,
					name,
					extra,
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					styles
				) : 0
			);
		}
	};
});

// Support: Android 2.3
jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
	function( elem, computed ) {
		if ( computed ) {
			return jQuery.swap( elem, { "display": "inline-block" },
				curCSS, [ elem, "marginRight" ] );
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each({
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split(" ") : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( !rmargin.test( prefix ) ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
});

jQuery.fn.extend({
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( jQuery.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	},
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each(function() {
			if ( isHidden( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		});
	}
});


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || "swing";
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			if ( tween.elem[ tween.prop ] != null &&
				(!tween.elem.style || tween.elem.style[ tween.prop ] == null) ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );
			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {
			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.style && ( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null || jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE9
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	}
};

jQuery.fx = Tween.prototype.init;

// Back Compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, timerId,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rfxnum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" ),
	rrun = /queueHooks$/,
	animationPrefilters = [ defaultPrefilter ],
	tweeners = {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value ),
				target = tween.cur(),
				parts = rfxnum.exec( value ),
				unit = parts && parts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

				// Starting value computation is required for potential unit mismatches
				start = ( jQuery.cssNumber[ prop ] || unit !== "px" && +target ) &&
					rfxnum.exec( jQuery.css( tween.elem, prop ) ),
				scale = 1,
				maxIterations = 20;

			if ( start && start[ 3 ] !== unit ) {
				// Trust units reported by jQuery.css
				unit = unit || start[ 3 ];

				// Make sure we update the tween properties later on
				parts = parts || [];

				// Iteratively approximate from a nonzero starting point
				start = +target || 1;

				do {
					// If previous iteration zeroed out, double until we get *something*.
					// Use string for doubling so we don't accidentally see scale as unchanged below
					scale = scale || ".5";

					// Adjust and apply
					start = start / scale;
					jQuery.style( tween.elem, prop, start + unit );

				// Update scale, tolerating zero or NaN from tween.cur(),
				// break the loop if scale is unchanged or perfect, or if we've just had enough
				} while ( scale !== (scale = tween.cur() / target) && scale !== 1 && --maxIterations );
			}

			// Update tween properties
			if ( parts ) {
				start = tween.start = +start || +target || 0;
				tween.unit = unit;
				// If a +=/-= token was provided, we're doing a relative animation
				tween.end = parts[ 1 ] ?
					start + ( parts[ 1 ] + 1 ) * parts[ 2 ] :
					+parts[ 2 ];
			}

			return tween;
		} ]
	};

// Animations created synchronously will run synchronously
function createFxNow() {
	setTimeout(function() {
		fxNow = undefined;
	});
	return ( fxNow = jQuery.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4 ; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( tweeners[ prop ] || [] ).concat( tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( (tween = collection[ index ].call( animation, prop, value )) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	/* jshint validthis: true */
	var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHidden( elem ),
		dataShow = data_priv.get( elem, "fxshow" );

	// Handle queue: false promises
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always(function() {
			// Ensure the complete handler is called before this completes
			anim.always(function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			});
		});
	}

	// Height/width overflow pass
	if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {
		// Make sure that nothing sneaks out
		// Record all 3 overflow attributes because IE9-10 do not
		// change the overflow attribute when overflowX and
		// overflowY are set to the same value
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Set display property to inline-block for height/width
		// animations on inline elements that are having width/height animated
		display = jQuery.css( elem, "display" );

		// Test default display if display is currently "none"
		checkDisplay = display === "none" ?
			data_priv.get( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;

		if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {
			style.display = "inline-block";
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always(function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		});
	}

	// show/hide pass
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.exec( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// If there is dataShow left over from a stopped hide or show and we are going to proceed with show, we should pretend to be hidden
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );

		// Any non-fx value stops us from restoring the original display value
		} else {
			display = undefined;
		}
	}

	if ( !jQuery.isEmptyObject( orig ) ) {
		if ( dataShow ) {
			if ( "hidden" in dataShow ) {
				hidden = dataShow.hidden;
			}
		} else {
			dataShow = data_priv.access( elem, "fxshow", {} );
		}

		// Store state if its toggle - enables .stop().toggle() to "reverse"
		if ( toggle ) {
			dataShow.hidden = !hidden;
		}
		if ( hidden ) {
			jQuery( elem ).show();
		} else {
			anim.done(function() {
				jQuery( elem ).hide();
			});
		}
		anim.done(function() {
			var prop;

			data_priv.remove( elem, "fxshow" );
			for ( prop in orig ) {
				jQuery.style( elem, prop, orig[ prop ] );
			}
		});
		for ( prop in orig ) {
			tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );

			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = tween.start;
				if ( hidden ) {
					tween.end = tween.start;
					tween.start = prop === "width" || prop === "height" ? 1 : 0;
				}
			}
		}

	// If this is a noop like .hide().hide(), restore an overwritten display value
	} else if ( (display === "none" ? defaultDisplay( elem.nodeName ) : display) === "inline" ) {
		style.display = display;
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = jQuery.camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( jQuery.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = animationPrefilters.length,
		deferred = jQuery.Deferred().always( function() {
			// Don't match elem in the :animated selector
			delete tick.elem;
		}),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
				// Support: Android 2.3
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length ; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ]);

			if ( percent < 1 && length ) {
				return remaining;
			} else {
				deferred.resolveWith( elem, [ animation ] );
				return false;
			}
		},
		animation = deferred.promise({
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, { specialEasing: {} }, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,
					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		}),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length ; index++ ) {
		result = animationPrefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( jQuery.isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		})
	);

	// attach callbacks from options
	return animation.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );
}

jQuery.Animation = jQuery.extend( Animation, {

	tweener: function( props, callback ) {
		if ( jQuery.isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.split(" ");
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length ; index++ ) {
			prop = props[ index ];
			tweeners[ prop ] = tweeners[ prop ] || [];
			tweeners[ prop ].unshift( callback );
		}
	},

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			animationPrefilters.unshift( callback );
		} else {
			animationPrefilters.push( callback );
		}
	}
});

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			jQuery.isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
	};

	opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ? opt.duration :
		opt.duration in jQuery.fx.speeds ? jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( jQuery.isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend({
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHidden ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate({ opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {
				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || data_priv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each(function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = data_priv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && (type == null || timers[ index ].queue === type) ) {
					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		});
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each(function() {
			var index,
				data = data_priv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		});
	}
});

jQuery.each([ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
});

// Generate shortcuts for custom animations
jQuery.each({
	slideDown: genFx("show"),
	slideUp: genFx("hide"),
	slideToggle: genFx("toggle"),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
});

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = jQuery.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];
		// Checks the timer has not already been removed
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	if ( timer() ) {
		jQuery.fx.start();
	} else {
		jQuery.timers.pop();
	}
};

jQuery.fx.interval = 13;

jQuery.fx.start = function() {
	if ( !timerId ) {
		timerId = setInterval( jQuery.fx.tick, jQuery.fx.interval );
	}
};

jQuery.fx.stop = function() {
	clearInterval( timerId );
	timerId = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,
	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = setTimeout( next, time );
		hooks.stop = function() {
			clearTimeout( timeout );
		};
	});
};


(function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: iOS<=5.1, Android<=4.2+
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE<=11+
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: Android<=2.3
	// Options inside disabled selects are incorrectly marked as disabled
	select.disabled = true;
	support.optDisabled = !opt.disabled;

	// Support: IE<=11+
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
})();


var nodeHook, boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend({
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each(function() {
			jQuery.removeAttr( this, name );
		});
	}
});

jQuery.extend({
	attr: function( elem, name, value ) {
		var hooks, ret,
			nType = elem.nodeType;

		// don't get/set attributes on text, comment and attribute nodes
		if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === strundefined ) {
			return jQuery.prop( elem, name, value );
		}

		// All attributes are lowercase
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			name = name.toLowerCase();
			hooks = jQuery.attrHooks[ name ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : nodeHook );
		}

		if ( value !== undefined ) {

			if ( value === null ) {
				jQuery.removeAttr( elem, name );

			} else if ( hooks && "set" in hooks && (ret = hooks.set( elem, value, name )) !== undefined ) {
				return ret;

			} else {
				elem.setAttribute( name, value + "" );
				return value;
			}

		} else if ( hooks && "get" in hooks && (ret = hooks.get( elem, name )) !== null ) {
			return ret;

		} else {
			ret = jQuery.find.attr( elem, name );

			// Non-existent attributes return null, we normalize to undefined
			return ret == null ?
				undefined :
				ret;
		}
	},

	removeAttr: function( elem, value ) {
		var name, propName,
			i = 0,
			attrNames = value && value.match( rnotwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( (name = attrNames[i++]) ) {
				propName = jQuery.propFix[ name ] || name;

				// Boolean attributes get special treatment (#10870)
				if ( jQuery.expr.match.bool.test( name ) ) {
					// Set corresponding property to false
					elem[ propName ] = false;
				}

				elem.removeAttribute( name );
			}
		}
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					jQuery.nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	}
});

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {
			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};
jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle;
		if ( !isXML ) {
			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ name ];
			attrHandle[ name ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				name.toLowerCase() :
				null;
			attrHandle[ name ] = handle;
		}
		return ret;
	};
});




var rfocusable = /^(?:input|select|textarea|button)$/i;

jQuery.fn.extend({
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each(function() {
			delete this[ jQuery.propFix[ name ] || name ];
		});
	}
});

jQuery.extend({
	propFix: {
		"for": "htmlFor",
		"class": "className"
	},

	prop: function( elem, name, value ) {
		var ret, hooks, notxml,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		notxml = nType !== 1 || !jQuery.isXMLDoc( elem );

		if ( notxml ) {
			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			return hooks && "set" in hooks && (ret = hooks.set( elem, value, name )) !== undefined ?
				ret :
				( elem[ name ] = value );

		} else {
			return hooks && "get" in hooks && (ret = hooks.get( elem, name )) !== null ?
				ret :
				elem[ name ];
		}
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {
				return elem.hasAttribute( "tabindex" ) || rfocusable.test( elem.nodeName ) || elem.href ?
					elem.tabIndex :
					-1;
			}
		}
	}
});

if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {
			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		}
	};
}

jQuery.each([
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
});




var rclass = /[\t\r\n\f]/g;

jQuery.fn.extend({
	addClass: function( value ) {
		var classes, elem, cur, clazz, j, finalValue,
			proceed = typeof value === "string" && value,
			i = 0,
			len = this.length;

		if ( jQuery.isFunction( value ) ) {
			return this.each(function( j ) {
				jQuery( this ).addClass( value.call( this, j, this.className ) );
			});
		}

		if ( proceed ) {
			// The disjunction here is for better compressibility (see removeClass)
			classes = ( value || "" ).match( rnotwhite ) || [];

			for ( ; i < len; i++ ) {
				elem = this[ i ];
				cur = elem.nodeType === 1 && ( elem.className ?
					( " " + elem.className + " " ).replace( rclass, " " ) :
					" "
				);

				if ( cur ) {
					j = 0;
					while ( (clazz = classes[j++]) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// only assign if different to avoid unneeded rendering.
					finalValue = jQuery.trim( cur );
					if ( elem.className !== finalValue ) {
						elem.className = finalValue;
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, clazz, j, finalValue,
			proceed = arguments.length === 0 || typeof value === "string" && value,
			i = 0,
			len = this.length;

		if ( jQuery.isFunction( value ) ) {
			return this.each(function( j ) {
				jQuery( this ).removeClass( value.call( this, j, this.className ) );
			});
		}
		if ( proceed ) {
			classes = ( value || "" ).match( rnotwhite ) || [];

			for ( ; i < len; i++ ) {
				elem = this[ i ];
				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( elem.className ?
					( " " + elem.className + " " ).replace( rclass, " " ) :
					""
				);

				if ( cur ) {
					j = 0;
					while ( (clazz = classes[j++]) ) {
						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) >= 0 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = value ? jQuery.trim( cur ) : "";
					if ( elem.className !== finalValue ) {
						elem.className = finalValue;
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value;

		if ( typeof stateVal === "boolean" && type === "string" ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( jQuery.isFunction( value ) ) {
			return this.each(function( i ) {
				jQuery( this ).toggleClass( value.call(this, i, this.className, stateVal), stateVal );
			});
		}

		return this.each(function() {
			if ( type === "string" ) {
				// Toggle individual class names
				var className,
					i = 0,
					self = jQuery( this ),
					classNames = value.match( rnotwhite ) || [];

				while ( (className = classNames[ i++ ]) ) {
					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( type === strundefined || type === "boolean" ) {
				if ( this.className ) {
					// store className if set
					data_priv.set( this, "__className__", this.className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				this.className = this.className || value === false ? "" : data_priv.get( this, "__className__" ) || "";
			}
		});
	},

	hasClass: function( selector ) {
		var className = " " + selector + " ",
			i = 0,
			l = this.length;
		for ( ; i < l; i++ ) {
			if ( this[i].nodeType === 1 && (" " + this[i].className + " ").replace(rclass, " ").indexOf( className ) >= 0 ) {
				return true;
			}
		}

		return false;
	}
});




var rreturn = /\r/g;

jQuery.fn.extend({
	val: function( value ) {
		var hooks, ret, isFunction,
			elem = this[0];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] || jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks && "get" in hooks && (ret = hooks.get( elem, "value" )) !== undefined ) {
					return ret;
				}

				ret = elem.value;

				return typeof ret === "string" ?
					// Handle most common string cases
					ret.replace(rreturn, "") :
					// Handle cases where value is null/undef or number
					ret == null ? "" : ret;
			}

			return;
		}

		isFunction = jQuery.isFunction( value );

		return this.each(function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( isFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( jQuery.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				});
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !("set" in hooks) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		});
	}
});

jQuery.extend({
	valHooks: {
		option: {
			get: function( elem ) {
				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :
					// Support: IE10-11+
					// option.text throws exceptions (#14686, #14858)
					jQuery.trim( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one" || index < 0,
					values = one ? null : [],
					max = one ? index + 1 : options.length,
					i = index < 0 ?
						max :
						one ? index : 0;

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// IE6-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&
							// Don't return options that are disabled or in a disabled optgroup
							( support.optDisabled ? !option.disabled : option.getAttribute( "disabled" ) === null ) &&
							( !option.parentNode.disabled || !jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];
					if ( (option.selected = jQuery.inArray( option.value, values ) >= 0) ) {
						optionSet = true;
					}
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
});

// Radios and checkboxes getter/setter
jQuery.each([ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( jQuery.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery(elem).val(), value ) >= 0 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute("value") === null ? "on" : elem.value;
		};
	}
});




// Return jQuery for attributes-only inclusion


jQuery.each( ("blur focus focusin focusout load resize scroll unload click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup error contextmenu").split(" "), function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
});

jQuery.fn.extend({
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	},

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {
		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ? this.off( selector, "**" ) : this.off( types, selector || "**", fn );
	}
});


var nonce = jQuery.now();

var rquery = (/\?/);



// Support: Android 2.3
// Workaround failure to string-cast null input
jQuery.parseJSON = function( data ) {
	return JSON.parse( data + "" );
};


// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, tmp;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE9
	try {
		tmp = new DOMParser();
		xml = tmp.parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rhash = /#.*$/,
	rts = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,
	rurl = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Document location
	ajaxLocation = window.location.href,

	// Segment location into parts
	ajaxLocParts = rurl.exec( ajaxLocation.toLowerCase() ) || [];

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];

		if ( jQuery.isFunction( func ) ) {
			// For each dataType in the dataTypeExpression
			while ( (dataType = dataTypes[i++]) ) {
				// Prepend if requested
				if ( dataType[0] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					(structure[ dataType ] = structure[ dataType ] || []).unshift( func );

				// Otherwise append
				} else {
					(structure[ dataType ] = structure[ dataType ] || []).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[ dataTypeOrTransport ] ) {
				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		});
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || (deep = {}) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {
		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[0] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}
		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},
		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

		// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {
								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s[ "throws" ] ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return { state: "parsererror", error: conv ? e : "No conversion from " + prev + " to " + current };
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend({

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: ajaxLocation,
		type: "GET",
		isLocal: rlocalProtocol.test( ajaxLocParts[ 1 ] ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",
		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /xml/,
			html: /html/,
			json: /json/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": jQuery.parseJSON,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,
			// URL without anti-cache param
			cacheURL,
			// Response headers
			responseHeadersString,
			responseHeaders,
			// timeout handle
			timeoutTimer,
			// Cross-domain detection vars
			parts,
			// To know if global events are to be dispatched
			fireGlobals,
			// Loop variable
			i,
			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),
			// Callbacks context
			callbackContext = s.context || s,
			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context && ( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,
			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks("once memory"),
			// Status-dependent callbacks
			statusCode = s.statusCode || {},
			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},
			// The jqXHR state
			state = 0,
			// Default abort message
			strAbort = "canceled",
			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( state === 2 ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( (match = rheaders.exec( responseHeadersString )) ) {
								responseHeaders[ match[1].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return state === 2 ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					var lname = name.toLowerCase();
					if ( !state ) {
						name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( !state ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( state < 2 ) {
							for ( code in map ) {
								// Lazy-add the new callback in a way that preserves old ones
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						} else {
							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR ).complete = completeDeferred.add;
		jqXHR.success = jqXHR.done;
		jqXHR.error = jqXHR.fail;

		// Remove hash character (#7531: and string promotion)
		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || ajaxLocation ) + "" ).replace( rhash, "" )
			.replace( rprotocol, ajaxLocParts[ 1 ] + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];

		// A cross-domain request is in order when we have a protocol:host:port mismatch
		if ( s.crossDomain == null ) {
			parts = rurl.exec( s.url.toLowerCase() );
			s.crossDomain = !!( parts &&
				( parts[ 1 ] !== ajaxLocParts[ 1 ] || parts[ 2 ] !== ajaxLocParts[ 2 ] ||
					( parts[ 3 ] || ( parts[ 1 ] === "http:" ? "80" : "443" ) ) !==
						( ajaxLocParts[ 3 ] || ( ajaxLocParts[ 1 ] === "http:" ? "80" : "443" ) ) )
			);
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( state === 2 ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger("ajaxStart");
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		cacheURL = s.url;

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// If data is available, append data to url
			if ( s.data ) {
				cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );
				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add anti-cache in url if needed
			if ( s.cache === false ) {
				s.url = rts.test( cacheURL ) ?

					// If there is already a '_' parameter, set its value
					cacheURL.replace( rts, "$1_=" + nonce++ ) :

					// Otherwise add one to the end
					cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
			}
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[0] ] ?
				s.accepts[ s.dataTypes[0] ] + ( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend && ( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {
			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		for ( i in { success: 1, error: 1, complete: 1 } ) {
			jqXHR[ i ]( s[ i ] );
		}

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}
			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = setTimeout(function() {
					jqXHR.abort("timeout");
				}, s.timeout );
			}

			try {
				state = 1;
				transport.send( requestHeaders, done );
			} catch ( e ) {
				// Propagate exception as error if not done
				if ( state < 2 ) {
					done( -1, e );
				// Simply rethrow otherwise
				} else {
					throw e;
				}
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Called once
			if ( state === 2 ) {
				return;
			}

			// State is "done" now
			state = 2;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader("Last-Modified");
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader("etag");
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {
				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger("ajaxStop");
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
});

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {
		// Shift arguments if data argument was omitted
		if ( jQuery.isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		return jQuery.ajax({
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		});
	};
});


jQuery._evalUrl = function( url ) {
	return jQuery.ajax({
		url: url,
		type: "GET",
		dataType: "script",
		async: false,
		global: false,
		"throws": true
	});
};


jQuery.fn.extend({
	wrapAll: function( html ) {
		var wrap;

		if ( jQuery.isFunction( html ) ) {
			return this.each(function( i ) {
				jQuery( this ).wrapAll( html.call(this, i) );
			});
		}

		if ( this[ 0 ] ) {

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map(function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			}).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each(function( i ) {
				jQuery( this ).wrapInner( html.call(this, i) );
			});
		}

		return this.each(function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		});
	},

	wrap: function( html ) {
		var isFunction = jQuery.isFunction( html );

		return this.each(function( i ) {
			jQuery( this ).wrapAll( isFunction ? html.call(this, i) : html );
		});
	},

	unwrap: function() {
		return this.parent().each(function() {
			if ( !jQuery.nodeName( this, "body" ) ) {
				jQuery( this ).replaceWith( this.childNodes );
			}
		}).end();
	}
});


jQuery.expr.filters.hidden = function( elem ) {
	// Support: Opera <= 12.12
	// Opera reports offsetWidths and offsetHeights less than zero on some elements
	return elem.offsetWidth <= 0 && elem.offsetHeight <= 0;
};
jQuery.expr.filters.visible = function( elem ) {
	return !jQuery.expr.filters.hidden( elem );
};




var r20 = /%20/g,
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( jQuery.isArray( obj ) ) {
		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {
				// Treat each array item as a scalar.
				add( prefix, v );

			} else {
				// Item is non-scalar (array or object), encode its numeric index.
				buildParams( prefix + "[" + ( typeof v === "object" ? i : "" ) + "]", v, traditional, add );
			}
		});

	} else if ( !traditional && jQuery.type( obj ) === "object" ) {
		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {
		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, value ) {
			// If value is a function, invoke it and return its value
			value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
			s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
		};

	// Set traditional to true for jQuery <= 1.3.2 behavior.
	if ( traditional === undefined ) {
		traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		});

	} else {
		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" ).replace( r20, "+" );
};

jQuery.fn.extend({
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map(function() {
			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		})
		.filter(function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		})
		.map(function( i, elem ) {
			var val = jQuery( this ).val();

			return val == null ?
				null :
				jQuery.isArray( val ) ?
					jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					}) :
					{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		}).get();
	}
});


jQuery.ajaxSettings.xhr = function() {
	try {
		return new XMLHttpRequest();
	} catch( e ) {}
};

var xhrId = 0,
	xhrCallbacks = {},
	xhrSuccessStatus = {
		// file protocol always yields status code 0, assume 200
		0: 200,
		// Support: IE9
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

// Support: IE9
// Open requests must be manually aborted on unload (#5280)
// See https://support.microsoft.com/kb/2856746 for more info
if ( window.attachEvent ) {
	window.attachEvent( "onunload", function() {
		for ( var key in xhrCallbacks ) {
			xhrCallbacks[ key ]();
		}
	});
}

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport(function( options ) {
	var callback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr(),
					id = ++xhrId;

				xhr.open( options.type, options.url, options.async, options.username, options.password );

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers["X-Requested-With"] ) {
					headers["X-Requested-With"] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							delete xhrCallbacks[ id ];
							callback = xhr.onload = xhr.onerror = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {
								complete(
									// file: protocol always yields status 0; see #8605, #14207
									xhr.status,
									xhr.statusText
								);
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,
									// Support: IE9
									// Accessing binary-data responseText throws an exception
									// (#11426)
									typeof xhr.responseText === "string" ? {
										text: xhr.responseText
									} : undefined,
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				xhr.onerror = callback("error");

				// Create the abort callback
				callback = xhrCallbacks[ id ] = callback("abort");

				try {
					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {
					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
});




// Install script dataType
jQuery.ajaxSetup({
	accepts: {
		script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /(?:java|ecma)script/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
});

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
});

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {
	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery("<script>").prop({
					async: true,
					charset: s.scriptCharset,
					src: s.url
				}).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
});




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup({
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
});

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" && !( s.contentType || "" ).indexOf("application/x-www-form-urlencoded") && rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters["script json"] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always(function() {
			// Restore preexisting value
			window[ callbackName ] = overwritten;

			// Save back as free
			if ( s[ callbackName ] ) {
				// make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && jQuery.isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		});

		// Delegate to script
		return "script";
	}
});




// data: string of html
// context (optional): If specified, the fragment will be created in this context, defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( !data || typeof data !== "string" ) {
		return null;
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}
	context = context || document;

	var parsed = rsingleTag.exec( data ),
		scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[1] ) ];
	}

	parsed = jQuery.buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


// Keep a copy of the old load method
var _load = jQuery.fn.load;

/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	if ( typeof url !== "string" && _load ) {
		return _load.apply( this, arguments );
	}

	var selector, type, response,
		self = this,
		off = url.indexOf(" ");

	if ( off >= 0 ) {
		selector = jQuery.trim( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( jQuery.isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax({
			url: url,

			// if "type" variable is undefined, then "GET" method will be used
			type: type,
			dataType: "html",
			data: params
		}).done(function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery("<div>").append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		}).complete( callback && function( jqXHR, status ) {
			self.each( callback, response || [ jqXHR.responseText, status, jqXHR ] );
		});
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [ "ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend" ], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
});




jQuery.expr.filters.animated = function( elem ) {
	return jQuery.grep(jQuery.timers, function( fn ) {
		return elem === fn.elem;
	}).length;
};




var docElem = window.document.documentElement;

/**
 * Gets a window from an element
 */
function getWindow( elem ) {
	return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
}

jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf("auto") > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( jQuery.isFunction( options ) ) {
			options = options.call( elem, i, curOffset );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend({
	offset: function( options ) {
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each(function( i ) {
					jQuery.offset.setOffset( this, options, i );
				});
		}

		var docElem, win,
			elem = this[ 0 ],
			box = { top: 0, left: 0 },
			doc = elem && elem.ownerDocument;

		if ( !doc ) {
			return;
		}

		docElem = doc.documentElement;

		// Make sure it's not a disconnected DOM node
		if ( !jQuery.contains( docElem, elem ) ) {
			return box;
		}

		// Support: BlackBerry 5, iOS 3 (original iPhone)
		// If we don't have gBCR, just use 0,0 rather than error
		if ( typeof elem.getBoundingClientRect !== strundefined ) {
			box = elem.getBoundingClientRect();
		}
		win = getWindow( doc );
		return {
			top: box.top + win.pageYOffset - docElem.clientTop,
			left: box.left + win.pageXOffset - docElem.clientLeft
		};
	},

	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// Fixed elements are offset from window (parentOffset = {top:0, left: 0}, because it is its only offset parent
		if ( jQuery.css( elem, "position" ) === "fixed" ) {
			// Assume getBoundingClientRect is there when computed position is fixed
			offset = elem.getBoundingClientRect();

		} else {
			// Get *real* offsetParent
			offsetParent = this.offsetParent();

			// Get correct offsets
			offset = this.offset();
			if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
				parentOffset = offsetParent.offset();
			}

			// Add offsetParent borders
			parentOffset.top += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
			parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	offsetParent: function() {
		return this.map(function() {
			var offsetParent = this.offsetParent || docElem;

			while ( offsetParent && ( !jQuery.nodeName( offsetParent, "html" ) && jQuery.css( offsetParent, "position" ) === "static" ) ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || docElem;
		});
	}
});

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {
			var win = getWindow( elem );

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : window.pageXOffset,
					top ? val : window.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length, null );
	};
});

// Support: Safari<7+, Chrome<37+
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://code.google.com/p/chromium/issues/detail?id=229280
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );
				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
});


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name }, function( defaultExtra, funcName ) {
		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( jQuery.isWindow( elem ) ) {
					// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
					// isn't a whole lot we can do. See pull request at this URL for discussion:
					// https://github.com/jquery/jquery/pull/764
					return elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?
					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable, null );
		};
	});
});


// The number of elements contained in the matched element set
jQuery.fn.size = function() {
	return this.length;
};

jQuery.fn.andSelf = jQuery.fn.addBack;




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( typeof define === "function" && define.amd ) {
	define( "jquery", [], function() {
		return jQuery;
	});
}




var
	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( typeof noGlobal === strundefined ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;

}));

},{}],31:[function(require,module,exports){
(function(e,r){typeof exports==="object"&&typeof module!=="undefined"?r(exports):typeof define==="function"&&define.amd?define(["exports"],r):(e=e||self,r(e.stylis={}))})(this,(function(e){"use strict";var r="-ms-";var a="-moz-";var c="-webkit-";var n="comm";var t="rule";var s="decl";var i="@page";var u="@media";var o="@import";var f="@charset";var l="@viewport";var p="@supports";var h="@document";var v="@namespace";var d="@keyframes";var b="@font-face";var w="@counter-style";var m="@font-feature-values";var g="@layer";var k=Math.abs;var $=String.fromCharCode;var x=Object.assign;function E(e,r){return M(e,0)^45?(((r<<2^M(e,0))<<2^M(e,1))<<2^M(e,2))<<2^M(e,3):0}function y(e){return e.trim()}function T(e,r){return(e=r.exec(e))?e[0]:e}function A(e,r,a){return e.replace(r,a)}function O(e,r){return e.indexOf(r)}function M(e,r){return e.charCodeAt(r)|0}function C(e,r,a){return e.slice(r,a)}function R(e){return e.length}function S(e){return e.length}function z(e,r){return r.push(e),e}function N(e,r){return e.map(r).join("")}e.line=1;e.column=1;e.length=0;e.position=0;e.character=0;e.characters="";function P(r,a,c,n,t,s,i){return{value:r,root:a,parent:c,type:n,props:t,children:s,line:e.line,column:e.column,length:i,return:""}}function j(e,r){return x(P("",null,null,"",null,null,0),e,{length:-e.length},r)}function U(){return e.character}function _(){e.character=e.position>0?M(e.characters,--e.position):0;if(e.column--,e.character===10)e.column=1,e.line--;return e.character}function F(){e.character=e.position<e.length?M(e.characters,e.position++):0;if(e.column++,e.character===10)e.column=1,e.line++;return e.character}function I(){return M(e.characters,e.position)}function L(){return e.position}function D(r,a){return C(e.characters,r,a)}function Y(e){switch(e){case 0:case 9:case 10:case 13:case 32:return 5;case 33:case 43:case 44:case 47:case 62:case 64:case 126:case 59:case 123:case 125:return 4;case 58:return 3;case 34:case 39:case 40:case 91:return 2;case 41:case 93:return 1}return 0}function K(r){return e.line=e.column=1,e.length=R(e.characters=r),e.position=0,[]}function V(r){return e.characters="",r}function W(r){return y(D(e.position-1,q(r===91?r+2:r===40?r+1:r)))}function B(e){return V(H(K(e)))}function G(r){while(e.character=I())if(e.character<33)F();else break;return Y(r)>2||Y(e.character)>3?"":" "}function H(r){while(F())switch(Y(e.character)){case 0:z(Q(e.position-1),r);break;case 2:z(W(e.character),r);break;default:z($(e.character),r)}return r}function Z(r,a){while(--a&&F())if(e.character<48||e.character>102||e.character>57&&e.character<65||e.character>70&&e.character<97)break;return D(r,L()+(a<6&&I()==32&&F()==32))}function q(r){while(F())switch(e.character){case r:return e.position;case 34:case 39:if(r!==34&&r!==39)q(e.character);break;case 40:if(r===41)q(r);break;case 92:F();break}return e.position}function J(r,a){while(F())if(r+e.character===47+10)break;else if(r+e.character===42+42&&I()===47)break;return"/*"+D(a,e.position-1)+"*"+$(r===47?r:F())}function Q(r){while(!Y(I()))F();return D(r,e.position)}function X(e){return V(ee("",null,null,null,[""],e=K(e),0,[0],e))}function ee(e,r,a,c,n,t,s,i,u){var o=0;var f=0;var l=s;var p=0;var h=0;var v=0;var d=1;var b=1;var w=1;var m=0;var g="";var k=n;var x=t;var E=c;var y=g;while(b)switch(v=m,m=F()){case 40:if(v!=108&&M(y,l-1)==58){if(O(y+=A(W(m),"&","&\f"),"&\f")!=-1)w=-1;break}case 34:case 39:case 91:y+=W(m);break;case 9:case 10:case 13:case 32:y+=G(v);break;case 92:y+=Z(L()-1,7);continue;case 47:switch(I()){case 42:case 47:z(ae(J(F(),L()),r,a),u);break;default:y+="/"}break;case 123*d:i[o++]=R(y)*w;case 125*d:case 59:case 0:switch(m){case 0:case 125:b=0;case 59+f:if(w==-1)y=A(y,/\f/g,"");if(h>0&&R(y)-l)z(h>32?ce(y+";",c,a,l-1):ce(A(y," ","")+";",c,a,l-2),u);break;case 59:y+=";";default:z(E=re(y,r,a,o,f,n,i,g,k=[],x=[],l),t);if(m===123)if(f===0)ee(y,r,E,E,k,t,l,i,x);else switch(p===99&&M(y,3)===110?100:p){case 100:case 108:case 109:case 115:ee(e,E,E,c&&z(re(e,E,E,0,0,n,i,g,n,k=[],l),x),n,x,l,i,c?k:x);break;default:ee(y,E,E,E,[""],x,0,i,x)}}o=f=h=0,d=w=1,g=y="",l=s;break;case 58:l=1+R(y),h=v;default:if(d<1)if(m==123)--d;else if(m==125&&d++==0&&_()==125)continue;switch(y+=$(m),m*d){case 38:w=f>0?1:(y+="\f",-1);break;case 44:i[o++]=(R(y)-1)*w,w=1;break;case 64:if(I()===45)y+=W(F());p=I(),f=l=R(g=y+=Q(L())),m++;break;case 45:if(v===45&&R(y)==2)d=0}}return t}function re(e,r,a,c,n,s,i,u,o,f,l){var p=n-1;var h=n===0?s:[""];var v=S(h);for(var d=0,b=0,w=0;d<c;++d)for(var m=0,g=C(e,p+1,p=k(b=i[d])),$=e;m<v;++m)if($=y(b>0?h[m]+" "+g:A(g,/&\f/g,h[m])))o[w++]=$;return P(e,r,a,n===0?t:u,o,f,l)}function ae(e,r,a){return P(e,r,a,n,$(U()),C(e,2,-2),0)}function ce(e,r,a,c){return P(e,r,a,s,C(e,0,c),C(e,c+1,-1),c)}function ne(e,n,t){switch(E(e,n)){case 5103:return c+"print-"+e+e;case 5737:case 4201:case 3177:case 3433:case 1641:case 4457:case 2921:case 5572:case 6356:case 5844:case 3191:case 6645:case 3005:case 6391:case 5879:case 5623:case 6135:case 4599:case 4855:case 4215:case 6389:case 5109:case 5365:case 5621:case 3829:return c+e+e;case 4789:return a+e+e;case 5349:case 4246:case 4810:case 6968:case 2756:return c+e+a+e+r+e+e;case 5936:switch(M(e,n+11)){case 114:return c+e+r+A(e,/[svh]\w+-[tblr]{2}/,"tb")+e;case 108:return c+e+r+A(e,/[svh]\w+-[tblr]{2}/,"tb-rl")+e;case 45:return c+e+r+A(e,/[svh]\w+-[tblr]{2}/,"lr")+e}case 6828:case 4268:case 2903:return c+e+r+e+e;case 6165:return c+e+r+"flex-"+e+e;case 5187:return c+e+A(e,/(\w+).+(:[^]+)/,c+"box-$1$2"+r+"flex-$1$2")+e;case 5443:return c+e+r+"flex-item-"+A(e,/flex-|-self/g,"")+(!T(e,/flex-|baseline/)?r+"grid-row-"+A(e,/flex-|-self/g,""):"")+e;case 4675:return c+e+r+"flex-line-pack"+A(e,/align-content|flex-|-self/g,"")+e;case 5548:return c+e+r+A(e,"shrink","negative")+e;case 5292:return c+e+r+A(e,"basis","preferred-size")+e;case 6060:return c+"box-"+A(e,"-grow","")+c+e+r+A(e,"grow","positive")+e;case 4554:return c+A(e,/([^-])(transform)/g,"$1"+c+"$2")+e;case 6187:return A(A(A(e,/(zoom-|grab)/,c+"$1"),/(image-set)/,c+"$1"),e,"")+e;case 5495:case 3959:return A(e,/(image-set\([^]*)/,c+"$1"+"$`$1");case 4968:return A(A(e,/(.+:)(flex-)?(.*)/,c+"box-pack:$3"+r+"flex-pack:$3"),/s.+-b[^;]+/,"justify")+c+e+e;case 4200:if(!T(e,/flex-|baseline/))return r+"grid-column-align"+C(e,n)+e;break;case 2592:case 3360:return r+A(e,"template-","")+e;case 4384:case 3616:if(t&&t.some((function(e,r){return n=r,T(e.props,/grid-\w+-end/)}))){return~O(e+(t=t[n].value),"span")?e:r+A(e,"-start","")+e+r+"grid-row-span:"+(~O(t,"span")?T(t,/\d+/):+T(t,/\d+/)-+T(e,/\d+/))+";"}return r+A(e,"-start","")+e;case 4896:case 4128:return t&&t.some((function(e){return T(e.props,/grid-\w+-start/)}))?e:r+A(A(e,"-end","-span"),"span ","")+e;case 4095:case 3583:case 4068:case 2532:return A(e,/(.+)-inline(.+)/,c+"$1$2")+e;case 8116:case 7059:case 5753:case 5535:case 5445:case 5701:case 4933:case 4677:case 5533:case 5789:case 5021:case 4765:if(R(e)-1-n>6)switch(M(e,n+1)){case 109:if(M(e,n+4)!==45)break;case 102:return A(e,/(.+:)(.+)-([^]+)/,"$1"+c+"$2-$3"+"$1"+a+(M(e,n+3)==108?"$3":"$2-$3"))+e;case 115:return~O(e,"stretch")?ne(A(e,"stretch","fill-available"),n,t)+e:e}break;case 5152:case 5920:return A(e,/(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/,(function(a,c,n,t,s,i,u){return r+c+":"+n+u+(t?r+c+"-span:"+(s?i:+i-+n)+u:"")+e}));case 4949:if(M(e,n+6)===121)return A(e,":",":"+c)+e;break;case 6444:switch(M(e,M(e,14)===45?18:11)){case 120:return A(e,/(.+:)([^;\s!]+)(;|(\s+)?!.+)?/,"$1"+c+(M(e,14)===45?"inline-":"")+"box$3"+"$1"+c+"$2$3"+"$1"+r+"$2box$3")+e;case 100:return A(e,":",":"+r)+e}break;case 5719:case 2647:case 2135:case 3927:case 2391:return A(e,"scroll-","scroll-snap-")+e}return e}function te(e,r){var a="";var c=S(e);for(var n=0;n<c;n++)a+=r(e[n],n,e,r)||"";return a}function se(e,r,a,c){switch(e.type){case g:if(e.children.length)break;case o:case s:return e.return=e.return||e.value;case n:return"";case d:return e.return=e.value+"{"+te(e.children,c)+"}";case t:e.value=e.props.join(",")}return R(a=te(e.children,c))?e.return=e.value+"{"+a+"}":""}function ie(e){var r=S(e);return function(a,c,n,t){var s="";for(var i=0;i<r;i++)s+=e[i](a,c,n,t)||"";return s}}function ue(e){return function(r){if(!r.root)if(r=r.return)e(r)}}function oe(e,n,i,u){if(e.length>-1)if(!e.return)switch(e.type){case s:e.return=ne(e.value,e.length,i);return;case d:return te([j(e,{value:A(e.value,"@","@"+c)})],u);case t:if(e.length)return N(e.props,(function(n){switch(T(n,/(::plac\w+|:read-\w+)/)){case":read-only":case":read-write":return te([j(e,{props:[A(n,/:(read-\w+)/,":"+a+"$1")]})],u);case"::placeholder":return te([j(e,{props:[A(n,/:(plac\w+)/,":"+c+"input-$1")]}),j(e,{props:[A(n,/:(plac\w+)/,":"+a+"$1")]}),j(e,{props:[A(n,/:(plac\w+)/,r+"input-$1")]})],u)}return""}))}}function fe(e){switch(e.type){case t:e.props=e.props.map((function(r){return N(B(r),(function(r,a,c){switch(M(r,0)){case 12:return C(r,1,R(r));case 0:case 40:case 43:case 62:case 126:return r;case 58:if(c[++a]==="global")c[a]="",c[++a]="\f"+C(c[a],a=1,-1);case 32:return a===1?"":r;default:switch(a){case 0:e=r;return S(c)>1?"":r;case a=S(c)-1:case 2:return a===2?r+e+e:r+e;default:return r}}}))}))}}e.CHARSET=f;e.COMMENT=n;e.COUNTER_STYLE=w;e.DECLARATION=s;e.DOCUMENT=h;e.FONT_FACE=b;e.FONT_FEATURE_VALUES=m;e.IMPORT=o;e.KEYFRAMES=d;e.LAYER=g;e.MEDIA=u;e.MOZ=a;e.MS=r;e.NAMESPACE=v;e.PAGE=i;e.RULESET=t;e.SUPPORTS=p;e.VIEWPORT=l;e.WEBKIT=c;e.abs=k;e.alloc=K;e.append=z;e.assign=x;e.caret=L;e.char=U;e.charat=M;e.combine=N;e.comment=ae;e.commenter=J;e.compile=X;e.copy=j;e.dealloc=V;e.declaration=ce;e.delimit=W;e.delimiter=q;e.escaping=Z;e.from=$;e.hash=E;e.identifier=Q;e.indexof=O;e.match=T;e.middleware=ie;e.namespace=fe;e.next=F;e.node=P;e.parse=ee;e.peek=I;e.prefix=ne;e.prefixer=oe;e.prev=_;e.replace=A;e.ruleset=re;e.rulesheet=ue;e.serialize=te;e.sizeof=S;e.slice=D;e.stringify=se;e.strlen=R;e.substr=C;e.token=Y;e.tokenize=B;e.tokenizer=H;e.trim=y;e.whitespace=G;Object.defineProperty(e,"__esModule",{value:true})}));


},{}],32:[function(require,module,exports){
/**
 * Swiper 5.2.1
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://swiperjs.com
 *
 * Copyright 2014-2019 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: November 16, 2019
 */

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, global.Swiper = factory());
}(this, function () { 'use strict';

  /**
   * SSR Window 1.0.1
   * Better handling for window object in SSR environment
   * https://github.com/nolimits4web/ssr-window
   *
   * Copyright 2018, Vladimir Kharlampidi
   *
   * Licensed under MIT
   *
   * Released on: July 18, 2018
   */
  var doc = (typeof document === 'undefined') ? {
    body: {},
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    activeElement: {
      blur: function blur() {},
      nodeName: '',
    },
    querySelector: function querySelector() {
      return null;
    },
    querySelectorAll: function querySelectorAll() {
      return [];
    },
    getElementById: function getElementById() {
      return null;
    },
    createEvent: function createEvent() {
      return {
        initEvent: function initEvent() {},
      };
    },
    createElement: function createElement() {
      return {
        children: [],
        childNodes: [],
        style: {},
        setAttribute: function setAttribute() {},
        getElementsByTagName: function getElementsByTagName() {
          return [];
        },
      };
    },
    location: { hash: '' },
  } : document; // eslint-disable-line

  var win = (typeof window === 'undefined') ? {
    document: doc,
    navigator: {
      userAgent: '',
    },
    location: {},
    history: {},
    CustomEvent: function CustomEvent() {
      return this;
    },
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    getComputedStyle: function getComputedStyle() {
      return {
        getPropertyValue: function getPropertyValue() {
          return '';
        },
      };
    },
    Image: function Image() {},
    Date: function Date() {},
    screen: {},
    setTimeout: function setTimeout() {},
    clearTimeout: function clearTimeout() {},
  } : window; // eslint-disable-line

  /**
   * Dom7 2.1.3
   * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
   * http://framework7.io/docs/dom.html
   *
   * Copyright 2019, Vladimir Kharlampidi
   * The iDangero.us
   * http://www.idangero.us/
   *
   * Licensed under MIT
   *
   * Released on: February 11, 2019
   */

  var Dom7 = function Dom7(arr) {
    var self = this;
    // Create array-like object
    for (var i = 0; i < arr.length; i += 1) {
      self[i] = arr[i];
    }
    self.length = arr.length;
    // Return collection with methods
    return this;
  };

  function $(selector, context) {
    var arr = [];
    var i = 0;
    if (selector && !context) {
      if (selector instanceof Dom7) {
        return selector;
      }
    }
    if (selector) {
        // String
      if (typeof selector === 'string') {
        var els;
        var tempParent;
        var html = selector.trim();
        if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
          var toCreate = 'div';
          if (html.indexOf('<li') === 0) { toCreate = 'ul'; }
          if (html.indexOf('<tr') === 0) { toCreate = 'tbody'; }
          if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) { toCreate = 'tr'; }
          if (html.indexOf('<tbody') === 0) { toCreate = 'table'; }
          if (html.indexOf('<option') === 0) { toCreate = 'select'; }
          tempParent = doc.createElement(toCreate);
          tempParent.innerHTML = html;
          for (i = 0; i < tempParent.childNodes.length; i += 1) {
            arr.push(tempParent.childNodes[i]);
          }
        } else {
          if (!context && selector[0] === '#' && !selector.match(/[ .<>:~]/)) {
            // Pure ID selector
            els = [doc.getElementById(selector.trim().split('#')[1])];
          } else {
            // Other selectors
            els = (context || doc).querySelectorAll(selector.trim());
          }
          for (i = 0; i < els.length; i += 1) {
            if (els[i]) { arr.push(els[i]); }
          }
        }
      } else if (selector.nodeType || selector === win || selector === doc) {
        // Node/element
        arr.push(selector);
      } else if (selector.length > 0 && selector[0].nodeType) {
        // Array of elements or instance of Dom
        for (i = 0; i < selector.length; i += 1) {
          arr.push(selector[i]);
        }
      }
    }
    return new Dom7(arr);
  }

  $.fn = Dom7.prototype;
  $.Class = Dom7;
  $.Dom7 = Dom7;

  function unique(arr) {
    var uniqueArray = [];
    for (var i = 0; i < arr.length; i += 1) {
      if (uniqueArray.indexOf(arr[i]) === -1) { uniqueArray.push(arr[i]); }
    }
    return uniqueArray;
  }

  // Classes and attributes
  function addClass(className) {
    if (typeof className === 'undefined') {
      return this;
    }
    var classes = className.split(' ');
    for (var i = 0; i < classes.length; i += 1) {
      for (var j = 0; j < this.length; j += 1) {
        if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') { this[j].classList.add(classes[i]); }
      }
    }
    return this;
  }
  function removeClass(className) {
    var classes = className.split(' ');
    for (var i = 0; i < classes.length; i += 1) {
      for (var j = 0; j < this.length; j += 1) {
        if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') { this[j].classList.remove(classes[i]); }
      }
    }
    return this;
  }
  function hasClass(className) {
    if (!this[0]) { return false; }
    return this[0].classList.contains(className);
  }
  function toggleClass(className) {
    var classes = className.split(' ');
    for (var i = 0; i < classes.length; i += 1) {
      for (var j = 0; j < this.length; j += 1) {
        if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') { this[j].classList.toggle(classes[i]); }
      }
    }
    return this;
  }
  function attr(attrs, value) {
    var arguments$1 = arguments;

    if (arguments.length === 1 && typeof attrs === 'string') {
      // Get attr
      if (this[0]) { return this[0].getAttribute(attrs); }
      return undefined;
    }

    // Set attrs
    for (var i = 0; i < this.length; i += 1) {
      if (arguments$1.length === 2) {
        // String
        this[i].setAttribute(attrs, value);
      } else {
        // Object
        // eslint-disable-next-line
        for (var attrName in attrs) {
          this[i][attrName] = attrs[attrName];
          this[i].setAttribute(attrName, attrs[attrName]);
        }
      }
    }
    return this;
  }
  // eslint-disable-next-line
  function removeAttr(attr) {
    for (var i = 0; i < this.length; i += 1) {
      this[i].removeAttribute(attr);
    }
    return this;
  }
  function data(key, value) {
    var el;
    if (typeof value === 'undefined') {
      el = this[0];
      // Get value
      if (el) {
        if (el.dom7ElementDataStorage && (key in el.dom7ElementDataStorage)) {
          return el.dom7ElementDataStorage[key];
        }

        var dataKey = el.getAttribute(("data-" + key));
        if (dataKey) {
          return dataKey;
        }
        return undefined;
      }
      return undefined;
    }

    // Set value
    for (var i = 0; i < this.length; i += 1) {
      el = this[i];
      if (!el.dom7ElementDataStorage) { el.dom7ElementDataStorage = {}; }
      el.dom7ElementDataStorage[key] = value;
    }
    return this;
  }
  // Transforms
  // eslint-disable-next-line
  function transform(transform) {
    for (var i = 0; i < this.length; i += 1) {
      var elStyle = this[i].style;
      elStyle.webkitTransform = transform;
      elStyle.transform = transform;
    }
    return this;
  }
  function transition(duration) {
    if (typeof duration !== 'string') {
      duration = duration + "ms"; // eslint-disable-line
    }
    for (var i = 0; i < this.length; i += 1) {
      var elStyle = this[i].style;
      elStyle.webkitTransitionDuration = duration;
      elStyle.transitionDuration = duration;
    }
    return this;
  }
  // Events
  function on() {
    var assign;

    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
    var eventType = args[0];
    var targetSelector = args[1];
    var listener = args[2];
    var capture = args[3];
    if (typeof args[1] === 'function') {
      (assign = args, eventType = assign[0], listener = assign[1], capture = assign[2]);
      targetSelector = undefined;
    }
    if (!capture) { capture = false; }

    function handleLiveEvent(e) {
      var target = e.target;
      if (!target) { return; }
      var eventData = e.target.dom7EventData || [];
      if (eventData.indexOf(e) < 0) {
        eventData.unshift(e);
      }
      if ($(target).is(targetSelector)) { listener.apply(target, eventData); }
      else {
        var parents = $(target).parents(); // eslint-disable-line
        for (var k = 0; k < parents.length; k += 1) {
          if ($(parents[k]).is(targetSelector)) { listener.apply(parents[k], eventData); }
        }
      }
    }
    function handleEvent(e) {
      var eventData = e && e.target ? e.target.dom7EventData || [] : [];
      if (eventData.indexOf(e) < 0) {
        eventData.unshift(e);
      }
      listener.apply(this, eventData);
    }
    var events = eventType.split(' ');
    var j;
    for (var i = 0; i < this.length; i += 1) {
      var el = this[i];
      if (!targetSelector) {
        for (j = 0; j < events.length; j += 1) {
          var event = events[j];
          if (!el.dom7Listeners) { el.dom7Listeners = {}; }
          if (!el.dom7Listeners[event]) { el.dom7Listeners[event] = []; }
          el.dom7Listeners[event].push({
            listener: listener,
            proxyListener: handleEvent,
          });
          el.addEventListener(event, handleEvent, capture);
        }
      } else {
        // Live events
        for (j = 0; j < events.length; j += 1) {
          var event$1 = events[j];
          if (!el.dom7LiveListeners) { el.dom7LiveListeners = {}; }
          if (!el.dom7LiveListeners[event$1]) { el.dom7LiveListeners[event$1] = []; }
          el.dom7LiveListeners[event$1].push({
            listener: listener,
            proxyListener: handleLiveEvent,
          });
          el.addEventListener(event$1, handleLiveEvent, capture);
        }
      }
    }
    return this;
  }
  function off() {
    var assign;

    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
    var eventType = args[0];
    var targetSelector = args[1];
    var listener = args[2];
    var capture = args[3];
    if (typeof args[1] === 'function') {
      (assign = args, eventType = assign[0], listener = assign[1], capture = assign[2]);
      targetSelector = undefined;
    }
    if (!capture) { capture = false; }

    var events = eventType.split(' ');
    for (var i = 0; i < events.length; i += 1) {
      var event = events[i];
      for (var j = 0; j < this.length; j += 1) {
        var el = this[j];
        var handlers = (void 0);
        if (!targetSelector && el.dom7Listeners) {
          handlers = el.dom7Listeners[event];
        } else if (targetSelector && el.dom7LiveListeners) {
          handlers = el.dom7LiveListeners[event];
        }
        if (handlers && handlers.length) {
          for (var k = handlers.length - 1; k >= 0; k -= 1) {
            var handler = handlers[k];
            if (listener && handler.listener === listener) {
              el.removeEventListener(event, handler.proxyListener, capture);
              handlers.splice(k, 1);
            } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
              el.removeEventListener(event, handler.proxyListener, capture);
              handlers.splice(k, 1);
            } else if (!listener) {
              el.removeEventListener(event, handler.proxyListener, capture);
              handlers.splice(k, 1);
            }
          }
        }
      }
    }
    return this;
  }
  function trigger() {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var events = args[0].split(' ');
    var eventData = args[1];
    for (var i = 0; i < events.length; i += 1) {
      var event = events[i];
      for (var j = 0; j < this.length; j += 1) {
        var el = this[j];
        var evt = (void 0);
        try {
          evt = new win.CustomEvent(event, {
            detail: eventData,
            bubbles: true,
            cancelable: true,
          });
        } catch (e) {
          evt = doc.createEvent('Event');
          evt.initEvent(event, true, true);
          evt.detail = eventData;
        }
        // eslint-disable-next-line
        el.dom7EventData = args.filter(function (data, dataIndex) { return dataIndex > 0; });
        el.dispatchEvent(evt);
        el.dom7EventData = [];
        delete el.dom7EventData;
      }
    }
    return this;
  }
  function transitionEnd(callback) {
    var events = ['webkitTransitionEnd', 'transitionend'];
    var dom = this;
    var i;
    function fireCallBack(e) {
      /* jshint validthis:true */
      if (e.target !== this) { return; }
      callback.call(this, e);
      for (i = 0; i < events.length; i += 1) {
        dom.off(events[i], fireCallBack);
      }
    }
    if (callback) {
      for (i = 0; i < events.length; i += 1) {
        dom.on(events[i], fireCallBack);
      }
    }
    return this;
  }
  function outerWidth(includeMargins) {
    if (this.length > 0) {
      if (includeMargins) {
        // eslint-disable-next-line
        var styles = this.styles();
        return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
      }
      return this[0].offsetWidth;
    }
    return null;
  }
  function outerHeight(includeMargins) {
    if (this.length > 0) {
      if (includeMargins) {
        // eslint-disable-next-line
        var styles = this.styles();
        return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
      }
      return this[0].offsetHeight;
    }
    return null;
  }
  function offset() {
    if (this.length > 0) {
      var el = this[0];
      var box = el.getBoundingClientRect();
      var body = doc.body;
      var clientTop = el.clientTop || body.clientTop || 0;
      var clientLeft = el.clientLeft || body.clientLeft || 0;
      var scrollTop = el === win ? win.scrollY : el.scrollTop;
      var scrollLeft = el === win ? win.scrollX : el.scrollLeft;
      return {
        top: (box.top + scrollTop) - clientTop,
        left: (box.left + scrollLeft) - clientLeft,
      };
    }

    return null;
  }
  function styles() {
    if (this[0]) { return win.getComputedStyle(this[0], null); }
    return {};
  }
  function css(props, value) {
    var i;
    if (arguments.length === 1) {
      if (typeof props === 'string') {
        if (this[0]) { return win.getComputedStyle(this[0], null).getPropertyValue(props); }
      } else {
        for (i = 0; i < this.length; i += 1) {
          // eslint-disable-next-line
          for (var prop in props) {
            this[i].style[prop] = props[prop];
          }
        }
        return this;
      }
    }
    if (arguments.length === 2 && typeof props === 'string') {
      for (i = 0; i < this.length; i += 1) {
        this[i].style[props] = value;
      }
      return this;
    }
    return this;
  }
  // Iterate over the collection passing elements to `callback`
  function each(callback) {
    // Don't bother continuing without a callback
    if (!callback) { return this; }
    // Iterate over the current collection
    for (var i = 0; i < this.length; i += 1) {
      // If the callback returns false
      if (callback.call(this[i], i, this[i]) === false) {
        // End the loop early
        return this;
      }
    }
    // Return `this` to allow chained DOM operations
    return this;
  }
  function filter(callback) {
    var matchedItems = [];
    var dom = this;
    for (var i = 0; i < dom.length; i += 1) {
      if (callback.call(dom[i], i, dom[i])) { matchedItems.push(dom[i]); }
    }
    return new Dom7(matchedItems);
  }
  // eslint-disable-next-line
  function html(html) {
    if (typeof html === 'undefined') {
      return this[0] ? this[0].innerHTML : undefined;
    }

    for (var i = 0; i < this.length; i += 1) {
      this[i].innerHTML = html;
    }
    return this;
  }
  // eslint-disable-next-line
  function text(text) {
    if (typeof text === 'undefined') {
      if (this[0]) {
        return this[0].textContent.trim();
      }
      return null;
    }

    for (var i = 0; i < this.length; i += 1) {
      this[i].textContent = text;
    }
    return this;
  }
  function is(selector) {
    var el = this[0];
    var compareWith;
    var i;
    if (!el || typeof selector === 'undefined') { return false; }
    if (typeof selector === 'string') {
      if (el.matches) { return el.matches(selector); }
      else if (el.webkitMatchesSelector) { return el.webkitMatchesSelector(selector); }
      else if (el.msMatchesSelector) { return el.msMatchesSelector(selector); }

      compareWith = $(selector);
      for (i = 0; i < compareWith.length; i += 1) {
        if (compareWith[i] === el) { return true; }
      }
      return false;
    } else if (selector === doc) { return el === doc; }
    else if (selector === win) { return el === win; }

    if (selector.nodeType || selector instanceof Dom7) {
      compareWith = selector.nodeType ? [selector] : selector;
      for (i = 0; i < compareWith.length; i += 1) {
        if (compareWith[i] === el) { return true; }
      }
      return false;
    }
    return false;
  }
  function index() {
    var child = this[0];
    var i;
    if (child) {
      i = 0;
      // eslint-disable-next-line
      while ((child = child.previousSibling) !== null) {
        if (child.nodeType === 1) { i += 1; }
      }
      return i;
    }
    return undefined;
  }
  // eslint-disable-next-line
  function eq(index) {
    if (typeof index === 'undefined') { return this; }
    var length = this.length;
    var returnIndex;
    if (index > length - 1) {
      return new Dom7([]);
    }
    if (index < 0) {
      returnIndex = length + index;
      if (returnIndex < 0) { return new Dom7([]); }
      return new Dom7([this[returnIndex]]);
    }
    return new Dom7([this[index]]);
  }
  function append() {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var newChild;

    for (var k = 0; k < args.length; k += 1) {
      newChild = args[k];
      for (var i = 0; i < this.length; i += 1) {
        if (typeof newChild === 'string') {
          var tempDiv = doc.createElement('div');
          tempDiv.innerHTML = newChild;
          while (tempDiv.firstChild) {
            this[i].appendChild(tempDiv.firstChild);
          }
        } else if (newChild instanceof Dom7) {
          for (var j = 0; j < newChild.length; j += 1) {
            this[i].appendChild(newChild[j]);
          }
        } else {
          this[i].appendChild(newChild);
        }
      }
    }

    return this;
  }
  function prepend(newChild) {
    var i;
    var j;
    for (i = 0; i < this.length; i += 1) {
      if (typeof newChild === 'string') {
        var tempDiv = doc.createElement('div');
        tempDiv.innerHTML = newChild;
        for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
          this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
        }
      } else if (newChild instanceof Dom7) {
        for (j = 0; j < newChild.length; j += 1) {
          this[i].insertBefore(newChild[j], this[i].childNodes[0]);
        }
      } else {
        this[i].insertBefore(newChild, this[i].childNodes[0]);
      }
    }
    return this;
  }
  function next(selector) {
    if (this.length > 0) {
      if (selector) {
        if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
          return new Dom7([this[0].nextElementSibling]);
        }
        return new Dom7([]);
      }

      if (this[0].nextElementSibling) { return new Dom7([this[0].nextElementSibling]); }
      return new Dom7([]);
    }
    return new Dom7([]);
  }
  function nextAll(selector) {
    var nextEls = [];
    var el = this[0];
    if (!el) { return new Dom7([]); }
    while (el.nextElementSibling) {
      var next = el.nextElementSibling; // eslint-disable-line
      if (selector) {
        if ($(next).is(selector)) { nextEls.push(next); }
      } else { nextEls.push(next); }
      el = next;
    }
    return new Dom7(nextEls);
  }
  function prev(selector) {
    if (this.length > 0) {
      var el = this[0];
      if (selector) {
        if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
          return new Dom7([el.previousElementSibling]);
        }
        return new Dom7([]);
      }

      if (el.previousElementSibling) { return new Dom7([el.previousElementSibling]); }
      return new Dom7([]);
    }
    return new Dom7([]);
  }
  function prevAll(selector) {
    var prevEls = [];
    var el = this[0];
    if (!el) { return new Dom7([]); }
    while (el.previousElementSibling) {
      var prev = el.previousElementSibling; // eslint-disable-line
      if (selector) {
        if ($(prev).is(selector)) { prevEls.push(prev); }
      } else { prevEls.push(prev); }
      el = prev;
    }
    return new Dom7(prevEls);
  }
  function parent(selector) {
    var parents = []; // eslint-disable-line
    for (var i = 0; i < this.length; i += 1) {
      if (this[i].parentNode !== null) {
        if (selector) {
          if ($(this[i].parentNode).is(selector)) { parents.push(this[i].parentNode); }
        } else {
          parents.push(this[i].parentNode);
        }
      }
    }
    return $(unique(parents));
  }
  function parents(selector) {
    var parents = []; // eslint-disable-line
    for (var i = 0; i < this.length; i += 1) {
      var parent = this[i].parentNode; // eslint-disable-line
      while (parent) {
        if (selector) {
          if ($(parent).is(selector)) { parents.push(parent); }
        } else {
          parents.push(parent);
        }
        parent = parent.parentNode;
      }
    }
    return $(unique(parents));
  }
  function closest(selector) {
    var closest = this; // eslint-disable-line
    if (typeof selector === 'undefined') {
      return new Dom7([]);
    }
    if (!closest.is(selector)) {
      closest = closest.parents(selector).eq(0);
    }
    return closest;
  }
  function find(selector) {
    var foundElements = [];
    for (var i = 0; i < this.length; i += 1) {
      var found = this[i].querySelectorAll(selector);
      for (var j = 0; j < found.length; j += 1) {
        foundElements.push(found[j]);
      }
    }
    return new Dom7(foundElements);
  }
  function children(selector) {
    var children = []; // eslint-disable-line
    for (var i = 0; i < this.length; i += 1) {
      var childNodes = this[i].childNodes;

      for (var j = 0; j < childNodes.length; j += 1) {
        if (!selector) {
          if (childNodes[j].nodeType === 1) { children.push(childNodes[j]); }
        } else if (childNodes[j].nodeType === 1 && $(childNodes[j]).is(selector)) {
          children.push(childNodes[j]);
        }
      }
    }
    return new Dom7(unique(children));
  }
  function remove() {
    for (var i = 0; i < this.length; i += 1) {
      if (this[i].parentNode) { this[i].parentNode.removeChild(this[i]); }
    }
    return this;
  }
  function add() {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var dom = this;
    var i;
    var j;
    for (i = 0; i < args.length; i += 1) {
      var toAdd = $(args[i]);
      for (j = 0; j < toAdd.length; j += 1) {
        dom[dom.length] = toAdd[j];
        dom.length += 1;
      }
    }
    return dom;
  }

  var Methods = {
    addClass: addClass,
    removeClass: removeClass,
    hasClass: hasClass,
    toggleClass: toggleClass,
    attr: attr,
    removeAttr: removeAttr,
    data: data,
    transform: transform,
    transition: transition,
    on: on,
    off: off,
    trigger: trigger,
    transitionEnd: transitionEnd,
    outerWidth: outerWidth,
    outerHeight: outerHeight,
    offset: offset,
    css: css,
    each: each,
    html: html,
    text: text,
    is: is,
    index: index,
    eq: eq,
    append: append,
    prepend: prepend,
    next: next,
    nextAll: nextAll,
    prev: prev,
    prevAll: prevAll,
    parent: parent,
    parents: parents,
    closest: closest,
    find: find,
    children: children,
    filter: filter,
    remove: remove,
    add: add,
    styles: styles,
  };

  Object.keys(Methods).forEach(function (methodName) {
    $.fn[methodName] = $.fn[methodName] || Methods[methodName];
  });

  var Utils = {
    deleteProps: function deleteProps(obj) {
      var object = obj;
      Object.keys(object).forEach(function (key) {
        try {
          object[key] = null;
        } catch (e) {
          // no getter for object
        }
        try {
          delete object[key];
        } catch (e) {
          // something got wrong
        }
      });
    },
    nextTick: function nextTick(callback, delay) {
      if ( delay === void 0 ) delay = 0;

      return setTimeout(callback, delay);
    },
    now: function now() {
      return Date.now();
    },
    getTranslate: function getTranslate(el, axis) {
      if ( axis === void 0 ) axis = 'x';

      var matrix;
      var curTransform;
      var transformMatrix;

      var curStyle = win.getComputedStyle(el, null);

      if (win.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(',').length > 6) {
          curTransform = curTransform.split(', ').map(function (a) { return a.replace(',', '.'); }).join(', ');
        }
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new win.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
      } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
        matrix = transformMatrix.toString().split(',');
      }

      if (axis === 'x') {
        // Latest Chrome and webkits Fix
        if (win.WebKitCSSMatrix) { curTransform = transformMatrix.m41; }
        // Crazy IE10 Matrix
        else if (matrix.length === 16) { curTransform = parseFloat(matrix[12]); }
        // Normal Browsers
        else { curTransform = parseFloat(matrix[4]); }
      }
      if (axis === 'y') {
        // Latest Chrome and webkits Fix
        if (win.WebKitCSSMatrix) { curTransform = transformMatrix.m42; }
        // Crazy IE10 Matrix
        else if (matrix.length === 16) { curTransform = parseFloat(matrix[13]); }
        // Normal Browsers
        else { curTransform = parseFloat(matrix[5]); }
      }
      return curTransform || 0;
    },
    parseUrlQuery: function parseUrlQuery(url) {
      var query = {};
      var urlToParse = url || win.location.href;
      var i;
      var params;
      var param;
      var length;
      if (typeof urlToParse === 'string' && urlToParse.length) {
        urlToParse = urlToParse.indexOf('?') > -1 ? urlToParse.replace(/\S*\?/, '') : '';
        params = urlToParse.split('&').filter(function (paramsPart) { return paramsPart !== ''; });
        length = params.length;

        for (i = 0; i < length; i += 1) {
          param = params[i].replace(/#\S+/g, '').split('=');
          query[decodeURIComponent(param[0])] = typeof param[1] === 'undefined' ? undefined : decodeURIComponent(param[1]) || '';
        }
      }
      return query;
    },
    isObject: function isObject(o) {
      return typeof o === 'object' && o !== null && o.constructor && o.constructor === Object;
    },
    extend: function extend() {
      var args = [], len$1 = arguments.length;
      while ( len$1-- ) args[ len$1 ] = arguments[ len$1 ];

      var to = Object(args[0]);
      for (var i = 1; i < args.length; i += 1) {
        var nextSource = args[i];
        if (nextSource !== undefined && nextSource !== null) {
          var keysArray = Object.keys(Object(nextSource));
          for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
            var nextKey = keysArray[nextIndex];
            var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
            if (desc !== undefined && desc.enumerable) {
              if (Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
                Utils.extend(to[nextKey], nextSource[nextKey]);
              } else if (!Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
                to[nextKey] = {};
                Utils.extend(to[nextKey], nextSource[nextKey]);
              } else {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
      }
      return to;
    },
  };

  var Support = (function Support() {
    return {
      touch: (win.Modernizr && win.Modernizr.touch === true) || (function checkTouch() {
        return !!((win.navigator.maxTouchPoints > 0) || ('ontouchstart' in win) || (win.DocumentTouch && doc instanceof win.DocumentTouch));
      }()),

      pointerEvents: !!win.PointerEvent && ('maxTouchPoints' in win.navigator) && win.navigator.maxTouchPoints > 0,

      observer: (function checkObserver() {
        return ('MutationObserver' in win || 'WebkitMutationObserver' in win);
      }()),

      passiveListener: (function checkPassiveListener() {
        var supportsPassive = false;
        try {
          var opts = Object.defineProperty({}, 'passive', {
            // eslint-disable-next-line
            get: function get() {
              supportsPassive = true;
            },
          });
          win.addEventListener('testPassiveListener', null, opts);
        } catch (e) {
          // No support
        }
        return supportsPassive;
      }()),

      gestures: (function checkGestures() {
        return 'ongesturestart' in win;
      }()),
    };
  }());

  var SwiperClass = function SwiperClass(params) {
    if ( params === void 0 ) params = {};

    var self = this;
    self.params = params;

    // Events
    self.eventsListeners = {};

    if (self.params && self.params.on) {
      Object.keys(self.params.on).forEach(function (eventName) {
        self.on(eventName, self.params.on[eventName]);
      });
    }
  };

  var staticAccessors = { components: { configurable: true } };

  SwiperClass.prototype.on = function on (events, handler, priority) {
    var self = this;
    if (typeof handler !== 'function') { return self; }
    var method = priority ? 'unshift' : 'push';
    events.split(' ').forEach(function (event) {
      if (!self.eventsListeners[event]) { self.eventsListeners[event] = []; }
      self.eventsListeners[event][method](handler);
    });
    return self;
  };

  SwiperClass.prototype.once = function once (events, handler, priority) {
    var self = this;
    if (typeof handler !== 'function') { return self; }
    function onceHandler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

      self.off(events, onceHandler);
      if (onceHandler.f7proxy) {
        delete onceHandler.f7proxy;
      }
      handler.apply(self, args);
    }
    onceHandler.f7proxy = handler;
    return self.on(events, onceHandler, priority);
  };

  SwiperClass.prototype.off = function off (events, handler) {
    var self = this;
    if (!self.eventsListeners) { return self; }
    events.split(' ').forEach(function (event) {
      if (typeof handler === 'undefined') {
        self.eventsListeners[event] = [];
      } else if (self.eventsListeners[event] && self.eventsListeners[event].length) {
        self.eventsListeners[event].forEach(function (eventHandler, index) {
          if (eventHandler === handler || (eventHandler.f7proxy && eventHandler.f7proxy === handler)) {
            self.eventsListeners[event].splice(index, 1);
          }
        });
      }
    });
    return self;
  };

  SwiperClass.prototype.emit = function emit () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

    var self = this;
    if (!self.eventsListeners) { return self; }
    var events;
    var data;
    var context;
    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
      events = args[0];
      data = args.slice(1, args.length);
      context = self;
    } else {
      events = args[0].events;
      data = args[0].data;
      context = args[0].context || self;
    }
    var eventsArray = Array.isArray(events) ? events : events.split(' ');
    eventsArray.forEach(function (event) {
      if (self.eventsListeners && self.eventsListeners[event]) {
        var handlers = [];
        self.eventsListeners[event].forEach(function (eventHandler) {
          handlers.push(eventHandler);
        });
        handlers.forEach(function (eventHandler) {
          eventHandler.apply(context, data);
        });
      }
    });
    return self;
  };

  SwiperClass.prototype.useModulesParams = function useModulesParams (instanceParams) {
    var instance = this;
    if (!instance.modules) { return; }
    Object.keys(instance.modules).forEach(function (moduleName) {
      var module = instance.modules[moduleName];
      // Extend params
      if (module.params) {
        Utils.extend(instanceParams, module.params);
      }
    });
  };

  SwiperClass.prototype.useModules = function useModules (modulesParams) {
      if ( modulesParams === void 0 ) modulesParams = {};

    var instance = this;
    if (!instance.modules) { return; }
    Object.keys(instance.modules).forEach(function (moduleName) {
      var module = instance.modules[moduleName];
      var moduleParams = modulesParams[moduleName] || {};
      // Extend instance methods and props
      if (module.instance) {
        Object.keys(module.instance).forEach(function (modulePropName) {
          var moduleProp = module.instance[modulePropName];
          if (typeof moduleProp === 'function') {
            instance[modulePropName] = moduleProp.bind(instance);
          } else {
            instance[modulePropName] = moduleProp;
          }
        });
      }
      // Add event listeners
      if (module.on && instance.on) {
        Object.keys(module.on).forEach(function (moduleEventName) {
          instance.on(moduleEventName, module.on[moduleEventName]);
        });
      }

      // Module create callback
      if (module.create) {
        module.create.bind(instance)(moduleParams);
      }
    });
  };

  staticAccessors.components.set = function (components) {
    var Class = this;
    if (!Class.use) { return; }
    Class.use(components);
  };

  SwiperClass.installModule = function installModule (module) {
      var params = [], len = arguments.length - 1;
      while ( len-- > 0 ) params[ len ] = arguments[ len + 1 ];

    var Class = this;
    if (!Class.prototype.modules) { Class.prototype.modules = {}; }
    var name = module.name || (((Object.keys(Class.prototype.modules).length) + "_" + (Utils.now())));
    Class.prototype.modules[name] = module;
    // Prototype
    if (module.proto) {
      Object.keys(module.proto).forEach(function (key) {
        Class.prototype[key] = module.proto[key];
      });
    }
    // Class
    if (module.static) {
      Object.keys(module.static).forEach(function (key) {
        Class[key] = module.static[key];
      });
    }
    // Callback
    if (module.install) {
      module.install.apply(Class, params);
    }
    return Class;
  };

  SwiperClass.use = function use (module) {
      var params = [], len = arguments.length - 1;
      while ( len-- > 0 ) params[ len ] = arguments[ len + 1 ];

    var Class = this;
    if (Array.isArray(module)) {
      module.forEach(function (m) { return Class.installModule(m); });
      return Class;
    }
    return Class.installModule.apply(Class, [ module ].concat( params ));
  };

  Object.defineProperties( SwiperClass, staticAccessors );

  function updateSize () {
    var swiper = this;
    var width;
    var height;
    var $el = swiper.$el;
    if (typeof swiper.params.width !== 'undefined') {
      width = swiper.params.width;
    } else {
      width = $el[0].clientWidth;
    }
    if (typeof swiper.params.height !== 'undefined') {
      height = swiper.params.height;
    } else {
      height = $el[0].clientHeight;
    }
    if ((width === 0 && swiper.isHorizontal()) || (height === 0 && swiper.isVertical())) {
      return;
    }

    // Subtract paddings
    width = width - parseInt($el.css('padding-left'), 10) - parseInt($el.css('padding-right'), 10);
    height = height - parseInt($el.css('padding-top'), 10) - parseInt($el.css('padding-bottom'), 10);

    Utils.extend(swiper, {
      width: width,
      height: height,
      size: swiper.isHorizontal() ? width : height,
    });
  }

  function updateSlides () {
    var swiper = this;
    var params = swiper.params;

    var $wrapperEl = swiper.$wrapperEl;
    var swiperSize = swiper.size;
    var rtl = swiper.rtlTranslate;
    var wrongRTL = swiper.wrongRTL;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    var slides = $wrapperEl.children(("." + (swiper.params.slideClass)));
    var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    var snapGrid = [];
    var slidesGrid = [];
    var slidesSizesGrid = [];

    function slidesForMargin(slideIndex) {
      if (!params.cssMode) { return true; }
      if (slideIndex === slides.length - 1) {
        return false;
      }
      return true;
    }

    var offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === 'function') {
      offsetBefore = params.slidesOffsetBefore.call(swiper);
    }

    var offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === 'function') {
      offsetAfter = params.slidesOffsetAfter.call(swiper);
    }

    var previousSnapGridLength = swiper.snapGrid.length;
    var previousSlidesGridLength = swiper.snapGrid.length;

    var spaceBetween = params.spaceBetween;
    var slidePosition = -offsetBefore;
    var prevSlideSize = 0;
    var index = 0;
    if (typeof swiperSize === 'undefined') {
      return;
    }
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
      spaceBetween = (parseFloat(spaceBetween.replace('%', '')) / 100) * swiperSize;
    }

    swiper.virtualSize = -spaceBetween;

    // reset margins
    if (rtl) { slides.css({ marginLeft: '', marginTop: '' }); }
    else { slides.css({ marginRight: '', marginBottom: '' }); }

    var slidesNumberEvenToRows;
    if (params.slidesPerColumn > 1) {
      if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
        slidesNumberEvenToRows = slidesLength;
      } else {
        slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
      }
      if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
        slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
      }
    }

    // Calc slides
    var slideSize;
    var slidesPerColumn = params.slidesPerColumn;
    var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
    var numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);
    for (var i = 0; i < slidesLength; i += 1) {
      slideSize = 0;
      var slide = slides.eq(i);
      if (params.slidesPerColumn > 1) {
        // Set slides order
        var newSlideOrderIndex = (void 0);
        var column = (void 0);
        var row = (void 0);
        if (params.slidesPerColumnFill === 'row' && params.slidesPerGroup > 1) {
          var groupIndex = Math.floor(i / (params.slidesPerGroup * params.slidesPerColumn));
          var slideIndexInGroup = i - params.slidesPerColumn * params.slidesPerGroup * groupIndex;
          var columnsInGroup = groupIndex === 0
            ? params.slidesPerGroup
            : Math.min(Math.ceil((slidesLength - groupIndex * slidesPerColumn * params.slidesPerGroup) / slidesPerColumn), params.slidesPerGroup);
          row = Math.floor(slideIndexInGroup / columnsInGroup);
          column = (slideIndexInGroup - row * columnsInGroup) + groupIndex * params.slidesPerGroup;

          newSlideOrderIndex = column + ((row * slidesNumberEvenToRows) / slidesPerColumn);
          slide
            .css({
              '-webkit-box-ordinal-group': newSlideOrderIndex,
              '-moz-box-ordinal-group': newSlideOrderIndex,
              '-ms-flex-order': newSlideOrderIndex,
              '-webkit-order': newSlideOrderIndex,
              order: newSlideOrderIndex,
            });
        } else if (params.slidesPerColumnFill === 'column') {
          column = Math.floor(i / slidesPerColumn);
          row = i - (column * slidesPerColumn);
          if (column > numFullColumns || (column === numFullColumns && row === slidesPerColumn - 1)) {
            row += 1;
            if (row >= slidesPerColumn) {
              row = 0;
              column += 1;
            }
          }
        } else {
          row = Math.floor(i / slidesPerRow);
          column = i - (row * slidesPerRow);
        }
        slide.css(
          ("margin-" + (swiper.isHorizontal() ? 'top' : 'left')),
          (row !== 0 && params.spaceBetween) && (((params.spaceBetween) + "px"))
        );
      }
      if (slide.css('display') === 'none') { continue; } // eslint-disable-line

      if (params.slidesPerView === 'auto') {
        var slideStyles = win.getComputedStyle(slide[0], null);
        var currentTransform = slide[0].style.transform;
        var currentWebKitTransform = slide[0].style.webkitTransform;
        if (currentTransform) {
          slide[0].style.transform = 'none';
        }
        if (currentWebKitTransform) {
          slide[0].style.webkitTransform = 'none';
        }
        if (params.roundLengths) {
          slideSize = swiper.isHorizontal()
            ? slide.outerWidth(true)
            : slide.outerHeight(true);
        } else {
          // eslint-disable-next-line
          if (swiper.isHorizontal()) {
            var width = parseFloat(slideStyles.getPropertyValue('width'));
            var paddingLeft = parseFloat(slideStyles.getPropertyValue('padding-left'));
            var paddingRight = parseFloat(slideStyles.getPropertyValue('padding-right'));
            var marginLeft = parseFloat(slideStyles.getPropertyValue('margin-left'));
            var marginRight = parseFloat(slideStyles.getPropertyValue('margin-right'));
            var boxSizing = slideStyles.getPropertyValue('box-sizing');
            if (boxSizing && boxSizing === 'border-box') {
              slideSize = width + marginLeft + marginRight;
            } else {
              slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight;
            }
          } else {
            var height = parseFloat(slideStyles.getPropertyValue('height'));
            var paddingTop = parseFloat(slideStyles.getPropertyValue('padding-top'));
            var paddingBottom = parseFloat(slideStyles.getPropertyValue('padding-bottom'));
            var marginTop = parseFloat(slideStyles.getPropertyValue('margin-top'));
            var marginBottom = parseFloat(slideStyles.getPropertyValue('margin-bottom'));
            var boxSizing$1 = slideStyles.getPropertyValue('box-sizing');
            if (boxSizing$1 && boxSizing$1 === 'border-box') {
              slideSize = height + marginTop + marginBottom;
            } else {
              slideSize = height + paddingTop + paddingBottom + marginTop + marginBottom;
            }
          }
        }
        if (currentTransform) {
          slide[0].style.transform = currentTransform;
        }
        if (currentWebKitTransform) {
          slide[0].style.webkitTransform = currentWebKitTransform;
        }
        if (params.roundLengths) { slideSize = Math.floor(slideSize); }
      } else {
        slideSize = (swiperSize - ((params.slidesPerView - 1) * spaceBetween)) / params.slidesPerView;
        if (params.roundLengths) { slideSize = Math.floor(slideSize); }

        if (slides[i]) {
          if (swiper.isHorizontal()) {
            slides[i].style.width = slideSize + "px";
          } else {
            slides[i].style.height = slideSize + "px";
          }
        }
      }
      if (slides[i]) {
        slides[i].swiperSlideSize = slideSize;
      }
      slidesSizesGrid.push(slideSize);


      if (params.centeredSlides) {
        slidePosition = slidePosition + (slideSize / 2) + (prevSlideSize / 2) + spaceBetween;
        if (prevSlideSize === 0 && i !== 0) { slidePosition = slidePosition - (swiperSize / 2) - spaceBetween; }
        if (i === 0) { slidePosition = slidePosition - (swiperSize / 2) - spaceBetween; }
        if (Math.abs(slidePosition) < 1 / 1000) { slidePosition = 0; }
        if (params.roundLengths) { slidePosition = Math.floor(slidePosition); }
        if ((index) % params.slidesPerGroup === 0) { snapGrid.push(slidePosition); }
        slidesGrid.push(slidePosition);
      } else {
        if (params.roundLengths) { slidePosition = Math.floor(slidePosition); }
        if ((index) % params.slidesPerGroup === 0) { snapGrid.push(slidePosition); }
        slidesGrid.push(slidePosition);
        slidePosition = slidePosition + slideSize + spaceBetween;
      }

      swiper.virtualSize += slideSize + spaceBetween;

      prevSlideSize = slideSize;

      index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    var newSlidesGrid;

    if (
      rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
      $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") });
    }
    if (params.setWrapperSize) {
      if (swiper.isHorizontal()) { $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
      else { $wrapperEl.css({ height: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
    }

    if (params.slidesPerColumn > 1) {
      swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
      swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
      if (swiper.isHorizontal()) { $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
      else { $wrapperEl.css({ height: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
      if (params.centeredSlides) {
        newSlidesGrid = [];
        for (var i$1 = 0; i$1 < snapGrid.length; i$1 += 1) {
          var slidesGridItem = snapGrid[i$1];
          if (params.roundLengths) { slidesGridItem = Math.floor(slidesGridItem); }
          if (snapGrid[i$1] < swiper.virtualSize + snapGrid[0]) { newSlidesGrid.push(slidesGridItem); }
        }
        snapGrid = newSlidesGrid;
      }
    }

    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
      newSlidesGrid = [];
      for (var i$2 = 0; i$2 < snapGrid.length; i$2 += 1) {
        var slidesGridItem$1 = snapGrid[i$2];
        if (params.roundLengths) { slidesGridItem$1 = Math.floor(slidesGridItem$1); }
        if (snapGrid[i$2] <= swiper.virtualSize - swiperSize) {
          newSlidesGrid.push(slidesGridItem$1);
        }
      }
      snapGrid = newSlidesGrid;
      if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
        snapGrid.push(swiper.virtualSize - swiperSize);
      }
    }
    if (snapGrid.length === 0) { snapGrid = [0]; }

    if (params.spaceBetween !== 0) {
      if (swiper.isHorizontal()) {
        if (rtl) { slides.filter(slidesForMargin).css({ marginLeft: (spaceBetween + "px") }); }
        else { slides.filter(slidesForMargin).css({ marginRight: (spaceBetween + "px") }); }
      } else { slides.filter(slidesForMargin).css({ marginBottom: (spaceBetween + "px") }); }
    }

    if (params.centeredSlides && params.centeredSlidesBounds) {
      var allSlidesSize = 0;
      slidesSizesGrid.forEach(function (slideSizeValue) {
        allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
      });
      allSlidesSize -= params.spaceBetween;
      var maxSnap = allSlidesSize - swiperSize;
      snapGrid = snapGrid.map(function (snap) {
        if (snap < 0) { return -offsetBefore; }
        if (snap > maxSnap) { return maxSnap + offsetAfter; }
        return snap;
      });
    }

    if (params.centerInsufficientSlides) {
      var allSlidesSize$1 = 0;
      slidesSizesGrid.forEach(function (slideSizeValue) {
        allSlidesSize$1 += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
      });
      allSlidesSize$1 -= params.spaceBetween;
      if (allSlidesSize$1 < swiperSize) {
        var allSlidesOffset = (swiperSize - allSlidesSize$1) / 2;
        snapGrid.forEach(function (snap, snapIndex) {
          snapGrid[snapIndex] = snap - allSlidesOffset;
        });
        slidesGrid.forEach(function (snap, snapIndex) {
          slidesGrid[snapIndex] = snap + allSlidesOffset;
        });
      }
    }

    Utils.extend(swiper, {
      slides: slides,
      snapGrid: snapGrid,
      slidesGrid: slidesGrid,
      slidesSizesGrid: slidesSizesGrid,
    });

    if (slidesLength !== previousSlidesLength) {
      swiper.emit('slidesLengthChange');
    }
    if (snapGrid.length !== previousSnapGridLength) {
      if (swiper.params.watchOverflow) { swiper.checkOverflow(); }
      swiper.emit('snapGridLengthChange');
    }
    if (slidesGrid.length !== previousSlidesGridLength) {
      swiper.emit('slidesGridLengthChange');
    }

    if (params.watchSlidesProgress || params.watchSlidesVisibility) {
      swiper.updateSlidesOffset();
    }
  }

  function updateAutoHeight (speed) {
    var swiper = this;
    var activeSlides = [];
    var newHeight = 0;
    var i;
    if (typeof speed === 'number') {
      swiper.setTransition(speed);
    } else if (speed === true) {
      swiper.setTransition(swiper.params.speed);
    }
    // Find slides currently in view
    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        var index = swiper.activeIndex + i;
        if (index > swiper.slides.length) { break; }
        activeSlides.push(swiper.slides.eq(index)[0]);
      }
    } else {
      activeSlides.push(swiper.slides.eq(swiper.activeIndex)[0]);
    }

    // Find new height from highest slide in view
    for (i = 0; i < activeSlides.length; i += 1) {
      if (typeof activeSlides[i] !== 'undefined') {
        var height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
      }
    }

    // Update Height
    if (newHeight) { swiper.$wrapperEl.css('height', (newHeight + "px")); }
  }

  function updateSlidesOffset () {
    var swiper = this;
    var slides = swiper.slides;
    for (var i = 0; i < slides.length; i += 1) {
      slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
    }
  }

  function updateSlidesProgress (translate) {
    if ( translate === void 0 ) translate = (this && this.translate) || 0;

    var swiper = this;
    var params = swiper.params;

    var slides = swiper.slides;
    var rtl = swiper.rtlTranslate;

    if (slides.length === 0) { return; }
    if (typeof slides[0].swiperSlideOffset === 'undefined') { swiper.updateSlidesOffset(); }

    var offsetCenter = -translate;
    if (rtl) { offsetCenter = translate; }

    // Visible Slides
    slides.removeClass(params.slideVisibleClass);

    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];

    for (var i = 0; i < slides.length; i += 1) {
      var slide = slides[i];
      var slideProgress = (
        (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0)) - slide.swiperSlideOffset
      ) / (slide.swiperSlideSize + params.spaceBetween);
      if (params.watchSlidesVisibility) {
        var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
        var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        var isVisible = (slideBefore >= 0 && slideBefore < swiper.size - 1)
                  || (slideAfter > 1 && slideAfter <= swiper.size)
                  || (slideBefore <= 0 && slideAfter >= swiper.size);
        if (isVisible) {
          swiper.visibleSlides.push(slide);
          swiper.visibleSlidesIndexes.push(i);
          slides.eq(i).addClass(params.slideVisibleClass);
        }
      }
      slide.progress = rtl ? -slideProgress : slideProgress;
    }
    swiper.visibleSlides = $(swiper.visibleSlides);
  }

  function updateProgress (translate) {
    var swiper = this;
    if (typeof translate === 'undefined') {
      var multiplier = swiper.rtlTranslate ? -1 : 1;
      // eslint-disable-next-line
      translate = (swiper && swiper.translate && (swiper.translate * multiplier)) || 0;
    }
    var params = swiper.params;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    var progress = swiper.progress;
    var isBeginning = swiper.isBeginning;
    var isEnd = swiper.isEnd;
    var wasBeginning = isBeginning;
    var wasEnd = isEnd;
    if (translatesDiff === 0) {
      progress = 0;
      isBeginning = true;
      isEnd = true;
    } else {
      progress = (translate - swiper.minTranslate()) / (translatesDiff);
      isBeginning = progress <= 0;
      isEnd = progress >= 1;
    }
    Utils.extend(swiper, {
      progress: progress,
      isBeginning: isBeginning,
      isEnd: isEnd,
    });

    if (params.watchSlidesProgress || params.watchSlidesVisibility) { swiper.updateSlidesProgress(translate); }

    if (isBeginning && !wasBeginning) {
      swiper.emit('reachBeginning toEdge');
    }
    if (isEnd && !wasEnd) {
      swiper.emit('reachEnd toEdge');
    }
    if ((wasBeginning && !isBeginning) || (wasEnd && !isEnd)) {
      swiper.emit('fromEdge');
    }

    swiper.emit('progress', progress);
  }

  function updateSlidesClasses () {
    var swiper = this;

    var slides = swiper.slides;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    var activeIndex = swiper.activeIndex;
    var realIndex = swiper.realIndex;
    var isVirtual = swiper.virtual && params.virtual.enabled;

    slides.removeClass(((params.slideActiveClass) + " " + (params.slideNextClass) + " " + (params.slidePrevClass) + " " + (params.slideDuplicateActiveClass) + " " + (params.slideDuplicateNextClass) + " " + (params.slideDuplicatePrevClass)));

    var activeSlide;
    if (isVirtual) {
      activeSlide = swiper.$wrapperEl.find(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + activeIndex + "\"]"));
    } else {
      activeSlide = slides.eq(activeIndex);
    }

    // Active classes
    activeSlide.addClass(params.slideActiveClass);

    if (params.loop) {
      // Duplicate to all looped slides
      if (activeSlide.hasClass(params.slideDuplicateClass)) {
        $wrapperEl
          .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + realIndex + "\"]"))
          .addClass(params.slideDuplicateActiveClass);
      } else {
        $wrapperEl
          .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]"))
          .addClass(params.slideDuplicateActiveClass);
      }
    }
    // Next Slide
    var nextSlide = activeSlide.nextAll(("." + (params.slideClass))).eq(0).addClass(params.slideNextClass);
    if (params.loop && nextSlide.length === 0) {
      nextSlide = slides.eq(0);
      nextSlide.addClass(params.slideNextClass);
    }
    // Prev Slide
    var prevSlide = activeSlide.prevAll(("." + (params.slideClass))).eq(0).addClass(params.slidePrevClass);
    if (params.loop && prevSlide.length === 0) {
      prevSlide = slides.eq(-1);
      prevSlide.addClass(params.slidePrevClass);
    }
    if (params.loop) {
      // Duplicate to all looped slides
      if (nextSlide.hasClass(params.slideDuplicateClass)) {
        $wrapperEl
          .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + (nextSlide.attr('data-swiper-slide-index')) + "\"]"))
          .addClass(params.slideDuplicateNextClass);
      } else {
        $wrapperEl
          .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + (nextSlide.attr('data-swiper-slide-index')) + "\"]"))
          .addClass(params.slideDuplicateNextClass);
      }
      if (prevSlide.hasClass(params.slideDuplicateClass)) {
        $wrapperEl
          .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + (prevSlide.attr('data-swiper-slide-index')) + "\"]"))
          .addClass(params.slideDuplicatePrevClass);
      } else {
        $wrapperEl
          .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + (prevSlide.attr('data-swiper-slide-index')) + "\"]"))
          .addClass(params.slideDuplicatePrevClass);
      }
    }
  }

  function updateActiveIndex (newActiveIndex) {
    var swiper = this;
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    var slidesGrid = swiper.slidesGrid;
    var snapGrid = swiper.snapGrid;
    var params = swiper.params;
    var previousIndex = swiper.activeIndex;
    var previousRealIndex = swiper.realIndex;
    var previousSnapIndex = swiper.snapIndex;
    var activeIndex = newActiveIndex;
    var snapIndex;
    if (typeof activeIndex === 'undefined') {
      for (var i = 0; i < slidesGrid.length; i += 1) {
        if (typeof slidesGrid[i + 1] !== 'undefined') {
          if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - ((slidesGrid[i + 1] - slidesGrid[i]) / 2)) {
            activeIndex = i;
          } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
            activeIndex = i + 1;
          }
        } else if (translate >= slidesGrid[i]) {
          activeIndex = i;
        }
      }
      // Normalize slideIndex
      if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === 'undefined') { activeIndex = 0; }
      }
    }
    if (snapGrid.indexOf(translate) >= 0) {
      snapIndex = snapGrid.indexOf(translate);
    } else {
      snapIndex = Math.floor(activeIndex / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) { snapIndex = snapGrid.length - 1; }
    if (activeIndex === previousIndex) {
      if (snapIndex !== previousSnapIndex) {
        swiper.snapIndex = snapIndex;
        swiper.emit('snapIndexChange');
      }
      return;
    }

    // Get real index
    var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);

    Utils.extend(swiper, {
      snapIndex: snapIndex,
      realIndex: realIndex,
      previousIndex: previousIndex,
      activeIndex: activeIndex,
    });
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');
    if (previousRealIndex !== realIndex) {
      swiper.emit('realIndexChange');
    }
    if (swiper.initialized || swiper.runCallbacksOnInit) {
      swiper.emit('slideChange');
    }
  }

  function updateClickedSlide (e) {
    var swiper = this;
    var params = swiper.params;
    var slide = $(e.target).closest(("." + (params.slideClass)))[0];
    var slideFound = false;
    if (slide) {
      for (var i = 0; i < swiper.slides.length; i += 1) {
        if (swiper.slides[i] === slide) { slideFound = true; }
      }
    }

    if (slide && slideFound) {
      swiper.clickedSlide = slide;
      if (swiper.virtual && swiper.params.virtual.enabled) {
        swiper.clickedIndex = parseInt($(slide).attr('data-swiper-slide-index'), 10);
      } else {
        swiper.clickedIndex = $(slide).index();
      }
    } else {
      swiper.clickedSlide = undefined;
      swiper.clickedIndex = undefined;
      return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
      swiper.slideToClickedSlide();
    }
  }

  var update = {
    updateSize: updateSize,
    updateSlides: updateSlides,
    updateAutoHeight: updateAutoHeight,
    updateSlidesOffset: updateSlidesOffset,
    updateSlidesProgress: updateSlidesProgress,
    updateProgress: updateProgress,
    updateSlidesClasses: updateSlidesClasses,
    updateActiveIndex: updateActiveIndex,
    updateClickedSlide: updateClickedSlide,
  };

  function getTranslate (axis) {
    if ( axis === void 0 ) axis = this.isHorizontal() ? 'x' : 'y';

    var swiper = this;

    var params = swiper.params;
    var rtl = swiper.rtlTranslate;
    var translate = swiper.translate;
    var $wrapperEl = swiper.$wrapperEl;

    if (params.virtualTranslate) {
      return rtl ? -translate : translate;
    }
    if (params.cssMode) {
      return translate;
    }

    var currentTranslate = Utils.getTranslate($wrapperEl[0], axis);
    if (rtl) { currentTranslate = -currentTranslate; }

    return currentTranslate || 0;
  }

  function setTranslate (translate, byController) {
    var swiper = this;
    var rtl = swiper.rtlTranslate;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    var wrapperEl = swiper.wrapperEl;
    var progress = swiper.progress;
    var x = 0;
    var y = 0;
    var z = 0;

    if (swiper.isHorizontal()) {
      x = rtl ? -translate : translate;
    } else {
      y = translate;
    }

    if (params.roundLengths) {
      x = Math.floor(x);
      y = Math.floor(y);
    }

    if (params.cssMode) {
      wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
    } else if (!params.virtualTranslate) {
      $wrapperEl.transform(("translate3d(" + x + "px, " + y + "px, " + z + "px)"));
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;

    // Check if we need to update progress
    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) {
      newProgress = 0;
    } else {
      newProgress = (translate - swiper.minTranslate()) / (translatesDiff);
    }
    if (newProgress !== progress) {
      swiper.updateProgress(translate);
    }

    swiper.emit('setTranslate', swiper.translate, byController);
  }

  function minTranslate () {
    return (-this.snapGrid[0]);
  }

  function maxTranslate () {
    return (-this.snapGrid[this.snapGrid.length - 1]);
  }

  function translateTo (translate, speed, runCallbacks, translateBounds, internal) {
    var obj;

    if ( translate === void 0 ) translate = 0;
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;
    if ( translateBounds === void 0 ) translateBounds = true;
    var swiper = this;

    var params = swiper.params;
    var wrapperEl = swiper.wrapperEl;

    if (swiper.animating && params.preventInteractionOnTransition) {
      return false;
    }

    var minTranslate = swiper.minTranslate();
    var maxTranslate = swiper.maxTranslate();
    var newTranslate;
    if (translateBounds && translate > minTranslate) { newTranslate = minTranslate; }
    else if (translateBounds && translate < maxTranslate) { newTranslate = maxTranslate; }
    else { newTranslate = translate; }

    // Update progress
    swiper.updateProgress(newTranslate);

    if (params.cssMode) {
      var isH = swiper.isHorizontal();
      if (speed === 0) {
        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
      } else {
        // eslint-disable-next-line
        if (wrapperEl.scrollTo) {
          wrapperEl.scrollTo(( obj = {}, obj[isH ? 'left' : 'top'] = -newTranslate, obj.behavior = 'smooth', obj ));
        } else {
          wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
        }
      }
      return true;
    }

    if (speed === 0) {
      swiper.setTransition(0);
      swiper.setTranslate(newTranslate);
      if (runCallbacks) {
        swiper.emit('beforeTransitionStart', speed, internal);
        swiper.emit('transitionEnd');
      }
    } else {
      swiper.setTransition(speed);
      swiper.setTranslate(newTranslate);
      if (runCallbacks) {
        swiper.emit('beforeTransitionStart', speed, internal);
        swiper.emit('transitionStart');
      }
      if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onTranslateToWrapperTransitionEnd) {
          swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) { return; }
            if (e.target !== this) { return; }
            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
            swiper.onTranslateToWrapperTransitionEnd = null;
            delete swiper.onTranslateToWrapperTransitionEnd;
            if (runCallbacks) {
              swiper.emit('transitionEnd');
            }
          };
        }
        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
      }
    }

    return true;
  }

  var translate = {
    getTranslate: getTranslate,
    setTranslate: setTranslate,
    minTranslate: minTranslate,
    maxTranslate: maxTranslate,
    translateTo: translateTo,
  };

  function setTransition (duration, byController) {
    var swiper = this;

    if (!swiper.params.cssMode) {
      swiper.$wrapperEl.transition(duration);
    }

    swiper.emit('setTransition', duration, byController);
  }

  function transitionStart (runCallbacks, direction) {
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var activeIndex = swiper.activeIndex;
    var params = swiper.params;
    var previousIndex = swiper.previousIndex;
    if (params.cssMode) { return; }
    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }

    var dir = direction;
    if (!dir) {
      if (activeIndex > previousIndex) { dir = 'next'; }
      else if (activeIndex < previousIndex) { dir = 'prev'; }
      else { dir = 'reset'; }
    }

    swiper.emit('transitionStart');

    if (runCallbacks && activeIndex !== previousIndex) {
      if (dir === 'reset') {
        swiper.emit('slideResetTransitionStart');
        return;
      }
      swiper.emit('slideChangeTransitionStart');
      if (dir === 'next') {
        swiper.emit('slideNextTransitionStart');
      } else {
        swiper.emit('slidePrevTransitionStart');
      }
    }
  }

  function transitionEnd$1 (runCallbacks, direction) {
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var activeIndex = swiper.activeIndex;
    var previousIndex = swiper.previousIndex;
    var params = swiper.params;
    swiper.animating = false;
    if (params.cssMode) { return; }
    swiper.setTransition(0);

    var dir = direction;
    if (!dir) {
      if (activeIndex > previousIndex) { dir = 'next'; }
      else if (activeIndex < previousIndex) { dir = 'prev'; }
      else { dir = 'reset'; }
    }

    swiper.emit('transitionEnd');

    if (runCallbacks && activeIndex !== previousIndex) {
      if (dir === 'reset') {
        swiper.emit('slideResetTransitionEnd');
        return;
      }
      swiper.emit('slideChangeTransitionEnd');
      if (dir === 'next') {
        swiper.emit('slideNextTransitionEnd');
      } else {
        swiper.emit('slidePrevTransitionEnd');
      }
    }
  }

  var transition$1 = {
    setTransition: setTransition,
    transitionStart: transitionStart,
    transitionEnd: transitionEnd$1,
  };

  function slideTo (index, speed, runCallbacks, internal) {
    var obj;

    if ( index === void 0 ) index = 0;
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;
    var swiper = this;
    var slideIndex = index;
    if (slideIndex < 0) { slideIndex = 0; }

    var params = swiper.params;
    var snapGrid = swiper.snapGrid;
    var slidesGrid = swiper.slidesGrid;
    var previousIndex = swiper.previousIndex;
    var activeIndex = swiper.activeIndex;
    var rtl = swiper.rtlTranslate;
    var wrapperEl = swiper.wrapperEl;
    if (swiper.animating && params.preventInteractionOnTransition) {
      return false;
    }

    var snapIndex = Math.floor(slideIndex / params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) { snapIndex = snapGrid.length - 1; }

    if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
      swiper.emit('beforeSlideChangeStart');
    }

    var translate = -snapGrid[snapIndex];

    // Update progress
    swiper.updateProgress(translate);

    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
      for (var i = 0; i < slidesGrid.length; i += 1) {
        if (-Math.floor(translate * 100) >= Math.floor(slidesGrid[i] * 100)) {
          slideIndex = i;
        }
      }
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
      if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
        return false;
      }
      if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
        if ((activeIndex || 0) !== slideIndex) { return false; }
      }
    }

    var direction;
    if (slideIndex > activeIndex) { direction = 'next'; }
    else if (slideIndex < activeIndex) { direction = 'prev'; }
    else { direction = 'reset'; }


    // Update Index
    if ((rtl && -translate === swiper.translate) || (!rtl && translate === swiper.translate)) {
      swiper.updateActiveIndex(slideIndex);
      // Update Height
      if (params.autoHeight) {
        swiper.updateAutoHeight();
      }
      swiper.updateSlidesClasses();
      if (params.effect !== 'slide') {
        swiper.setTranslate(translate);
      }
      if (direction !== 'reset') {
        swiper.transitionStart(runCallbacks, direction);
        swiper.transitionEnd(runCallbacks, direction);
      }
      return false;
    }
    if (params.cssMode) {
      var isH = swiper.isHorizontal();
      if (speed === 0) {
        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -translate;
      } else {
        // eslint-disable-next-line
        if (wrapperEl.scrollTo) {
          wrapperEl.scrollTo(( obj = {}, obj[isH ? 'left' : 'top'] = -translate, obj.behavior = 'smooth', obj ));
        } else {
          wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -translate;
        }
      }
      return true;
    }

    if (speed === 0) {
      swiper.setTransition(0);
      swiper.setTranslate(translate);
      swiper.updateActiveIndex(slideIndex);
      swiper.updateSlidesClasses();
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    } else {
      swiper.setTransition(speed);
      swiper.setTranslate(translate);
      swiper.updateActiveIndex(slideIndex);
      swiper.updateSlidesClasses();
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.transitionStart(runCallbacks, direction);
      if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) {
          swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) { return; }
            if (e.target !== this) { return; }
            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
          };
        }
        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
      }
    }

    return true;
  }

  function slideToLoop (index, speed, runCallbacks, internal) {
    if ( index === void 0 ) index = 0;
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var newIndex = index;
    if (swiper.params.loop) {
      newIndex += swiper.loopedSlides;
    }

    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
  }

  /* eslint no-unused-vars: "off" */
  function slideNext (speed, runCallbacks, internal) {
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var params = swiper.params;
    var animating = swiper.animating;
    if (params.loop) {
      if (animating) { return false; }
      swiper.loopFix();
      // eslint-disable-next-line
      swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
      return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
    }
    return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
  }

  /* eslint no-unused-vars: "off" */
  function slidePrev (speed, runCallbacks, internal) {
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var params = swiper.params;
    var animating = swiper.animating;
    var snapGrid = swiper.snapGrid;
    var slidesGrid = swiper.slidesGrid;
    var rtlTranslate = swiper.rtlTranslate;

    if (params.loop) {
      if (animating) { return false; }
      swiper.loopFix();
      // eslint-disable-next-line
      swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    var translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
      if (val < 0) { return -Math.floor(Math.abs(val)); }
      return Math.floor(val);
    }
    var normalizedTranslate = normalize(translate);
    var normalizedSnapGrid = snapGrid.map(function (val) { return normalize(val); });
    var normalizedSlidesGrid = slidesGrid.map(function (val) { return normalize(val); });

    var currentSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate)];
    var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === 'undefined' && params.cssMode) {
      snapGrid.forEach(function (snap) {
        if (!prevSnap && normalizedTranslate >= snap) { prevSnap = snap; }
      });
    }
    var prevIndex;
    if (typeof prevSnap !== 'undefined') {
      prevIndex = slidesGrid.indexOf(prevSnap);
      if (prevIndex < 0) { prevIndex = swiper.activeIndex - 1; }
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
  }

  /* eslint no-unused-vars: "off" */
  function slideReset (speed, runCallbacks, internal) {
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
  }

  /* eslint no-unused-vars: "off" */
  function slideToClosest (speed, runCallbacks, internal, threshold) {
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;
    if ( threshold === void 0 ) threshold = 0.5;

    var swiper = this;
    var index = swiper.activeIndex;
    var snapIndex = Math.floor(index / swiper.params.slidesPerGroup);

    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

    if (translate >= swiper.snapGrid[snapIndex]) {
      // The current translate is on or after the current snap index, so the choice
      // is between the current index and the one after it.
      var currentSnap = swiper.snapGrid[snapIndex];
      var nextSnap = swiper.snapGrid[snapIndex + 1];
      if ((translate - currentSnap) > (nextSnap - currentSnap) * threshold) {
        index += swiper.params.slidesPerGroup;
      }
    } else {
      // The current translate is before the current snap index, so the choice
      // is between the current index and the one before it.
      var prevSnap = swiper.snapGrid[snapIndex - 1];
      var currentSnap$1 = swiper.snapGrid[snapIndex];
      if ((translate - prevSnap) <= (currentSnap$1 - prevSnap) * threshold) {
        index -= swiper.params.slidesPerGroup;
      }
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.snapGrid.length - 1);

    return swiper.slideTo(index, speed, runCallbacks, internal);
  }

  function slideToClickedSlide () {
    var swiper = this;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;

    var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    var slideToIndex = swiper.clickedIndex;
    var realIndex;
    if (params.loop) {
      if (swiper.animating) { return; }
      realIndex = parseInt($(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
      if (params.centeredSlides) {
        if (
          (slideToIndex < swiper.loopedSlides - (slidesPerView / 2))
          || (slideToIndex > (swiper.slides.length - swiper.loopedSlides) + (slidesPerView / 2))
        ) {
          swiper.loopFix();
          slideToIndex = $wrapperEl
            .children(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + (params.slideDuplicateClass) + ")"))
            .eq(0)
            .index();

          Utils.nextTick(function () {
            swiper.slideTo(slideToIndex);
          });
        } else {
          swiper.slideTo(slideToIndex);
        }
      } else if (slideToIndex > swiper.slides.length - slidesPerView) {
        swiper.loopFix();
        slideToIndex = $wrapperEl
          .children(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + (params.slideDuplicateClass) + ")"))
          .eq(0)
          .index();

        Utils.nextTick(function () {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else {
      swiper.slideTo(slideToIndex);
    }
  }

  var slide = {
    slideTo: slideTo,
    slideToLoop: slideToLoop,
    slideNext: slideNext,
    slidePrev: slidePrev,
    slideReset: slideReset,
    slideToClosest: slideToClosest,
    slideToClickedSlide: slideToClickedSlide,
  };

  function loopCreate () {
    var swiper = this;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    // Remove duplicated slides
    $wrapperEl.children(("." + (params.slideClass) + "." + (params.slideDuplicateClass))).remove();

    var slides = $wrapperEl.children(("." + (params.slideClass)));

    if (params.loopFillGroupWithBlank) {
      var blankSlidesNum = params.slidesPerGroup - (slides.length % params.slidesPerGroup);
      if (blankSlidesNum !== params.slidesPerGroup) {
        for (var i = 0; i < blankSlidesNum; i += 1) {
          var blankNode = $(doc.createElement('div')).addClass(((params.slideClass) + " " + (params.slideBlankClass)));
          $wrapperEl.append(blankNode);
        }
        slides = $wrapperEl.children(("." + (params.slideClass)));
      }
    }

    if (params.slidesPerView === 'auto' && !params.loopedSlides) { params.loopedSlides = slides.length; }

    swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
    swiper.loopedSlides += params.loopAdditionalSlides;
    if (swiper.loopedSlides > slides.length) {
      swiper.loopedSlides = slides.length;
    }

    var prependSlides = [];
    var appendSlides = [];
    slides.each(function (index, el) {
      var slide = $(el);
      if (index < swiper.loopedSlides) { appendSlides.push(el); }
      if (index < slides.length && index >= slides.length - swiper.loopedSlides) { prependSlides.push(el); }
      slide.attr('data-swiper-slide-index', index);
    });
    for (var i$1 = 0; i$1 < appendSlides.length; i$1 += 1) {
      $wrapperEl.append($(appendSlides[i$1].cloneNode(true)).addClass(params.slideDuplicateClass));
    }
    for (var i$2 = prependSlides.length - 1; i$2 >= 0; i$2 -= 1) {
      $wrapperEl.prepend($(prependSlides[i$2].cloneNode(true)).addClass(params.slideDuplicateClass));
    }
  }

  function loopFix () {
    var swiper = this;

    swiper.emit('beforeLoopFix');

    var activeIndex = swiper.activeIndex;
    var slides = swiper.slides;
    var loopedSlides = swiper.loopedSlides;
    var allowSlidePrev = swiper.allowSlidePrev;
    var allowSlideNext = swiper.allowSlideNext;
    var snapGrid = swiper.snapGrid;
    var rtl = swiper.rtlTranslate;
    var newIndex;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;

    var snapTranslate = -snapGrid[activeIndex];
    var diff = snapTranslate - swiper.getTranslate();

    // Fix For Negative Oversliding
    if (activeIndex < loopedSlides) {
      newIndex = (slides.length - (loopedSlides * 3)) + activeIndex;
      newIndex += loopedSlides;
      var slideChanged = swiper.slideTo(newIndex, 0, false, true);
      if (slideChanged && diff !== 0) {
        swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
      }
    } else if (activeIndex >= slides.length - loopedSlides) {
      // Fix For Positive Oversliding
      newIndex = -slides.length + activeIndex + loopedSlides;
      newIndex += loopedSlides;
      var slideChanged$1 = swiper.slideTo(newIndex, 0, false, true);
      if (slideChanged$1 && diff !== 0) {
        swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
      }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;

    swiper.emit('loopFix');
  }

  function loopDestroy () {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl;
    var params = swiper.params;
    var slides = swiper.slides;
    $wrapperEl.children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + ",." + (params.slideClass) + "." + (params.slideBlankClass))).remove();
    slides.removeAttr('data-swiper-slide-index');
  }

  var loop = {
    loopCreate: loopCreate,
    loopFix: loopFix,
    loopDestroy: loopDestroy,
  };

  function setGrabCursor (moving) {
    var swiper = this;
    if (Support.touch || !swiper.params.simulateTouch || (swiper.params.watchOverflow && swiper.isLocked) || swiper.params.cssMode) { return; }
    var el = swiper.el;
    el.style.cursor = 'move';
    el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
    el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
    el.style.cursor = moving ? 'grabbing' : 'grab';
  }

  function unsetGrabCursor () {
    var swiper = this;
    if (Support.touch || (swiper.params.watchOverflow && swiper.isLocked) || swiper.params.cssMode) { return; }
    swiper.el.style.cursor = '';
  }

  var grabCursor = {
    setGrabCursor: setGrabCursor,
    unsetGrabCursor: unsetGrabCursor,
  };

  function appendSlide (slides) {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl;
    var params = swiper.params;
    if (params.loop) {
      swiper.loopDestroy();
    }
    if (typeof slides === 'object' && 'length' in slides) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i]) { $wrapperEl.append(slides[i]); }
      }
    } else {
      $wrapperEl.append(slides);
    }
    if (params.loop) {
      swiper.loopCreate();
    }
    if (!(params.observer && Support.observer)) {
      swiper.update();
    }
  }

  function prependSlide (slides) {
    var swiper = this;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    var activeIndex = swiper.activeIndex;

    if (params.loop) {
      swiper.loopDestroy();
    }
    var newActiveIndex = activeIndex + 1;
    if (typeof slides === 'object' && 'length' in slides) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i]) { $wrapperEl.prepend(slides[i]); }
      }
      newActiveIndex = activeIndex + slides.length;
    } else {
      $wrapperEl.prepend(slides);
    }
    if (params.loop) {
      swiper.loopCreate();
    }
    if (!(params.observer && Support.observer)) {
      swiper.update();
    }
    swiper.slideTo(newActiveIndex, 0, false);
  }

  function addSlide (index, slides) {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl;
    var params = swiper.params;
    var activeIndex = swiper.activeIndex;
    var activeIndexBuffer = activeIndex;
    if (params.loop) {
      activeIndexBuffer -= swiper.loopedSlides;
      swiper.loopDestroy();
      swiper.slides = $wrapperEl.children(("." + (params.slideClass)));
    }
    var baseLength = swiper.slides.length;
    if (index <= 0) {
      swiper.prependSlide(slides);
      return;
    }
    if (index >= baseLength) {
      swiper.appendSlide(slides);
      return;
    }
    var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;

    var slidesBuffer = [];
    for (var i = baseLength - 1; i >= index; i -= 1) {
      var currentSlide = swiper.slides.eq(i);
      currentSlide.remove();
      slidesBuffer.unshift(currentSlide);
    }

    if (typeof slides === 'object' && 'length' in slides) {
      for (var i$1 = 0; i$1 < slides.length; i$1 += 1) {
        if (slides[i$1]) { $wrapperEl.append(slides[i$1]); }
      }
      newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else {
      $wrapperEl.append(slides);
    }

    for (var i$2 = 0; i$2 < slidesBuffer.length; i$2 += 1) {
      $wrapperEl.append(slidesBuffer[i$2]);
    }

    if (params.loop) {
      swiper.loopCreate();
    }
    if (!(params.observer && Support.observer)) {
      swiper.update();
    }
    if (params.loop) {
      swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    } else {
      swiper.slideTo(newActiveIndex, 0, false);
    }
  }

  function removeSlide (slidesIndexes) {
    var swiper = this;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    var activeIndex = swiper.activeIndex;

    var activeIndexBuffer = activeIndex;
    if (params.loop) {
      activeIndexBuffer -= swiper.loopedSlides;
      swiper.loopDestroy();
      swiper.slides = $wrapperEl.children(("." + (params.slideClass)));
    }
    var newActiveIndex = activeIndexBuffer;
    var indexToRemove;

    if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
      for (var i = 0; i < slidesIndexes.length; i += 1) {
        indexToRemove = slidesIndexes[i];
        if (swiper.slides[indexToRemove]) { swiper.slides.eq(indexToRemove).remove(); }
        if (indexToRemove < newActiveIndex) { newActiveIndex -= 1; }
      }
      newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
      indexToRemove = slidesIndexes;
      if (swiper.slides[indexToRemove]) { swiper.slides.eq(indexToRemove).remove(); }
      if (indexToRemove < newActiveIndex) { newActiveIndex -= 1; }
      newActiveIndex = Math.max(newActiveIndex, 0);
    }

    if (params.loop) {
      swiper.loopCreate();
    }

    if (!(params.observer && Support.observer)) {
      swiper.update();
    }
    if (params.loop) {
      swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    } else {
      swiper.slideTo(newActiveIndex, 0, false);
    }
  }

  function removeAllSlides () {
    var swiper = this;

    var slidesIndexes = [];
    for (var i = 0; i < swiper.slides.length; i += 1) {
      slidesIndexes.push(i);
    }
    swiper.removeSlide(slidesIndexes);
  }

  var manipulation = {
    appendSlide: appendSlide,
    prependSlide: prependSlide,
    addSlide: addSlide,
    removeSlide: removeSlide,
    removeAllSlides: removeAllSlides,
  };

  var Device = (function Device() {
    var platform = win.navigator.platform;
    var ua = win.navigator.userAgent;

    var device = {
      ios: false,
      android: false,
      androidChrome: false,
      desktop: false,
      iphone: false,
      ipod: false,
      ipad: false,
      edge: false,
      ie: false,
      firefox: false,
      macos: false,
      windows: false,
      cordova: !!(win.cordova || win.phonegap),
      phonegap: !!(win.cordova || win.phonegap),
      electron: false,
    };

    var screenWidth = win.screen.width;
    var screenHeight = win.screen.height;

    var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    var ie = ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
    var edge = ua.indexOf('Edge/') >= 0;
    var firefox = ua.indexOf('Gecko/') >= 0 && ua.indexOf('Firefox/') >= 0;
    var windows = platform === 'Win32';
    var electron = ua.toLowerCase().indexOf('electron') >= 0;
    var macos = platform === 'MacIntel';

    // iPadOs 13 fix
    if (!ipad
      && macos
      && Support.touch
      && (
        (screenWidth === 1024 && screenHeight === 1366) // Pro 12.9
        || (screenWidth === 834 && screenHeight === 1194) // Pro 11
        || (screenWidth === 834 && screenHeight === 1112) // Pro 10.5
        || (screenWidth === 768 && screenHeight === 1024) // other
      )
    ) {
      ipad = ua.match(/(Version)\/([\d.]+)/);
      macos = false;
    }

    device.ie = ie;
    device.edge = edge;
    device.firefox = firefox;

    // Android
    if (android && !windows) {
      device.os = 'android';
      device.osVersion = android[2];
      device.android = true;
      device.androidChrome = ua.toLowerCase().indexOf('chrome') >= 0;
    }
    if (ipad || iphone || ipod) {
      device.os = 'ios';
      device.ios = true;
    }
    // iOS
    if (iphone && !ipod) {
      device.osVersion = iphone[2].replace(/_/g, '.');
      device.iphone = true;
    }
    if (ipad) {
      device.osVersion = ipad[2].replace(/_/g, '.');
      device.ipad = true;
    }
    if (ipod) {
      device.osVersion = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
      device.ipod = true;
    }
    // iOS 8+ changed UA
    if (device.ios && device.osVersion && ua.indexOf('Version/') >= 0) {
      if (device.osVersion.split('.')[0] === '10') {
        device.osVersion = ua.toLowerCase().split('version/')[1].split(' ')[0];
      }
    }

    // Webview
    device.webView = !!((iphone || ipad || ipod) && (ua.match(/.*AppleWebKit(?!.*Safari)/i) || win.navigator.standalone))
      || (win.matchMedia && win.matchMedia('(display-mode: standalone)').matches);
    device.webview = device.webView;
    device.standalone = device.webView;

    // Desktop
    device.desktop = !(device.ios || device.android) || electron;
    if (device.desktop) {
      device.electron = electron;
      device.macos = macos;
      device.windows = windows;
      if (device.macos) {
        device.os = 'macos';
      }
      if (device.windows) {
        device.os = 'windows';
      }
    }

    // Pixel Ratio
    device.pixelRatio = win.devicePixelRatio || 1;

    // Export object
    return device;
  }());

  function onTouchStart (event) {
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params;
    var touches = swiper.touches;

    if (swiper.animating && params.preventInteractionOnTransition) {
      return;
    }
    var e = event;
    if (e.originalEvent) { e = e.originalEvent; }
    var $targetEl = $(e.target);

    if (params.touchEventsTarget === 'wrapper') {
      if (!$targetEl.closest(swiper.wrapperEl).length) { return; }
    }
    data.isTouchEvent = e.type === 'touchstart';
    if (!data.isTouchEvent && 'which' in e && e.which === 3) { return; }
    if (!data.isTouchEvent && 'button' in e && e.button > 0) { return; }
    if (data.isTouched && data.isMoved) { return; }
    if (params.noSwiping && $targetEl.closest(params.noSwipingSelector ? params.noSwipingSelector : ("." + (params.noSwipingClass)))[0]) {
      swiper.allowClick = true;
      return;
    }
    if (params.swipeHandler) {
      if (!$targetEl.closest(params.swipeHandler)[0]) { return; }
    }

    touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
    touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    var startX = touches.currentX;
    var startY = touches.currentY;

    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app (UIWebView) cannot swipe-to-go-back anymore

    var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
    if (
      edgeSwipeDetection
      && ((startX <= edgeSwipeThreshold)
      || (startX >= win.screen.width - edgeSwipeThreshold))
    ) {
      return;
    }

    Utils.extend(data, {
      isTouched: true,
      isMoved: false,
      allowTouchCallbacks: true,
      isScrolling: undefined,
      startMoving: undefined,
    });

    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = Utils.now();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) { data.allowThresholdMove = false; }
    if (e.type !== 'touchstart') {
      var preventDefault = true;
      if ($targetEl.is(data.formElements)) { preventDefault = false; }
      if (
        doc.activeElement
        && $(doc.activeElement).is(data.formElements)
        && doc.activeElement !== $targetEl[0]
      ) {
        doc.activeElement.blur();
      }

      var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
      if (params.touchStartForcePreventDefault || shouldPreventDefault) {
        e.preventDefault();
      }
    }
    swiper.emit('touchStart', e);
  }

  function onTouchMove (event) {
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params;
    var touches = swiper.touches;
    var rtl = swiper.rtlTranslate;
    var e = event;
    if (e.originalEvent) { e = e.originalEvent; }
    if (!data.isTouched) {
      if (data.startMoving && data.isScrolling) {
        swiper.emit('touchMoveOpposite', e);
      }
      return;
    }
    if (data.isTouchEvent && e.type === 'mousemove') { return; }
    var targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
    var pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
    var pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;
    if (e.preventedByNestedSwiper) {
      touches.startX = pageX;
      touches.startY = pageY;
      return;
    }
    if (!swiper.allowTouchMove) {
      // isMoved = true;
      swiper.allowClick = false;
      if (data.isTouched) {
        Utils.extend(touches, {
          startX: pageX,
          startY: pageY,
          currentX: pageX,
          currentY: pageY,
        });
        data.touchStartTime = Utils.now();
      }
      return;
    }
    if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
      if (swiper.isVertical()) {
        // Vertical
        if (
          (pageY < touches.startY && swiper.translate <= swiper.maxTranslate())
          || (pageY > touches.startY && swiper.translate >= swiper.minTranslate())
        ) {
          data.isTouched = false;
          data.isMoved = false;
          return;
        }
      } else if (
        (pageX < touches.startX && swiper.translate <= swiper.maxTranslate())
        || (pageX > touches.startX && swiper.translate >= swiper.minTranslate())
      ) {
        return;
      }
    }
    if (data.isTouchEvent && doc.activeElement) {
      if (e.target === doc.activeElement && $(e.target).is(data.formElements)) {
        data.isMoved = true;
        swiper.allowClick = false;
        return;
      }
    }
    if (data.allowTouchCallbacks) {
      swiper.emit('touchMove', e);
    }
    if (e.targetTouches && e.targetTouches.length > 1) { return; }

    touches.currentX = pageX;
    touches.currentY = pageY;

    var diffX = touches.currentX - touches.startX;
    var diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt((Math.pow( diffX, 2 )) + (Math.pow( diffY, 2 ))) < swiper.params.threshold) { return; }

    if (typeof data.isScrolling === 'undefined') {
      var touchAngle;
      if ((swiper.isHorizontal() && touches.currentY === touches.startY) || (swiper.isVertical() && touches.currentX === touches.startX)) {
        data.isScrolling = false;
      } else {
        // eslint-disable-next-line
        if ((diffX * diffX) + (diffY * diffY) >= 25) {
          touchAngle = (Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180) / Math.PI;
          data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : (90 - touchAngle > params.touchAngle);
        }
      }
    }
    if (data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }
    if (typeof data.startMoving === 'undefined') {
      if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
        data.startMoving = true;
      }
    }
    if (data.isScrolling) {
      data.isTouched = false;
      return;
    }
    if (!data.startMoving) {
      return;
    }
    swiper.allowClick = false;
    if (!params.cssMode) {
      e.preventDefault();
    }
    if (params.touchMoveStopPropagation && !params.nested) {
      e.stopPropagation();
    }

    if (!data.isMoved) {
      if (params.loop) {
        swiper.loopFix();
      }
      data.startTranslate = swiper.getTranslate();
      swiper.setTransition(0);
      if (swiper.animating) {
        swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
      }
      data.allowMomentumBounce = false;
      // Grab Cursor
      if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
        swiper.setGrabCursor(true);
      }
      swiper.emit('sliderFirstMove', e);
    }
    swiper.emit('sliderMove', e);
    data.isMoved = true;

    var diff = swiper.isHorizontal() ? diffX : diffY;
    touches.diff = diff;

    diff *= params.touchRatio;
    if (rtl) { diff = -diff; }

    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    data.currentTranslate = diff + data.startTranslate;

    var disableParentSwiper = true;
    var resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) {
      resistanceRatio = 0;
    }
    if ((diff > 0 && data.currentTranslate > swiper.minTranslate())) {
      disableParentSwiper = false;
      if (params.resistance) { data.currentTranslate = (swiper.minTranslate() - 1) + (Math.pow( (-swiper.minTranslate() + data.startTranslate + diff), resistanceRatio )); }
    } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) { data.currentTranslate = (swiper.maxTranslate() + 1) - (Math.pow( (swiper.maxTranslate() - data.startTranslate - diff), resistanceRatio )); }
    }

    if (disableParentSwiper) {
      e.preventedByNestedSwiper = true;
    }

    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
      data.currentTranslate = data.startTranslate;
    }
    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
      data.currentTranslate = data.startTranslate;
    }


    // Threshold
    if (params.threshold > 0) {
      if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
        if (!data.allowThresholdMove) {
          data.allowThresholdMove = true;
          touches.startX = touches.currentX;
          touches.startY = touches.currentY;
          data.currentTranslate = data.startTranslate;
          touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
          return;
        }
      } else {
        data.currentTranslate = data.startTranslate;
        return;
      }
    }

    if (!params.followFinger || params.cssMode) { return; }

    // Update active index in free mode
    if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
    if (params.freeMode) {
      // Velocity
      if (data.velocities.length === 0) {
        data.velocities.push({
          position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
          time: data.touchStartTime,
        });
      }
      data.velocities.push({
        position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
        time: Utils.now(),
      });
    }
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate);
  }

  function onTouchEnd (event) {
    var swiper = this;
    var data = swiper.touchEventsData;

    var params = swiper.params;
    var touches = swiper.touches;
    var rtl = swiper.rtlTranslate;
    var $wrapperEl = swiper.$wrapperEl;
    var slidesGrid = swiper.slidesGrid;
    var snapGrid = swiper.snapGrid;
    var e = event;
    if (e.originalEvent) { e = e.originalEvent; }
    if (data.allowTouchCallbacks) {
      swiper.emit('touchEnd', e);
    }
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
      if (data.isMoved && params.grabCursor) {
        swiper.setGrabCursor(false);
      }
      data.isMoved = false;
      data.startMoving = false;
      return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(false);
    }

    // Time diff
    var touchEndTime = Utils.now();
    var timeDiff = touchEndTime - data.touchStartTime;

    // Tap, doubleTap, Click
    if (swiper.allowClick) {
      swiper.updateClickedSlide(e);
      swiper.emit('tap click', e);
      if (timeDiff < 300 && (touchEndTime - data.lastClickTime) < 300) {
        swiper.emit('doubleTap doubleClick', e);
      }
    }

    data.lastClickTime = Utils.now();
    Utils.nextTick(function () {
      if (!swiper.destroyed) { swiper.allowClick = true; }
    });

    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
      data.isTouched = false;
      data.isMoved = false;
      data.startMoving = false;
      return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;

    var currentPos;
    if (params.followFinger) {
      currentPos = rtl ? swiper.translate : -swiper.translate;
    } else {
      currentPos = -data.currentTranslate;
    }

    if (params.cssMode) {
      return;
    }

    if (params.freeMode) {
      if (currentPos < -swiper.minTranslate()) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }
      if (currentPos > -swiper.maxTranslate()) {
        if (swiper.slides.length < snapGrid.length) {
          swiper.slideTo(snapGrid.length - 1);
        } else {
          swiper.slideTo(swiper.slides.length - 1);
        }
        return;
      }

      if (params.freeModeMomentum) {
        if (data.velocities.length > 1) {
          var lastMoveEvent = data.velocities.pop();
          var velocityEvent = data.velocities.pop();

          var distance = lastMoveEvent.position - velocityEvent.position;
          var time = lastMoveEvent.time - velocityEvent.time;
          swiper.velocity = distance / time;
          swiper.velocity /= 2;
          if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
            swiper.velocity = 0;
          }
          // this implies that the user stopped moving a finger then released.
          // There would be no events with distance zero, so the last event is stale.
          if (time > 150 || (Utils.now() - lastMoveEvent.time) > 300) {
            swiper.velocity = 0;
          }
        } else {
          swiper.velocity = 0;
        }
        swiper.velocity *= params.freeModeMomentumVelocityRatio;

        data.velocities.length = 0;
        var momentumDuration = 1000 * params.freeModeMomentumRatio;
        var momentumDistance = swiper.velocity * momentumDuration;

        var newPosition = swiper.translate + momentumDistance;
        if (rtl) { newPosition = -newPosition; }

        var doBounce = false;
        var afterBouncePosition;
        var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
        var needsLoopFix;
        if (newPosition < swiper.maxTranslate()) {
          if (params.freeModeMomentumBounce) {
            if (newPosition + swiper.maxTranslate() < -bounceAmount) {
              newPosition = swiper.maxTranslate() - bounceAmount;
            }
            afterBouncePosition = swiper.maxTranslate();
            doBounce = true;
            data.allowMomentumBounce = true;
          } else {
            newPosition = swiper.maxTranslate();
          }
          if (params.loop && params.centeredSlides) { needsLoopFix = true; }
        } else if (newPosition > swiper.minTranslate()) {
          if (params.freeModeMomentumBounce) {
            if (newPosition - swiper.minTranslate() > bounceAmount) {
              newPosition = swiper.minTranslate() + bounceAmount;
            }
            afterBouncePosition = swiper.minTranslate();
            doBounce = true;
            data.allowMomentumBounce = true;
          } else {
            newPosition = swiper.minTranslate();
          }
          if (params.loop && params.centeredSlides) { needsLoopFix = true; }
        } else if (params.freeModeSticky) {
          var nextSlide;
          for (var j = 0; j < snapGrid.length; j += 1) {
            if (snapGrid[j] > -newPosition) {
              nextSlide = j;
              break;
            }
          }

          if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
            newPosition = snapGrid[nextSlide];
          } else {
            newPosition = snapGrid[nextSlide - 1];
          }
          newPosition = -newPosition;
        }
        if (needsLoopFix) {
          swiper.once('transitionEnd', function () {
            swiper.loopFix();
          });
        }
        // Fix duration
        if (swiper.velocity !== 0) {
          if (rtl) {
            momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
          } else {
            momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
          }
          if (params.freeModeSticky) {
            // If freeModeSticky is active and the user ends a swipe with a slow-velocity
            // event, then durations can be 20+ seconds to slide one (or zero!) slides.
            // It's easy to see this when simulating touch with mouse events. To fix this,
            // limit single-slide swipes to the default slide duration. This also has the
            // nice side effect of matching slide speed if the user stopped moving before
            // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
            // For faster swipes, also apply limits (albeit higher ones).
            var moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
            var currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
            if (moveDistance < currentSlideSize) {
              momentumDuration = params.speed;
            } else if (moveDistance < 2 * currentSlideSize) {
              momentumDuration = params.speed * 1.5;
            } else {
              momentumDuration = params.speed * 2.5;
            }
          }
        } else if (params.freeModeSticky) {
          swiper.slideToClosest();
          return;
        }

        if (params.freeModeMomentumBounce && doBounce) {
          swiper.updateProgress(afterBouncePosition);
          swiper.setTransition(momentumDuration);
          swiper.setTranslate(newPosition);
          swiper.transitionStart(true, swiper.swipeDirection);
          swiper.animating = true;
          $wrapperEl.transitionEnd(function () {
            if (!swiper || swiper.destroyed || !data.allowMomentumBounce) { return; }
            swiper.emit('momentumBounce');

            swiper.setTransition(params.speed);
            swiper.setTranslate(afterBouncePosition);
            $wrapperEl.transitionEnd(function () {
              if (!swiper || swiper.destroyed) { return; }
              swiper.transitionEnd();
            });
          });
        } else if (swiper.velocity) {
          swiper.updateProgress(newPosition);
          swiper.setTransition(momentumDuration);
          swiper.setTranslate(newPosition);
          swiper.transitionStart(true, swiper.swipeDirection);
          if (!swiper.animating) {
            swiper.animating = true;
            $wrapperEl.transitionEnd(function () {
              if (!swiper || swiper.destroyed) { return; }
              swiper.transitionEnd();
            });
          }
        } else {
          swiper.updateProgress(newPosition);
        }

        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      } else if (params.freeModeSticky) {
        swiper.slideToClosest();
        return;
      }

      if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
      return;
    }

    // Find current slide
    var stopIndex = 0;
    var groupSize = swiper.slidesSizesGrid[0];
    for (var i = 0; i < slidesGrid.length; i += params.slidesPerGroup) {
      if (typeof slidesGrid[i + params.slidesPerGroup] !== 'undefined') {
        if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + params.slidesPerGroup]) {
          stopIndex = i;
          groupSize = slidesGrid[i + params.slidesPerGroup] - slidesGrid[i];
        }
      } else if (currentPos >= slidesGrid[i]) {
        stopIndex = i;
        groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
      }
    }

    // Find current slide size
    var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;

    if (timeDiff > params.longSwipesMs) {
      // Long touches
      if (!params.longSwipes) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }
      if (swiper.swipeDirection === 'next') {
        if (ratio >= params.longSwipesRatio) { swiper.slideTo(stopIndex + params.slidesPerGroup); }
        else { swiper.slideTo(stopIndex); }
      }
      if (swiper.swipeDirection === 'prev') {
        if (ratio > (1 - params.longSwipesRatio)) { swiper.slideTo(stopIndex + params.slidesPerGroup); }
        else { swiper.slideTo(stopIndex); }
      }
    } else {
      // Short swipes
      if (!params.shortSwipes) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }
      var isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
      if (!isNavButtonTarget) {
        if (swiper.swipeDirection === 'next') {
          swiper.slideTo(stopIndex + params.slidesPerGroup);
        }
        if (swiper.swipeDirection === 'prev') {
          swiper.slideTo(stopIndex);
        }
      } else if (e.target === swiper.navigation.nextEl) {
        swiper.slideTo(stopIndex + params.slidesPerGroup);
      } else {
        swiper.slideTo(stopIndex);
      }
    }
  }

  function onResize () {
    var swiper = this;

    var params = swiper.params;
    var el = swiper.el;

    if (el && el.offsetWidth === 0) { return; }

    // Breakpoints
    if (params.breakpoints) {
      swiper.setBreakpoint();
    }

    // Save locks
    var allowSlideNext = swiper.allowSlideNext;
    var allowSlidePrev = swiper.allowSlidePrev;
    var snapGrid = swiper.snapGrid;

    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;

    swiper.updateSize();
    swiper.updateSlides();

    swiper.updateSlidesClasses();
    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
      swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    } else {
      swiper.slideTo(swiper.activeIndex, 0, false, true);
    }

    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
      swiper.autoplay.run();
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;

    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }
  }

  function onClick (e) {
    var swiper = this;
    if (!swiper.allowClick) {
      if (swiper.params.preventClicks) { e.preventDefault(); }
      if (swiper.params.preventClicksPropagation && swiper.animating) {
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
    }
  }

  function onScroll () {
    var swiper = this;
    var wrapperEl = swiper.wrapperEl;
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? -wrapperEl.scrollLeft : -wrapperEl.scrollTop;
    // eslint-disable-next-line
    if (swiper.translate === -0) { swiper.translate = 0; }

    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();

    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) {
      newProgress = 0;
    } else {
      newProgress = (swiper.translate - swiper.minTranslate()) / (translatesDiff);
    }
    if (newProgress !== swiper.progress) {
      swiper.updateProgress(swiper.translate);
    }

    swiper.emit('setTranslate', swiper.translate, false);
  }

  var dummyEventAttached = false;
  function dummyEventListener() {}

  function attachEvents() {
    var swiper = this;
    var params = swiper.params;
    var touchEvents = swiper.touchEvents;
    var el = swiper.el;
    var wrapperEl = swiper.wrapperEl;

    swiper.onTouchStart = onTouchStart.bind(swiper);
    swiper.onTouchMove = onTouchMove.bind(swiper);
    swiper.onTouchEnd = onTouchEnd.bind(swiper);
    if (params.cssMode) {
      swiper.onScroll = onScroll.bind(swiper);
    }

    swiper.onClick = onClick.bind(swiper);

    var capture = !!params.nested;

    // Touch Events
    if (!Support.touch && Support.pointerEvents) {
      el.addEventListener(touchEvents.start, swiper.onTouchStart, false);
      doc.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
      doc.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
    } else {
      if (Support.touch) {
        var passiveListener = touchEvents.start === 'touchstart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
        el.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
        el.addEventListener(touchEvents.move, swiper.onTouchMove, Support.passiveListener ? { passive: false, capture: capture } : capture);
        el.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
        if (touchEvents.cancel) {
          el.addEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
        }
        if (!dummyEventAttached) {
          doc.addEventListener('touchstart', dummyEventListener);
          dummyEventAttached = true;
        }
      }
      if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
        el.addEventListener('mousedown', swiper.onTouchStart, false);
        doc.addEventListener('mousemove', swiper.onTouchMove, capture);
        doc.addEventListener('mouseup', swiper.onTouchEnd, false);
      }
    }
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) {
      el.addEventListener('click', swiper.onClick, true);
    }
    if (params.cssMode) {
      wrapperEl.addEventListener('scroll', swiper.onScroll);
    }

    // Resize handler
    if (params.updateOnWindowResize) {
      swiper.on((Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate'), onResize, true);
    } else {
      swiper.on('observerUpdate', onResize, true);
    }
  }

  function detachEvents() {
    var swiper = this;

    var params = swiper.params;
    var touchEvents = swiper.touchEvents;
    var el = swiper.el;
    var wrapperEl = swiper.wrapperEl;

    var capture = !!params.nested;

    // Touch Events
    if (!Support.touch && Support.pointerEvents) {
      el.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
      doc.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
      doc.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
    } else {
      if (Support.touch) {
        var passiveListener = touchEvents.start === 'onTouchStart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
        el.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
        el.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
        el.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
        if (touchEvents.cancel) {
          el.removeEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
        }
      }
      if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
        el.removeEventListener('mousedown', swiper.onTouchStart, false);
        doc.removeEventListener('mousemove', swiper.onTouchMove, capture);
        doc.removeEventListener('mouseup', swiper.onTouchEnd, false);
      }
    }
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) {
      el.removeEventListener('click', swiper.onClick, true);
    }

    if (params.cssMode) {
      wrapperEl.removeEventListener('scroll', swiper.onScroll);
    }

    // Resize handler
    swiper.off((Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate'), onResize);
  }

  var events = {
    attachEvents: attachEvents,
    detachEvents: detachEvents,
  };

  function setBreakpoint () {
    var swiper = this;
    var activeIndex = swiper.activeIndex;
    var initialized = swiper.initialized;
    var loopedSlides = swiper.loopedSlides; if ( loopedSlides === void 0 ) loopedSlides = 0;
    var params = swiper.params;
    var $el = swiper.$el;
    var breakpoints = params.breakpoints;
    if (!breakpoints || (breakpoints && Object.keys(breakpoints).length === 0)) { return; }

    // Get breakpoint for window width and update parameters
    var breakpoint = swiper.getBreakpoint(breakpoints);

    if (breakpoint && swiper.currentBreakpoint !== breakpoint) {
      var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
      if (breakpointOnlyParams) {
        ['slidesPerView', 'spaceBetween', 'slidesPerGroup', 'slidesPerColumn'].forEach(function (param) {
          var paramValue = breakpointOnlyParams[param];
          if (typeof paramValue === 'undefined') { return; }
          if (param === 'slidesPerView' && (paramValue === 'AUTO' || paramValue === 'auto')) {
            breakpointOnlyParams[param] = 'auto';
          } else if (param === 'slidesPerView') {
            breakpointOnlyParams[param] = parseFloat(paramValue);
          } else {
            breakpointOnlyParams[param] = parseInt(paramValue, 10);
          }
        });
      }

      var breakpointParams = breakpointOnlyParams || swiper.originalParams;
      var wasMultiRow = params.slidesPerColumn > 1;
      var isMultiRow = breakpointParams.slidesPerColumn > 1;
      if (wasMultiRow && !isMultiRow) {
        $el.removeClass(((params.containerModifierClass) + "multirow " + (params.containerModifierClass) + "multirow-column"));
      } else if (!wasMultiRow && isMultiRow) {
        $el.addClass(((params.containerModifierClass) + "multirow"));
        if (breakpointParams.slidesPerColumnFill === 'column') {
          $el.addClass(((params.containerModifierClass) + "multirow-column"));
        }
      }

      var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
      var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);

      if (directionChanged && initialized) {
        swiper.changeDirection();
      }

      Utils.extend(swiper.params, breakpointParams);

      Utils.extend(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev,
      });

      swiper.currentBreakpoint = breakpoint;

      if (needsReLoop && initialized) {
        swiper.loopDestroy();
        swiper.loopCreate();
        swiper.updateSlides();
        swiper.slideTo((activeIndex - loopedSlides) + swiper.loopedSlides, 0, false);
      }

      swiper.emit('breakpoint', breakpointParams);
    }
  }

  function getBreakpoint (breakpoints) {
    // Get breakpoint for window width
    if (!breakpoints) { return undefined; }
    var breakpoint = false;
    var points = [];
    Object.keys(breakpoints).forEach(function (point) {
      points.push(point);
    });
    points.sort(function (a, b) { return parseInt(a, 10) - parseInt(b, 10); });
    for (var i = 0; i < points.length; i += 1) {
      var point = points[i];
      if (point <= win.innerWidth) {
        breakpoint = point;
      }
    }
    return breakpoint || 'max';
  }

  var breakpoints = { setBreakpoint: setBreakpoint, getBreakpoint: getBreakpoint };

  function addClasses () {
    var swiper = this;
    var classNames = swiper.classNames;
    var params = swiper.params;
    var rtl = swiper.rtl;
    var $el = swiper.$el;
    var suffixes = [];

    suffixes.push('initialized');
    suffixes.push(params.direction);

    if (params.freeMode) {
      suffixes.push('free-mode');
    }
    if (params.autoHeight) {
      suffixes.push('autoheight');
    }
    if (rtl) {
      suffixes.push('rtl');
    }
    if (params.slidesPerColumn > 1) {
      suffixes.push('multirow');
      if (params.slidesPerColumnFill === 'column') {
        suffixes.push('multirow-column');
      }
    }
    if (Device.android) {
      suffixes.push('android');
    }
    if (Device.ios) {
      suffixes.push('ios');
    }

    if (params.cssMode) {
      suffixes.push('css-mode');
    }

    suffixes.forEach(function (suffix) {
      classNames.push(params.containerModifierClass + suffix);
    });

    $el.addClass(classNames.join(' '));
  }

  function removeClasses () {
    var swiper = this;
    var $el = swiper.$el;
    var classNames = swiper.classNames;

    $el.removeClass(classNames.join(' '));
  }

  var classes = { addClasses: addClasses, removeClasses: removeClasses };

  function loadImage (imageEl, src, srcset, sizes, checkForComplete, callback) {
    var image;
    function onReady() {
      if (callback) { callback(); }
    }
    if (!imageEl.complete || !checkForComplete) {
      if (src) {
        image = new win.Image();
        image.onload = onReady;
        image.onerror = onReady;
        if (sizes) {
          image.sizes = sizes;
        }
        if (srcset) {
          image.srcset = srcset;
        }
        if (src) {
          image.src = src;
        }
      } else {
        onReady();
      }
    } else {
      // image already loaded...
      onReady();
    }
  }

  function preloadImages () {
    var swiper = this;
    swiper.imagesToLoad = swiper.$el.find('img');
    function onReady() {
      if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) { return; }
      if (swiper.imagesLoaded !== undefined) { swiper.imagesLoaded += 1; }
      if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
        if (swiper.params.updateOnImagesReady) { swiper.update(); }
        swiper.emit('imagesReady');
      }
    }
    for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
      var imageEl = swiper.imagesToLoad[i];
      swiper.loadImage(
        imageEl,
        imageEl.currentSrc || imageEl.getAttribute('src'),
        imageEl.srcset || imageEl.getAttribute('srcset'),
        imageEl.sizes || imageEl.getAttribute('sizes'),
        true,
        onReady
      );
    }
  }

  var images = {
    loadImage: loadImage,
    preloadImages: preloadImages,
  };

  function checkOverflow() {
    var swiper = this;
    var params = swiper.params;
    var wasLocked = swiper.isLocked;
    var lastSlidePosition = swiper.slides.length > 0 && (params.slidesOffsetBefore + (params.spaceBetween * (swiper.slides.length - 1)) + ((swiper.slides[0]).offsetWidth) * swiper.slides.length);

    if (params.slidesOffsetBefore && params.slidesOffsetAfter && lastSlidePosition) {
      swiper.isLocked = lastSlidePosition <= swiper.size;
    } else {
      swiper.isLocked = swiper.snapGrid.length === 1;
    }

    swiper.allowSlideNext = !swiper.isLocked;
    swiper.allowSlidePrev = !swiper.isLocked;

    // events
    if (wasLocked !== swiper.isLocked) { swiper.emit(swiper.isLocked ? 'lock' : 'unlock'); }

    if (wasLocked && wasLocked !== swiper.isLocked) {
      swiper.isEnd = false;
      swiper.navigation.update();
    }
  }

  var checkOverflow$1 = { checkOverflow: checkOverflow };

  var defaults = {
    init: true,
    direction: 'horizontal',
    touchEventsTarget: 'container',
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    //
    preventInteractionOnTransition: false,

    // To support iOS's swipe-to-go-back gesture (when being used in-app, with UIWebView).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,

    // Free mode
    freeMode: false,
    freeModeMomentum: true,
    freeModeMomentumRatio: 1,
    freeModeMomentumBounce: true,
    freeModeMomentumBounceRatio: 1,
    freeModeMomentumVelocityRatio: 1,
    freeModeSticky: false,
    freeModeMinimumVelocity: 0.02,

    // Autoheight
    autoHeight: false,

    // Set wrapper width
    setWrapperSize: false,

    // Virtual Translate
    virtualTranslate: false,

    // Effects
    effect: 'slide', // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'

    // Breakpoints
    breakpoints: undefined,

    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerColumn: 1,
    slidesPerColumnFill: 'column',
    slidesPerGroup: 1,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0, // in px
    slidesOffsetAfter: 0, // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,

    // Disable swiper and hide navigation when container not overflow
    watchOverflow: false,

    // Round length
    roundLengths: false,

    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 0,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,

    // Unique Navigation Elements
    uniqueNavElements: true,

    // Resistance
    resistance: true,
    resistanceRatio: 0.85,

    // Progress
    watchSlidesProgress: false,
    watchSlidesVisibility: false,

    // Cursor
    grabCursor: false,

    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,

    // Images
    preloadImages: true,
    updateOnImagesReady: true,

    // loop
    loop: false,
    loopAdditionalSlides: 0,
    loopedSlides: null,
    loopFillGroupWithBlank: false,

    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null, // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,

    // Passive Listeners
    passiveListeners: true,

    // NS
    containerModifierClass: 'swiper-container-', // NEW
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-invisible-blank',
    slideActiveClass: 'swiper-slide-active',
    slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideDuplicateClass: 'swiper-slide-duplicate',
    slideNextClass: 'swiper-slide-next',
    slideDuplicateNextClass: 'swiper-slide-duplicate-next',
    slidePrevClass: 'swiper-slide-prev',
    slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
    wrapperClass: 'swiper-wrapper',

    // Callbacks
    runCallbacksOnInit: true,
  };

  /* eslint no-param-reassign: "off" */

  var prototypes = {
    update: update,
    translate: translate,
    transition: transition$1,
    slide: slide,
    loop: loop,
    grabCursor: grabCursor,
    manipulation: manipulation,
    events: events,
    breakpoints: breakpoints,
    checkOverflow: checkOverflow$1,
    classes: classes,
    images: images,
  };

  var extendedDefaults = {};

  var Swiper = /*@__PURE__*/(function (SwiperClass) {
    function Swiper() {
      var assign;

      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];
      var el;
      var params;
      if (args.length === 1 && args[0].constructor && args[0].constructor === Object) {
        params = args[0];
      } else {
        (assign = args, el = assign[0], params = assign[1]);
      }
      if (!params) { params = {}; }

      params = Utils.extend({}, params);
      if (el && !params.el) { params.el = el; }

      SwiperClass.call(this, params);

      Object.keys(prototypes).forEach(function (prototypeGroup) {
        Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
          if (!Swiper.prototype[protoMethod]) {
            Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
          }
        });
      });

      // Swiper Instance
      var swiper = this;
      if (typeof swiper.modules === 'undefined') {
        swiper.modules = {};
      }
      Object.keys(swiper.modules).forEach(function (moduleName) {
        var module = swiper.modules[moduleName];
        if (module.params) {
          var moduleParamName = Object.keys(module.params)[0];
          var moduleParams = module.params[moduleParamName];
          if (typeof moduleParams !== 'object' || moduleParams === null) { return; }
          if (!(moduleParamName in params && 'enabled' in moduleParams)) { return; }
          if (params[moduleParamName] === true) {
            params[moduleParamName] = { enabled: true };
          }
          if (
            typeof params[moduleParamName] === 'object'
            && !('enabled' in params[moduleParamName])
          ) {
            params[moduleParamName].enabled = true;
          }
          if (!params[moduleParamName]) { params[moduleParamName] = { enabled: false }; }
        }
      });

      // Extend defaults with modules params
      var swiperParams = Utils.extend({}, defaults);
      swiper.useModulesParams(swiperParams);

      // Extend defaults with passed params
      swiper.params = Utils.extend({}, swiperParams, extendedDefaults, params);
      swiper.originalParams = Utils.extend({}, swiper.params);
      swiper.passedParams = Utils.extend({}, params);

      // Save Dom lib
      swiper.$ = $;

      // Find el
      var $el = $(swiper.params.el);
      el = $el[0];

      if (!el) {
        return undefined;
      }

      if ($el.length > 1) {
        var swipers = [];
        $el.each(function (index, containerEl) {
          var newParams = Utils.extend({}, params, { el: containerEl });
          swipers.push(new Swiper(newParams));
        });
        return swipers;
      }

      el.swiper = swiper;
      $el.data('swiper', swiper);

      // Find Wrapper
      var $wrapperEl;
      if (el && el.shadowRoot && el.shadowRoot.querySelector) {
        $wrapperEl = $(el.shadowRoot.querySelector(("." + (swiper.params.wrapperClass))));
        // Children needs to return slot items
        $wrapperEl.children = function (options) { return $el.children(options); };
      } else {
        $wrapperEl = $el.children(("." + (swiper.params.wrapperClass)));
      }
      // Extend Swiper
      Utils.extend(swiper, {
        $el: $el,
        el: el,
        $wrapperEl: $wrapperEl,
        wrapperEl: $wrapperEl[0],

        // Classes
        classNames: [],

        // Slides
        slides: $(),
        slidesGrid: [],
        snapGrid: [],
        slidesSizesGrid: [],

        // isDirection
        isHorizontal: function isHorizontal() {
          return swiper.params.direction === 'horizontal';
        },
        isVertical: function isVertical() {
          return swiper.params.direction === 'vertical';
        },
        // RTL
        rtl: (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
        rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
        wrongRTL: $wrapperEl.css('display') === '-webkit-box',

        // Indexes
        activeIndex: 0,
        realIndex: 0,

        //
        isBeginning: true,
        isEnd: false,

        // Props
        translate: 0,
        previousTranslate: 0,
        progress: 0,
        velocity: 0,
        animating: false,

        // Locks
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev,

        // Touch Events
        touchEvents: (function touchEvents() {
          var touch = ['touchstart', 'touchmove', 'touchend', 'touchcancel'];
          var desktop = ['mousedown', 'mousemove', 'mouseup'];
          if (Support.pointerEvents) {
            desktop = ['pointerdown', 'pointermove', 'pointerup'];
          }
          swiper.touchEventsTouch = {
            start: touch[0],
            move: touch[1],
            end: touch[2],
            cancel: touch[3],
          };
          swiper.touchEventsDesktop = {
            start: desktop[0],
            move: desktop[1],
            end: desktop[2],
          };
          return Support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
        }()),
        touchEventsData: {
          isTouched: undefined,
          isMoved: undefined,
          allowTouchCallbacks: undefined,
          touchStartTime: undefined,
          isScrolling: undefined,
          currentTranslate: undefined,
          startTranslate: undefined,
          allowThresholdMove: undefined,
          // Form elements to match
          formElements: 'input, select, option, textarea, button, video',
          // Last click time
          lastClickTime: Utils.now(),
          clickTimeout: undefined,
          // Velocities
          velocities: [],
          allowMomentumBounce: undefined,
          isTouchEvent: undefined,
          startMoving: undefined,
        },

        // Clicks
        allowClick: true,

        // Touches
        allowTouchMove: swiper.params.allowTouchMove,

        touches: {
          startX: 0,
          startY: 0,
          currentX: 0,
          currentY: 0,
          diff: 0,
        },

        // Images
        imagesToLoad: [],
        imagesLoaded: 0,

      });

      // Install Modules
      swiper.useModules();

      // Init
      if (swiper.params.init) {
        swiper.init();
      }

      // Return app instance
      return swiper;
    }

    if ( SwiperClass ) Swiper.__proto__ = SwiperClass;
    Swiper.prototype = Object.create( SwiperClass && SwiperClass.prototype );
    Swiper.prototype.constructor = Swiper;

    var staticAccessors = { extendedDefaults: { configurable: true },defaults: { configurable: true },Class: { configurable: true },$: { configurable: true } };

    Swiper.prototype.slidesPerViewDynamic = function slidesPerViewDynamic () {
      var swiper = this;
      var params = swiper.params;
      var slides = swiper.slides;
      var slidesGrid = swiper.slidesGrid;
      var swiperSize = swiper.size;
      var activeIndex = swiper.activeIndex;
      var spv = 1;
      if (params.centeredSlides) {
        var slideSize = slides[activeIndex].swiperSlideSize;
        var breakLoop;
        for (var i = activeIndex + 1; i < slides.length; i += 1) {
          if (slides[i] && !breakLoop) {
            slideSize += slides[i].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize) { breakLoop = true; }
          }
        }
        for (var i$1 = activeIndex - 1; i$1 >= 0; i$1 -= 1) {
          if (slides[i$1] && !breakLoop) {
            slideSize += slides[i$1].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize) { breakLoop = true; }
          }
        }
      } else {
        for (var i$2 = activeIndex + 1; i$2 < slides.length; i$2 += 1) {
          if (slidesGrid[i$2] - slidesGrid[activeIndex] < swiperSize) {
            spv += 1;
          }
        }
      }
      return spv;
    };

    Swiper.prototype.update = function update () {
      var swiper = this;
      if (!swiper || swiper.destroyed) { return; }
      var snapGrid = swiper.snapGrid;
      var params = swiper.params;
      // Breakpoints
      if (params.breakpoints) {
        swiper.setBreakpoint();
      }
      swiper.updateSize();
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();

      function setTranslate() {
        var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
        var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
        swiper.setTranslate(newTranslate);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
      var translated;
      if (swiper.params.freeMode) {
        setTranslate();
        if (swiper.params.autoHeight) {
          swiper.updateAutoHeight();
        }
      } else {
        if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
          translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
        } else {
          translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
        }
        if (!translated) {
          setTranslate();
        }
      }
      if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
        swiper.checkOverflow();
      }
      swiper.emit('update');
    };

    Swiper.prototype.changeDirection = function changeDirection (newDirection, needUpdate) {
      if ( needUpdate === void 0 ) needUpdate = true;

      var swiper = this;
      var currentDirection = swiper.params.direction;
      if (!newDirection) {
        // eslint-disable-next-line
        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
      }
      if ((newDirection === currentDirection) || (newDirection !== 'horizontal' && newDirection !== 'vertical')) {
        return swiper;
      }

      swiper.$el
        .removeClass(("" + (swiper.params.containerModifierClass) + currentDirection))
        .addClass(("" + (swiper.params.containerModifierClass) + newDirection));

      swiper.params.direction = newDirection;

      swiper.slides.each(function (slideIndex, slideEl) {
        if (newDirection === 'vertical') {
          slideEl.style.width = '';
        } else {
          slideEl.style.height = '';
        }
      });

      swiper.emit('changeDirection');
      if (needUpdate) { swiper.update(); }

      return swiper;
    };

    Swiper.prototype.init = function init () {
      var swiper = this;
      if (swiper.initialized) { return; }

      swiper.emit('beforeInit');

      // Set breakpoint
      if (swiper.params.breakpoints) {
        swiper.setBreakpoint();
      }

      // Add Classes
      swiper.addClasses();

      // Create loop
      if (swiper.params.loop) {
        swiper.loopCreate();
      }

      // Update size
      swiper.updateSize();

      // Update slides
      swiper.updateSlides();

      if (swiper.params.watchOverflow) {
        swiper.checkOverflow();
      }

      // Set Grab Cursor
      if (swiper.params.grabCursor) {
        swiper.setGrabCursor();
      }

      if (swiper.params.preloadImages) {
        swiper.preloadImages();
      }

      // Slide To Initial Slide
      if (swiper.params.loop) {
        swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit);
      } else {
        swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit);
      }

      // Attach events
      swiper.attachEvents();

      // Init Flag
      swiper.initialized = true;

      // Emit
      swiper.emit('init');
    };

    Swiper.prototype.destroy = function destroy (deleteInstance, cleanStyles) {
      if ( deleteInstance === void 0 ) deleteInstance = true;
      if ( cleanStyles === void 0 ) cleanStyles = true;

      var swiper = this;
      var params = swiper.params;
      var $el = swiper.$el;
      var $wrapperEl = swiper.$wrapperEl;
      var slides = swiper.slides;

      if (typeof swiper.params === 'undefined' || swiper.destroyed) {
        return null;
      }

      swiper.emit('beforeDestroy');

      // Init Flag
      swiper.initialized = false;

      // Detach events
      swiper.detachEvents();

      // Destroy loop
      if (params.loop) {
        swiper.loopDestroy();
      }

      // Cleanup styles
      if (cleanStyles) {
        swiper.removeClasses();
        $el.removeAttr('style');
        $wrapperEl.removeAttr('style');
        if (slides && slides.length) {
          slides
            .removeClass([
              params.slideVisibleClass,
              params.slideActiveClass,
              params.slideNextClass,
              params.slidePrevClass ].join(' '))
            .removeAttr('style')
            .removeAttr('data-swiper-slide-index');
        }
      }

      swiper.emit('destroy');

      // Detach emitter events
      Object.keys(swiper.eventsListeners).forEach(function (eventName) {
        swiper.off(eventName);
      });

      if (deleteInstance !== false) {
        swiper.$el[0].swiper = null;
        swiper.$el.data('swiper', null);
        Utils.deleteProps(swiper);
      }
      swiper.destroyed = true;

      return null;
    };

    Swiper.extendDefaults = function extendDefaults (newDefaults) {
      Utils.extend(extendedDefaults, newDefaults);
    };

    staticAccessors.extendedDefaults.get = function () {
      return extendedDefaults;
    };

    staticAccessors.defaults.get = function () {
      return defaults;
    };

    staticAccessors.Class.get = function () {
      return SwiperClass;
    };

    staticAccessors.$.get = function () {
      return $;
    };

    Object.defineProperties( Swiper, staticAccessors );

    return Swiper;
  }(SwiperClass));

  var Device$1 = {
    name: 'device',
    proto: {
      device: Device,
    },
    static: {
      device: Device,
    },
  };

  var Support$1 = {
    name: 'support',
    proto: {
      support: Support,
    },
    static: {
      support: Support,
    },
  };

  var Browser = (function Browser() {
    function isSafari() {
      var ua = win.navigator.userAgent.toLowerCase();
      return (ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0);
    }
    return {
      isEdge: !!win.navigator.userAgent.match(/Edge/g),
      isSafari: isSafari(),
      isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(win.navigator.userAgent),
    };
  }());

  var Browser$1 = {
    name: 'browser',
    proto: {
      browser: Browser,
    },
    static: {
      browser: Browser,
    },
  };

  var Resize = {
    name: 'resize',
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        resize: {
          resizeHandler: function resizeHandler() {
            if (!swiper || swiper.destroyed || !swiper.initialized) { return; }
            swiper.emit('beforeResize');
            swiper.emit('resize');
          },
          orientationChangeHandler: function orientationChangeHandler() {
            if (!swiper || swiper.destroyed || !swiper.initialized) { return; }
            swiper.emit('orientationchange');
          },
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        // Emit resize
        win.addEventListener('resize', swiper.resize.resizeHandler);

        // Emit orientationchange
        win.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
      },
      destroy: function destroy() {
        var swiper = this;
        win.removeEventListener('resize', swiper.resize.resizeHandler);
        win.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
      },
    },
  };

  var Observer = {
    func: win.MutationObserver || win.WebkitMutationObserver,
    attach: function attach(target, options) {
      if ( options === void 0 ) options = {};

      var swiper = this;

      var ObserverFunc = Observer.func;
      var observer = new ObserverFunc(function (mutations) {
        // The observerUpdate event should only be triggered
        // once despite the number of mutations.  Additional
        // triggers are redundant and are very costly
        if (mutations.length === 1) {
          swiper.emit('observerUpdate', mutations[0]);
          return;
        }
        var observerUpdate = function observerUpdate() {
          swiper.emit('observerUpdate', mutations[0]);
        };

        if (win.requestAnimationFrame) {
          win.requestAnimationFrame(observerUpdate);
        } else {
          win.setTimeout(observerUpdate, 0);
        }
      });

      observer.observe(target, {
        attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
        childList: typeof options.childList === 'undefined' ? true : options.childList,
        characterData: typeof options.characterData === 'undefined' ? true : options.characterData,
      });

      swiper.observer.observers.push(observer);
    },
    init: function init() {
      var swiper = this;
      if (!Support.observer || !swiper.params.observer) { return; }
      if (swiper.params.observeParents) {
        var containerParents = swiper.$el.parents();
        for (var i = 0; i < containerParents.length; i += 1) {
          swiper.observer.attach(containerParents[i]);
        }
      }
      // Observe container
      swiper.observer.attach(swiper.$el[0], { childList: swiper.params.observeSlideChildren });

      // Observe wrapper
      swiper.observer.attach(swiper.$wrapperEl[0], { attributes: false });
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.observer.observers.forEach(function (observer) {
        observer.disconnect();
      });
      swiper.observer.observers = [];
    },
  };

  var Observer$1 = {
    name: 'observer',
    params: {
      observer: false,
      observeParents: false,
      observeSlideChildren: false,
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        observer: {
          init: Observer.init.bind(swiper),
          attach: Observer.attach.bind(swiper),
          destroy: Observer.destroy.bind(swiper),
          observers: [],
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        swiper.observer.init();
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.observer.destroy();
      },
    },
  };

  var Virtual = {
    update: function update(force) {
      var swiper = this;
      var ref = swiper.params;
      var slidesPerView = ref.slidesPerView;
      var slidesPerGroup = ref.slidesPerGroup;
      var centeredSlides = ref.centeredSlides;
      var ref$1 = swiper.params.virtual;
      var addSlidesBefore = ref$1.addSlidesBefore;
      var addSlidesAfter = ref$1.addSlidesAfter;
      var ref$2 = swiper.virtual;
      var previousFrom = ref$2.from;
      var previousTo = ref$2.to;
      var slides = ref$2.slides;
      var previousSlidesGrid = ref$2.slidesGrid;
      var renderSlide = ref$2.renderSlide;
      var previousOffset = ref$2.offset;
      swiper.updateActiveIndex();
      var activeIndex = swiper.activeIndex || 0;

      var offsetProp;
      if (swiper.rtlTranslate) { offsetProp = 'right'; }
      else { offsetProp = swiper.isHorizontal() ? 'left' : 'top'; }

      var slidesAfter;
      var slidesBefore;
      if (centeredSlides) {
        slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
      } else {
        slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesBefore;
        slidesBefore = slidesPerGroup + addSlidesAfter;
      }
      var from = Math.max((activeIndex || 0) - slidesBefore, 0);
      var to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
      var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);

      Utils.extend(swiper.virtual, {
        from: from,
        to: to,
        offset: offset,
        slidesGrid: swiper.slidesGrid,
      });

      function onRendered() {
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        if (swiper.lazy && swiper.params.lazy.enabled) {
          swiper.lazy.load();
        }
      }

      if (previousFrom === from && previousTo === to && !force) {
        if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
          swiper.slides.css(offsetProp, (offset + "px"));
        }
        swiper.updateProgress();
        return;
      }
      if (swiper.params.virtual.renderExternal) {
        swiper.params.virtual.renderExternal.call(swiper, {
          offset: offset,
          from: from,
          to: to,
          slides: (function getSlides() {
            var slidesToRender = [];
            for (var i = from; i <= to; i += 1) {
              slidesToRender.push(slides[i]);
            }
            return slidesToRender;
          }()),
        });
        onRendered();
        return;
      }
      var prependIndexes = [];
      var appendIndexes = [];
      if (force) {
        swiper.$wrapperEl.find(("." + (swiper.params.slideClass))).remove();
      } else {
        for (var i = previousFrom; i <= previousTo; i += 1) {
          if (i < from || i > to) {
            swiper.$wrapperEl.find(("." + (swiper.params.slideClass) + "[data-swiper-slide-index=\"" + i + "\"]")).remove();
          }
        }
      }
      for (var i$1 = 0; i$1 < slides.length; i$1 += 1) {
        if (i$1 >= from && i$1 <= to) {
          if (typeof previousTo === 'undefined' || force) {
            appendIndexes.push(i$1);
          } else {
            if (i$1 > previousTo) { appendIndexes.push(i$1); }
            if (i$1 < previousFrom) { prependIndexes.push(i$1); }
          }
        }
      }
      appendIndexes.forEach(function (index) {
        swiper.$wrapperEl.append(renderSlide(slides[index], index));
      });
      prependIndexes.sort(function (a, b) { return b - a; }).forEach(function (index) {
        swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
      });
      swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, (offset + "px"));
      onRendered();
    },
    renderSlide: function renderSlide(slide, index) {
      var swiper = this;
      var params = swiper.params.virtual;
      if (params.cache && swiper.virtual.cache[index]) {
        return swiper.virtual.cache[index];
      }
      var $slideEl = params.renderSlide
        ? $(params.renderSlide.call(swiper, slide, index))
        : $(("<div class=\"" + (swiper.params.slideClass) + "\" data-swiper-slide-index=\"" + index + "\">" + slide + "</div>"));
      if (!$slideEl.attr('data-swiper-slide-index')) { $slideEl.attr('data-swiper-slide-index', index); }
      if (params.cache) { swiper.virtual.cache[index] = $slideEl; }
      return $slideEl;
    },
    appendSlide: function appendSlide(slides) {
      var swiper = this;
      if (typeof slides === 'object' && 'length' in slides) {
        for (var i = 0; i < slides.length; i += 1) {
          if (slides[i]) { swiper.virtual.slides.push(slides[i]); }
        }
      } else {
        swiper.virtual.slides.push(slides);
      }
      swiper.virtual.update(true);
    },
    prependSlide: function prependSlide(slides) {
      var swiper = this;
      var activeIndex = swiper.activeIndex;
      var newActiveIndex = activeIndex + 1;
      var numberOfNewSlides = 1;

      if (Array.isArray(slides)) {
        for (var i = 0; i < slides.length; i += 1) {
          if (slides[i]) { swiper.virtual.slides.unshift(slides[i]); }
        }
        newActiveIndex = activeIndex + slides.length;
        numberOfNewSlides = slides.length;
      } else {
        swiper.virtual.slides.unshift(slides);
      }
      if (swiper.params.virtual.cache) {
        var cache = swiper.virtual.cache;
        var newCache = {};
        Object.keys(cache).forEach(function (cachedIndex) {
          var $cachedEl = cache[cachedIndex];
          var cachedElIndex = $cachedEl.attr('data-swiper-slide-index');
          if (cachedElIndex) {
            $cachedEl.attr('data-swiper-slide-index', parseInt(cachedElIndex, 10) + 1);
          }
          newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
        });
        swiper.virtual.cache = newCache;
      }
      swiper.virtual.update(true);
      swiper.slideTo(newActiveIndex, 0);
    },
    removeSlide: function removeSlide(slidesIndexes) {
      var swiper = this;
      if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) { return; }
      var activeIndex = swiper.activeIndex;
      if (Array.isArray(slidesIndexes)) {
        for (var i = slidesIndexes.length - 1; i >= 0; i -= 1) {
          swiper.virtual.slides.splice(slidesIndexes[i], 1);
          if (swiper.params.virtual.cache) {
            delete swiper.virtual.cache[slidesIndexes[i]];
          }
          if (slidesIndexes[i] < activeIndex) { activeIndex -= 1; }
          activeIndex = Math.max(activeIndex, 0);
        }
      } else {
        swiper.virtual.slides.splice(slidesIndexes, 1);
        if (swiper.params.virtual.cache) {
          delete swiper.virtual.cache[slidesIndexes];
        }
        if (slidesIndexes < activeIndex) { activeIndex -= 1; }
        activeIndex = Math.max(activeIndex, 0);
      }
      swiper.virtual.update(true);
      swiper.slideTo(activeIndex, 0);
    },
    removeAllSlides: function removeAllSlides() {
      var swiper = this;
      swiper.virtual.slides = [];
      if (swiper.params.virtual.cache) {
        swiper.virtual.cache = {};
      }
      swiper.virtual.update(true);
      swiper.slideTo(0, 0);
    },
  };

  var Virtual$1 = {
    name: 'virtual',
    params: {
      virtual: {
        enabled: false,
        slides: [],
        cache: true,
        renderSlide: null,
        renderExternal: null,
        addSlidesBefore: 0,
        addSlidesAfter: 0,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        virtual: {
          update: Virtual.update.bind(swiper),
          appendSlide: Virtual.appendSlide.bind(swiper),
          prependSlide: Virtual.prependSlide.bind(swiper),
          removeSlide: Virtual.removeSlide.bind(swiper),
          removeAllSlides: Virtual.removeAllSlides.bind(swiper),
          renderSlide: Virtual.renderSlide.bind(swiper),
          slides: swiper.params.virtual.slides,
          cache: {},
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (!swiper.params.virtual.enabled) { return; }
        swiper.classNames.push(((swiper.params.containerModifierClass) + "virtual"));
        var overwriteParams = {
          watchSlidesProgress: true,
        };
        Utils.extend(swiper.params, overwriteParams);
        Utils.extend(swiper.originalParams, overwriteParams);

        if (!swiper.params.initialSlide) {
          swiper.virtual.update();
        }
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (!swiper.params.virtual.enabled) { return; }
        swiper.virtual.update();
      },
    },
  };

  var Keyboard = {
    handle: function handle(event) {
      var swiper = this;
      var rtl = swiper.rtlTranslate;
      var e = event;
      if (e.originalEvent) { e = e.originalEvent; } // jquery fix
      var kc = e.keyCode || e.charCode;
      // Directions locks
      if (!swiper.allowSlideNext && ((swiper.isHorizontal() && kc === 39) || (swiper.isVertical() && kc === 40) || kc === 34)) {
        return false;
      }
      if (!swiper.allowSlidePrev && ((swiper.isHorizontal() && kc === 37) || (swiper.isVertical() && kc === 38) || kc === 33)) {
        return false;
      }
      if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
        return undefined;
      }
      if (doc.activeElement && doc.activeElement.nodeName && (doc.activeElement.nodeName.toLowerCase() === 'input' || doc.activeElement.nodeName.toLowerCase() === 'textarea')) {
        return undefined;
      }
      if (swiper.params.keyboard.onlyInViewport && (kc === 33 || kc === 34 || kc === 37 || kc === 39 || kc === 38 || kc === 40)) {
        var inView = false;
        // Check that swiper should be inside of visible area of window
        if (swiper.$el.parents(("." + (swiper.params.slideClass))).length > 0 && swiper.$el.parents(("." + (swiper.params.slideActiveClass))).length === 0) {
          return undefined;
        }
        var windowWidth = win.innerWidth;
        var windowHeight = win.innerHeight;
        var swiperOffset = swiper.$el.offset();
        if (rtl) { swiperOffset.left -= swiper.$el[0].scrollLeft; }
        var swiperCoord = [
          [swiperOffset.left, swiperOffset.top],
          [swiperOffset.left + swiper.width, swiperOffset.top],
          [swiperOffset.left, swiperOffset.top + swiper.height],
          [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height] ];
        for (var i = 0; i < swiperCoord.length; i += 1) {
          var point = swiperCoord[i];
          if (
            point[0] >= 0 && point[0] <= windowWidth
            && point[1] >= 0 && point[1] <= windowHeight
          ) {
            inView = true;
          }
        }
        if (!inView) { return undefined; }
      }
      if (swiper.isHorizontal()) {
        if (kc === 33 || kc === 34 || kc === 37 || kc === 39) {
          if (e.preventDefault) { e.preventDefault(); }
          else { e.returnValue = false; }
        }
        if (((kc === 34 || kc === 39) && !rtl) || ((kc === 33 || kc === 37) && rtl)) { swiper.slideNext(); }
        if (((kc === 33 || kc === 37) && !rtl) || ((kc === 34 || kc === 39) && rtl)) { swiper.slidePrev(); }
      } else {
        if (kc === 33 || kc === 34 || kc === 38 || kc === 40) {
          if (e.preventDefault) { e.preventDefault(); }
          else { e.returnValue = false; }
        }
        if (kc === 34 || kc === 40) { swiper.slideNext(); }
        if (kc === 33 || kc === 38) { swiper.slidePrev(); }
      }
      swiper.emit('keyPress', kc);
      return undefined;
    },
    enable: function enable() {
      var swiper = this;
      if (swiper.keyboard.enabled) { return; }
      $(doc).on('keydown', swiper.keyboard.handle);
      swiper.keyboard.enabled = true;
    },
    disable: function disable() {
      var swiper = this;
      if (!swiper.keyboard.enabled) { return; }
      $(doc).off('keydown', swiper.keyboard.handle);
      swiper.keyboard.enabled = false;
    },
  };

  var Keyboard$1 = {
    name: 'keyboard',
    params: {
      keyboard: {
        enabled: false,
        onlyInViewport: true,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        keyboard: {
          enabled: false,
          enable: Keyboard.enable.bind(swiper),
          disable: Keyboard.disable.bind(swiper),
          handle: Keyboard.handle.bind(swiper),
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.keyboard.enabled) {
          swiper.keyboard.enable();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.keyboard.enabled) {
          swiper.keyboard.disable();
        }
      },
    },
  };

  function isEventSupported() {
    var eventName = 'onwheel';
    var isSupported = eventName in doc;

    if (!isSupported) {
      var element = doc.createElement('div');
      element.setAttribute(eventName, 'return;');
      isSupported = typeof element[eventName] === 'function';
    }

    if (!isSupported
      && doc.implementation
      && doc.implementation.hasFeature
      // always returns true in newer browsers as per the standard.
      // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
      && doc.implementation.hasFeature('', '') !== true
    ) {
      // This is the only way to test support for the `wheel` event in IE9+.
      isSupported = doc.implementation.hasFeature('Events.wheel', '3.0');
    }

    return isSupported;
  }
  var Mousewheel = {
    lastScrollTime: Utils.now(),
    lastEventBeforeSnap: undefined,
    recentWheelEvents: [],
    event: function event() {
      if (win.navigator.userAgent.indexOf('firefox') > -1) { return 'DOMMouseScroll'; }
      return isEventSupported() ? 'wheel' : 'mousewheel';
    },
    normalize: function normalize(e) {
      // Reasonable defaults
      var PIXEL_STEP = 10;
      var LINE_HEIGHT = 40;
      var PAGE_HEIGHT = 800;

      var sX = 0;
      var sY = 0; // spinX, spinY
      var pX = 0;
      var pY = 0; // pixelX, pixelY

      // Legacy
      if ('detail' in e) {
        sY = e.detail;
      }
      if ('wheelDelta' in e) {
        sY = -e.wheelDelta / 120;
      }
      if ('wheelDeltaY' in e) {
        sY = -e.wheelDeltaY / 120;
      }
      if ('wheelDeltaX' in e) {
        sX = -e.wheelDeltaX / 120;
      }

      // side scrolling on FF with DOMMouseScroll
      if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
        sX = sY;
        sY = 0;
      }

      pX = sX * PIXEL_STEP;
      pY = sY * PIXEL_STEP;

      if ('deltaY' in e) {
        pY = e.deltaY;
      }
      if ('deltaX' in e) {
        pX = e.deltaX;
      }

      if (e.shiftKey && !pX) { // if user scrolls with shift he wants horizontal scroll
        pX = pY;
        pY = 0;
      }

      if ((pX || pY) && e.deltaMode) {
        if (e.deltaMode === 1) { // delta in LINE units
          pX *= LINE_HEIGHT;
          pY *= LINE_HEIGHT;
        } else { // delta in PAGE units
          pX *= PAGE_HEIGHT;
          pY *= PAGE_HEIGHT;
        }
      }

      // Fall-back if spin cannot be determined
      if (pX && !sX) {
        sX = (pX < 1) ? -1 : 1;
      }
      if (pY && !sY) {
        sY = (pY < 1) ? -1 : 1;
      }

      return {
        spinX: sX,
        spinY: sY,
        pixelX: pX,
        pixelY: pY,
      };
    },
    handleMouseEnter: function handleMouseEnter() {
      var swiper = this;
      swiper.mouseEntered = true;
    },
    handleMouseLeave: function handleMouseLeave() {
      var swiper = this;
      swiper.mouseEntered = false;
    },
    handle: function handle(event) {
      var e = event;
      var swiper = this;
      var params = swiper.params.mousewheel;

      if (swiper.params.cssMode) {
        e.preventDefault();
      }

      if (!swiper.mouseEntered && !params.releaseOnEdges) { return true; }

      if (e.originalEvent) { e = e.originalEvent; } // jquery fix
      var delta = 0;
      var rtlFactor = swiper.rtlTranslate ? -1 : 1;

      var data = Mousewheel.normalize(e);

      if (params.forceToAxis) {
        if (swiper.isHorizontal()) {
          if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) { delta = data.pixelX * rtlFactor; }
          else { return true; }
        } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) { delta = data.pixelY; }
        else { return true; }
      } else {
        delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
      }

      if (delta === 0) { return true; }

      if (params.invert) { delta = -delta; }

      if (!swiper.params.freeMode) {
        // Register the new event in a variable which stores the relevant data
        var newEvent = {
          time: Utils.now(),
          delta: Math.abs(delta),
          direction: Math.sign(delta),
          raw: event,
        };

        // Keep the most recent events
        var recentWheelEvents = swiper.mousewheel.recentWheelEvents;
        if (recentWheelEvents.length >= 2) {
          recentWheelEvents.shift(); // only store the last N events
        }
        var prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
        recentWheelEvents.push(newEvent);

        // If there is at least one previous recorded event:
        //   If direction has changed or
        //   if the scroll is quicker than the previous one:
        //     Animate the slider.
        // Else (this is the first time the wheel is moved):
        //     Animate the slider.
        if (prevEvent) {
          if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta) {
            swiper.mousewheel.animateSlider(newEvent);
          }
        } else {
          swiper.mousewheel.animateSlider(newEvent);
        }

        // If it's time to release the scroll:
        //   Return now so you don't hit the preventDefault.
        if (swiper.mousewheel.releaseScroll(newEvent)) {
          return true;
        }
      } else {
        // Freemode or scrollContainer:

        // If we recently snapped after a momentum scroll, then ignore wheel events
        // to give time for the deceleration to finish. Stop ignoring after 500 msecs
        // or if it's a new scroll (larger delta or inverse sign as last event before
        // an end-of-momentum snap).
        var newEvent$1 = { time: Utils.now(), delta: Math.abs(delta), direction: Math.sign(delta) };
        var ref = swiper.mousewheel;
        var lastEventBeforeSnap = ref.lastEventBeforeSnap;
        var ignoreWheelEvents = lastEventBeforeSnap
          && newEvent$1.time < lastEventBeforeSnap.time + 500
          && newEvent$1.delta <= lastEventBeforeSnap.delta
          && newEvent$1.direction === lastEventBeforeSnap.direction;
        if (!ignoreWheelEvents) {
          swiper.mousewheel.lastEventBeforeSnap = undefined;

          if (swiper.params.loop) {
            swiper.loopFix();
          }
          var position = swiper.getTranslate() + (delta * params.sensitivity);
          var wasBeginning = swiper.isBeginning;
          var wasEnd = swiper.isEnd;

          if (position >= swiper.minTranslate()) { position = swiper.minTranslate(); }
          if (position <= swiper.maxTranslate()) { position = swiper.maxTranslate(); }

          swiper.setTransition(0);
          swiper.setTranslate(position);
          swiper.updateProgress();
          swiper.updateActiveIndex();
          swiper.updateSlidesClasses();

          if ((!wasBeginning && swiper.isBeginning) || (!wasEnd && swiper.isEnd)) {
            swiper.updateSlidesClasses();
          }

          if (swiper.params.freeModeSticky) {
            // When wheel scrolling starts with sticky (aka snap) enabled, then detect
            // the end of a momentum scroll by storing recent (N=15?) wheel events.
            // 1. do all N events have decreasing or same (absolute value) delta?
            // 2. did all N events arrive in the last M (M=500?) msecs?
            // 3. does the earliest event have an (absolute value) delta that's
            //    at least P (P=1?) larger than the most recent event's delta?
            // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
            // If 1-4 are "yes" then we're near the end of a momuntum scroll deceleration.
            // Snap immediately and ignore remaining wheel events in this scroll.
            // See comment above for "remaining wheel events in this scroll" determination.
            // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
            clearTimeout(swiper.mousewheel.timeout);
            swiper.mousewheel.timeout = undefined;
            var recentWheelEvents$1 = swiper.mousewheel.recentWheelEvents;
            if (recentWheelEvents$1.length >= 15) {
              recentWheelEvents$1.shift(); // only store the last N events
            }
            var prevEvent$1 = recentWheelEvents$1.length ? recentWheelEvents$1[recentWheelEvents$1.length - 1] : undefined;
            var firstEvent = recentWheelEvents$1[0];
            recentWheelEvents$1.push(newEvent$1);
            if (prevEvent$1 && (newEvent$1.delta > prevEvent$1.delta || newEvent$1.direction !== prevEvent$1.direction)) {
              // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
              recentWheelEvents$1.splice(0);
            } else if (recentWheelEvents$1.length >= 15
                && newEvent$1.time - firstEvent.time < 500
                && firstEvent.delta - newEvent$1.delta >= 1
                && newEvent$1.delta <= 6
            ) {
              // We're at the end of the deceleration of a momentum scroll, so there's no need
              // to wait for more events. Snap ASAP on the next tick.
              // Also, because there's some remaining momentum we'll bias the snap in the
              // direction of the ongoing scroll because it's better UX for the scroll to snap
              // in the same direction as the scroll instead of reversing to snap.  Therefore,
              // if it's already scrolled more than 20% in the current direction, keep going.
              var snapToThreshold = delta > 0 ? 0.8 : 0.2;
              swiper.mousewheel.lastEventBeforeSnap = newEvent$1;
              recentWheelEvents$1.splice(0);
              swiper.mousewheel.timeout = Utils.nextTick(function () {
                swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
              }, 0); // no delay; move on next tick
            }
            if (!swiper.mousewheel.timeout) {
              // if we get here, then we haven't detected the end of a momentum scroll, so
              // we'll consider a scroll "complete" when there haven't been any wheel events
              // for 500ms.
              swiper.mousewheel.timeout = Utils.nextTick(function () {
                var snapToThreshold = 0.5;
                swiper.mousewheel.lastEventBeforeSnap = newEvent$1;
                recentWheelEvents$1.splice(0);
                swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
              }, 500);
            }
          }

          // Emit event
          if (!ignoreWheelEvents) { swiper.emit('scroll', e); }

          // Stop autoplay
          if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) { swiper.autoplay.stop(); }
          // Return page scroll on edge positions
          if (position === swiper.minTranslate() || position === swiper.maxTranslate()) { return true; }
        }
      }

      if (e.preventDefault) { e.preventDefault(); }
      else { e.returnValue = false; }
      return false;
    },
    animateSlider: function animateSlider(newEvent) {
      var swiper = this;
      // If the movement is NOT big enough and
      // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
      //   Don't go any further (avoid insignificant scroll movement).
      if (newEvent.delta >= 6 && Utils.now() - swiper.mousewheel.lastScrollTime < 60) {
        // Return false as a default
        return true;
      }
      // If user is scrolling towards the end:
      //   If the slider hasn't hit the latest slide or
      //   if the slider is a loop and
      //   if the slider isn't moving right now:
      //     Go to next slide and
      //     emit a scroll event.
      // Else (the user is scrolling towards the beginning) and
      // if the slider hasn't hit the first slide or
      // if the slider is a loop and
      // if the slider isn't moving right now:
      //   Go to prev slide and
      //   emit a scroll event.
      if (newEvent.direction < 0) {
        if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
          swiper.slideNext();
          swiper.emit('scroll', newEvent.raw);
        }
      } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
        swiper.slidePrev();
        swiper.emit('scroll', newEvent.raw);
      }
      // If you got here is because an animation has been triggered so store the current time
      swiper.mousewheel.lastScrollTime = (new win.Date()).getTime();
      // Return false as a default
      return false;
    },
    releaseScroll: function releaseScroll(newEvent) {
      var swiper = this;
      var params = swiper.params.mousewheel;
      if (newEvent.direction < 0) {
        if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) {
          // Return true to animate scroll on edges
          return true;
        }
      } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) {
        // Return true to animate scroll on edges
        return true;
      }
      return false;
    },
    enable: function enable() {
      var swiper = this;
      var event = Mousewheel.event();
      if (swiper.params.cssMode) {
        swiper.wrapperEl.removeEventListener(event, swiper.mousewheel.handle);
        return true;
      }
      if (!event) { return false; }
      if (swiper.mousewheel.enabled) { return false; }
      var target = swiper.$el;
      if (swiper.params.mousewheel.eventsTarged !== 'container') {
        target = $(swiper.params.mousewheel.eventsTarged);
      }
      target.on('mouseenter', swiper.mousewheel.handleMouseEnter);
      target.on('mouseleave', swiper.mousewheel.handleMouseLeave);
      target.on(event, swiper.mousewheel.handle);
      swiper.mousewheel.enabled = true;
      return true;
    },
    disable: function disable() {
      var swiper = this;
      var event = Mousewheel.event();
      if (swiper.params.cssMode) {
        swiper.wrapperEl.addEventListener(event, swiper.mousewheel.handle);
        return true;
      }
      if (!event) { return false; }
      if (!swiper.mousewheel.enabled) { return false; }
      var target = swiper.$el;
      if (swiper.params.mousewheel.eventsTarged !== 'container') {
        target = $(swiper.params.mousewheel.eventsTarged);
      }
      target.off(event, swiper.mousewheel.handle);
      swiper.mousewheel.enabled = false;
      return true;
    },
  };

  var Mousewheel$1 = {
    name: 'mousewheel',
    params: {
      mousewheel: {
        enabled: false,
        releaseOnEdges: false,
        invert: false,
        forceToAxis: false,
        sensitivity: 1,
        eventsTarged: 'container',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        mousewheel: {
          enabled: false,
          enable: Mousewheel.enable.bind(swiper),
          disable: Mousewheel.disable.bind(swiper),
          handle: Mousewheel.handle.bind(swiper),
          handleMouseEnter: Mousewheel.handleMouseEnter.bind(swiper),
          handleMouseLeave: Mousewheel.handleMouseLeave.bind(swiper),
          animateSlider: Mousewheel.animateSlider.bind(swiper),
          releaseScroll: Mousewheel.releaseScroll.bind(swiper),
          lastScrollTime: Utils.now(),
          lastEventBeforeSnap: undefined,
          recentWheelEvents: [],
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) {
          swiper.mousewheel.disable();
        }
        if (swiper.params.mousewheel.enabled) { swiper.mousewheel.enable(); }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.params.cssMode) {
          swiper.mousewheel.enable();
        }
        if (swiper.mousewheel.enabled) { swiper.mousewheel.disable(); }
      },
    },
  };

  var Navigation = {
    update: function update() {
      // Update Navigation Buttons
      var swiper = this;
      var params = swiper.params.navigation;

      if (swiper.params.loop) { return; }
      var ref = swiper.navigation;
      var $nextEl = ref.$nextEl;
      var $prevEl = ref.$prevEl;

      if ($prevEl && $prevEl.length > 0) {
        if (swiper.isBeginning) {
          $prevEl.addClass(params.disabledClass);
        } else {
          $prevEl.removeClass(params.disabledClass);
        }
        $prevEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
      if ($nextEl && $nextEl.length > 0) {
        if (swiper.isEnd) {
          $nextEl.addClass(params.disabledClass);
        } else {
          $nextEl.removeClass(params.disabledClass);
        }
        $nextEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
    },
    onPrevClick: function onPrevClick(e) {
      var swiper = this;
      e.preventDefault();
      if (swiper.isBeginning && !swiper.params.loop) { return; }
      swiper.slidePrev();
    },
    onNextClick: function onNextClick(e) {
      var swiper = this;
      e.preventDefault();
      if (swiper.isEnd && !swiper.params.loop) { return; }
      swiper.slideNext();
    },
    init: function init() {
      var swiper = this;
      var params = swiper.params.navigation;
      if (!(params.nextEl || params.prevEl)) { return; }

      var $nextEl;
      var $prevEl;
      if (params.nextEl) {
        $nextEl = $(params.nextEl);
        if (
          swiper.params.uniqueNavElements
          && typeof params.nextEl === 'string'
          && $nextEl.length > 1
          && swiper.$el.find(params.nextEl).length === 1
        ) {
          $nextEl = swiper.$el.find(params.nextEl);
        }
      }
      if (params.prevEl) {
        $prevEl = $(params.prevEl);
        if (
          swiper.params.uniqueNavElements
          && typeof params.prevEl === 'string'
          && $prevEl.length > 1
          && swiper.$el.find(params.prevEl).length === 1
        ) {
          $prevEl = swiper.$el.find(params.prevEl);
        }
      }

      if ($nextEl && $nextEl.length > 0) {
        $nextEl.on('click', swiper.navigation.onNextClick);
      }
      if ($prevEl && $prevEl.length > 0) {
        $prevEl.on('click', swiper.navigation.onPrevClick);
      }

      Utils.extend(swiper.navigation, {
        $nextEl: $nextEl,
        nextEl: $nextEl && $nextEl[0],
        $prevEl: $prevEl,
        prevEl: $prevEl && $prevEl[0],
      });
    },
    destroy: function destroy() {
      var swiper = this;
      var ref = swiper.navigation;
      var $nextEl = ref.$nextEl;
      var $prevEl = ref.$prevEl;
      if ($nextEl && $nextEl.length) {
        $nextEl.off('click', swiper.navigation.onNextClick);
        $nextEl.removeClass(swiper.params.navigation.disabledClass);
      }
      if ($prevEl && $prevEl.length) {
        $prevEl.off('click', swiper.navigation.onPrevClick);
        $prevEl.removeClass(swiper.params.navigation.disabledClass);
      }
    },
  };

  var Navigation$1 = {
    name: 'navigation',
    params: {
      navigation: {
        nextEl: null,
        prevEl: null,

        hideOnClick: false,
        disabledClass: 'swiper-button-disabled',
        hiddenClass: 'swiper-button-hidden',
        lockClass: 'swiper-button-lock',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        navigation: {
          init: Navigation.init.bind(swiper),
          update: Navigation.update.bind(swiper),
          destroy: Navigation.destroy.bind(swiper),
          onNextClick: Navigation.onNextClick.bind(swiper),
          onPrevClick: Navigation.onPrevClick.bind(swiper),
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        swiper.navigation.init();
        swiper.navigation.update();
      },
      toEdge: function toEdge() {
        var swiper = this;
        swiper.navigation.update();
      },
      fromEdge: function fromEdge() {
        var swiper = this;
        swiper.navigation.update();
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.navigation.destroy();
      },
      click: function click(e) {
        var swiper = this;
        var ref = swiper.navigation;
        var $nextEl = ref.$nextEl;
        var $prevEl = ref.$prevEl;
        if (
          swiper.params.navigation.hideOnClick
          && !$(e.target).is($prevEl)
          && !$(e.target).is($nextEl)
        ) {
          var isHidden;
          if ($nextEl) {
            isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
          } else if ($prevEl) {
            isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
          }
          if (isHidden === true) {
            swiper.emit('navigationShow', swiper);
          } else {
            swiper.emit('navigationHide', swiper);
          }
          if ($nextEl) {
            $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
          }
          if ($prevEl) {
            $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
          }
        }
      },
    },
  };

  var Pagination = {
    update: function update() {
      // Render || Update Pagination bullets/items
      var swiper = this;
      var rtl = swiper.rtl;
      var params = swiper.params.pagination;
      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
      var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
      var $el = swiper.pagination.$el;
      // Current/Total
      var current;
      var total = swiper.params.loop ? Math.ceil((slidesLength - (swiper.loopedSlides * 2)) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
      if (swiper.params.loop) {
        current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
        if (current > slidesLength - 1 - (swiper.loopedSlides * 2)) {
          current -= (slidesLength - (swiper.loopedSlides * 2));
        }
        if (current > total - 1) { current -= total; }
        if (current < 0 && swiper.params.paginationType !== 'bullets') { current = total + current; }
      } else if (typeof swiper.snapIndex !== 'undefined') {
        current = swiper.snapIndex;
      } else {
        current = swiper.activeIndex || 0;
      }
      // Types
      if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
        var bullets = swiper.pagination.bullets;
        var firstIndex;
        var lastIndex;
        var midIndex;
        if (params.dynamicBullets) {
          swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
          $el.css(swiper.isHorizontal() ? 'width' : 'height', ((swiper.pagination.bulletSize * (params.dynamicMainBullets + 4)) + "px"));
          if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
            swiper.pagination.dynamicBulletIndex += (current - swiper.previousIndex);
            if (swiper.pagination.dynamicBulletIndex > (params.dynamicMainBullets - 1)) {
              swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
            } else if (swiper.pagination.dynamicBulletIndex < 0) {
              swiper.pagination.dynamicBulletIndex = 0;
            }
          }
          firstIndex = current - swiper.pagination.dynamicBulletIndex;
          lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
          midIndex = (lastIndex + firstIndex) / 2;
        }
        bullets.removeClass(((params.bulletActiveClass) + " " + (params.bulletActiveClass) + "-next " + (params.bulletActiveClass) + "-next-next " + (params.bulletActiveClass) + "-prev " + (params.bulletActiveClass) + "-prev-prev " + (params.bulletActiveClass) + "-main"));
        if ($el.length > 1) {
          bullets.each(function (index, bullet) {
            var $bullet = $(bullet);
            var bulletIndex = $bullet.index();
            if (bulletIndex === current) {
              $bullet.addClass(params.bulletActiveClass);
            }
            if (params.dynamicBullets) {
              if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
                $bullet.addClass(((params.bulletActiveClass) + "-main"));
              }
              if (bulletIndex === firstIndex) {
                $bullet
                  .prev()
                  .addClass(((params.bulletActiveClass) + "-prev"))
                  .prev()
                  .addClass(((params.bulletActiveClass) + "-prev-prev"));
              }
              if (bulletIndex === lastIndex) {
                $bullet
                  .next()
                  .addClass(((params.bulletActiveClass) + "-next"))
                  .next()
                  .addClass(((params.bulletActiveClass) + "-next-next"));
              }
            }
          });
        } else {
          var $bullet = bullets.eq(current);
          var bulletIndex = $bullet.index();
          $bullet.addClass(params.bulletActiveClass);
          if (params.dynamicBullets) {
            var $firstDisplayedBullet = bullets.eq(firstIndex);
            var $lastDisplayedBullet = bullets.eq(lastIndex);
            for (var i = firstIndex; i <= lastIndex; i += 1) {
              bullets.eq(i).addClass(((params.bulletActiveClass) + "-main"));
            }
            if (swiper.params.loop) {
              if (bulletIndex >= bullets.length - params.dynamicMainBullets) {
                for (var i$1 = params.dynamicMainBullets; i$1 >= 0; i$1 -= 1) {
                  bullets.eq(bullets.length - i$1).addClass(((params.bulletActiveClass) + "-main"));
                }
                bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(((params.bulletActiveClass) + "-prev"));
              } else {
                $firstDisplayedBullet
                  .prev()
                  .addClass(((params.bulletActiveClass) + "-prev"))
                  .prev()
                  .addClass(((params.bulletActiveClass) + "-prev-prev"));
                $lastDisplayedBullet
                  .next()
                  .addClass(((params.bulletActiveClass) + "-next"))
                  .next()
                  .addClass(((params.bulletActiveClass) + "-next-next"));
              }
            } else {
              $firstDisplayedBullet
                .prev()
                .addClass(((params.bulletActiveClass) + "-prev"))
                .prev()
                .addClass(((params.bulletActiveClass) + "-prev-prev"));
              $lastDisplayedBullet
                .next()
                .addClass(((params.bulletActiveClass) + "-next"))
                .next()
                .addClass(((params.bulletActiveClass) + "-next-next"));
            }
          }
        }
        if (params.dynamicBullets) {
          var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
          var bulletsOffset = (((swiper.pagination.bulletSize * dynamicBulletsLength) - (swiper.pagination.bulletSize)) / 2) - (midIndex * swiper.pagination.bulletSize);
          var offsetProp = rtl ? 'right' : 'left';
          bullets.css(swiper.isHorizontal() ? offsetProp : 'top', (bulletsOffset + "px"));
        }
      }
      if (params.type === 'fraction') {
        $el.find(("." + (params.currentClass))).text(params.formatFractionCurrent(current + 1));
        $el.find(("." + (params.totalClass))).text(params.formatFractionTotal(total));
      }
      if (params.type === 'progressbar') {
        var progressbarDirection;
        if (params.progressbarOpposite) {
          progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
        } else {
          progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
        }
        var scale = (current + 1) / total;
        var scaleX = 1;
        var scaleY = 1;
        if (progressbarDirection === 'horizontal') {
          scaleX = scale;
        } else {
          scaleY = scale;
        }
        $el.find(("." + (params.progressbarFillClass))).transform(("translate3d(0,0,0) scaleX(" + scaleX + ") scaleY(" + scaleY + ")")).transition(swiper.params.speed);
      }
      if (params.type === 'custom' && params.renderCustom) {
        $el.html(params.renderCustom(swiper, current + 1, total));
        swiper.emit('paginationRender', swiper, $el[0]);
      } else {
        swiper.emit('paginationUpdate', swiper, $el[0]);
      }
      $el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    },
    render: function render() {
      // Render Container
      var swiper = this;
      var params = swiper.params.pagination;
      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
      var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;

      var $el = swiper.pagination.$el;
      var paginationHTML = '';
      if (params.type === 'bullets') {
        var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - (swiper.loopedSlides * 2)) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        for (var i = 0; i < numberOfBullets; i += 1) {
          if (params.renderBullet) {
            paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
          } else {
            paginationHTML += "<" + (params.bulletElement) + " class=\"" + (params.bulletClass) + "\"></" + (params.bulletElement) + ">";
          }
        }
        $el.html(paginationHTML);
        swiper.pagination.bullets = $el.find(("." + (params.bulletClass)));
      }
      if (params.type === 'fraction') {
        if (params.renderFraction) {
          paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
        } else {
          paginationHTML = "<span class=\"" + (params.currentClass) + "\"></span>"
          + ' / '
          + "<span class=\"" + (params.totalClass) + "\"></span>";
        }
        $el.html(paginationHTML);
      }
      if (params.type === 'progressbar') {
        if (params.renderProgressbar) {
          paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
        } else {
          paginationHTML = "<span class=\"" + (params.progressbarFillClass) + "\"></span>";
        }
        $el.html(paginationHTML);
      }
      if (params.type !== 'custom') {
        swiper.emit('paginationRender', swiper.pagination.$el[0]);
      }
    },
    init: function init() {
      var swiper = this;
      var params = swiper.params.pagination;
      if (!params.el) { return; }

      var $el = $(params.el);
      if ($el.length === 0) { return; }

      if (
        swiper.params.uniqueNavElements
        && typeof params.el === 'string'
        && $el.length > 1
        && swiper.$el.find(params.el).length === 1
      ) {
        $el = swiper.$el.find(params.el);
      }

      if (params.type === 'bullets' && params.clickable) {
        $el.addClass(params.clickableClass);
      }

      $el.addClass(params.modifierClass + params.type);

      if (params.type === 'bullets' && params.dynamicBullets) {
        $el.addClass(("" + (params.modifierClass) + (params.type) + "-dynamic"));
        swiper.pagination.dynamicBulletIndex = 0;
        if (params.dynamicMainBullets < 1) {
          params.dynamicMainBullets = 1;
        }
      }
      if (params.type === 'progressbar' && params.progressbarOpposite) {
        $el.addClass(params.progressbarOppositeClass);
      }

      if (params.clickable) {
        $el.on('click', ("." + (params.bulletClass)), function onClick(e) {
          e.preventDefault();
          var index = $(this).index() * swiper.params.slidesPerGroup;
          if (swiper.params.loop) { index += swiper.loopedSlides; }
          swiper.slideTo(index);
        });
      }

      Utils.extend(swiper.pagination, {
        $el: $el,
        el: $el[0],
      });
    },
    destroy: function destroy() {
      var swiper = this;
      var params = swiper.params.pagination;
      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
      var $el = swiper.pagination.$el;

      $el.removeClass(params.hiddenClass);
      $el.removeClass(params.modifierClass + params.type);
      if (swiper.pagination.bullets) { swiper.pagination.bullets.removeClass(params.bulletActiveClass); }
      if (params.clickable) {
        $el.off('click', ("." + (params.bulletClass)));
      }
    },
  };

  var Pagination$1 = {
    name: 'pagination',
    params: {
      pagination: {
        el: null,
        bulletElement: 'span',
        clickable: false,
        hideOnClick: false,
        renderBullet: null,
        renderProgressbar: null,
        renderFraction: null,
        renderCustom: null,
        progressbarOpposite: false,
        type: 'bullets', // 'bullets' or 'progressbar' or 'fraction' or 'custom'
        dynamicBullets: false,
        dynamicMainBullets: 1,
        formatFractionCurrent: function (number) { return number; },
        formatFractionTotal: function (number) { return number; },
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active',
        modifierClass: 'swiper-pagination-', // NEW
        currentClass: 'swiper-pagination-current',
        totalClass: 'swiper-pagination-total',
        hiddenClass: 'swiper-pagination-hidden',
        progressbarFillClass: 'swiper-pagination-progressbar-fill',
        progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
        clickableClass: 'swiper-pagination-clickable', // NEW
        lockClass: 'swiper-pagination-lock',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        pagination: {
          init: Pagination.init.bind(swiper),
          render: Pagination.render.bind(swiper),
          update: Pagination.update.bind(swiper),
          destroy: Pagination.destroy.bind(swiper),
          dynamicBulletIndex: 0,
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        swiper.pagination.init();
        swiper.pagination.render();
        swiper.pagination.update();
      },
      activeIndexChange: function activeIndexChange() {
        var swiper = this;
        if (swiper.params.loop) {
          swiper.pagination.update();
        } else if (typeof swiper.snapIndex === 'undefined') {
          swiper.pagination.update();
        }
      },
      snapIndexChange: function snapIndexChange() {
        var swiper = this;
        if (!swiper.params.loop) {
          swiper.pagination.update();
        }
      },
      slidesLengthChange: function slidesLengthChange() {
        var swiper = this;
        if (swiper.params.loop) {
          swiper.pagination.render();
          swiper.pagination.update();
        }
      },
      snapGridLengthChange: function snapGridLengthChange() {
        var swiper = this;
        if (!swiper.params.loop) {
          swiper.pagination.render();
          swiper.pagination.update();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.pagination.destroy();
      },
      click: function click(e) {
        var swiper = this;
        if (
          swiper.params.pagination.el
          && swiper.params.pagination.hideOnClick
          && swiper.pagination.$el.length > 0
          && !$(e.target).hasClass(swiper.params.pagination.bulletClass)
        ) {
          var isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);
          if (isHidden === true) {
            swiper.emit('paginationShow', swiper);
          } else {
            swiper.emit('paginationHide', swiper);
          }
          swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
        }
      },
    },
  };

  var Scrollbar = {
    setTranslate: function setTranslate() {
      var swiper = this;
      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }
      var scrollbar = swiper.scrollbar;
      var rtl = swiper.rtlTranslate;
      var progress = swiper.progress;
      var dragSize = scrollbar.dragSize;
      var trackSize = scrollbar.trackSize;
      var $dragEl = scrollbar.$dragEl;
      var $el = scrollbar.$el;
      var params = swiper.params.scrollbar;

      var newSize = dragSize;
      var newPos = (trackSize - dragSize) * progress;
      if (rtl) {
        newPos = -newPos;
        if (newPos > 0) {
          newSize = dragSize - newPos;
          newPos = 0;
        } else if (-newPos + dragSize > trackSize) {
          newSize = trackSize + newPos;
        }
      } else if (newPos < 0) {
        newSize = dragSize + newPos;
        newPos = 0;
      } else if (newPos + dragSize > trackSize) {
        newSize = trackSize - newPos;
      }
      if (swiper.isHorizontal()) {
        $dragEl.transform(("translate3d(" + newPos + "px, 0, 0)"));
        $dragEl[0].style.width = newSize + "px";
      } else {
        $dragEl.transform(("translate3d(0px, " + newPos + "px, 0)"));
        $dragEl[0].style.height = newSize + "px";
      }
      if (params.hide) {
        clearTimeout(swiper.scrollbar.timeout);
        $el[0].style.opacity = 1;
        swiper.scrollbar.timeout = setTimeout(function () {
          $el[0].style.opacity = 0;
          $el.transition(400);
        }, 1000);
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }
      swiper.scrollbar.$dragEl.transition(duration);
    },
    updateSize: function updateSize() {
      var swiper = this;
      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }

      var scrollbar = swiper.scrollbar;
      var $dragEl = scrollbar.$dragEl;
      var $el = scrollbar.$el;

      $dragEl[0].style.width = '';
      $dragEl[0].style.height = '';
      var trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;

      var divider = swiper.size / swiper.virtualSize;
      var moveDivider = divider * (trackSize / swiper.size);
      var dragSize;
      if (swiper.params.scrollbar.dragSize === 'auto') {
        dragSize = trackSize * divider;
      } else {
        dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
      }

      if (swiper.isHorizontal()) {
        $dragEl[0].style.width = dragSize + "px";
      } else {
        $dragEl[0].style.height = dragSize + "px";
      }

      if (divider >= 1) {
        $el[0].style.display = 'none';
      } else {
        $el[0].style.display = '';
      }
      if (swiper.params.scrollbar.hide) {
        $el[0].style.opacity = 0;
      }
      Utils.extend(scrollbar, {
        trackSize: trackSize,
        divider: divider,
        moveDivider: moveDivider,
        dragSize: dragSize,
      });
      scrollbar.$el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
    },
    getPointerPosition: function getPointerPosition(e) {
      var swiper = this;
      if (swiper.isHorizontal()) {
        return ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].clientX : e.clientX);
      }
      return ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].clientY : e.clientY);
    },
    setDragPosition: function setDragPosition(e) {
      var swiper = this;
      var scrollbar = swiper.scrollbar;
      var rtl = swiper.rtlTranslate;
      var $el = scrollbar.$el;
      var dragSize = scrollbar.dragSize;
      var trackSize = scrollbar.trackSize;
      var dragStartPos = scrollbar.dragStartPos;

      var positionRatio;
      positionRatio = ((scrollbar.getPointerPosition(e)) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top']
        - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
      positionRatio = Math.max(Math.min(positionRatio, 1), 0);
      if (rtl) {
        positionRatio = 1 - positionRatio;
      }

      var position = swiper.minTranslate() + ((swiper.maxTranslate() - swiper.minTranslate()) * positionRatio);

      swiper.updateProgress(position);
      swiper.setTranslate(position);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    },
    onDragStart: function onDragStart(e) {
      var swiper = this;
      var params = swiper.params.scrollbar;
      var scrollbar = swiper.scrollbar;
      var $wrapperEl = swiper.$wrapperEl;
      var $el = scrollbar.$el;
      var $dragEl = scrollbar.$dragEl;
      swiper.scrollbar.isTouched = true;
      swiper.scrollbar.dragStartPos = (e.target === $dragEl[0] || e.target === $dragEl)
        ? scrollbar.getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
      e.preventDefault();
      e.stopPropagation();

      $wrapperEl.transition(100);
      $dragEl.transition(100);
      scrollbar.setDragPosition(e);

      clearTimeout(swiper.scrollbar.dragTimeout);

      $el.transition(0);
      if (params.hide) {
        $el.css('opacity', 1);
      }
      if (swiper.params.cssMode) {
        swiper.$wrapperEl.css('scroll-snap-type', 'none');
      }
      swiper.emit('scrollbarDragStart', e);
    },
    onDragMove: function onDragMove(e) {
      var swiper = this;
      var scrollbar = swiper.scrollbar;
      var $wrapperEl = swiper.$wrapperEl;
      var $el = scrollbar.$el;
      var $dragEl = scrollbar.$dragEl;

      if (!swiper.scrollbar.isTouched) { return; }
      if (e.preventDefault) { e.preventDefault(); }
      else { e.returnValue = false; }
      scrollbar.setDragPosition(e);
      $wrapperEl.transition(0);
      $el.transition(0);
      $dragEl.transition(0);
      swiper.emit('scrollbarDragMove', e);
    },
    onDragEnd: function onDragEnd(e) {
      var swiper = this;

      var params = swiper.params.scrollbar;
      var scrollbar = swiper.scrollbar;
      var $wrapperEl = swiper.$wrapperEl;
      var $el = scrollbar.$el;

      if (!swiper.scrollbar.isTouched) { return; }
      swiper.scrollbar.isTouched = false;
      if (swiper.params.cssMode) {
        swiper.$wrapperEl.css('scroll-snap-type', '');
        $wrapperEl.transition('');
      }
      if (params.hide) {
        clearTimeout(swiper.scrollbar.dragTimeout);
        swiper.scrollbar.dragTimeout = Utils.nextTick(function () {
          $el.css('opacity', 0);
          $el.transition(400);
        }, 1000);
      }
      swiper.emit('scrollbarDragEnd', e);
      if (params.snapOnRelease) {
        swiper.slideToClosest();
      }
    },
    enableDraggable: function enableDraggable() {
      var swiper = this;
      if (!swiper.params.scrollbar.el) { return; }
      var scrollbar = swiper.scrollbar;
      var touchEventsTouch = swiper.touchEventsTouch;
      var touchEventsDesktop = swiper.touchEventsDesktop;
      var params = swiper.params;
      var $el = scrollbar.$el;
      var target = $el[0];
      var activeListener = Support.passiveListener && params.passiveListeners ? { passive: false, capture: false } : false;
      var passiveListener = Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
      if (!Support.touch) {
        target.addEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
        doc.addEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
        doc.addEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
      } else {
        target.addEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
        target.addEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
        target.addEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
      }
    },
    disableDraggable: function disableDraggable() {
      var swiper = this;
      if (!swiper.params.scrollbar.el) { return; }
      var scrollbar = swiper.scrollbar;
      var touchEventsTouch = swiper.touchEventsTouch;
      var touchEventsDesktop = swiper.touchEventsDesktop;
      var params = swiper.params;
      var $el = scrollbar.$el;
      var target = $el[0];
      var activeListener = Support.passiveListener && params.passiveListeners ? { passive: false, capture: false } : false;
      var passiveListener = Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
      if (!Support.touch) {
        target.removeEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
        doc.removeEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
        doc.removeEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
      } else {
        target.removeEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
        target.removeEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
        target.removeEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
      }
    },
    init: function init() {
      var swiper = this;
      if (!swiper.params.scrollbar.el) { return; }
      var scrollbar = swiper.scrollbar;
      var $swiperEl = swiper.$el;
      var params = swiper.params.scrollbar;

      var $el = $(params.el);
      if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
        $el = $swiperEl.find(params.el);
      }

      var $dragEl = $el.find(("." + (swiper.params.scrollbar.dragClass)));
      if ($dragEl.length === 0) {
        $dragEl = $(("<div class=\"" + (swiper.params.scrollbar.dragClass) + "\"></div>"));
        $el.append($dragEl);
      }

      Utils.extend(scrollbar, {
        $el: $el,
        el: $el[0],
        $dragEl: $dragEl,
        dragEl: $dragEl[0],
      });

      if (params.draggable) {
        scrollbar.enableDraggable();
      }
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.scrollbar.disableDraggable();
    },
  };

  var Scrollbar$1 = {
    name: 'scrollbar',
    params: {
      scrollbar: {
        el: null,
        dragSize: 'auto',
        hide: false,
        draggable: false,
        snapOnRelease: true,
        lockClass: 'swiper-scrollbar-lock',
        dragClass: 'swiper-scrollbar-drag',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        scrollbar: {
          init: Scrollbar.init.bind(swiper),
          destroy: Scrollbar.destroy.bind(swiper),
          updateSize: Scrollbar.updateSize.bind(swiper),
          setTranslate: Scrollbar.setTranslate.bind(swiper),
          setTransition: Scrollbar.setTransition.bind(swiper),
          enableDraggable: Scrollbar.enableDraggable.bind(swiper),
          disableDraggable: Scrollbar.disableDraggable.bind(swiper),
          setDragPosition: Scrollbar.setDragPosition.bind(swiper),
          getPointerPosition: Scrollbar.getPointerPosition.bind(swiper),
          onDragStart: Scrollbar.onDragStart.bind(swiper),
          onDragMove: Scrollbar.onDragMove.bind(swiper),
          onDragEnd: Scrollbar.onDragEnd.bind(swiper),
          isTouched: false,
          timeout: null,
          dragTimeout: null,
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        swiper.scrollbar.init();
        swiper.scrollbar.updateSize();
        swiper.scrollbar.setTranslate();
      },
      update: function update() {
        var swiper = this;
        swiper.scrollbar.updateSize();
      },
      resize: function resize() {
        var swiper = this;
        swiper.scrollbar.updateSize();
      },
      observerUpdate: function observerUpdate() {
        var swiper = this;
        swiper.scrollbar.updateSize();
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        swiper.scrollbar.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        swiper.scrollbar.setTransition(duration);
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.scrollbar.destroy();
      },
    },
  };

  var Parallax = {
    setTransform: function setTransform(el, progress) {
      var swiper = this;
      var rtl = swiper.rtl;

      var $el = $(el);
      var rtlFactor = rtl ? -1 : 1;

      var p = $el.attr('data-swiper-parallax') || '0';
      var x = $el.attr('data-swiper-parallax-x');
      var y = $el.attr('data-swiper-parallax-y');
      var scale = $el.attr('data-swiper-parallax-scale');
      var opacity = $el.attr('data-swiper-parallax-opacity');

      if (x || y) {
        x = x || '0';
        y = y || '0';
      } else if (swiper.isHorizontal()) {
        x = p;
        y = '0';
      } else {
        y = p;
        x = '0';
      }

      if ((x).indexOf('%') >= 0) {
        x = (parseInt(x, 10) * progress * rtlFactor) + "%";
      } else {
        x = (x * progress * rtlFactor) + "px";
      }
      if ((y).indexOf('%') >= 0) {
        y = (parseInt(y, 10) * progress) + "%";
      } else {
        y = (y * progress) + "px";
      }

      if (typeof opacity !== 'undefined' && opacity !== null) {
        var currentOpacity = opacity - ((opacity - 1) * (1 - Math.abs(progress)));
        $el[0].style.opacity = currentOpacity;
      }
      if (typeof scale === 'undefined' || scale === null) {
        $el.transform(("translate3d(" + x + ", " + y + ", 0px)"));
      } else {
        var currentScale = scale - ((scale - 1) * (1 - Math.abs(progress)));
        $el.transform(("translate3d(" + x + ", " + y + ", 0px) scale(" + currentScale + ")"));
      }
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      var $el = swiper.$el;
      var slides = swiper.slides;
      var progress = swiper.progress;
      var snapGrid = swiper.snapGrid;
      $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]')
        .each(function (index, el) {
          swiper.parallax.setTransform(el, progress);
        });
      slides.each(function (slideIndex, slideEl) {
        var slideProgress = slideEl.progress;
        if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
          slideProgress += Math.ceil(slideIndex / 2) - (progress * (snapGrid.length - 1));
        }
        slideProgress = Math.min(Math.max(slideProgress, -1), 1);
        $(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]')
          .each(function (index, el) {
            swiper.parallax.setTransform(el, slideProgress);
          });
      });
    },
    setTransition: function setTransition(duration) {
      if ( duration === void 0 ) duration = this.params.speed;

      var swiper = this;
      var $el = swiper.$el;
      $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]')
        .each(function (index, parallaxEl) {
          var $parallaxEl = $(parallaxEl);
          var parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
          if (duration === 0) { parallaxDuration = 0; }
          $parallaxEl.transition(parallaxDuration);
        });
    },
  };

  var Parallax$1 = {
    name: 'parallax',
    params: {
      parallax: {
        enabled: false,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        parallax: {
          setTransform: Parallax.setTransform.bind(swiper),
          setTranslate: Parallax.setTranslate.bind(swiper),
          setTransition: Parallax.setTransition.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (!swiper.params.parallax.enabled) { return; }
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
      },
      init: function init() {
        var swiper = this;
        if (!swiper.params.parallax.enabled) { return; }
        swiper.parallax.setTranslate();
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (!swiper.params.parallax.enabled) { return; }
        swiper.parallax.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (!swiper.params.parallax.enabled) { return; }
        swiper.parallax.setTransition(duration);
      },
    },
  };

  var Zoom = {
    // Calc Scale From Multi-touches
    getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
      if (e.targetTouches.length < 2) { return 1; }
      var x1 = e.targetTouches[0].pageX;
      var y1 = e.targetTouches[0].pageY;
      var x2 = e.targetTouches[1].pageX;
      var y2 = e.targetTouches[1].pageY;
      var distance = Math.sqrt((Math.pow( (x2 - x1), 2 )) + (Math.pow( (y2 - y1), 2 )));
      return distance;
    },
    // Events
    onGestureStart: function onGestureStart(e) {
      var swiper = this;
      var params = swiper.params.zoom;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      zoom.fakeGestureTouched = false;
      zoom.fakeGestureMoved = false;
      if (!Support.gestures) {
        if (e.type !== 'touchstart' || (e.type === 'touchstart' && e.targetTouches.length < 2)) {
          return;
        }
        zoom.fakeGestureTouched = true;
        gesture.scaleStart = Zoom.getDistanceBetweenTouches(e);
      }
      if (!gesture.$slideEl || !gesture.$slideEl.length) {
        gesture.$slideEl = $(e.target).closest('.swiper-slide');
        if (gesture.$slideEl.length === 0) { gesture.$slideEl = swiper.slides.eq(swiper.activeIndex); }
        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
        gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
        gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
        if (gesture.$imageWrapEl.length === 0) {
          gesture.$imageEl = undefined;
          return;
        }
      }
      gesture.$imageEl.transition(0);
      swiper.zoom.isScaling = true;
    },
    onGestureChange: function onGestureChange(e) {
      var swiper = this;
      var params = swiper.params.zoom;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      if (!Support.gestures) {
        if (e.type !== 'touchmove' || (e.type === 'touchmove' && e.targetTouches.length < 2)) {
          return;
        }
        zoom.fakeGestureMoved = true;
        gesture.scaleMove = Zoom.getDistanceBetweenTouches(e);
      }
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
      if (Support.gestures) {
        zoom.scale = e.scale * zoom.currentScale;
      } else {
        zoom.scale = (gesture.scaleMove / gesture.scaleStart) * zoom.currentScale;
      }
      if (zoom.scale > gesture.maxRatio) {
        zoom.scale = (gesture.maxRatio - 1) + (Math.pow( ((zoom.scale - gesture.maxRatio) + 1), 0.5 ));
      }
      if (zoom.scale < params.minRatio) {
        zoom.scale = (params.minRatio + 1) - (Math.pow( ((params.minRatio - zoom.scale) + 1), 0.5 ));
      }
      gesture.$imageEl.transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
    },
    onGestureEnd: function onGestureEnd(e) {
      var swiper = this;
      var params = swiper.params.zoom;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      if (!Support.gestures) {
        if (!zoom.fakeGestureTouched || !zoom.fakeGestureMoved) {
          return;
        }
        if (e.type !== 'touchend' || (e.type === 'touchend' && e.changedTouches.length < 2 && !Device.android)) {
          return;
        }
        zoom.fakeGestureTouched = false;
        zoom.fakeGestureMoved = false;
      }
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
      zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
      gesture.$imageEl.transition(swiper.params.speed).transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
      zoom.currentScale = zoom.scale;
      zoom.isScaling = false;
      if (zoom.scale === 1) { gesture.$slideEl = undefined; }
    },
    onTouchStart: function onTouchStart(e) {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      var image = zoom.image;
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
      if (image.isTouched) { return; }
      if (Device.android) { e.preventDefault(); }
      image.isTouched = true;
      image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
      image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    },
    onTouchMove: function onTouchMove(e) {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      var image = zoom.image;
      var velocity = zoom.velocity;
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
      swiper.allowClick = false;
      if (!image.isTouched || !gesture.$slideEl) { return; }

      if (!image.isMoved) {
        image.width = gesture.$imageEl[0].offsetWidth;
        image.height = gesture.$imageEl[0].offsetHeight;
        image.startX = Utils.getTranslate(gesture.$imageWrapEl[0], 'x') || 0;
        image.startY = Utils.getTranslate(gesture.$imageWrapEl[0], 'y') || 0;
        gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
        gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
        gesture.$imageWrapEl.transition(0);
        if (swiper.rtl) {
          image.startX = -image.startX;
          image.startY = -image.startY;
        }
      }
      // Define if we need image drag
      var scaledWidth = image.width * zoom.scale;
      var scaledHeight = image.height * zoom.scale;

      if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) { return; }

      image.minX = Math.min(((gesture.slideWidth / 2) - (scaledWidth / 2)), 0);
      image.maxX = -image.minX;
      image.minY = Math.min(((gesture.slideHeight / 2) - (scaledHeight / 2)), 0);
      image.maxY = -image.minY;

      image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
      image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;

      if (!image.isMoved && !zoom.isScaling) {
        if (
          swiper.isHorizontal()
          && (
            (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x)
            || (Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)
          )
        ) {
          image.isTouched = false;
          return;
        } if (
          !swiper.isHorizontal()
          && (
            (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y)
            || (Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)
          )
        ) {
          image.isTouched = false;
          return;
        }
      }
      e.preventDefault();
      e.stopPropagation();

      image.isMoved = true;
      image.currentX = (image.touchesCurrent.x - image.touchesStart.x) + image.startX;
      image.currentY = (image.touchesCurrent.y - image.touchesStart.y) + image.startY;

      if (image.currentX < image.minX) {
        image.currentX = (image.minX + 1) - (Math.pow( ((image.minX - image.currentX) + 1), 0.8 ));
      }
      if (image.currentX > image.maxX) {
        image.currentX = (image.maxX - 1) + (Math.pow( ((image.currentX - image.maxX) + 1), 0.8 ));
      }

      if (image.currentY < image.minY) {
        image.currentY = (image.minY + 1) - (Math.pow( ((image.minY - image.currentY) + 1), 0.8 ));
      }
      if (image.currentY > image.maxY) {
        image.currentY = (image.maxY - 1) + (Math.pow( ((image.currentY - image.maxY) + 1), 0.8 ));
      }

      // Velocity
      if (!velocity.prevPositionX) { velocity.prevPositionX = image.touchesCurrent.x; }
      if (!velocity.prevPositionY) { velocity.prevPositionY = image.touchesCurrent.y; }
      if (!velocity.prevTime) { velocity.prevTime = Date.now(); }
      velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
      velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
      if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) { velocity.x = 0; }
      if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) { velocity.y = 0; }
      velocity.prevPositionX = image.touchesCurrent.x;
      velocity.prevPositionY = image.touchesCurrent.y;
      velocity.prevTime = Date.now();

      gesture.$imageWrapEl.transform(("translate3d(" + (image.currentX) + "px, " + (image.currentY) + "px,0)"));
    },
    onTouchEnd: function onTouchEnd() {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      var image = zoom.image;
      var velocity = zoom.velocity;
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
      if (!image.isTouched || !image.isMoved) {
        image.isTouched = false;
        image.isMoved = false;
        return;
      }
      image.isTouched = false;
      image.isMoved = false;
      var momentumDurationX = 300;
      var momentumDurationY = 300;
      var momentumDistanceX = velocity.x * momentumDurationX;
      var newPositionX = image.currentX + momentumDistanceX;
      var momentumDistanceY = velocity.y * momentumDurationY;
      var newPositionY = image.currentY + momentumDistanceY;

      // Fix duration
      if (velocity.x !== 0) { momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x); }
      if (velocity.y !== 0) { momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y); }
      var momentumDuration = Math.max(momentumDurationX, momentumDurationY);

      image.currentX = newPositionX;
      image.currentY = newPositionY;

      // Define if we need image drag
      var scaledWidth = image.width * zoom.scale;
      var scaledHeight = image.height * zoom.scale;
      image.minX = Math.min(((gesture.slideWidth / 2) - (scaledWidth / 2)), 0);
      image.maxX = -image.minX;
      image.minY = Math.min(((gesture.slideHeight / 2) - (scaledHeight / 2)), 0);
      image.maxY = -image.minY;
      image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
      image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);

      gesture.$imageWrapEl.transition(momentumDuration).transform(("translate3d(" + (image.currentX) + "px, " + (image.currentY) + "px,0)"));
    },
    onTransitionEnd: function onTransitionEnd() {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
        gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
        gesture.$imageWrapEl.transform('translate3d(0,0,0)');

        zoom.scale = 1;
        zoom.currentScale = 1;

        gesture.$slideEl = undefined;
        gesture.$imageEl = undefined;
        gesture.$imageWrapEl = undefined;
      }
    },
    // Toggle Zoom
    toggle: function toggle(e) {
      var swiper = this;
      var zoom = swiper.zoom;

      if (zoom.scale && zoom.scale !== 1) {
        // Zoom Out
        zoom.out();
      } else {
        // Zoom In
        zoom.in(e);
      }
    },
    in: function in$1(e) {
      var swiper = this;

      var zoom = swiper.zoom;
      var params = swiper.params.zoom;
      var gesture = zoom.gesture;
      var image = zoom.image;

      if (!gesture.$slideEl) {
        gesture.$slideEl = swiper.clickedSlide ? $(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
        gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
      }
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }

      gesture.$slideEl.addClass(("" + (params.zoomedSlideClass)));

      var touchX;
      var touchY;
      var offsetX;
      var offsetY;
      var diffX;
      var diffY;
      var translateX;
      var translateY;
      var imageWidth;
      var imageHeight;
      var scaledWidth;
      var scaledHeight;
      var translateMinX;
      var translateMinY;
      var translateMaxX;
      var translateMaxY;
      var slideWidth;
      var slideHeight;

      if (typeof image.touchesStart.x === 'undefined' && e) {
        touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
        touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
      } else {
        touchX = image.touchesStart.x;
        touchY = image.touchesStart.y;
      }

      zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
      zoom.currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
      if (e) {
        slideWidth = gesture.$slideEl[0].offsetWidth;
        slideHeight = gesture.$slideEl[0].offsetHeight;
        offsetX = gesture.$slideEl.offset().left;
        offsetY = gesture.$slideEl.offset().top;
        diffX = (offsetX + (slideWidth / 2)) - touchX;
        diffY = (offsetY + (slideHeight / 2)) - touchY;

        imageWidth = gesture.$imageEl[0].offsetWidth;
        imageHeight = gesture.$imageEl[0].offsetHeight;
        scaledWidth = imageWidth * zoom.scale;
        scaledHeight = imageHeight * zoom.scale;

        translateMinX = Math.min(((slideWidth / 2) - (scaledWidth / 2)), 0);
        translateMinY = Math.min(((slideHeight / 2) - (scaledHeight / 2)), 0);
        translateMaxX = -translateMinX;
        translateMaxY = -translateMinY;

        translateX = diffX * zoom.scale;
        translateY = diffY * zoom.scale;

        if (translateX < translateMinX) {
          translateX = translateMinX;
        }
        if (translateX > translateMaxX) {
          translateX = translateMaxX;
        }

        if (translateY < translateMinY) {
          translateY = translateMinY;
        }
        if (translateY > translateMaxY) {
          translateY = translateMaxY;
        }
      } else {
        translateX = 0;
        translateY = 0;
      }
      gesture.$imageWrapEl.transition(300).transform(("translate3d(" + translateX + "px, " + translateY + "px,0)"));
      gesture.$imageEl.transition(300).transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
    },
    out: function out() {
      var swiper = this;

      var zoom = swiper.zoom;
      var params = swiper.params.zoom;
      var gesture = zoom.gesture;

      if (!gesture.$slideEl) {
        gesture.$slideEl = swiper.clickedSlide ? $(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
        gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
      }
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }

      zoom.scale = 1;
      zoom.currentScale = 1;
      gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
      gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
      gesture.$slideEl.removeClass(("" + (params.zoomedSlideClass)));
      gesture.$slideEl = undefined;
    },
    // Attach/Detach Events
    enable: function enable() {
      var swiper = this;
      var zoom = swiper.zoom;
      if (zoom.enabled) { return; }
      zoom.enabled = true;

      var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;
      var activeListenerWithCapture = Support.passiveListener ? { passive: false, capture: true } : true;

      // Scale image
      if (Support.gestures) {
        swiper.$wrapperEl.on('gesturestart', '.swiper-slide', zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.on('gesturechange', '.swiper-slide', zoom.onGestureChange, passiveListener);
        swiper.$wrapperEl.on('gestureend', '.swiper-slide', zoom.onGestureEnd, passiveListener);
      } else if (swiper.touchEvents.start === 'touchstart') {
        swiper.$wrapperEl.on(swiper.touchEvents.start, '.swiper-slide', zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.on(swiper.touchEvents.move, '.swiper-slide', zoom.onGestureChange, activeListenerWithCapture);
        swiper.$wrapperEl.on(swiper.touchEvents.end, '.swiper-slide', zoom.onGestureEnd, passiveListener);
        if (swiper.touchEvents.cancel) {
          swiper.$wrapperEl.on(swiper.touchEvents.cancel, '.swiper-slide', zoom.onGestureEnd, passiveListener);
        }
      }

      // Move image
      swiper.$wrapperEl.on(swiper.touchEvents.move, ("." + (swiper.params.zoom.containerClass)), zoom.onTouchMove, activeListenerWithCapture);
    },
    disable: function disable() {
      var swiper = this;
      var zoom = swiper.zoom;
      if (!zoom.enabled) { return; }

      swiper.zoom.enabled = false;

      var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;
      var activeListenerWithCapture = Support.passiveListener ? { passive: false, capture: true } : true;

      // Scale image
      if (Support.gestures) {
        swiper.$wrapperEl.off('gesturestart', '.swiper-slide', zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.off('gesturechange', '.swiper-slide', zoom.onGestureChange, passiveListener);
        swiper.$wrapperEl.off('gestureend', '.swiper-slide', zoom.onGestureEnd, passiveListener);
      } else if (swiper.touchEvents.start === 'touchstart') {
        swiper.$wrapperEl.off(swiper.touchEvents.start, '.swiper-slide', zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.off(swiper.touchEvents.move, '.swiper-slide', zoom.onGestureChange, activeListenerWithCapture);
        swiper.$wrapperEl.off(swiper.touchEvents.end, '.swiper-slide', zoom.onGestureEnd, passiveListener);
        if (swiper.touchEvents.cancel) {
          swiper.$wrapperEl.off(swiper.touchEvents.cancel, '.swiper-slide', zoom.onGestureEnd, passiveListener);
        }
      }

      // Move image
      swiper.$wrapperEl.off(swiper.touchEvents.move, ("." + (swiper.params.zoom.containerClass)), zoom.onTouchMove, activeListenerWithCapture);
    },
  };

  var Zoom$1 = {
    name: 'zoom',
    params: {
      zoom: {
        enabled: false,
        maxRatio: 3,
        minRatio: 1,
        toggle: true,
        containerClass: 'swiper-zoom-container',
        zoomedSlideClass: 'swiper-slide-zoomed',
      },
    },
    create: function create() {
      var swiper = this;
      var zoom = {
        enabled: false,
        scale: 1,
        currentScale: 1,
        isScaling: false,
        gesture: {
          $slideEl: undefined,
          slideWidth: undefined,
          slideHeight: undefined,
          $imageEl: undefined,
          $imageWrapEl: undefined,
          maxRatio: 3,
        },
        image: {
          isTouched: undefined,
          isMoved: undefined,
          currentX: undefined,
          currentY: undefined,
          minX: undefined,
          minY: undefined,
          maxX: undefined,
          maxY: undefined,
          width: undefined,
          height: undefined,
          startX: undefined,
          startY: undefined,
          touchesStart: {},
          touchesCurrent: {},
        },
        velocity: {
          x: undefined,
          y: undefined,
          prevPositionX: undefined,
          prevPositionY: undefined,
          prevTime: undefined,
        },
      };

      ('onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out').split(' ').forEach(function (methodName) {
        zoom[methodName] = Zoom[methodName].bind(swiper);
      });
      Utils.extend(swiper, {
        zoom: zoom,
      });

      var scale = 1;
      Object.defineProperty(swiper.zoom, 'scale', {
        get: function get() {
          return scale;
        },
        set: function set(value) {
          if (scale !== value) {
            var imageEl = swiper.zoom.gesture.$imageEl ? swiper.zoom.gesture.$imageEl[0] : undefined;
            var slideEl = swiper.zoom.gesture.$slideEl ? swiper.zoom.gesture.$slideEl[0] : undefined;
            swiper.emit('zoomChange', value, imageEl, slideEl);
          }
          scale = value;
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.zoom.enabled) {
          swiper.zoom.enable();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.zoom.disable();
      },
      touchStart: function touchStart(e) {
        var swiper = this;
        if (!swiper.zoom.enabled) { return; }
        swiper.zoom.onTouchStart(e);
      },
      touchEnd: function touchEnd(e) {
        var swiper = this;
        if (!swiper.zoom.enabled) { return; }
        swiper.zoom.onTouchEnd(e);
      },
      doubleTap: function doubleTap(e) {
        var swiper = this;
        if (swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
          swiper.zoom.toggle(e);
        }
      },
      transitionEnd: function transitionEnd() {
        var swiper = this;
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
          swiper.zoom.onTransitionEnd();
        }
      },
      slideChange: function slideChange() {
        var swiper = this;
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) {
          swiper.zoom.onTransitionEnd();
        }
      },
    },
  };

  var Lazy = {
    loadInSlide: function loadInSlide(index, loadInDuplicate) {
      if ( loadInDuplicate === void 0 ) loadInDuplicate = true;

      var swiper = this;
      var params = swiper.params.lazy;
      if (typeof index === 'undefined') { return; }
      if (swiper.slides.length === 0) { return; }
      var isVirtual = swiper.virtual && swiper.params.virtual.enabled;

      var $slideEl = isVirtual
        ? swiper.$wrapperEl.children(("." + (swiper.params.slideClass) + "[data-swiper-slide-index=\"" + index + "\"]"))
        : swiper.slides.eq(index);

      var $images = $slideEl.find(("." + (params.elementClass) + ":not(." + (params.loadedClass) + "):not(." + (params.loadingClass) + ")"));
      if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
        $images = $images.add($slideEl[0]);
      }
      if ($images.length === 0) { return; }

      $images.each(function (imageIndex, imageEl) {
        var $imageEl = $(imageEl);
        $imageEl.addClass(params.loadingClass);

        var background = $imageEl.attr('data-background');
        var src = $imageEl.attr('data-src');
        var srcset = $imageEl.attr('data-srcset');
        var sizes = $imageEl.attr('data-sizes');

        swiper.loadImage($imageEl[0], (src || background), srcset, sizes, false, function () {
          if (typeof swiper === 'undefined' || swiper === null || !swiper || (swiper && !swiper.params) || swiper.destroyed) { return; }
          if (background) {
            $imageEl.css('background-image', ("url(\"" + background + "\")"));
            $imageEl.removeAttr('data-background');
          } else {
            if (srcset) {
              $imageEl.attr('srcset', srcset);
              $imageEl.removeAttr('data-srcset');
            }
            if (sizes) {
              $imageEl.attr('sizes', sizes);
              $imageEl.removeAttr('data-sizes');
            }
            if (src) {
              $imageEl.attr('src', src);
              $imageEl.removeAttr('data-src');
            }
          }

          $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
          $slideEl.find(("." + (params.preloaderClass))).remove();
          if (swiper.params.loop && loadInDuplicate) {
            var slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');
            if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
              var originalSlide = swiper.$wrapperEl.children(("[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]:not(." + (swiper.params.slideDuplicateClass) + ")"));
              swiper.lazy.loadInSlide(originalSlide.index(), false);
            } else {
              var duplicatedSlide = swiper.$wrapperEl.children(("." + (swiper.params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]"));
              swiper.lazy.loadInSlide(duplicatedSlide.index(), false);
            }
          }
          swiper.emit('lazyImageReady', $slideEl[0], $imageEl[0]);
        });

        swiper.emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
      });
    },
    load: function load() {
      var swiper = this;
      var $wrapperEl = swiper.$wrapperEl;
      var swiperParams = swiper.params;
      var slides = swiper.slides;
      var activeIndex = swiper.activeIndex;
      var isVirtual = swiper.virtual && swiperParams.virtual.enabled;
      var params = swiperParams.lazy;

      var slidesPerView = swiperParams.slidesPerView;
      if (slidesPerView === 'auto') {
        slidesPerView = 0;
      }

      function slideExist(index) {
        if (isVirtual) {
          if ($wrapperEl.children(("." + (swiperParams.slideClass) + "[data-swiper-slide-index=\"" + index + "\"]")).length) {
            return true;
          }
        } else if (slides[index]) { return true; }
        return false;
      }
      function slideIndex(slideEl) {
        if (isVirtual) {
          return $(slideEl).attr('data-swiper-slide-index');
        }
        return $(slideEl).index();
      }

      if (!swiper.lazy.initialImageLoaded) { swiper.lazy.initialImageLoaded = true; }
      if (swiper.params.watchSlidesVisibility) {
        $wrapperEl.children(("." + (swiperParams.slideVisibleClass))).each(function (elIndex, slideEl) {
          var index = isVirtual ? $(slideEl).attr('data-swiper-slide-index') : $(slideEl).index();
          swiper.lazy.loadInSlide(index);
        });
      } else if (slidesPerView > 1) {
        for (var i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
          if (slideExist(i)) { swiper.lazy.loadInSlide(i); }
        }
      } else {
        swiper.lazy.loadInSlide(activeIndex);
      }
      if (params.loadPrevNext) {
        if (slidesPerView > 1 || (params.loadPrevNextAmount && params.loadPrevNextAmount > 1)) {
          var amount = params.loadPrevNextAmount;
          var spv = slidesPerView;
          var maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
          var minIndex = Math.max(activeIndex - Math.max(spv, amount), 0);
          // Next Slides
          for (var i$1 = activeIndex + slidesPerView; i$1 < maxIndex; i$1 += 1) {
            if (slideExist(i$1)) { swiper.lazy.loadInSlide(i$1); }
          }
          // Prev Slides
          for (var i$2 = minIndex; i$2 < activeIndex; i$2 += 1) {
            if (slideExist(i$2)) { swiper.lazy.loadInSlide(i$2); }
          }
        } else {
          var nextSlide = $wrapperEl.children(("." + (swiperParams.slideNextClass)));
          if (nextSlide.length > 0) { swiper.lazy.loadInSlide(slideIndex(nextSlide)); }

          var prevSlide = $wrapperEl.children(("." + (swiperParams.slidePrevClass)));
          if (prevSlide.length > 0) { swiper.lazy.loadInSlide(slideIndex(prevSlide)); }
        }
      }
    },
  };

  var Lazy$1 = {
    name: 'lazy',
    params: {
      lazy: {
        enabled: false,
        loadPrevNext: false,
        loadPrevNextAmount: 1,
        loadOnTransitionStart: false,

        elementClass: 'swiper-lazy',
        loadingClass: 'swiper-lazy-loading',
        loadedClass: 'swiper-lazy-loaded',
        preloaderClass: 'swiper-lazy-preloader',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        lazy: {
          initialImageLoaded: false,
          load: Lazy.load.bind(swiper),
          loadInSlide: Lazy.loadInSlide.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
          swiper.params.preloadImages = false;
        }
      },
      init: function init() {
        var swiper = this;
        if (swiper.params.lazy.enabled && !swiper.params.loop && swiper.params.initialSlide === 0) {
          swiper.lazy.load();
        }
      },
      scroll: function scroll() {
        var swiper = this;
        if (swiper.params.freeMode && !swiper.params.freeModeSticky) {
          swiper.lazy.load();
        }
      },
      resize: function resize() {
        var swiper = this;
        if (swiper.params.lazy.enabled) {
          swiper.lazy.load();
        }
      },
      scrollbarDragMove: function scrollbarDragMove() {
        var swiper = this;
        if (swiper.params.lazy.enabled) {
          swiper.lazy.load();
        }
      },
      transitionStart: function transitionStart() {
        var swiper = this;
        if (swiper.params.lazy.enabled) {
          if (swiper.params.lazy.loadOnTransitionStart || (!swiper.params.lazy.loadOnTransitionStart && !swiper.lazy.initialImageLoaded)) {
            swiper.lazy.load();
          }
        }
      },
      transitionEnd: function transitionEnd() {
        var swiper = this;
        if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
          swiper.lazy.load();
        }
      },
      slideChange: function slideChange() {
        var swiper = this;
        if (swiper.params.lazy.enabled && swiper.params.cssMode) {
          swiper.lazy.load();
        }
      },
    },
  };

  /* eslint no-bitwise: ["error", { "allow": [">>"] }] */

  var Controller = {
    LinearSpline: function LinearSpline(x, y) {
      var binarySearch = (function search() {
        var maxIndex;
        var minIndex;
        var guess;
        return function (array, val) {
          minIndex = -1;
          maxIndex = array.length;
          while (maxIndex - minIndex > 1) {
            guess = maxIndex + minIndex >> 1;
            if (array[guess] <= val) {
              minIndex = guess;
            } else {
              maxIndex = guess;
            }
          }
          return maxIndex;
        };
      }());
      this.x = x;
      this.y = y;
      this.lastIndex = x.length - 1;
      // Given an x value (x2), return the expected y2 value:
      // (x1,y1) is the known point before given value,
      // (x3,y3) is the known point after given value.
      var i1;
      var i3;

      this.interpolate = function interpolate(x2) {
        if (!x2) { return 0; }

        // Get the indexes of x1 and x3 (the array indexes before and after given x2):
        i3 = binarySearch(this.x, x2);
        i1 = i3 - 1;

        // We have our indexes i1 & i3, so we can calculate already:
        // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
        return (((x2 - this.x[i1]) * (this.y[i3] - this.y[i1])) / (this.x[i3] - this.x[i1])) + this.y[i1];
      };
      return this;
    },
    // xxx: for now i will just save one spline function to to
    getInterpolateFunction: function getInterpolateFunction(c) {
      var swiper = this;
      if (!swiper.controller.spline) {
        swiper.controller.spline = swiper.params.loop
          ? new Controller.LinearSpline(swiper.slidesGrid, c.slidesGrid)
          : new Controller.LinearSpline(swiper.snapGrid, c.snapGrid);
      }
    },
    setTranslate: function setTranslate(setTranslate$1, byController) {
      var swiper = this;
      var controlled = swiper.controller.control;
      var multiplier;
      var controlledTranslate;
      function setControlledTranslate(c) {
        // this will create an Interpolate function based on the snapGrids
        // x is the Grid of the scrolled scroller and y will be the controlled scroller
        // it makes sense to create this only once and recall it for the interpolation
        // the function does a lot of value caching for performance
        var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
        if (swiper.params.controller.by === 'slide') {
          swiper.controller.getInterpolateFunction(c);
          // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
          // but it did not work out
          controlledTranslate = -swiper.controller.spline.interpolate(-translate);
        }

        if (!controlledTranslate || swiper.params.controller.by === 'container') {
          multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
          controlledTranslate = ((translate - swiper.minTranslate()) * multiplier) + c.minTranslate();
        }

        if (swiper.params.controller.inverse) {
          controlledTranslate = c.maxTranslate() - controlledTranslate;
        }
        c.updateProgress(controlledTranslate);
        c.setTranslate(controlledTranslate, swiper);
        c.updateActiveIndex();
        c.updateSlidesClasses();
      }
      if (Array.isArray(controlled)) {
        for (var i = 0; i < controlled.length; i += 1) {
          if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
            setControlledTranslate(controlled[i]);
          }
        }
      } else if (controlled instanceof Swiper && byController !== controlled) {
        setControlledTranslate(controlled);
      }
    },
    setTransition: function setTransition(duration, byController) {
      var swiper = this;
      var controlled = swiper.controller.control;
      var i;
      function setControlledTransition(c) {
        c.setTransition(duration, swiper);
        if (duration !== 0) {
          c.transitionStart();
          if (c.params.autoHeight) {
            Utils.nextTick(function () {
              c.updateAutoHeight();
            });
          }
          c.$wrapperEl.transitionEnd(function () {
            if (!controlled) { return; }
            if (c.params.loop && swiper.params.controller.by === 'slide') {
              c.loopFix();
            }
            c.transitionEnd();
          });
        }
      }
      if (Array.isArray(controlled)) {
        for (i = 0; i < controlled.length; i += 1) {
          if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
            setControlledTransition(controlled[i]);
          }
        }
      } else if (controlled instanceof Swiper && byController !== controlled) {
        setControlledTransition(controlled);
      }
    },
  };
  var Controller$1 = {
    name: 'controller',
    params: {
      controller: {
        control: undefined,
        inverse: false,
        by: 'slide', // or 'container'
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        controller: {
          control: swiper.params.controller.control,
          getInterpolateFunction: Controller.getInterpolateFunction.bind(swiper),
          setTranslate: Controller.setTranslate.bind(swiper),
          setTransition: Controller.setTransition.bind(swiper),
        },
      });
    },
    on: {
      update: function update() {
        var swiper = this;
        if (!swiper.controller.control) { return; }
        if (swiper.controller.spline) {
          swiper.controller.spline = undefined;
          delete swiper.controller.spline;
        }
      },
      resize: function resize() {
        var swiper = this;
        if (!swiper.controller.control) { return; }
        if (swiper.controller.spline) {
          swiper.controller.spline = undefined;
          delete swiper.controller.spline;
        }
      },
      observerUpdate: function observerUpdate() {
        var swiper = this;
        if (!swiper.controller.control) { return; }
        if (swiper.controller.spline) {
          swiper.controller.spline = undefined;
          delete swiper.controller.spline;
        }
      },
      setTranslate: function setTranslate(translate, byController) {
        var swiper = this;
        if (!swiper.controller.control) { return; }
        swiper.controller.setTranslate(translate, byController);
      },
      setTransition: function setTransition(duration, byController) {
        var swiper = this;
        if (!swiper.controller.control) { return; }
        swiper.controller.setTransition(duration, byController);
      },
    },
  };

  var a11y = {
    makeElFocusable: function makeElFocusable($el) {
      $el.attr('tabIndex', '0');
      return $el;
    },
    addElRole: function addElRole($el, role) {
      $el.attr('role', role);
      return $el;
    },
    addElLabel: function addElLabel($el, label) {
      $el.attr('aria-label', label);
      return $el;
    },
    disableEl: function disableEl($el) {
      $el.attr('aria-disabled', true);
      return $el;
    },
    enableEl: function enableEl($el) {
      $el.attr('aria-disabled', false);
      return $el;
    },
    onEnterKey: function onEnterKey(e) {
      var swiper = this;
      var params = swiper.params.a11y;
      if (e.keyCode !== 13) { return; }
      var $targetEl = $(e.target);
      if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
        if (!(swiper.isEnd && !swiper.params.loop)) {
          swiper.slideNext();
        }
        if (swiper.isEnd) {
          swiper.a11y.notify(params.lastSlideMessage);
        } else {
          swiper.a11y.notify(params.nextSlideMessage);
        }
      }
      if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
        if (!(swiper.isBeginning && !swiper.params.loop)) {
          swiper.slidePrev();
        }
        if (swiper.isBeginning) {
          swiper.a11y.notify(params.firstSlideMessage);
        } else {
          swiper.a11y.notify(params.prevSlideMessage);
        }
      }
      if (swiper.pagination && $targetEl.is(("." + (swiper.params.pagination.bulletClass)))) {
        $targetEl[0].click();
      }
    },
    notify: function notify(message) {
      var swiper = this;
      var notification = swiper.a11y.liveRegion;
      if (notification.length === 0) { return; }
      notification.html('');
      notification.html(message);
    },
    updateNavigation: function updateNavigation() {
      var swiper = this;

      if (swiper.params.loop || !swiper.navigation) { return; }
      var ref = swiper.navigation;
      var $nextEl = ref.$nextEl;
      var $prevEl = ref.$prevEl;

      if ($prevEl && $prevEl.length > 0) {
        if (swiper.isBeginning) {
          swiper.a11y.disableEl($prevEl);
        } else {
          swiper.a11y.enableEl($prevEl);
        }
      }
      if ($nextEl && $nextEl.length > 0) {
        if (swiper.isEnd) {
          swiper.a11y.disableEl($nextEl);
        } else {
          swiper.a11y.enableEl($nextEl);
        }
      }
    },
    updatePagination: function updatePagination() {
      var swiper = this;
      var params = swiper.params.a11y;
      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
        swiper.pagination.bullets.each(function (bulletIndex, bulletEl) {
          var $bulletEl = $(bulletEl);
          swiper.a11y.makeElFocusable($bulletEl);
          swiper.a11y.addElRole($bulletEl, 'button');
          swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/{{index}}/, $bulletEl.index() + 1));
        });
      }
    },
    init: function init() {
      var swiper = this;

      swiper.$el.append(swiper.a11y.liveRegion);

      // Navigation
      var params = swiper.params.a11y;
      var $nextEl;
      var $prevEl;
      if (swiper.navigation && swiper.navigation.$nextEl) {
        $nextEl = swiper.navigation.$nextEl;
      }
      if (swiper.navigation && swiper.navigation.$prevEl) {
        $prevEl = swiper.navigation.$prevEl;
      }
      if ($nextEl) {
        swiper.a11y.makeElFocusable($nextEl);
        swiper.a11y.addElRole($nextEl, 'button');
        swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
        $nextEl.on('keydown', swiper.a11y.onEnterKey);
      }
      if ($prevEl) {
        swiper.a11y.makeElFocusable($prevEl);
        swiper.a11y.addElRole($prevEl, 'button');
        swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
        $prevEl.on('keydown', swiper.a11y.onEnterKey);
      }

      // Pagination
      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
        swiper.pagination.$el.on('keydown', ("." + (swiper.params.pagination.bulletClass)), swiper.a11y.onEnterKey);
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) { swiper.a11y.liveRegion.remove(); }

      var $nextEl;
      var $prevEl;
      if (swiper.navigation && swiper.navigation.$nextEl) {
        $nextEl = swiper.navigation.$nextEl;
      }
      if (swiper.navigation && swiper.navigation.$prevEl) {
        $prevEl = swiper.navigation.$prevEl;
      }
      if ($nextEl) {
        $nextEl.off('keydown', swiper.a11y.onEnterKey);
      }
      if ($prevEl) {
        $prevEl.off('keydown', swiper.a11y.onEnterKey);
      }

      // Pagination
      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
        swiper.pagination.$el.off('keydown', ("." + (swiper.params.pagination.bulletClass)), swiper.a11y.onEnterKey);
      }
    },
  };
  var A11y = {
    name: 'a11y',
    params: {
      a11y: {
        enabled: true,
        notificationClass: 'swiper-notification',
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        firstSlideMessage: 'This is the first slide',
        lastSlideMessage: 'This is the last slide',
        paginationBulletMessage: 'Go to slide {{index}}',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        a11y: {
          liveRegion: $(("<span class=\"" + (swiper.params.a11y.notificationClass) + "\" aria-live=\"assertive\" aria-atomic=\"true\"></span>")),
        },
      });
      Object.keys(a11y).forEach(function (methodName) {
        swiper.a11y[methodName] = a11y[methodName].bind(swiper);
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) { return; }
        swiper.a11y.init();
        swiper.a11y.updateNavigation();
      },
      toEdge: function toEdge() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) { return; }
        swiper.a11y.updateNavigation();
      },
      fromEdge: function fromEdge() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) { return; }
        swiper.a11y.updateNavigation();
      },
      paginationUpdate: function paginationUpdate() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) { return; }
        swiper.a11y.updatePagination();
      },
      destroy: function destroy() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) { return; }
        swiper.a11y.destroy();
      },
    },
  };

  var History = {
    init: function init() {
      var swiper = this;
      if (!swiper.params.history) { return; }
      if (!win.history || !win.history.pushState) {
        swiper.params.history.enabled = false;
        swiper.params.hashNavigation.enabled = true;
        return;
      }
      var history = swiper.history;
      history.initialized = true;
      history.paths = History.getPathValues();
      if (!history.paths.key && !history.paths.value) { return; }
      history.scrollToSlide(0, history.paths.value, swiper.params.runCallbacksOnInit);
      if (!swiper.params.history.replaceState) {
        win.addEventListener('popstate', swiper.history.setHistoryPopState);
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (!swiper.params.history.replaceState) {
        win.removeEventListener('popstate', swiper.history.setHistoryPopState);
      }
    },
    setHistoryPopState: function setHistoryPopState() {
      var swiper = this;
      swiper.history.paths = History.getPathValues();
      swiper.history.scrollToSlide(swiper.params.speed, swiper.history.paths.value, false);
    },
    getPathValues: function getPathValues() {
      var pathArray = win.location.pathname.slice(1).split('/').filter(function (part) { return part !== ''; });
      var total = pathArray.length;
      var key = pathArray[total - 2];
      var value = pathArray[total - 1];
      return { key: key, value: value };
    },
    setHistory: function setHistory(key, index) {
      var swiper = this;
      if (!swiper.history.initialized || !swiper.params.history.enabled) { return; }
      var slide = swiper.slides.eq(index);
      var value = History.slugify(slide.attr('data-history'));
      if (!win.location.pathname.includes(key)) {
        value = key + "/" + value;
      }
      var currentState = win.history.state;
      if (currentState && currentState.value === value) {
        return;
      }
      if (swiper.params.history.replaceState) {
        win.history.replaceState({ value: value }, null, value);
      } else {
        win.history.pushState({ value: value }, null, value);
      }
    },
    slugify: function slugify(text) {
      return text.toString()
        .replace(/\s+/g, '-')
        .replace(/[^\w-]+/g, '')
        .replace(/--+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
    },
    scrollToSlide: function scrollToSlide(speed, value, runCallbacks) {
      var swiper = this;
      if (value) {
        for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
          var slide = swiper.slides.eq(i);
          var slideHistory = History.slugify(slide.attr('data-history'));
          if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
            var index = slide.index();
            swiper.slideTo(index, speed, runCallbacks);
          }
        }
      } else {
        swiper.slideTo(0, speed, runCallbacks);
      }
    },
  };

  var History$1 = {
    name: 'history',
    params: {
      history: {
        enabled: false,
        replaceState: false,
        key: 'slides',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        history: {
          init: History.init.bind(swiper),
          setHistory: History.setHistory.bind(swiper),
          setHistoryPopState: History.setHistoryPopState.bind(swiper),
          scrollToSlide: History.scrollToSlide.bind(swiper),
          destroy: History.destroy.bind(swiper),
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.history.enabled) {
          swiper.history.init();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.params.history.enabled) {
          swiper.history.destroy();
        }
      },
      transitionEnd: function transitionEnd() {
        var swiper = this;
        if (swiper.history.initialized) {
          swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
        }
      },
      slideChange: function slideChange() {
        var swiper = this;
        if (swiper.history.initialized && swiper.params.cssMode) {
          swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
        }
      },
    },
  };

  var HashNavigation = {
    onHashCange: function onHashCange() {
      var swiper = this;
      var newHash = doc.location.hash.replace('#', '');
      var activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');
      if (newHash !== activeSlideHash) {
        var newIndex = swiper.$wrapperEl.children(("." + (swiper.params.slideClass) + "[data-hash=\"" + newHash + "\"]")).index();
        if (typeof newIndex === 'undefined') { return; }
        swiper.slideTo(newIndex);
      }
    },
    setHash: function setHash() {
      var swiper = this;
      if (!swiper.hashNavigation.initialized || !swiper.params.hashNavigation.enabled) { return; }
      if (swiper.params.hashNavigation.replaceState && win.history && win.history.replaceState) {
        win.history.replaceState(null, null, (("#" + (swiper.slides.eq(swiper.activeIndex).attr('data-hash'))) || ''));
      } else {
        var slide = swiper.slides.eq(swiper.activeIndex);
        var hash = slide.attr('data-hash') || slide.attr('data-history');
        doc.location.hash = hash || '';
      }
    },
    init: function init() {
      var swiper = this;
      if (!swiper.params.hashNavigation.enabled || (swiper.params.history && swiper.params.history.enabled)) { return; }
      swiper.hashNavigation.initialized = true;
      var hash = doc.location.hash.replace('#', '');
      if (hash) {
        var speed = 0;
        for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
          var slide = swiper.slides.eq(i);
          var slideHash = slide.attr('data-hash') || slide.attr('data-history');
          if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
            var index = slide.index();
            swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
          }
        }
      }
      if (swiper.params.hashNavigation.watchState) {
        $(win).on('hashchange', swiper.hashNavigation.onHashCange);
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (swiper.params.hashNavigation.watchState) {
        $(win).off('hashchange', swiper.hashNavigation.onHashCange);
      }
    },
  };
  var HashNavigation$1 = {
    name: 'hash-navigation',
    params: {
      hashNavigation: {
        enabled: false,
        replaceState: false,
        watchState: false,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        hashNavigation: {
          initialized: false,
          init: HashNavigation.init.bind(swiper),
          destroy: HashNavigation.destroy.bind(swiper),
          setHash: HashNavigation.setHash.bind(swiper),
          onHashCange: HashNavigation.onHashCange.bind(swiper),
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.hashNavigation.enabled) {
          swiper.hashNavigation.init();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.params.hashNavigation.enabled) {
          swiper.hashNavigation.destroy();
        }
      },
      transitionEnd: function transitionEnd() {
        var swiper = this;
        if (swiper.hashNavigation.initialized) {
          swiper.hashNavigation.setHash();
        }
      },
      slideChange: function slideChange() {
        var swiper = this;
        if (swiper.hashNavigation.initialized && swiper.params.cssMode) {
          swiper.hashNavigation.setHash();
        }
      },
    },
  };

  /* eslint no-underscore-dangle: "off" */

  var Autoplay = {
    run: function run() {
      var swiper = this;
      var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
      var delay = swiper.params.autoplay.delay;
      if ($activeSlideEl.attr('data-swiper-autoplay')) {
        delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
      }
      clearTimeout(swiper.autoplay.timeout);
      swiper.autoplay.timeout = Utils.nextTick(function () {
        if (swiper.params.autoplay.reverseDirection) {
          if (swiper.params.loop) {
            swiper.loopFix();
            swiper.slidePrev(swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else if (!swiper.isBeginning) {
            swiper.slidePrev(swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else if (!swiper.params.autoplay.stopOnLastSlide) {
            swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else {
            swiper.autoplay.stop();
          }
        } else if (swiper.params.loop) {
          swiper.loopFix();
          swiper.slideNext(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.isEnd) {
          swiper.slideNext(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          swiper.slideTo(0, swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else {
          swiper.autoplay.stop();
        }
        if (swiper.params.cssMode && swiper.autoplay.running) { swiper.autoplay.run(); }
      }, delay);
    },
    start: function start() {
      var swiper = this;
      if (typeof swiper.autoplay.timeout !== 'undefined') { return false; }
      if (swiper.autoplay.running) { return false; }
      swiper.autoplay.running = true;
      swiper.emit('autoplayStart');
      swiper.autoplay.run();
      return true;
    },
    stop: function stop() {
      var swiper = this;
      if (!swiper.autoplay.running) { return false; }
      if (typeof swiper.autoplay.timeout === 'undefined') { return false; }

      if (swiper.autoplay.timeout) {
        clearTimeout(swiper.autoplay.timeout);
        swiper.autoplay.timeout = undefined;
      }
      swiper.autoplay.running = false;
      swiper.emit('autoplayStop');
      return true;
    },
    pause: function pause(speed) {
      var swiper = this;
      if (!swiper.autoplay.running) { return; }
      if (swiper.autoplay.paused) { return; }
      if (swiper.autoplay.timeout) { clearTimeout(swiper.autoplay.timeout); }
      swiper.autoplay.paused = true;
      if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
        swiper.autoplay.paused = false;
        swiper.autoplay.run();
      } else {
        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.autoplay.onTransitionEnd);
        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
      }
    },
  };

  var Autoplay$1 = {
    name: 'autoplay',
    params: {
      autoplay: {
        enabled: false,
        delay: 3000,
        waitForTransition: true,
        disableOnInteraction: true,
        stopOnLastSlide: false,
        reverseDirection: false,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        autoplay: {
          running: false,
          paused: false,
          run: Autoplay.run.bind(swiper),
          start: Autoplay.start.bind(swiper),
          stop: Autoplay.stop.bind(swiper),
          pause: Autoplay.pause.bind(swiper),
          onVisibilityChange: function onVisibilityChange() {
            if (document.visibilityState === 'hidden' && swiper.autoplay.running) {
              swiper.autoplay.pause();
            }
            if (document.visibilityState === 'visible' && swiper.autoplay.paused) {
              swiper.autoplay.run();
              swiper.autoplay.paused = false;
            }
          },
          onTransitionEnd: function onTransitionEnd(e) {
            if (!swiper || swiper.destroyed || !swiper.$wrapperEl) { return; }
            if (e.target !== this) { return; }
            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.autoplay.onTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
            swiper.autoplay.paused = false;
            if (!swiper.autoplay.running) {
              swiper.autoplay.stop();
            } else {
              swiper.autoplay.run();
            }
          },
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.autoplay.enabled) {
          swiper.autoplay.start();
          document.addEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
        }
      },
      beforeTransitionStart: function beforeTransitionStart(speed, internal) {
        var swiper = this;
        if (swiper.autoplay.running) {
          if (internal || !swiper.params.autoplay.disableOnInteraction) {
            swiper.autoplay.pause(speed);
          } else {
            swiper.autoplay.stop();
          }
        }
      },
      sliderFirstMove: function sliderFirstMove() {
        var swiper = this;
        if (swiper.autoplay.running) {
          if (swiper.params.autoplay.disableOnInteraction) {
            swiper.autoplay.stop();
          } else {
            swiper.autoplay.pause();
          }
        }
      },
      touchEnd: function touchEnd() {
        var swiper = this;
        if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) {
          swiper.autoplay.run();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.autoplay.running) {
          swiper.autoplay.stop();
        }
        document.removeEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
      },
    },
  };

  var Fade = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var slides = swiper.slides;
      for (var i = 0; i < slides.length; i += 1) {
        var $slideEl = swiper.slides.eq(i);
        var offset = $slideEl[0].swiperSlideOffset;
        var tx = -offset;
        if (!swiper.params.virtualTranslate) { tx -= swiper.translate; }
        var ty = 0;
        if (!swiper.isHorizontal()) {
          ty = tx;
          tx = 0;
        }
        var slideOpacity = swiper.params.fadeEffect.crossFade
          ? Math.max(1 - Math.abs($slideEl[0].progress), 0)
          : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
        $slideEl
          .css({
            opacity: slideOpacity,
          })
          .transform(("translate3d(" + tx + "px, " + ty + "px, 0px)"));
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      var slides = swiper.slides;
      var $wrapperEl = swiper.$wrapperEl;
      slides.transition(duration);
      if (swiper.params.virtualTranslate && duration !== 0) {
        var eventTriggered = false;
        slides.transitionEnd(function () {
          if (eventTriggered) { return; }
          if (!swiper || swiper.destroyed) { return; }
          eventTriggered = true;
          swiper.animating = false;
          var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
          for (var i = 0; i < triggerEvents.length; i += 1) {
            $wrapperEl.trigger(triggerEvents[i]);
          }
        });
      }
    },
  };

  var EffectFade = {
    name: 'effect-fade',
    params: {
      fadeEffect: {
        crossFade: false,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        fadeEffect: {
          setTranslate: Fade.setTranslate.bind(swiper),
          setTransition: Fade.setTransition.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.effect !== 'fade') { return; }
        swiper.classNames.push(((swiper.params.containerModifierClass) + "fade"));
        var overwriteParams = {
          slidesPerView: 1,
          slidesPerColumn: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          spaceBetween: 0,
          virtualTranslate: true,
        };
        Utils.extend(swiper.params, overwriteParams);
        Utils.extend(swiper.originalParams, overwriteParams);
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (swiper.params.effect !== 'fade') { return; }
        swiper.fadeEffect.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (swiper.params.effect !== 'fade') { return; }
        swiper.fadeEffect.setTransition(duration);
      },
    },
  };

  var Cube = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var $el = swiper.$el;
      var $wrapperEl = swiper.$wrapperEl;
      var slides = swiper.slides;
      var swiperWidth = swiper.width;
      var swiperHeight = swiper.height;
      var rtl = swiper.rtlTranslate;
      var swiperSize = swiper.size;
      var params = swiper.params.cubeEffect;
      var isHorizontal = swiper.isHorizontal();
      var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
      var wrapperRotate = 0;
      var $cubeShadowEl;
      if (params.shadow) {
        if (isHorizontal) {
          $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');
          if ($cubeShadowEl.length === 0) {
            $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
            $wrapperEl.append($cubeShadowEl);
          }
          $cubeShadowEl.css({ height: (swiperWidth + "px") });
        } else {
          $cubeShadowEl = $el.find('.swiper-cube-shadow');
          if ($cubeShadowEl.length === 0) {
            $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
            $el.append($cubeShadowEl);
          }
        }
      }
      for (var i = 0; i < slides.length; i += 1) {
        var $slideEl = slides.eq(i);
        var slideIndex = i;
        if (isVirtual) {
          slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
        }
        var slideAngle = slideIndex * 90;
        var round = Math.floor(slideAngle / 360);
        if (rtl) {
          slideAngle = -slideAngle;
          round = Math.floor(-slideAngle / 360);
        }
        var progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
        var tx = 0;
        var ty = 0;
        var tz = 0;
        if (slideIndex % 4 === 0) {
          tx = -round * 4 * swiperSize;
          tz = 0;
        } else if ((slideIndex - 1) % 4 === 0) {
          tx = 0;
          tz = -round * 4 * swiperSize;
        } else if ((slideIndex - 2) % 4 === 0) {
          tx = swiperSize + (round * 4 * swiperSize);
          tz = swiperSize;
        } else if ((slideIndex - 3) % 4 === 0) {
          tx = -swiperSize;
          tz = (3 * swiperSize) + (swiperSize * 4 * round);
        }
        if (rtl) {
          tx = -tx;
        }

        if (!isHorizontal) {
          ty = tx;
          tx = 0;
        }

        var transform = "rotateX(" + (isHorizontal ? 0 : -slideAngle) + "deg) rotateY(" + (isHorizontal ? slideAngle : 0) + "deg) translate3d(" + tx + "px, " + ty + "px, " + tz + "px)";
        if (progress <= 1 && progress > -1) {
          wrapperRotate = (slideIndex * 90) + (progress * 90);
          if (rtl) { wrapperRotate = (-slideIndex * 90) - (progress * 90); }
        }
        $slideEl.transform(transform);
        if (params.slideShadows) {
          // Set shadows
          var shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
          var shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
          if (shadowBefore.length === 0) {
            shadowBefore = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>"));
            $slideEl.append(shadowBefore);
          }
          if (shadowAfter.length === 0) {
            shadowAfter = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>"));
            $slideEl.append(shadowAfter);
          }
          if (shadowBefore.length) { shadowBefore[0].style.opacity = Math.max(-progress, 0); }
          if (shadowAfter.length) { shadowAfter[0].style.opacity = Math.max(progress, 0); }
        }
      }
      $wrapperEl.css({
        '-webkit-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
        '-moz-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
        '-ms-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
        'transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
      });

      if (params.shadow) {
        if (isHorizontal) {
          $cubeShadowEl.transform(("translate3d(0px, " + ((swiperWidth / 2) + params.shadowOffset) + "px, " + (-swiperWidth / 2) + "px) rotateX(90deg) rotateZ(0deg) scale(" + (params.shadowScale) + ")"));
        } else {
          var shadowAngle = Math.abs(wrapperRotate) - (Math.floor(Math.abs(wrapperRotate) / 90) * 90);
          var multiplier = 1.5 - (
            (Math.sin((shadowAngle * 2 * Math.PI) / 360) / 2)
            + (Math.cos((shadowAngle * 2 * Math.PI) / 360) / 2)
          );
          var scale1 = params.shadowScale;
          var scale2 = params.shadowScale / multiplier;
          var offset = params.shadowOffset;
          $cubeShadowEl.transform(("scale3d(" + scale1 + ", 1, " + scale2 + ") translate3d(0px, " + ((swiperHeight / 2) + offset) + "px, " + (-swiperHeight / 2 / scale2) + "px) rotateX(-90deg)"));
        }
      }
      var zFactor = (Browser.isSafari || Browser.isUiWebView) ? (-swiperSize / 2) : 0;
      $wrapperEl
        .transform(("translate3d(0px,0," + zFactor + "px) rotateX(" + (swiper.isHorizontal() ? 0 : wrapperRotate) + "deg) rotateY(" + (swiper.isHorizontal() ? -wrapperRotate : 0) + "deg)"));
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      var $el = swiper.$el;
      var slides = swiper.slides;
      slides
        .transition(duration)
        .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
        .transition(duration);
      if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
        $el.find('.swiper-cube-shadow').transition(duration);
      }
    },
  };

  var EffectCube = {
    name: 'effect-cube',
    params: {
      cubeEffect: {
        slideShadows: true,
        shadow: true,
        shadowOffset: 20,
        shadowScale: 0.94,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        cubeEffect: {
          setTranslate: Cube.setTranslate.bind(swiper),
          setTransition: Cube.setTransition.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.effect !== 'cube') { return; }
        swiper.classNames.push(((swiper.params.containerModifierClass) + "cube"));
        swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));
        var overwriteParams = {
          slidesPerView: 1,
          slidesPerColumn: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          resistanceRatio: 0,
          spaceBetween: 0,
          centeredSlides: false,
          virtualTranslate: true,
        };
        Utils.extend(swiper.params, overwriteParams);
        Utils.extend(swiper.originalParams, overwriteParams);
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (swiper.params.effect !== 'cube') { return; }
        swiper.cubeEffect.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (swiper.params.effect !== 'cube') { return; }
        swiper.cubeEffect.setTransition(duration);
      },
    },
  };

  var Flip = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var slides = swiper.slides;
      var rtl = swiper.rtlTranslate;
      for (var i = 0; i < slides.length; i += 1) {
        var $slideEl = slides.eq(i);
        var progress = $slideEl[0].progress;
        if (swiper.params.flipEffect.limitRotation) {
          progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
        }
        var offset = $slideEl[0].swiperSlideOffset;
        var rotate = -180 * progress;
        var rotateY = rotate;
        var rotateX = 0;
        var tx = -offset;
        var ty = 0;
        if (!swiper.isHorizontal()) {
          ty = tx;
          tx = 0;
          rotateX = -rotateY;
          rotateY = 0;
        } else if (rtl) {
          rotateY = -rotateY;
        }

        $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;

        if (swiper.params.flipEffect.slideShadows) {
          // Set shadows
          var shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
          var shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
          if (shadowBefore.length === 0) {
            shadowBefore = $(("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'left' : 'top') + "\"></div>"));
            $slideEl.append(shadowBefore);
          }
          if (shadowAfter.length === 0) {
            shadowAfter = $(("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'right' : 'bottom') + "\"></div>"));
            $slideEl.append(shadowAfter);
          }
          if (shadowBefore.length) { shadowBefore[0].style.opacity = Math.max(-progress, 0); }
          if (shadowAfter.length) { shadowAfter[0].style.opacity = Math.max(progress, 0); }
        }
        $slideEl
          .transform(("translate3d(" + tx + "px, " + ty + "px, 0px) rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)"));
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      var slides = swiper.slides;
      var activeIndex = swiper.activeIndex;
      var $wrapperEl = swiper.$wrapperEl;
      slides
        .transition(duration)
        .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
        .transition(duration);
      if (swiper.params.virtualTranslate && duration !== 0) {
        var eventTriggered = false;
        // eslint-disable-next-line
        slides.eq(activeIndex).transitionEnd(function onTransitionEnd() {
          if (eventTriggered) { return; }
          if (!swiper || swiper.destroyed) { return; }
          // if (!$(this).hasClass(swiper.params.slideActiveClass)) return;
          eventTriggered = true;
          swiper.animating = false;
          var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
          for (var i = 0; i < triggerEvents.length; i += 1) {
            $wrapperEl.trigger(triggerEvents[i]);
          }
        });
      }
    },
  };

  var EffectFlip = {
    name: 'effect-flip',
    params: {
      flipEffect: {
        slideShadows: true,
        limitRotation: true,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        flipEffect: {
          setTranslate: Flip.setTranslate.bind(swiper),
          setTransition: Flip.setTransition.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.effect !== 'flip') { return; }
        swiper.classNames.push(((swiper.params.containerModifierClass) + "flip"));
        swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));
        var overwriteParams = {
          slidesPerView: 1,
          slidesPerColumn: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          spaceBetween: 0,
          virtualTranslate: true,
        };
        Utils.extend(swiper.params, overwriteParams);
        Utils.extend(swiper.originalParams, overwriteParams);
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (swiper.params.effect !== 'flip') { return; }
        swiper.flipEffect.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (swiper.params.effect !== 'flip') { return; }
        swiper.flipEffect.setTransition(duration);
      },
    },
  };

  var Coverflow = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var swiperWidth = swiper.width;
      var swiperHeight = swiper.height;
      var slides = swiper.slides;
      var $wrapperEl = swiper.$wrapperEl;
      var slidesSizesGrid = swiper.slidesSizesGrid;
      var params = swiper.params.coverflowEffect;
      var isHorizontal = swiper.isHorizontal();
      var transform = swiper.translate;
      var center = isHorizontal ? -transform + (swiperWidth / 2) : -transform + (swiperHeight / 2);
      var rotate = isHorizontal ? params.rotate : -params.rotate;
      var translate = params.depth;
      // Each slide offset from center
      for (var i = 0, length = slides.length; i < length; i += 1) {
        var $slideEl = slides.eq(i);
        var slideSize = slidesSizesGrid[i];
        var slideOffset = $slideEl[0].swiperSlideOffset;
        var offsetMultiplier = ((center - slideOffset - (slideSize / 2)) / slideSize) * params.modifier;

        var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
        var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
        // var rotateZ = 0
        var translateZ = -translate * Math.abs(offsetMultiplier);

        var translateY = isHorizontal ? 0 : params.stretch * (offsetMultiplier);
        var translateX = isHorizontal ? params.stretch * (offsetMultiplier) : 0;

        // Fix for ultra small values
        if (Math.abs(translateX) < 0.001) { translateX = 0; }
        if (Math.abs(translateY) < 0.001) { translateY = 0; }
        if (Math.abs(translateZ) < 0.001) { translateZ = 0; }
        if (Math.abs(rotateY) < 0.001) { rotateY = 0; }
        if (Math.abs(rotateX) < 0.001) { rotateX = 0; }

        var slideTransform = "translate3d(" + translateX + "px," + translateY + "px," + translateZ + "px)  rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)";

        $slideEl.transform(slideTransform);
        $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
        if (params.slideShadows) {
          // Set shadows
          var $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
          var $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
          if ($shadowBeforeEl.length === 0) {
            $shadowBeforeEl = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>"));
            $slideEl.append($shadowBeforeEl);
          }
          if ($shadowAfterEl.length === 0) {
            $shadowAfterEl = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>"));
            $slideEl.append($shadowAfterEl);
          }
          if ($shadowBeforeEl.length) { $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0; }
          if ($shadowAfterEl.length) { $shadowAfterEl[0].style.opacity = (-offsetMultiplier) > 0 ? -offsetMultiplier : 0; }
        }
      }

      // Set correct perspective for IE10
      if (Support.pointerEvents || Support.prefixedPointerEvents) {
        var ws = $wrapperEl[0].style;
        ws.perspectiveOrigin = center + "px 50%";
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      swiper.slides
        .transition(duration)
        .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
        .transition(duration);
    },
  };

  var EffectCoverflow = {
    name: 'effect-coverflow',
    params: {
      coverflowEffect: {
        rotate: 50,
        stretch: 0,
        depth: 100,
        modifier: 1,
        slideShadows: true,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        coverflowEffect: {
          setTranslate: Coverflow.setTranslate.bind(swiper),
          setTransition: Coverflow.setTransition.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.effect !== 'coverflow') { return; }

        swiper.classNames.push(((swiper.params.containerModifierClass) + "coverflow"));
        swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));

        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (swiper.params.effect !== 'coverflow') { return; }
        swiper.coverflowEffect.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (swiper.params.effect !== 'coverflow') { return; }
        swiper.coverflowEffect.setTransition(duration);
      },
    },
  };

  var Thumbs = {
    init: function init() {
      var swiper = this;
      var ref = swiper.params;
      var thumbsParams = ref.thumbs;
      var SwiperClass = swiper.constructor;
      if (thumbsParams.swiper instanceof SwiperClass) {
        swiper.thumbs.swiper = thumbsParams.swiper;
        Utils.extend(swiper.thumbs.swiper.originalParams, {
          watchSlidesProgress: true,
          slideToClickedSlide: false,
        });
        Utils.extend(swiper.thumbs.swiper.params, {
          watchSlidesProgress: true,
          slideToClickedSlide: false,
        });
      } else if (Utils.isObject(thumbsParams.swiper)) {
        swiper.thumbs.swiper = new SwiperClass(Utils.extend({}, thumbsParams.swiper, {
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          slideToClickedSlide: false,
        }));
        swiper.thumbs.swiperCreated = true;
      }
      swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
      swiper.thumbs.swiper.on('tap', swiper.thumbs.onThumbClick);
    },
    onThumbClick: function onThumbClick() {
      var swiper = this;
      var thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper) { return; }
      var clickedIndex = thumbsSwiper.clickedIndex;
      var clickedSlide = thumbsSwiper.clickedSlide;
      if (clickedSlide && $(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) { return; }
      if (typeof clickedIndex === 'undefined' || clickedIndex === null) { return; }
      var slideToIndex;
      if (thumbsSwiper.params.loop) {
        slideToIndex = parseInt($(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
      } else {
        slideToIndex = clickedIndex;
      }
      if (swiper.params.loop) {
        var currentIndex = swiper.activeIndex;
        if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
          swiper.loopFix();
          // eslint-disable-next-line
          swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
          currentIndex = swiper.activeIndex;
        }
        var prevIndex = swiper.slides.eq(currentIndex).prevAll(("[data-swiper-slide-index=\"" + slideToIndex + "\"]")).eq(0).index();
        var nextIndex = swiper.slides.eq(currentIndex).nextAll(("[data-swiper-slide-index=\"" + slideToIndex + "\"]")).eq(0).index();
        if (typeof prevIndex === 'undefined') { slideToIndex = nextIndex; }
        else if (typeof nextIndex === 'undefined') { slideToIndex = prevIndex; }
        else if (nextIndex - currentIndex < currentIndex - prevIndex) { slideToIndex = nextIndex; }
        else { slideToIndex = prevIndex; }
      }
      swiper.slideTo(slideToIndex);
    },
    update: function update(initial) {
      var swiper = this;
      var thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper) { return; }

      var slidesPerView = thumbsSwiper.params.slidesPerView === 'auto'
        ? thumbsSwiper.slidesPerViewDynamic()
        : thumbsSwiper.params.slidesPerView;

      if (swiper.realIndex !== thumbsSwiper.realIndex) {
        var currentThumbsIndex = thumbsSwiper.activeIndex;
        var newThumbsIndex;
        if (thumbsSwiper.params.loop) {
          if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
            thumbsSwiper.loopFix();
            // eslint-disable-next-line
            thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
            currentThumbsIndex = thumbsSwiper.activeIndex;
          }
          // Find actual thumbs index to slide to
          var prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll(("[data-swiper-slide-index=\"" + (swiper.realIndex) + "\"]")).eq(0).index();
          var nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll(("[data-swiper-slide-index=\"" + (swiper.realIndex) + "\"]")).eq(0).index();
          if (typeof prevThumbsIndex === 'undefined') { newThumbsIndex = nextThumbsIndex; }
          else if (typeof nextThumbsIndex === 'undefined') { newThumbsIndex = prevThumbsIndex; }
          else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) { newThumbsIndex = currentThumbsIndex; }
          else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) { newThumbsIndex = nextThumbsIndex; }
          else { newThumbsIndex = prevThumbsIndex; }
        } else {
          newThumbsIndex = swiper.realIndex;
        }
        if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
          if (thumbsSwiper.params.centeredSlides) {
            if (newThumbsIndex > currentThumbsIndex) {
              newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
            } else {
              newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
            }
          } else if (newThumbsIndex > currentThumbsIndex) {
            newThumbsIndex = newThumbsIndex - slidesPerView + 1;
          }
          thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
        }
      }

      // Activate thumbs
      var thumbsToActivate = 1;
      var thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;

      if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
        thumbsToActivate = swiper.params.slidesPerView;
      }

      if (!swiper.params.thumbs.multipleActiveThumbs) {
        thumbsToActivate = 1;
      }

      thumbsToActivate = Math.floor(thumbsToActivate);

      thumbsSwiper.slides.removeClass(thumbActiveClass);
      if (thumbsSwiper.params.loop || (thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled)) {
        for (var i = 0; i < thumbsToActivate; i += 1) {
          thumbsSwiper.$wrapperEl.children(("[data-swiper-slide-index=\"" + (swiper.realIndex + i) + "\"]")).addClass(thumbActiveClass);
        }
      } else {
        for (var i$1 = 0; i$1 < thumbsToActivate; i$1 += 1) {
          thumbsSwiper.slides.eq(swiper.realIndex + i$1).addClass(thumbActiveClass);
        }
      }
    },
  };
  var Thumbs$1 = {
    name: 'thumbs',
    params: {
      thumbs: {
        multipleActiveThumbs: true,
        swiper: null,
        slideThumbActiveClass: 'swiper-slide-thumb-active',
        thumbsContainerClass: 'swiper-container-thumbs',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        thumbs: {
          swiper: null,
          init: Thumbs.init.bind(swiper),
          update: Thumbs.update.bind(swiper),
          onThumbClick: Thumbs.onThumbClick.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        var ref = swiper.params;
        var thumbs = ref.thumbs;
        if (!thumbs || !thumbs.swiper) { return; }
        swiper.thumbs.init();
        swiper.thumbs.update(true);
      },
      slideChange: function slideChange() {
        var swiper = this;
        if (!swiper.thumbs.swiper) { return; }
        swiper.thumbs.update();
      },
      update: function update() {
        var swiper = this;
        if (!swiper.thumbs.swiper) { return; }
        swiper.thumbs.update();
      },
      resize: function resize() {
        var swiper = this;
        if (!swiper.thumbs.swiper) { return; }
        swiper.thumbs.update();
      },
      observerUpdate: function observerUpdate() {
        var swiper = this;
        if (!swiper.thumbs.swiper) { return; }
        swiper.thumbs.update();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) { return; }
        thumbsSwiper.setTransition(duration);
      },
      beforeDestroy: function beforeDestroy() {
        var swiper = this;
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) { return; }
        if (swiper.thumbs.swiperCreated && thumbsSwiper) {
          thumbsSwiper.destroy();
        }
      },
    },
  };

  // Swiper Class

  var components = [
    Device$1,
    Support$1,
    Browser$1,
    Resize,
    Observer$1,
    Virtual$1,
    Keyboard$1,
    Mousewheel$1,
    Navigation$1,
    Pagination$1,
    Scrollbar$1,
    Parallax$1,
    Zoom$1,
    Lazy$1,
    Controller$1,
    A11y,
    History$1,
    HashNavigation$1,
    Autoplay$1,
    EffectFade,
    EffectCube,
    EffectFlip,
    EffectCoverflow,
    Thumbs$1
  ];

  if (typeof Swiper.use === 'undefined') {
    Swiper.use = Swiper.Class.use;
    Swiper.installModule = Swiper.Class.installModule;
  }

  Swiper.use(components);

  return Swiper;

}));


},{}],33:[function(require,module,exports){
/**!
 * trunk8 v1.3.3
 * https://github.com/rviscomi/trunk8
 * 
 * Copyright 2012 Rick Viscomi
 * Released under the MIT License.
 * 
 * Date: September 26, 2012
 */

(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (typeof module === 'object' && module.exports) {
        factory(require('jquery'));
    } else {
        factory(root.jQuery);
    }
}(this, function ($) {
	var methods,
		utils,
		SIDES = {
			/* cen...ter */
			center: 'center',
			/* ...left */
			left: 'left',
			/* right... */
			right: 'right'
		},
		WIDTH = {
			auto: 'auto'
		};
	
	function trunk8(element) {
		this.$element = $(element);
		this.original_text = $.trim(this.$element.html());
		this.settings = $.extend({}, $.fn.trunk8.defaults);
	}
	
	trunk8.prototype.updateSettings = function (options) {
		this.settings = $.extend(this.settings, options);
	};

	function stripHTML(html) {
		var tmp = document.createElement("DIV");
		tmp.innerHTML = html;
		
		if (typeof tmp.textContent != 'undefined') {
			return tmp.textContent;
		}

		return tmp.innerText
	}

	function getHtmlArr(str) {
		/* Builds an array of strings and designated */
		/* HTML tags around them. */
		if (stripHTML(str) === str) {
			return str.split(/\s/g);
		}
		var allResults = [],
			reg = /<([a-z]+)([^<]*)(?:>(.*?(?!<\1>))<\/\1>|\s+\/>)(['.?!,]*)|((?:[^<>\s])+['.?!,]*\w?|<br\s?\/?>)/ig,
			outArr = reg.exec(str),
			lastI,
			ind;
		while (outArr && lastI !== reg.lastIndex) {
			lastI = reg.lastIndex;
			if (outArr[5]) {
				allResults.push(outArr[5]);
			} else if (outArr[1]) {
				allResults.push({
					tag: outArr[1],
					attribs: outArr[2],
					content: outArr[3],
					after: outArr[4]
				});
			}
			outArr = reg.exec(str);
		}
		for (ind = 0; ind < allResults.length; ind++) {
			if (typeof allResults[ind] !== 'string' &&
					allResults[ind].content) {
				allResults[ind].content = getHtmlArr(allResults[ind].content);
			}
		}
		return allResults;
	}

	function rebuildHtmlFromBite(bite, htmlObject, fill) {
		// Take the processed bite after binary-search
		// truncated and re-build the original HTML
		// tags around the processed string.
		bite = bite.replace(fill, '');

		var biteHelper = function(contentArr, tagInfo) {
				var retStr = '',
					content,
					biteContent,
					biteLength,
					nextWord,
					i;
				for (i = 0; i < contentArr.length; i++) {
					content = contentArr[i];
					biteLength = $.trim(bite).split(' ').length;
					if ($.trim(bite).length) {
						if (typeof content === 'string') {
							if (!/<br\s*\/?>/i.test(content)) {
								if (biteLength === 1 && $.trim(bite).length <= content.length) {
									content = bite;
									// We want the fill to go inside of the last HTML
									// element if the element is a container.
									if (tagInfo === 'p' || tagInfo === 'div') {
										content += fill;
									}
									bite = '';
								} else {
									bite = bite.replace(content, '');
								}
							}
							retStr += $.trim(content) + ((i === contentArr.length-1 || biteLength <= 1) ? '' : ' ');
						} else {
							biteContent = biteHelper(content.content, content.tag);
							if (content.after) bite = bite.replace(content.after, '');
							if (biteContent) {
								if (!content.after) content.after = ' ';
								retStr += '<'+content.tag+content.attribs+'>'+biteContent+'</'+content.tag+'>' + content.after;
							}
						}
					}
				}
				return retStr;
			},
			htmlResults = biteHelper(htmlObject);

		// Add fill if doesn't exist. This will place it outside the HTML elements.
		if (htmlResults.slice(htmlResults.length - fill.length) === fill) {
			htmlResults += fill;
		}

		return htmlResults;
	}

	function truncate() {
		var data = this.data('trunk8'),
			settings = data.settings,
			width = settings.width,
			side = settings.side,
			fill = settings.fill,
			parseHTML = settings.parseHTML,
			line_height = utils.getLineHeight(this) * settings.lines,
			str = data.original_text,
			length = str.length,
			max_bite = '',
			lower, upper,
			bite_size,
			bite,
			text,
			htmlObject;
		
		/* Reset the field to the original string. */
		this.html(str);
		text = this.text();

		/* If string has HTML and parse HTML is set, build */
		/* the data struct to house the tags */
		if (parseHTML && stripHTML(str) !== str) {
			htmlObject = getHtmlArr(str);
			str = stripHTML(str);
			length = str.length;
		}

		if (width === WIDTH.auto) {
			/* Assuming there is no "overflow: hidden". */
			if (this.height() <= line_height) {
				/* Text is already at the optimal trunkage. */
				return;
			}

			/* Binary search technique for finding the optimal trunkage. */
			/* Find the maximum bite without overflowing. */
			lower = 0;
			upper = length - 1;

			while (lower <= upper) {
				bite_size = lower + ((upper - lower) >> 1);
				
				bite = utils.eatStr(str, side, length - bite_size, fill);

				if (parseHTML && htmlObject) {
					bite = rebuildHtmlFromBite(bite, htmlObject, fill);
				}
				
				this.html(bite);

				/* Check for overflow. */
				if (this.height() > line_height) {
					upper = bite_size - 1;
				}
				else {
					lower = bite_size + 1;

					/* Save the bigger bite. */
					max_bite = (max_bite.length > bite.length) ? max_bite : bite;
				}
			}

			/* Reset the content to eliminate possible existing scroll bars. */
			this.html('');
			
			/* Display the biggest bite. */
			this.html(max_bite);
			
			if (settings.tooltip) {
				this.attr('title', text);
			}
		}
		else if (!isNaN(width)) {
			bite_size = length - width;

			bite = utils.eatStr(str, side, bite_size, fill);

			this.html(bite);
			
			if (settings.tooltip) {
				this.attr('title', str);
			}
		}
		else {
			$.error('Invalid width "' + width + '".');
			return;
		}
		settings.onTruncate();
	}

	methods = {
		init: function (options) {
			return this.each(function () {
				var $this = $(this),
					data = $this.data('trunk8');
				
				if (!data) {
					$this.data('trunk8', (data = new trunk8(this)));
				}
				
				data.updateSettings(options);
				
				truncate.call($this);
			});
		},

		/** Updates the text value of the elements while maintaining truncation. */
		update: function (new_string) {
			return this.each(function () {
				var $this = $(this);
				
				/* Update text. */
				if (new_string) {
					$this.data('trunk8').original_text = new_string;
				}

				/* Truncate accordingly. */
				truncate.call($this);
			});
		},
		
		revert: function () {
			return this.each(function () {
				/* Get original text. */
				var text = $(this).data('trunk8').original_text;
				
				/* Revert element to original text. */
				$(this).html(text);
			});
		},

		/** Returns this instance's settings object. NOT CHAINABLE. */
		getSettings: function () {
			return $(this.get(0)).data('trunk8').settings;
		}
	};

	utils = {
		/** Replaces [bite_size] [side]-most chars in [str] with [fill]. */
		eatStr: function (str, side, bite_size, fill) {
			var length = str.length,
				key = utils.eatStr.generateKey.apply(null, arguments),
				half_length,
				half_bite_size;

			/* If the result is already in the cache, return it. */
			if (utils.eatStr.cache[key]) {
				return utils.eatStr.cache[key];
			}
			
			/* Common error handling. */
			if ((typeof str !== 'string') || (length === 0)) {
				$.error('Invalid source string "' + str + '".');
			}
			if ((bite_size < 0) || (bite_size > length)) {
				$.error('Invalid bite size "' + bite_size + '".');
			}
			else if (bite_size === 0) {
				/* No bite should show no truncation. */
				return str;
			}
			if (typeof (fill + '') !== 'string') {
				$.error('Fill unable to be converted to a string.');
			}

			/* Compute the result, store it in the cache, and return it. */
			switch (side) {
				case SIDES.right:
					/* str... */
					return utils.eatStr.cache[key] =
							$.trim(str.substr(0, length - bite_size)) + fill;
					
				case SIDES.left:
					/* ...str */
					return utils.eatStr.cache[key] =
							fill + $.trim(str.substr(bite_size));
					
				case SIDES.center:
					/* Bit-shift to the right by one === Math.floor(x / 2) */
					half_length = length >> 1; // halve the length
					half_bite_size = bite_size >> 1; // halve the bite_size

					/* st...r */
					return utils.eatStr.cache[key] =
							$.trim(utils.eatStr(str.substr(0, length - half_length), SIDES.right, bite_size - half_bite_size, '')) +
							fill +
							$.trim(utils.eatStr(str.substr(length - half_length), SIDES.left, half_bite_size, ''));
					
				default:
					$.error('Invalid side "' + side + '".');
			}
		},
		
		getLineHeight: function (elem) {
				var floats = $(elem).css('float');
				if (floats !== 'none') {
					$(elem).css('float', 'none');
				}
				var pos = $(elem).css('position');
				if (pos === 'absolute') {
					$(elem).css('position', 'static');
				}
	
				var html = $(elem).html(),
				wrapper_id = 'line-height-test',
				line_height;
	
				/* Set the content to a small single character and wrap. */
				$(elem).html('i').wrap('<div id="' + wrapper_id + '" />');
	
				/* Calculate the line height by measuring the wrapper.*/
				line_height = $('#' + wrapper_id).innerHeight();
	
				/* Remove the wrapper and reset the content. */
				$(elem).html(html).css({ 'float': floats, 'position': pos }).unwrap();
	
				return line_height;
			}
	};

	utils.eatStr.cache = {};
	utils.eatStr.generateKey = function () {
		return Array.prototype.join.call(arguments, '');
	};
	
	$.fn.trunk8 = function (method) {
		if (methods[method]) {
			return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
		}
		else if (typeof method === 'object' || !method) {
			return methods.init.apply(this, arguments);
		}
		else {
			$.error('Method ' + method + ' does not exist on jQuery.trunk8');
		}
	};
	
	/* Default trunk8 settings. */
	$.fn.trunk8.defaults = {
		fill: '&hellip;',
		lines: 1,
		side: SIDES.right,
		tooltip: true,
		width: WIDTH.auto,
		parseHTML: false,
		onTruncate: function () {}
	};
}));

},{"jquery":30}],34:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var $ = require('jquery');

var SEND_LOG_SELECTOR = '.js-clickLog';
var DATA_SEND_URL_NAME = 'data-send-url';
var CLICK_EVENT = 'click.clickLog';
var AJAX_PARAM = {
  type: 'get',
  cache: false,
  timeout: 3000
};

/**
  * @desc ページ遷移前に指定の url を get させる
  */
var ClickLog = function ClickLog() {
  $(SEND_LOG_SELECTOR).each(function () {
    var $self = $(this);
    var url = $self.attr('href');
    $self.on(CLICK_EVENT, function (e) {
      e.preventDefault();
      $.ajax($self.attr(DATA_SEND_URL_NAME), AJAX_PARAM).always(function () {
        // クリックした箇所が画面遷移する場合
        if (!!url) {
          document.location.href = url;
        }
      });

      return false;
    });
  });
};

exports['default'] = ClickLog;
module.exports = exports['default'];

},{"jquery":30}],35:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var $ = require('jquery');

var DATE_LIST_SELECTOR = '.js-dateList';
var DATE_ITEM_SELECTOR = '.js-dateItem';
var DATE_YEAR_SELECTOR = '.js-dateYear';
var DATE_NUMBER_SELECTOR = '.js-dateNumber';
var DATE_TEXT_SELECTOR = '.js-dateText';
var DATE_LENGTH_NAME = 'date-length';
var DATE_ITEM_NAME = 'date-item';
var DATE_LIST_MORE_HTML = '<li class="dateList__more">…</li>';

/**
  * @class ConvertDate
  * @desc 日付変換処理
  * 年/月/日/曜日 をセット => 日付カセット
  * 月/日/曜日/日付のセット上限数を超えたら省略表記 をセット => 導線カセット
  */

var ConvertDate = (function () {

  /**
    * @constructor
    */

  function ConvertDate() {
    _classCallCheck(this, ConvertDate);

    this.$dateList = $.makeArray($(DATE_LIST_SELECTOR));
    this.$dateItem = $.makeArray($(DATE_ITEM_SELECTOR));
    this._insert();
  }

  /**
    * @desc 各要素へ「日付」「曜日」「…」 挿入
    */

  _createClass(ConvertDate, [{
    key: '_insert',
    value: function _insert() {
      this._setAbbr();
      this._setDate();
    }

    /**
      * @desc 日付セットリスト以上日付が存在すればリストの末尾に「…」 挿入
      */
  }, {
    key: '_setAbbr',
    value: function _setAbbr() {
      var _this = this;

      if (this.$dateList.length === 0) return; // .js-dateList が存在しなければ省略「…」を表示しない
      this.$dateList.forEach(function (el) {
        var $el = $(el);
        var dateLength = $el.data(DATE_LENGTH_NAME);
        var listLength = $el.find('>li').length;
        if (dateLength < listLength) {
          _this._spreadList(dateLength, $el.find('>li'));
          $el.append(DATE_LIST_MORE_HTML);
        }
      });
    }

    /**
      * @desc 上限以上の日付が入っていた場合、最大長まで削る
      */
  }, {
    key: '_spreadList',
    value: function _spreadList(maxLength, $list) {
      for (var i = $list.length - 1; i > 0; i--) {
        if (i >= maxLength) {
          $list.eq(i).remove();
        }
      }
    }

    /**
      * @desc 日付/曜日/class 挿入
      */
  }, {
    key: '_setDate',
    value: function _setDate() {
      var _this2 = this;

      this.$dateItem.forEach(function (el) {
        var $el = $(el);
        var date = String($(el).data(DATE_ITEM_NAME));
        var year = date.slice(0, 4);
        var month = _this2._convertZero(date.slice(4, 6));
        var day = _this2._convertZero(date.slice(6, 8));
        var dayOfWeek = _this2._covertDayOfWeek(year, month, day);

        // 年 セット
        if ($el.find(DATE_YEAR_SELECTOR).length > 0) $el.find(DATE_YEAR_SELECTOR).text(year);

        // 月/日 セット
        $el.find(DATE_NUMBER_SELECTOR).text(month + '/' + day);

        // 曜日/class セット
        $el.find(DATE_TEXT_SELECTOR).text(dayOfWeek).addClass(_this2._convertTextToClassName(dayOfWeek));
      });
    }

    /**
      * @desc 月/日から0詰め
      * @param {string} text - 月 or 日
      * @return {string}} - 詰め処理後の 月 or 日
      */
  }, {
    key: '_convertZero',
    value: function _convertZero(text) {
      return text.charAt(0) === '0' ? text.charAt(1) : text;
    }

    /**
      * @desc 曜日変換
      * @param {string} year - 年
      * @param {string} month - 月
      * @param {string} day - 日
      * @return {string}} - 曜日名
      */
  }, {
    key: '_covertDayOfWeek',
    value: function _covertDayOfWeek(year, month, day) {
      var tmp = year + '/' + month + '/' + day;
      return '日月火水木金土'[new Date(tmp).getDay()];
    }

    /**
      * @desc 曜日名 → クラス名への変換
      * @param {Object} str - 曜日テキスト
      * @return {String} 曜日クラス名
      */
  }, {
    key: '_convertTextToClassName',
    value: function _convertTextToClassName(str) {
      if (str === '土') {
        return 'saturday';
      } else if (str === '日') {
        return 'sunday';
      }
    }
  }]);

  return ConvertDate;
})();

exports['default'] = ConvertDate;
module.exports = exports['default'];

},{"jquery":30}],36:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var $ = require('jquery');
var Stories = require('./Stories');

var OPEN_TRIGGER = '.js-ocCameraOpenTrigger';
var CLICK_EVENT = 'click';
var INDEX_DATA_NAME = 'data-oc-camera-index';
var VIDEO_PV_SELECTOR = '#js-videoContainer .video-js';

/**
  * @class OcCameraThumbnail
  * @desc OC カメラ動画のサムネイルと本体を結びつける
  */

var OcCameraThumbnail = (function () {

  /**
    * @constructor
    * @param {Stories} - 発火対象
    */

  function OcCameraThumbnail(stories) {
    _classCallCheck(this, OcCameraThumbnail);

    this._setParameter(stories);
    this._bindEvent();
  }

  /**
    * @desc パラメータを定義
    * @param {Stroies} stories - 発火対象
    */

  _createClass(OcCameraThumbnail, [{
    key: '_setParameter',
    value: function _setParameter(stories) {
      this.stories = stories;
      this.$openTrigger = $(OPEN_TRIGGER);
    }

    /**
      * @desc イベントをバインド
      */
  }, {
    key: '_bindEvent',
    value: function _bindEvent() {
      for (var i = 0, len = this.$openTrigger.length; i < len; i++) {
        var $trigger = this.$openTrigger.eq(i);
        $trigger.on(CLICK_EVENT, this._onClick.bind(this, $trigger.attr(INDEX_DATA_NAME)));
      }
    }

    /**
     * @desc 指定されたインデックス番号のストーリーズを表示する
     * @param {number} i - 選択されたトリガーに定義されたインデックス番号
     */
  }, {
    key: '_onClick',
    value: function _onClick(i) {
      this._removePV();
      this.stories.open(i);
    }

    /**
    * @desc （PC画面時のみ対応）OC動画再生する際にPV動画がある場合に同時に再生しないようにプレイヤーを削除する
    */
  }, {
    key: '_removePV',
    value: function _removePV() {
      if ($(VIDEO_PV_SELECTOR).length) {
        var oldPlayer = document.getElementById($(VIDEO_PV_SELECTOR).attr('id'));
        // 動画を停止した後に削除しないとエラーが発生
        videojs(oldPlayer).pause();
        videojs(oldPlayer).dispose();
      }
    }
  }]);

  return OcCameraThumbnail;
})();

exports['default'] = OcCameraThumbnail;
module.exports = exports['default'];

},{"./Stories":39,"jquery":30}],37:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var $ = require('jquery');

var IMAGE_Fill_TARGET_SELECTOR = '.js-resizeImageFill';

/**
  * @class ResizeImageFill
  * @desc 画像リサイズ処理（Fill）
  * 画像の枠に縦横短い方を合わせてリサイズ
  */

var ResizeImageFill = (function () {
  /**
    * @constructor
    * @param {Number} x - 縦比率
    * @param {Number} y - 横比率
    * @param {String} selecter - 対象のセレクタ
    */

  function ResizeImageFill(x, y) {
    var selecter = arguments.length <= 2 || arguments[2] === undefined ? IMAGE_Fill_TARGET_SELECTOR : arguments[2];

    _classCallCheck(this, ResizeImageFill);

    this.aspectRatio = x / y;
    this.$targetElm = $.makeArray($(selecter));
    this._resizeFill();
  }

  /**
    * @desc 画像の大きさによってリサイズ
    */

  _createClass(ResizeImageFill, [{
    key: '_resizeFill',
    value: function _resizeFill() {
      var _this = this;

      this.$targetElm.forEach(function (el) {
        var $el = $(el);
        var $parentElm = $el.parent();
        var image = new Image();
        image.src = $el.attr('src');

        var imageWidth = image.width;
        var imageHeight = image.height;
        var outerWidth = $parentElm.outerWidth();
        var ratio = imageWidth / imageHeight;

        // 横長
        if (ratio > 1) {
          if (ratio > _this.aspectRatio) {
            $el.css('width', 'auto');
            $el.css('height', '100%');
          } else if (ratio === _this.aspectRatio) {
            if (outerWidth < imageWidth) {
              $el.css('width', 'auto');
              $el.css('height', '100%');
            }
          }
        }
      });
    }
  }]);

  return ResizeImageFill;
})();

exports['default'] = ResizeImageFill;
module.exports = exports['default'];

},{"jquery":30}],38:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var $ = require('jquery');

var AJAX_PARAM = {
  type: 'get',
  cache: false,
  timeout: 3000
};

var SendLog = function SendLog(url) {
  $.ajax(url, AJAX_PARAM);
};

exports['default'] = SendLog;
module.exports = exports['default'];

},{"jquery":30}],39:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

/**
  * @class Stories
  * @desc Oc カメラ動画(ストーリーズ)の基底クラス<br>
  * 共通処理をまとめる
  */

var Stories = (function () {
  function Stories() {
    _classCallCheck(this, Stories);
  }

  /**
   * @desc 指定のインデックス番号を現在のインデックス番号として登録する
   * @param {number} index - 最初に表示する動画の master data におけるインデックス番号
   */

  _createClass(Stories, [{
    key: 'open',
    value: function open(index) {
      this.currentIndex = parseInt(index, 10) || 0;
      this._update();
    }

    /**
      * @desc ローカル変数として定義されている master data を取得する
      */
  }, {
    key: '_loadMasterData',
    value: function _loadMasterData() {
      this.masterData = OcStories.data || [];
      this.itemLength = this.masterData.length;
    }

    /**
      * @desc リサイズイベントが走った時に動画を一旦止める
      */
  }, {
    key: '_onResize',
    value: function _onResize() {
      if (this.videojs.paused()) {
        this._stop();
      }
    }

    /**
      * @desc 前の動画に戻る
      */
  }, {
    key: '_movePrev',
    value: function _movePrev() {
      if (this.currentIndex > 0) --this.currentIndex;
      this._update();
    }

    /**
      * @desc 次の動画に進む
      */
  }, {
    key: '_moveNext',
    value: function _moveNext() {
      if (this.currentIndex < this.itemLength) ++this.currentIndex;
      this._update();
    }

    /**
      * @desc 動画切り替え時の処理
      */
  }, {
    key: '_update',
    value: function _update() {}

    /**
      * @desc 再生時の処理
      */
  }, {
    key: '_play',
    value: function _play() {}

    /**
      * @desc 終了時の処理
      */
  }, {
    key: '_stop',
    value: function _stop() {}

    /**
     * @desc document の一番外側にあるスクロール可能な要素を返却する
     */
  }, {
    key: '_getScrollableElement',
    value: function _getScrollableElement() {
      var scrollableElement = undefined;

      if ('scrollingElement' in document) {
        scrollableElement = document.scrollingElement;
      } else if ( /*@cc_on!@*/false || !!window.MSInputMethodContext && !!document.documentMode) {
        scrollableElement = document.documentElement;
      } else {
        scrollableElement = document.body;
      }
      return (0, _jquery2['default'])(scrollableElement);
    }
  }]);

  return Stories;
})();

exports['default'] = Stories;
module.exports = exports['default'];

},{"jquery":30}],40:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var $ = require('jquery');
var Stories = require('./Stories');
var SendLog = require('./SendLog');

// セレクタ
var CONTAINER_SELECTOR = '.js-storiesContainer';
var COLLEGE_LINK_SELECTOR = '.js-storiesCollegeLink';
var COLLEGE_NAME_SELECTOR = '.js-storiesCollegeName';
var OC_LINK_SELECTOR = '.js-storiesOcLink';
var OC_ENTRY_LINK_SELECTOR = '.js-storiesOcEntryLink';
var PLAY_BUTTON_SELECTOR = '.js-storiesPlayButton';
var PREV_BUTTON_SELECTOR = '.js-storiesPrevButton';
var NEXT_BUTTON_SELECTOR = '.js-storiesNextButton';
var CLOSE_BUTTON_SELECTOR = '.js-storiesCloseButton';
var AUTHOR_THUMBNAIL_SELECTOR = '.js-storiesAuthorThumbnail';
var AUTHOR_NAME_SELECTOR = '.js-storiesAuthorName';
var AUTHOR_DEPARTMENT_SELECTOR = '.js-storiesAuthorDepartment';
var DESCRIPTION_SELECTOR = '.js-storiesDescription';
var STORIES_ITEM_SELECTOR = '.js-stories-item';
var VIDEO_CONTAINER_SELECTOR = '#js-storiesVideoContainer';
var CLICKABLE_AREA_SELECTOR = '.js-storiesClickableArea';
var BODY_SELECTOR = 'html, body';
var TAG_SELECTOR = '.js-storiesTag';
var DATE_SELECTOR = '.js-storiesDate';
var INDICATOR_SELECTOR = '.js-indicator';
var VIDEO_SELECTOR = '#js-storiesVideoContainer .video-js';
var THUMBNAIL_SELECTOR = '.js-storiesThumbnail';
var INFO_SELECTOR = '.js-storiesInfo';

// イベント
var CLICK_EVENT = 'click.stories';
var ENDED_EVENT = 'ended';
var RESIZE_EVENT = 'resize';

// キー
var STORIES_MOVIE = {
  COLLEGE_LINK: 'collegeLink',
  COLLEGE_NAME: 'collegeName',
  OC_LINK: 'ocLink',
  OC_ENTRY: 'ocEntry',
  AUTHOR_THUMB: 'authorThumb',
  AUTHOR_NAME: 'authorName',
  AUTHOR_DEPARTMENT: 'authorDepartment',
  DESCRIPTION: 'description',
  TAG_COLOR: 'tagColor',
  TAG_TEXT: 'tagText',
  DATE: 'date',
  REFERENCE_ID: 'referenceId',
  THUMBNAIL_URL: 'thumbnailUrl',
  BC_ACCOUNT_DATA_NAME: 'data-account-id',
  BC_PLAYER_ID_DATA_NAME: 'data-player-id',
  IS_MUTED: 'isMuted'
};

var FIX_CLASS = 'is-fix';
var FADE_SPEED = 'fast';

/**
  * @class StoriesManager
  * @desc ストーリーズの全処理を担当する<br>
  * pc/sp共に共通
  */

var StoriesManager = (function (_Stories) {
  _inherits(StoriesManager, _Stories);

  /**
    * @constructor
    */

  function StoriesManager() {
    _classCallCheck(this, StoriesManager);

    _get(Object.getPrototypeOf(StoriesManager.prototype), 'constructor', this).call(this);
    this._setParameter();
    if (!this.$container.length) return;
    this._loadMasterData();
    this._bindEvent();
  }

  /**
    * @desc プロパティを定義する
    */

  _createClass(StoriesManager, [{
    key: '_setParameter',
    value: function _setParameter() {
      this.$body = $(BODY_SELECTOR);
      this.$container = $(CONTAINER_SELECTOR);
      if (!this.$container.length) return;
      this.$collegeLink = $(COLLEGE_LINK_SELECTOR);
      this.$collegeName = $(COLLEGE_NAME_SELECTOR);
      this.$ocLink = $(OC_LINK_SELECTOR);
      this.$playButton = $(PLAY_BUTTON_SELECTOR);
      this.$prevButton = $(PREV_BUTTON_SELECTOR);
      this.$nextButton = $(NEXT_BUTTON_SELECTOR);
      this.$closeButton = $(CLOSE_BUTTON_SELECTOR);
      this.$authorThumbnail = $(AUTHOR_THUMBNAIL_SELECTOR);
      this.$authorName = $(AUTHOR_NAME_SELECTOR);
      this.$authorDepartment = $(AUTHOR_DEPARTMENT_SELECTOR);
      this.$description = $(DESCRIPTION_SELECTOR);
      this.$tag = $(TAG_SELECTOR);
      this.$date = $(DATE_SELECTOR);
      this.$indicator = $(INDICATOR_SELECTOR);
      this.$thumbnail = $(THUMBNAIL_SELECTOR);
      this.$info = $(INFO_SELECTOR);
      this.$videoContainer = $(VIDEO_CONTAINER_SELECTOR);
      this.$clickableArea = $(CLICKABLE_AREA_SELECTOR);
      this.$scrollableElement = this._getScrollableElement();
      this.$storiesItem = $(STORIES_ITEM_SELECTOR);
      // bc: BrightCove
      this.bcAccountId = this.$videoContainer.attr(STORIES_MOVIE.BC_ACCOUNT_DATA_NAME);
      this.bcPlayerId = this.$videoContainer.attr(STORIES_MOVIE.BC_PLAYER_ID_DATA_NAME);
      this.currentIndex = this.currentIndex || 0;
    }

    /**
      * @desc イベントをバインドする
      */
  }, {
    key: '_bindEvent',
    value: function _bindEvent() {
      this.$prevButton.on(CLICK_EVENT, this._movePrev.bind(this));
      this.$nextButton.on(CLICK_EVENT, this._moveNext.bind(this));
      this.$playButton.on(CLICK_EVENT, this._play.bind(this));
      this.$closeButton.on(CLICK_EVENT, this._close.bind(this));
      this.$body.eq(0).on(RESIZE_EVENT, this._onResize.bind(this));
    }

    /**
     * @desc IE対応：動画プレーヤーのリセット
     */
  }, {
    key: '_reset',
    value: function _reset() {
      if ($(VIDEO_SELECTOR).length) {
        var oldPlayer = videojs($(VIDEO_SELECTOR)[0]);
        oldPlayer.pause();
        oldPlayer.dispose();
      }
    }

    /**
     * @desc 指定のインデックス番号を現在のインデックス番号として登録する
     * @param {number} index - 最初に表示する動画の master data におけるインデックス番号
     */
  }, {
    key: 'open',
    value: function open(index) {
      this.scrollTop = this.$scrollableElement.scrollTop();
      this.$container.fadeIn(FADE_SPEED);
      this.$body.addClass(FIX_CLASS);
      _get(Object.getPrototypeOf(StoriesManager.prototype), 'open', this).call(this, index);
    }

    /**
      * @desc ストーリーズを非表示にする
      */
  }, {
    key: '_close',
    value: function _close() {
      this.$container.hide();
      this._showInfo();
      this.$body.removeClass(FIX_CLASS);
      this.$scrollableElement.scrollTop(this.scrollTop || 0);
      this._reset();
    }

    /**
      * 現在のインデックス番号を元に各種データを更新する
      */
  }, {
    key: '_update',
    value: function _update() {
      this._reset();
      this.$clickableArea.off(CLICK_EVENT);

      // 最後の動画を再生時のみ最後の動画の再生画面に戻る値に変更
      if (this.currentIndex === this.itemLength) {
        this.currentIndex = this.itemLength - 1;
      }
      var currentItem = this.masterData[this.currentIndex];
      this._initBCPlayer(currentItem);

      this.$thumbnail.attr('src', currentItem[STORIES_MOVIE.THUMBNAIL_URL]);
      this.$thumbnail.show();
      this.$collegeLink.attr('href', currentItem[STORIES_MOVIE.COLLEGE_LINK]);
      this.$collegeName.text(currentItem[STORIES_MOVIE.COLLEGE_NAME]);
      this.$ocLink.attr('href', currentItem[STORIES_MOVIE.OC_LINK]);
      this.$authorThumbnail.attr('src', currentItem[STORIES_MOVIE.AUTHOR_THUMB]);
      this.$authorName.text(currentItem[STORIES_MOVIE.AUTHOR_NAME]);
      this.$authorDepartment.html(currentItem[STORIES_MOVIE.AUTHOR_DEPARTMENT]);
      this.$description.html(currentItem[STORIES_MOVIE.DESCRIPTION]);
      this.$tag.css('background-color', currentItem[STORIES_MOVIE.TAG_COLOR]);
      this.$tag.text(currentItem[STORIES_MOVIE.TAG_TEXT]);
      this.$date.text(currentItem[STORIES_MOVIE.DATE]);

      // 「コメント」項目箇所は"存在しない場合トルツメ"のため、場合に応じて間隔のcssを付け外し。
      if (currentItem[STORIES_MOVIE.DESCRIPTION]) {
        this.$description.css('margin-bottom', '20px');
      } else {
        this.$description.css('margin-bottom', '0');
      }

      // 「オープンキャンパス参加」のボタン表示・非表示判定
      var $ocEntryLink = this.$storiesItem.find(OC_ENTRY_LINK_SELECTOR);
      var $ocLink = this.$storiesItem.find(OC_LINK_SELECTOR);

      if (currentItem[STORIES_MOVIE.OC_ENTRY] && $ocEntryLink.length) {
        $ocEntryLink.show();
        $ocEntryLink.attr('href', currentItem[STORIES_MOVIE.OC_ENTRY]);
        $ocLink.removeClass('is-only');
      } else {
        $ocEntryLink.hide();
        $ocLink.addClass('is-only');
      }

      // ログの送信状況を初期化
      this.sendLogFlag = {
        currentIndex: this.currentIndex,
        isSend: false
      };

      this._updateControll();

      // サムネイル画像のaspect-fill対応
      this._resizeThumbnailFill();
    }

    /**
      * @desc 現在のインデックス番号を元にコントロールボタンの表示非表示を更新する
      */
  }, {
    key: '_updateControll',
    value: function _updateControll() {
      if (this.currentIndex === 0) {
        this.$prevButton.stop().fadeOut(FADE_SPEED);
      } else {
        this.$prevButton.stop().fadeIn(FADE_SPEED);
      }
      if (this.currentIndex === this.itemLength - 1) {
        this.$nextButton.stop().fadeOut(FADE_SPEED);
      } else {
        this.$nextButton.stop().fadeIn(FADE_SPEED);
      }
      this.$indicator.text(this.currentIndex + 1 + '/' + this.itemLength);
    }

    /**
      * @desc サムネイル画像のaspect-fill対応
      */
  }, {
    key: '_resizeThumbnailFill',
    value: function _resizeThumbnailFill() {
      var image = new Image();
      image.src = this.$authorThumbnail.attr('src');
      var imageWidth = image.width;
      var imageHeight = image.height;
      var ratio = imageWidth / imageHeight;
      if (ratio > 1) {
        this.$authorThumbnail.css('width', 'auto');
        this.$authorThumbnail.css('height', '100%');
      } else {
        this.$authorThumbnail.css('width', '');
        this.$authorThumbnail.css('height', '');
      }
    }

    /**
      * @desc 情報を非表示にする
      */
  }, {
    key: '_hideInfo',
    value: function _hideInfo() {
      this.$info.stop().fadeOut(FADE_SPEED);
    }

    /**
      * @desc 情報を表示する
      */
  }, {
    key: '_showInfo',
    value: function _showInfo() {
      this._updateControll();
      this.$info.stop().fadeIn(FADE_SPEED);
    }

    /**
      * @desc 現在の動画の再生状況をトグルさせる。<br>
      * 再生 <-> 停止or一時停止
      */
  }, {
    key: '_toggleState',
    value: function _toggleState() {
      if (this.videojs.paused()) {
        this._play();
      } else {
        this._stop();
      }
    }

    /**
      * @desc 動画再生完了時のコールバック<br>
      * 次の動画があれば次の動画を再生する
      */
  }, {
    key: '_ended',
    value: function _ended() {
      this._stop();
      if (this.currentIndex < this.itemLength) {
        this._moveNext();
      }
    }

    /**
      * @desc 終了時の処理
      */
  }, {
    key: '_stop',
    value: function _stop() {
      this.videojs.pause();
      this._updateInfo();
    }

    /**
      * @desc 再生時の処理
      */
  }, {
    key: '_play',
    value: function _play() {
      this.videojs.play();
      this._sendLog();
      this._updateInfo();
      this._sendClickLog();
    }

    /**
      * @desc ログを送信
      */
  }, {
    key: '_sendLog',
    value: function _sendLog() {
      if (this.sendLogFlag.currentIndex !== this.currentIndex || this.sendLogFlag.isSend) return;
      SendLog(this.masterData[this.currentIndex].sendLogUrl);
      this.sendLogFlag.isSend = true;
    }

    /**
    * @desc クリックログ送信
    */
  }, {
    key: '_sendClickLog',
    value: function _sendClickLog() {
      var s2 = s_gi(s_account);
      var currentItem = this.masterData[this.currentIndex];
      var pageID = s2.prop4;
      var gakkoCd = String(currentItem.collegeLink).match(/SC?\d{1,}/g);
      var playerReferenceId = currentItem.referenceId;
      s2.tl(this, 'o', 'camera_' + pageID + '_' + gakkoCd + '_' + playerReferenceId);
    }

    /**
      * @desc 情報の表示非表示を更新
      */
  }, {
    key: '_updateInfo',
    value: function _updateInfo() {
      if (this.videojs.paused()) {
        this._showInfo();
      } else {
        this._hideInfo();
        this.$playButton.hide();
      }
    }

    /**
      * @desc brightcove プレイヤーを再設置する<br>
      * プロモビデオの流用。引数のみ違う
      * @param {Object} item - 現在読み込ませているストーリーズのアイテム
      */
  }, {
    key: '_initBCPlayer',
    value: function _initBCPlayer(item) {
      this._showInfo();
      this.$videoContainer.html(this._getPlayerHtml(item[STORIES_MOVIE.REFERENCE_ID], this.bcAccountId, this.bcPlayerId, item[STORIES_MOVIE.IS_MUTED]));
      var s = document.createElement('script');
      s.src = this._getScriptSrc(this.bcAccountId, this.bcPlayerId);
      this.$videoContainer[0].appendChild(s);
      s.onload = this._onReady.bind(this);
    }

    /**
      * @desc video タグ用の html を返却
      * @return {string} - video タグ生成用の html
      */
  }, {
    key: '_getPlayerHtml',
    value: function _getPlayerHtml(videoId, accountId, playerId, isMuted) {
      var muteText = isMuted ? 'muted' : '';
      return '<video data-video-id="ref:' + videoId + '" data-account="' + accountId + '" data-player="' + playerId + '" data-embed="default" class="video-js is-show" ' + muteText + '></video>';
    }

    /**
      * @desc brightcove player 用の js を呼び出す url を生成し返却
      * @param {string} accountId - brightcove のアカウント id
      * @param {string} playerId - brightcove プレイヤーの id
      * @return {string} - brightcove 用のスクリプトの url
      */
  }, {
    key: '_getScriptSrc',
    value: function _getScriptSrc(accountId, playerId) {
      return '//players.brightcove.net/' + accountId + '/' + playerId + '_default/index.min.js';
    }

    /**
      * @desc 動画関連のプロパティを定義し、動画を再生できるようにする
      */
  }, {
    key: '_onReady',
    value: function _onReady() {
      this.$video = $(VIDEO_SELECTOR);
      this.videojs = videojs(this.$video[0]);
      this.videojs.catalog.autoFindAndLoadMedia({ videoId: 'ref:' + this.masterData[this.currentIndex][STORIES_MOVIE.REFERENCE_ID] });
      this.videojs.on(ENDED_EVENT, this._ended.bind(this));
      this.$thumbnail.hide();
      this.$playButton.show();
      this.$clickableArea.on(CLICK_EVENT, this._toggleState.bind(this));
    }
  }]);

  return StoriesManager;
})(Stories);

exports['default'] = StoriesManager;
module.exports = exports['default'];

},{"./SendLog":38,"./Stories":39,"jquery":30}],41:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.disposableObserver = disposableObserver;

function disposableObserver(targetElement, callback) {
  var observer = new MutationObserver(function (mutations) {
    if (mutations.some(function (mutation) {
      return mutation.addedNodes.length > 0;
    })) {
      callback();
      observer.disconnect();
    }
  });

  observer.observe(document.querySelector(targetElement), {
    childList: true,
    subtree: true
  });
}

},{}],42:[function(require,module,exports){
/**
 * ログ送信
 * @param target イベント観測対象。event.targetの取得が困難な場合は、documentで代用可。
 * @param messageID メッセージID
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.sendLog = sendLog;
exports.initClickLog = initClickLog;

function sendLog(target, messageID) {
  if (!s) return;
  s.tl(target, 'o', messageID);
}

/**
 * @description クリックログ送信
 * @param clickLogElementList イベント観測対象
 * @param dataName - 飛ばしたいログ設定用のデータ属性名（data-xxxxの部分のキャメルケースのみ）
 */

function initClickLog(clickLogElementList, dataName) {
  var clickLogTriggerElements = Array.prototype.slice.call(clickLogElementList, 0);
  clickLogTriggerElements.forEach(function (trigger) {
    trigger.addEventListener('click', function (event) {
      var clickedElement = event.currentTarget;
      var customLink = clickedElement.dataset[dataName];
      sendLog(clickedElement, customLink);
      event.stopPropagation();
    });
  });
}

},{}],43:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initCustomScrollLog = initCustomScrollLog;
exports.observeSettingLog = observeSettingLog;

var _disposableObserver = require("./_disposableObserver");

var _sendClickLog = require("./_sendClickLog");

/**
 * ログ送信
 * @param s 基本的に進路内にグローバルに存在する『s』をいれる
 * @param target イベント観測対象。event.targetの取得が困難な場合は、documentで代用可。
 * @param customLink カスタムリンク
 */
function sendLog(s, target, customLink) {
  if (!s) return;
  s.tl(target, 'o', customLink);
}

/**
 * スクロールログinit
 * @param s 基本的に進路内にグローバルに存在する『s』をいれる
 * @param scrollLogTargetList イベント観測対象
 * @param dataNameInView - 表示領域inで飛ばしたいログ設定用のデータ属性名（data-xxxxの部分のキャメルケースのみ）
 * @param thresholdValue - 対処要素の見える範囲を設定 0~1まで Default:1(要素全体が見えた時)
 * @returns 処理後のターゲットリスト
 */

function initCustomScrollLog(s, scrollLogTargetList, dataNameInView) {
  var thresholdValue = arguments.length <= 3 || arguments[3] === undefined ? 1 : arguments[3];

  // オプション設定
  var options = {
    root: null,
    rootMargin: '0px',
    threshold: thresholdValue
  };
  // 要素が画面に入ったときの処理
  var inViewCallback = function inViewCallback(entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var customLink = entry.target.dataset[dataNameInView];
      sendLog(s, entry.target, customLink);
      // 一度inViewログを飛ばしたら、監視をやめる
      observer.unobserve(entry.target);
    });
  };
  // IntersectionObserverを呼ぶ
  var observer = new IntersectionObserver(inViewCallback, options);
  scrollLogTargetList.forEach(function (target) {
    observer.observe(target);
  });
}

/**
 * @description 27卒ログ実装 - targetDOM生成を監視し生成された時特定のDOMにクリックログ、Viewログ機能を入れ込む
 * @param {string} targetDOM 監視対象のDOMクラス名（PR枠）
 * @returns なし
 */

function observeSettingLog(targetDOM) {
  // 引数値チェック：targetDOM(PR枠)が未指定、またはstring型でない場合は後続の処理を中断
  if (!targetDOM || typeof targetDOM !== 'string') return;

  // DOM存在チェック：対象要素がない画面では処理を中断
  var targetSelector = "." + targetDOM;
  var targetElement = document.querySelector(targetSelector);
  if (!targetElement) return;

  try {
    // 27ログ対応、PR枠imp時,click時ログ送信
    (0, _disposableObserver.disposableObserver)(targetSelector, function () {
      var inviewPrLogHook = document.querySelectorAll('.js-pr-isInView');
      var clickLogHook = document.querySelectorAll('.js-pr-clickLog');

      initCustomScrollLog(window.s, inviewPrLogHook, 'prInviewLog', 0);
      (0, _sendClickLog.initClickLog)(clickLogHook, 'prClickLog');
    });
  } catch (error) {
    // エラー時に関数名＋引数を含めたログを出力
    console.error("[observeSettingLog] disposableObserver failed for selector: " + targetSelector, error);
  }
}

},{"./_disposableObserver":41,"./_sendClickLog":42}],44:[function(require,module,exports){
/**
 * [27卒PR枠] PC PR枠 共感一覧画面用コンポーネント
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  border-top: solid 1px #dddddd;\n  padding-block: 16px;\n'], ['\n  border-top: solid 1px #dddddd;\n  padding-block: 16px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  background-color: #E7F6FF;\n  box-sizing: border-box;\n  padding: 16px;\n  text-align: left;\n'], ['\n  background-color: #E7F6FF;\n  box-sizing: border-box;\n  padding: 16px;\n  text-align: left;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  max-width: 692px;\n'], ['\n  max-width: 692px;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  margin-top: 8px;\n'], ['\n  display: flex;\n  flex-direction: column;\n  margin-top: 8px;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  background-color: #fff;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);\n  font-size: 12px;\n  line-height: 1.5;\n  overflow: hidden;\n\n  &:first-child {\n    margin-top: 0 !important;\n  }\n'], ['\n  background-color: #fff;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);\n  font-size: 12px;\n  line-height: 1.5;\n  overflow: hidden;\n\n  &:first-child {\n    margin-top: 0 !important;\n  }\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  display: flex;\n  padding: 15px 10px;\n  text-decoration: none;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n      text-decoration: none;\n    }\n  }\n\n  &:link, &:visited {\n    text-decoration: none;\n  }\n'], ['\n  display: flex;\n  padding: 15px 10px;\n  text-decoration: none;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n      text-decoration: none;\n    }\n  }\n\n  &:link, &:visited {\n    text-decoration: none;\n  }\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  box-sizing: border-box;\n  margin-left: 12px;\n  width: calc(100% - 100px);\n'], ['\n  box-sizing: border-box;\n  margin-left: 12px;\n  width: calc(100% - 100px);\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  color: #0b41a0;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.5;\n  margin-block: 10px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n'], ['\n  color: #0b41a0;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.5;\n  margin-block: 10px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n  color: #24243f;\n  margin: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n'], ['\n  color: #24243f;\n  margin: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n  overflow: hidden;\n  position: relative;\n  width: 100px;\n  height: 100px;\n'], ['\n  overflow: hidden;\n  position: relative;\n  width: 100px;\n  height: 100px;\n']),
    _templateObject11 = _taggedTemplateLiteral(['\n  display: block;\n  width: auto;\n  height: 100%;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n'], ['\n  display: block;\n  width: auto;\n  height: 100%;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n']),
    _templateObject12 = _taggedTemplateLiteral(['\n  color: #24243F;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.5;\n'], ['\n  color: #24243F;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.5;\n']),
    _templateObject13 = _taggedTemplateLiteral(['\n  border-radius: 4px;\n  background-color:  #3EC1BD;\n  color: #FFF;\n  display: inline-block;\n  padding: 2px 8px;\n'], ['\n  border-radius: 4px;\n  background-color:  #3EC1BD;\n  color: #FFF;\n  display: inline-block;\n  padding: 2px 8px;\n']),
    _templateObject14 = _taggedTemplateLiteral(['\n  align-items: center;\n  background-color: ', ';\n  box-sizing: border-box;\n  color: #FFF;\n  display: inline-flex;\n  font-size: 10px;\n  font-weight: 700;\n  height: 20px;\n  padding: 2px 13px;\n'], ['\n  align-items: center;\n  background-color: ', ';\n  box-sizing: border-box;\n  color: #FFF;\n  display: inline-flex;\n  font-size: 10px;\n  font-weight: 700;\n  height: 20px;\n  padding: 2px 13px;\n']),
    _templateObject15 = _taggedTemplateLiteral(['\n  align-items: center;\n  background-color:  #EFEFF3;\n  box-sizing: border-box;\n  color: #24243F;\n  display: inline-flex;\n  font-size: 10px;\n  font-weight: 700;\n  height: 20px;\n  padding: 2px 8px;\n  margin-left: 4px;\n'], ['\n  align-items: center;\n  background-color:  #EFEFF3;\n  box-sizing: border-box;\n  color: #24243F;\n  display: inline-flex;\n  font-size: 10px;\n  font-weight: 700;\n  height: 20px;\n  padding: 2px 8px;\n  margin-left: 4px;\n']),
    _templateObject16 = _taggedTemplateLiteral(['\n  background-color: #E7F6FF;\n  box-sizing: border-box;\n  margin-top: 16px;\n  text-align: left;\n'], ['\n  background-color: #E7F6FF;\n  box-sizing: border-box;\n  margin-top: 16px;\n  text-align: left;\n']),
    _templateObject17 = _taggedTemplateLiteral(['\n  width: 95%;\n  margin: 0 auto;\n  padding: 16px 0;\n'], ['\n  width: 95%;\n  margin: 0 auto;\n  padding: 16px 0;\n']),
    _templateObject18 = _taggedTemplateLiteral(['\n  background-color: #fff;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);\n  font-size: 12px;\n  line-height: 1.5;\n  margin: 8px auto 0;\n  overflow: hidden;\n  width: 100%;\n\n  &:first-child {\n    margin-top: 0 !important;\n  }\n'], ['\n  background-color: #fff;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);\n  font-size: 12px;\n  line-height: 1.5;\n  margin: 8px auto 0;\n  overflow: hidden;\n  width: 100%;\n\n  &:first-child {\n    margin-top: 0 !important;\n  }\n']),
    _templateObject19 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  -webkit-tap-highlight-color:rgba(0,0,0,0);\n  cursor: pointer;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n      text-decoration: none;\n    }\n  }\n\n  &:link, &:visited {\n    text-decoration: none;\n  }\n'], ['\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  -webkit-tap-highlight-color:rgba(0,0,0,0);\n  cursor: pointer;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n      text-decoration: none;\n    }\n  }\n\n  &:link, &:visited {\n    text-decoration: none;\n  }\n']),
    _templateObject20 = _taggedTemplateLiteral(['\n  box-sizing: border-box;\n  padding: 5px 10px;\n  width: calc(100% - 120px);\n'], ['\n  box-sizing: border-box;\n  padding: 5px 10px;\n  width: calc(100% - 120px);\n']),
    _templateObject21 = _taggedTemplateLiteral(['\n  color: #333;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-bottom: 5px;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.3;\n'], ['\n  color: #333;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-bottom: 5px;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.3;\n']),
    _templateObject22 = _taggedTemplateLiteral(['\n  font-size: 11px;\n  font-weight: 300;\n  color: #24243F;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n'], ['\n  font-size: 11px;\n  font-weight: 300;\n  color: #24243F;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n']),
    _templateObject23 = _taggedTemplateLiteral(['\n  font-size: 10px;\n  font-weight: 300;\n  color: #808D96;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n'], ['\n  font-size: 10px;\n  font-weight: 300;\n  color: #808D96;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n']),
    _templateObject24 = _taggedTemplateLiteral(['\n  position: relative;\n  overflow: hidden;\n  width: 120px;\n  height: 120px;\n'], ['\n  position: relative;\n  overflow: hidden;\n  width: 120px;\n  height: 120px;\n']),
    _templateObject25 = _taggedTemplateLiteral(['\n  color: #24243F;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1.3;\n'], ['\n  color: #24243F;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1.3;\n']),
    _templateObject26 = _taggedTemplateLiteral(['\n  background-color:  #3EC1BD;\n  border-radius: 4px;\n  box-sizing: border-box;\n  color: #FFF;\n  display: inline-flex;\n  font-size: 10px;\n  align-items: center;\n  padding: 2px 8px;\n  height: 19px;\n'], ['\n  background-color:  #3EC1BD;\n  border-radius: 4px;\n  box-sizing: border-box;\n  color: #FFF;\n  display: inline-flex;\n  font-size: 10px;\n  align-items: center;\n  padding: 2px 8px;\n  height: 19px;\n']),
    _templateObject27 = _taggedTemplateLiteral(['\n  align-items: center;\n  background-color: ', ';\n  bottom: 0;\n  box-sizing: border-box;\n  color: #FFF;\n  display: inline-flex;\n  font-weight: 700;\n  font-size: 10px;\n  line-height: 1.3;\n  height: 20px;\n  padding: 2px 13px;\n  position: absolute;\n  right: 0;\n'], ['\n  align-items: center;\n  background-color: ', ';\n  bottom: 0;\n  box-sizing: border-box;\n  color: #FFF;\n  display: inline-flex;\n  font-weight: 700;\n  font-size: 10px;\n  line-height: 1.3;\n  height: 20px;\n  padding: 2px 13px;\n  position: absolute;\n  right: 0;\n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var _emotionCss = require('@emotion/css');

var _modulesPrAreaUtilities_prAreaUtilities = require('../../../../modules/prAreaUtilities/_prAreaUtilities');

/**
 * @description 共感一覧用PRカセットDOM生成
 * @param {array} empathyContentsList - PR枠に表示する情報
 * @param {boolean} [isSp = false] - SP判定
 * @returns {string} - 共感一覧用PRカセット枠コンポーネントのHTML DOM文字列
 */
var concernFieldEmpathyContents = function concernFieldEmpathyContents(empathyContentsList) {
  var isSp = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];

  var cassetteHtml = '';

  empathyContentsList.forEach(function (empathyContentsItem, index) {
    cassetteHtml += __createEmpathyContentsHtml(empathyContentsItem, isSp, index + 1);
  });

  return isSp ? '\n    <div class="' + spStyles + '">\n      <div class="' + spWrapperStyles + '">\n        <div class="' + spTextStyles + '">\n          <span class="' + spIconStyles + '">PR</span>\n        </div>\n        <div class="' + spListStyles + '">\n          ' + cassetteHtml + '\n        </div>\n      </div>\n    </div>\n  ' : '\n    <div class="' + prAreaBorderWrapperStyles + '">\n      <div class="' + prAreaStyles + '">\n        <div class="' + prAreaWrapperStyles + '">\n          <div class="' + textStyles + '">\n            <p><span class="' + iconStyles + '">PR</span></p>\n          </div>\n          <div class="' + prAreaListStyles + '">\n            ' + cassetteHtml + '\n          </div>\n        </div>\n      </div>\n    </div>\n  ';
};

/**
 * @private
 * @description カセット「おすすめの学校情報」パターンのバナーの単体HTMLフォーマット生成
 * @param {object} empathyContentsItem - PR枠カセット情報
 * @param {boolean} [isSp = false] - SP判定
 * @returns {string} - 「おすすめの学校情報」単体HTMLのDOM文字列
 */
var __createEmpathyContentsHtml = function __createEmpathyContentsHtml(empathyContentsItem, isSp, order) {
  if (isSp === undefined) isSp = false;
  var planningType = empathyContentsItem.planningType;
  var gakkoCd = empathyContentsItem.gakkoCd;
  var productCd = empathyContentsItem.productCd;
  var mainImage = empathyContentsItem.mainImage;
  var mainCatch = empathyContentsItem.mainCatch;
  var semmonGakumon = empathyContentsItem.semmonGakumon;
  var shigotoNm = empathyContentsItem.shigotoNm;
  var shozokuShushinGakko = empathyContentsItem.shozokuShushinGakko;
  var gakubuGakkaCourseNm = empathyContentsItem.gakubuGakkaCourseNm;
  var headLine = empathyContentsItem.headLine;

  var planningString = __setPlannigTypeRule(planningType);

  var labelText = __getLabelTextByPlanningType(planningString);
  var labelBackgroundColor = (0, _modulesPrAreaUtilities_prAreaUtilities.getEmpathyContentsBackgroundColor)(labelText);

  // 「授業」とそれ以外でURLの形式が異なるため出し分けを行う
  var URL = ['sensei', 'campusLife', 'senpaiShigoto'].includes(planningString) ? '/gakko/' + gakkoCd + '/' + planningString + '/' + productCd + '/' : '/net/kokishin/detail/' + gakkoCd + '/' + productCd + '/';

  return isSp ? '\n    <div class="' + spItemStyles + ' js-pr-isInView" data-pr-inview-log="' + trace_p + '_PRcassette_imp_' + order + '_' + gakkoCd + '">\n      <a\n        href="' + URL + '"\n        class="' + spLinkStyles + ' js-pr-clickLog" \n        target="_blank"\n        data-pr-click-log="' + trace_p + '_PRcassette_click_' + order + '_' + gakkoCd + '"\n      >\n        <div class="' + spImageBlockStyles + '">\n          <img class="' + spImageStyles + '" src="' + mainImage + '" alt="' + shozokuShushinGakko + '">\n          ' + (labelText ? '<span class="' + spCategoryStyles(labelBackgroundColor) + '">' + labelText + '</span>' : '') + '\n        </div>\n        <div class="' + spInfoStyles + '">\n          <h2 class="' + spTitleStyles + '">' + mainCatch + '</h2>\n          <div class="' + spOtherInfoStyles + '">' + (semmonGakumon ? "専門：" + semmonGakumon : '') + '</div>\n          <div class="' + spOtherInfoStyles + '">' + (shigotoNm ? shigotoNm : '') + '</div>\n          <div class="' + spOtherInfoStyles + '">' + shozokuShushinGakko + '／' + gakubuGakkaCourseNm + '</div>\n          <div class="' + spOtherInfoSmallTextStyles + '">' + (planningString === 'lesson' ? headLine : '') + '</div>\n        </div>\n      </a>\n    </div>\n  ' : '\n    <div class="' + prAreaItemStyles + ' js-pr-isInView" data-pr-inview-log="' + trace_p + '_PRcassette_imp_' + order + '_' + gakkoCd + '">\n      <a\n        href="' + URL + '"\n        class="' + prAreaLinkStyles + ' js-pr-clickLog" \n        target="_blank"\n        data-pr-click-log="' + trace_p + '_PRcassette_click_' + order + '_' + gakkoCd + '"\n      >\n        <div class="' + prAreaImageBlockStyles + '">\n          <img class="' + prAreaImageStyles + '" src="' + mainImage + '" alt="' + shozokuShushinGakko + '">\n        </div>\n        <div class="' + prAreaInfoStyles + '">\n          <div class="">\n            ' + (labelText ? '<span class="' + categoryStyles(labelBackgroundColor) + '">' + labelText + '</span>' : '') + '\n            <span class="' + normalTagStyles + '">' + headLine + '</span>\n          </div>\n          <div class="' + prAreaTitleStyles + '">' + mainCatch + '</div>\n          <div class="' + prAreaOtherInfoStyles + '">' + (semmonGakumon ? "専門：" + semmonGakumon : '') + '</div>\n          <div class="' + prAreaOtherInfoStyles + '">' + (shigotoNm ? shigotoNm : '') + '</div>\n          <div class="' + prAreaOtherInfoStyles + '">' + shozokuShushinGakko + '／' + gakubuGakkaCourseNm + '</div>\n        </div>\n      </a>\n    </div>\n  ';
};

/**
 * @private
 * @description 企画ごとにテキストを取得する関数
 * @param {string} planningString - 企画タイプ
 * @returns {string} - ラベル用テキスト
 */
var __getLabelTextByPlanningType = function __getLabelTextByPlanningType(planningString) {
  switch (planningString) {
    case 'sensei':
      return '先生・教授';
    case 'campusLife':
      return '在校生';
    case 'senpaiShigoto':
      return '卒業後';
    case 'lesson':
      return '授業';
    default:
      return '';
  }
};

/**
 * @private
 * @description json データ plannigTypeを正しいデータに紐付けし返す関数
 * @param {string} planningType - 1: 在校生 2: 先生・教授 3: 卒業生（先輩の仕事）
 * @returns {string} - planningString
 */
var __setPlannigTypeRule = function __setPlannigTypeRule(planningType) {
  switch (planningType) {
    case '1':
      return 'campusLife';
    case '2':
      return 'sensei';
    case '3':
      return 'senpaiShigoto';
    case '4':
      return 'lesson';
    default:
      return '';
  }
};

exports.concernFieldEmpathyContents = concernFieldEmpathyContents;

/*---- CSS定義 ----*/
var prAreaBorderWrapperStyles = (0, _emotionCss.css)(_templateObject);

var prAreaStyles = (0, _emotionCss.css)(_templateObject2);

var prAreaWrapperStyles = (0, _emotionCss.css)(_templateObject3);

var prAreaListStyles = (0, _emotionCss.css)(_templateObject4);

var prAreaItemStyles = (0, _emotionCss.css)(_templateObject5);

var prAreaLinkStyles = (0, _emotionCss.css)(_templateObject6);

var prAreaInfoStyles = (0, _emotionCss.css)(_templateObject7);

var prAreaTitleStyles = (0, _emotionCss.css)(_templateObject8);

var prAreaOtherInfoStyles = (0, _emotionCss.css)(_templateObject9);

var prAreaImageBlockStyles = (0, _emotionCss.css)(_templateObject10);

var prAreaImageStyles = (0, _emotionCss.css)(_templateObject11);

var textStyles = (0, _emotionCss.css)(_templateObject12);

var iconStyles = (0, _emotionCss.css)(_templateObject13);

var categoryStyles = function categoryStyles(bgColor) {
  return (0, _emotionCss.css)(_templateObject14, bgColor);
};

var normalTagStyles = (0, _emotionCss.css)(_templateObject15);

/*---- SP CSS定義 ----*/
var spStyles = (0, _emotionCss.css)(_templateObject16);

var spWrapperStyles = (0, _emotionCss.css)(_templateObject17);

var spListStyles = (0, _emotionCss.css)(_templateObject4);

var spItemStyles = (0, _emotionCss.css)(_templateObject18);

var spLinkStyles = (0, _emotionCss.css)(_templateObject19);

var spInfoStyles = (0, _emotionCss.css)(_templateObject20);

var spTitleStyles = (0, _emotionCss.css)(_templateObject21);

var spOtherInfoStyles = (0, _emotionCss.css)(_templateObject22);

var spOtherInfoSmallTextStyles = (0, _emotionCss.css)(_templateObject23);

var spImageBlockStyles = (0, _emotionCss.css)(_templateObject24);

var spImageStyles = (0, _emotionCss.css)(_templateObject11);

var spTextStyles = (0, _emotionCss.css)(_templateObject25);

var spIconStyles = (0, _emotionCss.css)(_templateObject26);

var spCategoryStyles = function spCategoryStyles(bgColor) {
  return (0, _emotionCss.css)(_templateObject27, bgColor);
};

},{"../../../../modules/prAreaUtilities/_prAreaUtilities":64,"@emotion/css":7}],45:[function(require,module,exports){
/**
 * [27卒PR枠] PC PR枠 新増設一覧画面用コンポーネント
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  background-color: #E7F6FF;\n  width: 100vw;\n\n  @media screen and (min-width: 960px) {\n    margin: 0 calc(50% - 50vw);\n  };\n'], ['\n  background-color: #E7F6FF;\n  width: 100vw;\n\n  @media screen and (min-width: 960px) {\n    margin: 0 calc(50% - 50vw);\n  };\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  box-sizing: border-box;\n  padding-block: 16px;\n  margin: 0 auto 16px;\n  width: 960px;\n  text-align: left;\n'], ['\n  box-sizing: border-box;\n  padding-block: 16px;\n  margin: 0 auto 16px;\n  width: 960px;\n  text-align: left;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  margin: 0 auto;\n'], ['\n  margin: 0 auto;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  width: 100%;\n  margin-left: 0;\n'], ['\n  width: 100%;\n  margin-left: 0;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  color: #24243F;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.5;\n  padding-bottom: 8px;\n'], ['\n  color: #24243F;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.5;\n  padding-bottom: 8px;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  border-radius: 4px;\n  background-color:  #3EC1BD;\n  color: #FFF;\n  display: inline-block;\n  padding: 2px 8px;\n  margin-right: 8px;\n'], ['\n  border-radius: 4px;\n  background-color:  #3EC1BD;\n  color: #FFF;\n  display: inline-block;\n  padding: 2px 8px;\n  margin-right: 8px;\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  background-color: #FFF;\n  border-top: 2px solid #0B41A0;\n  border-bottom: 1px solid #D3D4D4;\n  display: flex;\n  border-right: none;\n  border-left: none;\n  margin: 0;\n'], ['\n  background-color: #FFF;\n  border-top: 2px solid #0B41A0;\n  border-bottom: 1px solid #D3D4D4;\n  display: flex;\n  border-right: none;\n  border-left: none;\n  margin: 0;\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  width: auto;\n  float: left;\n  text-align: center;\n'], ['\n  width: auto;\n  float: left;\n  text-align: center;\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n  display: block;\n  padding: 12px 16px 15px 16px;\n'], ['\n  display: block;\n  padding: 12px 16px 15px 16px;\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n  margin: 0;\n'], ['\n  margin: 0;\n']),
    _templateObject11 = _taggedTemplateLiteral(['\n  border: 1px solid #0B41A0;\n  border-radius: 2px;\n  color: #0B41A0;\n  width: 74px;\n  height: 34px;\n  font-size: 10px;\n  padding: 3px;\n  text-align: center;\n  margin: 0 auto;\n  box-sizing: border-box;\n'], ['\n  border: 1px solid #0B41A0;\n  border-radius: 2px;\n  color: #0B41A0;\n  width: 74px;\n  height: 34px;\n  font-size: 10px;\n  padding: 3px;\n  text-align: center;\n  margin: 0 auto;\n  box-sizing: border-box;\n']),
    _templateObject12 = _taggedTemplateLiteral(['\n  margin: 0;\n  line-height: 1;\n'], ['\n  margin: 0;\n  line-height: 1;\n']),
    _templateObject13 = _taggedTemplateLiteral(['\n  font-weight: 700;\n  font-size: 14px;\n'], ['\n  font-weight: 700;\n  font-size: 14px;\n']),
    _templateObject14 = _taggedTemplateLiteral(['\n  border-left: 1px solid #D3D4D4;\n  box-sizing: border-box;\n  width: 100%;\n'], ['\n  border-left: 1px solid #D3D4D4;\n  box-sizing: border-box;\n  width: 100%;\n']),
    _templateObject15 = _taggedTemplateLiteral(['\n  padding: 12px 16px;\n  border-bottom: 1px solid #D3D4D4;\n'], ['\n  padding: 12px 16px;\n  border-bottom: 1px solid #D3D4D4;\n']),
    _templateObject16 = _taggedTemplateLiteral(['\n  border-radius: 4px;\n  background-color: #0B41A0;\n  padding: 2px 6px;\n  margin-bottom: 8px;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.5;\n  display: inline-block;\n'], ['\n  border-radius: 4px;\n  background-color: #0B41A0;\n  padding: 2px 6px;\n  margin-bottom: 8px;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.5;\n  display: inline-block;\n']),
    _templateObject17 = _taggedTemplateLiteral(['\n  color: #808d96;\n  font-size: 12px;\n  font-weight: 300;\n  padding: 0;\n  margin-bottom: 4px;\n  line-height: 1.5;\n'], ['\n  color: #808d96;\n  font-size: 12px;\n  font-weight: 300;\n  padding: 0;\n  margin-bottom: 4px;\n  line-height: 1.5;\n']),
    _templateObject18 = _taggedTemplateLiteral(['\n  padding: 0;\n  margin-bottom: 8px;\n  color: #0B41A0;\n  font-size: 18px;\n  line-height: 1.3;\n'], ['\n  padding: 0;\n  margin-bottom: 8px;\n  color: #0B41A0;\n  font-size: 18px;\n  line-height: 1.3;\n']),
    _templateObject19 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n'], ['\n  display: flex;\n  flex-direction: column;\n']),
    _templateObject20 = _taggedTemplateLiteral(['\n  font-weight: 700;\n'], ['\n  font-weight: 700;\n']),
    _templateObject21 = _taggedTemplateLiteral(['\n  padding: 0;\n  border-bottom: none;\n  color: #24243f;\n  font-size: 12px;\n  font-weight: 300;\n  line-height: 1.3;\n'], ['\n  padding: 0;\n  border-bottom: none;\n  color: #24243f;\n  font-size: 12px;\n  font-weight: 300;\n  line-height: 1.3;\n']),
    _templateObject22 = _taggedTemplateLiteral(['\n  padding: 12px 16px 16px;\n'], ['\n  padding: 12px 16px 16px;\n']),
    _templateObject23 = _taggedTemplateLiteral(['\n  margin-bottom: 16px;\n  padding: 0;\n  color: #24243f;\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 1.5;\n'], ['\n  margin-bottom: 16px;\n  padding: 0;\n  color: #24243f;\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 1.5;\n']),
    _templateObject24 = _taggedTemplateLiteral(['\n  display: flex;\n  gap: 8px;\n  margin-left: 0;\n  padding-bottom: 5px;\n'], ['\n  display: flex;\n  gap: 8px;\n  margin-left: 0;\n  padding-bottom: 5px;\n']),
    _templateObject25 = _taggedTemplateLiteral(['\n  margin-top: 7px;\n'], ['\n  margin-top: 7px;\n']),
    _templateObject26 = _taggedTemplateLiteral(['\n  display: inline-block;\n  margin-right: 5px;\n  vertical-align: middle;\n  width: 139px;\n  height: 29px;\n  background: url(/images/common/btn_gakko_s.png) no-repeat 0 0;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n'], ['\n  display: inline-block;\n  margin-right: 5px;\n  vertical-align: middle;\n  width: 139px;\n  height: 29px;\n  background: url(/images/common/btn_gakko_s.png) no-repeat 0 0;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n']),
    _templateObject27 = _taggedTemplateLiteral(['\n  display: inline-block;\n  margin-right: 5px;\n  vertical-align: middle;\n  width: 120px;\n  height: 29px;\n  background: url(/images/common/btn_gakko_s.png) no-repeat 0 -29px;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n'], ['\n  display: inline-block;\n  margin-right: 5px;\n  vertical-align: middle;\n  width: 120px;\n  height: 29px;\n  background: url(/images/common/btn_gakko_s.png) no-repeat 0 -29px;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n']),
    _templateObject28 = _taggedTemplateLiteral(['\n  background-color: #E7F6FF;\n  box-sizing: border-box;\n  text-align: left;\n  padding: 16px 10px;\n  margin: 0 calc(50% - 50vw) 20px;\n  width: 100xw;\n'], ['\n  background-color: #E7F6FF;\n  box-sizing: border-box;\n  text-align: left;\n  padding: 16px 10px;\n  margin: 0 calc(50% - 50vw) 20px;\n  width: 100xw;\n']),
    _templateObject29 = _taggedTemplateLiteral(['\n  color: #24243F;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.3;\n  padding-bottom: 8px;\n'], ['\n  color: #24243F;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.3;\n  padding-bottom: 8px;\n']),
    _templateObject30 = _taggedTemplateLiteral(['\n  border-radius: 4px;\n  background-color:  #3EC1BD;\n  color: #FFF;\n  display: inline-flex;\n  font-size: 10px;\n  align-items: center;\n  padding: 2px 8px;\n  height: 19px;\n'], ['\n  border-radius: 4px;\n  background-color:  #3EC1BD;\n  color: #FFF;\n  display: inline-flex;\n  font-size: 10px;\n  align-items: center;\n  padding: 2px 8px;\n  height: 19px;\n']),
    _templateObject31 = _taggedTemplateLiteral(['\n  background-color: #fff;\n  border-top: 2px solid #0B41A0;\n  border-bottom: 1px solid #D3D4D4;\n  display: table;\n  width: 100%;\n'], ['\n  background-color: #fff;\n  border-top: 2px solid #0B41A0;\n  border-bottom: 1px solid #D3D4D4;\n  display: table;\n  width: 100%;\n']),
    _templateObject32 = _taggedTemplateLiteral(['\n  display: table-cell;\n  float: none;\n  padding: 5px;\n  vertical-align: top;\n  width: 20% !important;\n'], ['\n  display: table-cell;\n  float: none;\n  padding: 5px;\n  vertical-align: top;\n  width: 20% !important;\n']),
    _templateObject33 = _taggedTemplateLiteral(['\n  height: auto;\n  margin: 0;\n  margin-bottom: 5px;\n  width: 100%;\n'], ['\n  height: auto;\n  margin: 0;\n  margin-bottom: 5px;\n  width: 100%;\n']),
    _templateObject34 = _taggedTemplateLiteral(['\n  border: 1px solid #0B41A0;\n  border-radius: 2px;\n  color: #0B41A0;\n  width: 74px;\n  height: 34px;\n  font-size: 10px;\n  padding: 3px;\n  text-align: center;\n  align-items: center;\n'], ['\n  border: 1px solid #0B41A0;\n  border-radius: 2px;\n  color: #0B41A0;\n  width: 74px;\n  height: 34px;\n  font-size: 10px;\n  padding: 3px;\n  text-align: center;\n  align-items: center;\n']),
    _templateObject35 = _taggedTemplateLiteral(['\n  margin: unset !important;\n  line-height: 1;\n'], ['\n  margin: unset !important;\n  line-height: 1;\n']),
    _templateObject36 = _taggedTemplateLiteral(['\n  display: table-cell;\n  float: none;\n  vertical-align: top;\n  width: 80%;\n  border-left: 1px solid #D3D4D4;\n'], ['\n  display: table-cell;\n  float: none;\n  vertical-align: top;\n  width: 80%;\n  border-left: 1px solid #D3D4D4;\n']),
    _templateObject37 = _taggedTemplateLiteral(['\n  padding: 12px;\n  border-bottom: 1px solid #D3D4D4;\n'], ['\n  padding: 12px;\n  border-bottom: 1px solid #D3D4D4;\n']),
    _templateObject38 = _taggedTemplateLiteral(['\n  border-radius: 4px;\n  background-color: #0B41A0;\n  padding: 2px 6px;\n  margin-bottom: 8px;\n  color: #fff;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1.5;\n  display: inline-block;\n'], ['\n  border-radius: 4px;\n  background-color: #0B41A0;\n  padding: 2px 6px;\n  margin-bottom: 8px;\n  color: #fff;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1.5;\n  display: inline-block;\n']),
    _templateObject39 = _taggedTemplateLiteral(['\n  padding: 0;\n  margin-bottom: 4px;\n  color: #808d96;\n  font-size: 10px;\n  font-weight: 300;\n  line-height: 1.5;\n'], ['\n  padding: 0;\n  margin-bottom: 4px;\n  color: #808d96;\n  font-size: 10px;\n  font-weight: 300;\n  line-height: 1.5;\n']),
    _templateObject40 = _taggedTemplateLiteral(['\n  padding: 0;\n  margin-bottom: 8px;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 1.3;\n'], ['\n  padding: 0;\n  margin-bottom: 8px;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 1.3;\n']),
    _templateObject41 = _taggedTemplateLiteral(['\n  padding: 8px 12px 11px;\n'], ['\n  padding: 8px 12px 11px;\n']),
    _templateObject42 = _taggedTemplateLiteral(['\n  margin-bottom: 16px;\n  padding: 0;\n  font-size: 12px;\n  line-height: 1.5;\n  color: #24243f;\n'], ['\n  margin-bottom: 16px;\n  padding: 0;\n  font-size: 12px;\n  line-height: 1.5;\n  color: #24243f;\n']),
    _templateObject43 = _taggedTemplateLiteral(['\n  margin-left: 0;\n  padding-bottom: 12px;\n'], ['\n  margin-left: 0;\n  padding-bottom: 12px;\n']),
    _templateObject44 = _taggedTemplateLiteral(['\n  display: inline-block;\n  margin-bottom: 5px;\n  margin-right: 5px;\n  vertical-align: middle;\n'], ['\n  display: inline-block;\n  margin-bottom: 5px;\n  margin-right: 5px;\n  vertical-align: middle;\n']),
    _templateObject45 = _taggedTemplateLiteral(['\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 5px;\n  margin-bottom: 5px;\n  width: 139px;\n  height: 29px;\n  background: url(/images/common/btn_gakko_s.png) no-repeat 0 0;\n  -webkit-tap-highlight-color:rgba(0,0,0,0);\n  cursor: pointer;\n'], ['\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 5px;\n  margin-bottom: 5px;\n  width: 139px;\n  height: 29px;\n  background: url(/images/common/btn_gakko_s.png) no-repeat 0 0;\n  -webkit-tap-highlight-color:rgba(0,0,0,0);\n  cursor: pointer;\n']),
    _templateObject46 = _taggedTemplateLiteral(['\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 5px;\n  margin-bottom: 5px;\n  width: 120px;\n  height: 29px;\n  background: url(/images/common/btn_gakko_s.png) no-repeat 0 -29px;\n  -webkit-tap-highlight-color:rgba(0,0,0,0);\n  cursor: pointer;\n'], ['\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 5px;\n  margin-bottom: 5px;\n  width: 120px;\n  height: 29px;\n  background: url(/images/common/btn_gakko_s.png) no-repeat 0 -29px;\n  -webkit-tap-highlight-color:rgba(0,0,0,0);\n  cursor: pointer;\n']),
    _templateObject47 = _taggedTemplateLiteral(['\n  margin-inline: unset !important;\n'], ['\n  margin-inline: unset !important;\n']),
    _templateObject48 = _taggedTemplateLiteral(['\n  display: inline-block;\n  -webkit-tap-highlight-color:rgba(0,0,0,0);\n  cursor: pointer;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n'], ['\n  display: inline-block;\n  -webkit-tap-highlight-color:rgba(0,0,0,0);\n  cursor: pointer;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var _emotionCss = require('@emotion/css');

/**
 * @description 新増設一覧用PRカセットDOM生成
 * @param {array} shinzosetsuList - PR枠に表示する情報
 * @param {boolean} [isSp = false] - SP判定
 * @returns {string} - 新増設一覧用PRカセット枠コンポーネントのHTML DOM文字列
 */
var concernFieldShinsetsu = function concernFieldShinsetsu(shinzosetsuList) {
  var isSp = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];

  var cassetteHtml = '';

  shinzosetsuList.forEach(function (shinzosetsuItem, index) {
    cassetteHtml += __createCassetteHtml(shinzosetsuItem, isSp, index + 1);
  });

  return isSp ? '\n    <div class="' + spStyles + '">\n      <div>\n        <div class="' + spTextStyles + '">\n          <span class="' + spIconStyles + '">PR</span>\n        </div>\n        <div class="' + spListStyles + '">\n          ' + cassetteHtml + '\n        </div>\n      </div>\n    </div>\n  ' : '\n    <div class="' + prAreaOverWrapperStyles + '">\n      <div class="' + prAreaStyles + '">\n        <div class="' + prAreaWrapperStyles + '">\n          <div class="' + textStyles + '">\n            <p><span class="' + iconStyles + '">PR</span></p>\n          </div>\n          <div class="' + prAreaListStyles + '">\n            ' + cassetteHtml + '\n          </div>\n        </div>\n      </div>\n    </div>\n  ';
};

/**
 * @private
 * @description 新増設一覧用の単体HTMLフォーマット生成
 * @param {object} shinzosetsuItem - 新増設アイテム
 * @param {boolean} [isSp = false] - SP判定
 * @param {number} order - 表示順位
 * @returns {string} - 「おすすめの学校情報」単体HTMLのDOM文字列
 */
var __createCassetteHtml = function __createCassetteHtml(shinzosetsuItem, isSp, order) {
  if (isSp === undefined) isSp = false;
  var productCd = shinzosetsuItem.productCd;
  var gakkoCd = shinzosetsuItem.gakkoCd;
  var admissionYear = shinzosetsuItem.admissionYear;
  var koshuNm = shinzosetsuItem.koshuNm;
  var todofukenRnm = shinzosetsuItem.todofukenRnm;
  var gakkoNm = shinzosetsuItem.gakkoNm;
  var gakkoNmHosoku = shinzosetsuItem.gakkoNmHosoku;
  var gakubuNm = shinzosetsuItem.gakubuNm;
  var gakubuHosoku = shinzosetsuItem.gakubuHosoku;
  var topicsCatch = shinzosetsuItem.topicsCatch;
  var mainImage = shinzosetsuItem.mainImage;
  var optionSankakuNm = shinzosetsuItem.optionSankakuNm;
  var optionSankakuUrl = shinzosetsuItem.optionSankakuUrl;
  var optionSankakuImageUrl = shinzosetsuItem.optionSankakuImageUrl;
  var actionSankakuEnm = shinzosetsuItem.actionSankakuEnm;
  var actionSankakuUrl = shinzosetsuItem.actionSankakuUrl;
  var shinsetsuYear = shinzosetsuItem.shinsetsuYear;
  var shinsetsuMonth = shinzosetsuItem.shinsetsuMonth;
  var shinsetsuInfo = shinzosetsuItem.shinsetsuInfo;
  var yotei = shinzosetsuItem.yotei;
  var shinsetsuStatus = shinzosetsuItem.shinsetsuStatus;
  var shinsetsuStatusComment = shinzosetsuItem.shinsetsuStatusComment;
  var shinzosetsuShubetsuCd = shinzosetsuItem.shinzosetsuShubetsuCd;

  var linkUrl = '/gakko/' + gakkoCd + '/newfoundation/' + productCd + '/';
  var clickLog = trace_p + '_PRcassette_click_' + order + '_' + gakkoCd;

  var linkTagHtml = '';
  optionSankakuNm.forEach(function (_, index) {
    linkTagHtml += __createLinkTagHtml(optionSankakuNm[index], optionSankakuImageUrl[index], optionSankakuUrl[index], clickLog);
  });

  var pamphButtonHtml = '';
  actionSankakuEnm.forEach(function (_, index) {
    pamphButtonHtml += __createPamphButtonHtml(isSp, actionSankakuEnm[index], actionSankakuUrl[index], clickLog);
  });

  var shinsetsuLabel = function shinsetsuLabel() {
    return shinzosetsuShubetsuCd === '1' ? '新しい学校' : '新しい学部学科コース';
  };
  var gakubuLink = function gakubuLink() {
    return shinzosetsuShubetsuCd === '1' ? '' : '' + (gakubuNm + gakubuHosoku);
  };
  var shinsetsuCommnet = function shinsetsuCommnet() {
    var year = shinsetsuYear ? "年" : "";
    var month = shinsetsuMonth ? "月" : "";

    return shinsetsuYear + year + shinsetsuMonth + month + shinsetsuInfo + yotei + shinsetsuStatus + shinsetsuStatusComment;
  };

  return isSp ? '\n    <div class="' + spBoxStyles + ' js-pr-isInView" data-pr-inview-log="' + trace_p + '_PRcassette_imp_' + order + '_' + gakkoCd + '">\n      <div class="' + spBoxLeftStyles + '">\n        <a href="' + linkUrl + '" class="js-pr-clickLog" target="_blank" data-pr-click-log="' + clickLog + '">\n          <img src="' + mainImage + '" border="0" alt=' + (gakkoNm + gakkoNmHosoku) + ' class="' + spImageStyles + '" height="80" width="80">\n        </a>\n        <div class="' + spBoxLeftTagStyles + '">\n          <p class="' + spBoxLeftTextStyles + '"><span class="' + spBoxLeftTextLargeStyles + '">' + admissionYear + '</span> 年度<br>入学から対象</p>\n        </div>\n      </div>\n      <div class="' + spBoxRightStyles + '">\n        <div class="' + spBoxRightTopStyles + '">\n          <div class="' + spBoxRightTagStyles + '">' + shinsetsuLabel() + '</div>\n          <div class="' + spBoxRightUniversityInfoStyles + '">' + koshuNm + ' ／ ' + todofukenRnm + '</div>\n          <div class="' + spBoxRightUniversityLinkStyles + '">\n            <h2 class="' + spUnsetMarginInlineStyles + ' ' + spBoxRightTitleStyles + '">\n              <a\n                href="' + linkUrl + '"\n                class="' + spBoxRightLinkStyles + ' js-pr-clickLog" \n                target="_blank"\n                data-pr-click-log="' + clickLog + '">\n              ' + (gakkoNm + gakkoNmHosoku) + '\n              ' + ('<br>' + gakubuLink()) + '\n              </a>\n            </h2>\n          </div>\n          <p class="' + spFoundingPlanTextStyles + ' ' + spUnsetMarginInlineStyles + '">' + shinsetsuCommnet() + '</p>\n        </div>\n        <div class="' + spBoxRightBottomStyles + '">\n          <p class="' + spBoxRightBottomDescriptionStyles + ' ' + spUnsetMarginInlineStyles + '">' + topicsCatch + '</p>\n          <div class="' + spBoxButtonListStyles + '">\n            ' + linkTagHtml + '\n          </div>\n          <div class="' + spPamphletButtonBoxStyles + '">\n            ' + pamphButtonHtml + '\n          </div>\n        </div>\n      </div>\n    </div>\n  ' : '\n    <div class="' + prAreaBoxStyles + ' js-pr-isInView" data-pr-inview-log="' + trace_p + '_PRcassette_imp_' + order + '_' + gakkoCd + '">\n      <div class="' + prAreaBoxLeftStyles + '">\n        <a href="' + linkUrl + '" class="' + prAreaBoxLeftLinkStyles + ' js-pr-clickLog" target="_blank" data-pr-click-log="' + clickLog + '">\n          <img src="' + mainImage + '" border="0" alt=' + (gakkoNm + gakkoNmHosoku) + ' class="' + prAreaImageStyles + '" height="80" width="80">\n        </a>\n        <div class="' + prAreaBoxLeftTagStyles + '">\n          <p class="' + prAreaBoxLeftTextStyles + '">\n            <span class="' + prAreaBoxLeftTextLargeStyles + '">' + admissionYear + '</span> 年度\n            <br>入学から対象\n          </p>\n        </div>\n      </div>\n      <div class="' + prAreaBoxRightStyles + '">\n        <div class="' + prAreaBoxRightTopStyles + '">\n          <div class="' + prAreaBoxRightTagStyles + '">' + shinsetsuLabel() + '</div>\n          <div class="' + prAreaBoxRightUniversityInfoStyles + '">' + koshuNm + ' ／ ' + todofukenRnm + '</div>\n          <div class="' + prAreaBoxRightUniversityLinkWrapperStyles + '">\n            <h2 class="' + prAreaBoxRightTitleStyles + '">\n              <a\n                href="' + linkUrl + '"\n                class="' + prAreaBoxRightUniversityLinkStyles + ' js-pr-clickLog" \n                target="_blank"\n                data-pr-click-log="' + clickLog + '">\n              ' + (gakkoNm + gakkoNmHosoku) + '\n              ' + ('<br>' + gakubuLink()) + '\n              </a>\n            </h2>\n          </div>\n          <p class="' + prAreaFoundingPlanTextStyles + '">' + shinsetsuCommnet() + '</p>\n        </div>\n        <div class="' + prAreaBoxRightBottomStyles + '">\n          <p class="' + prAreaBoxRightBottomDescriptionStyles + '">' + topicsCatch + '</p>\n          <div class="' + prAreaBoxButtonListStyles + '">\n            ' + linkTagHtml + '\n          </div>\n          <div class="' + prAreaPamphletBoxStyles + '">\n            ' + pamphButtonHtml + '\n          </div>\n        </div>\n      </div>\n    </div>\n  ';
};

/**
 * @private
 * @description リンク属性を引数で渡された数だけ生成する
 * @param {string} optionSankakuNm - リンク日本語ネーム
 * @param {string} optionSankakuImageUrl - リンクイメージURL
 * @param {string} optionSankakuUrl - リンク遷移URL
 * @param {string} clickLog - クリック時送信ログ
 * @returns {string} - 「おすすめの学校情報」単体HTMLのDOM文字列
 */
var __createLinkTagHtml = function __createLinkTagHtml(optionSankakuNm, optionSankakuImageUrl, optionSankakuUrl, clickLog) {
  return '\n      <div class="' + linkTagStyles + '">\n        <a href="' + optionSankakuUrl + '" target="_blank" class="js-pr-clickLog" data-pr-click-log="' + clickLog + '">\n          <img src="' + optionSankakuImageUrl + '" alt="' + optionSankakuNm + '">\n        </a>\n      </div>\n    ';
};

/**
 * @private
 * @description PAMPH請求ボタンを生成する
 * @param {boolean} isSp - UA判定
 * @param {string} actionSankakuEnm - アクション英語ネーム
 * @param {string} actionSankakuUrl - 遷移先URL
 * @param {string} clickLog - クリック時送信ログ
 * @returns {string} - 「パンプを請求する、原書を請求する」DOM
 */
var __createPamphButtonHtml = function __createPamphButtonHtml(isSp, actionSankakuEnm, actionSankakuUrl, clickLog) {
  var style = '';
  if (isSp) {
    style = actionSankakuEnm === 'PAMPH' ? spPamphletButtonStyles : spApplicationButtonStyles;
  } else {
    style = actionSankakuEnm === 'PAMPH' ? prAreaPamphletButtonStyles : prAreaApplicationButtonStyles;
  }

  return '\n    <a href="' + actionSankakuUrl + '" target="_blank" class="' + style + ' js-pr-clickLog" data-pr-click-log="' + clickLog + '"></a>\n  ';
};

exports.concernFieldShinsetsu = concernFieldShinsetsu;

/*---- CSS定義 ----*/
var prAreaOverWrapperStyles = (0, _emotionCss.css)(_templateObject);

var prAreaStyles = (0, _emotionCss.css)(_templateObject2);

var prAreaWrapperStyles = (0, _emotionCss.css)(_templateObject3);

var prAreaListStyles = (0, _emotionCss.css)(_templateObject4);

var textStyles = (0, _emotionCss.css)(_templateObject5);

var iconStyles = (0, _emotionCss.css)(_templateObject6);

var prAreaBoxStyles = (0, _emotionCss.css)(_templateObject7);

var prAreaBoxLeftStyles = (0, _emotionCss.css)(_templateObject8);

var prAreaBoxLeftLinkStyles = (0, _emotionCss.css)(_templateObject9);

var prAreaImageStyles = (0, _emotionCss.css)(_templateObject10);

var prAreaBoxLeftTagStyles = (0, _emotionCss.css)(_templateObject11);

var prAreaBoxLeftTextStyles = (0, _emotionCss.css)(_templateObject12);

var prAreaBoxLeftTextLargeStyles = (0, _emotionCss.css)(_templateObject13);

var prAreaBoxRightStyles = (0, _emotionCss.css)(_templateObject14);

var prAreaBoxRightTopStyles = (0, _emotionCss.css)(_templateObject15);

var prAreaBoxRightTagStyles = (0, _emotionCss.css)(_templateObject16);

var prAreaBoxRightUniversityInfoStyles = (0, _emotionCss.css)(_templateObject17);

var prAreaBoxRightUniversityLinkWrapperStyles = (0, _emotionCss.css)(_templateObject18);

var prAreaBoxRightTitleStyles = (0, _emotionCss.css)(_templateObject19);

var prAreaBoxRightUniversityLinkStyles = (0, _emotionCss.css)(_templateObject20);

var prAreaFoundingPlanTextStyles = (0, _emotionCss.css)(_templateObject21);

var prAreaBoxRightBottomStyles = (0, _emotionCss.css)(_templateObject22);

var prAreaBoxRightBottomDescriptionStyles = (0, _emotionCss.css)(_templateObject23);

var prAreaBoxButtonListStyles = (0, _emotionCss.css)(_templateObject24);

var prAreaPamphletBoxStyles = (0, _emotionCss.css)(_templateObject25);

var prAreaPamphletButtonStyles = (0, _emotionCss.css)(_templateObject26);

var prAreaApplicationButtonStyles = (0, _emotionCss.css)(_templateObject27);

/*---- SP CSS定義 ----*/
var spStyles = (0, _emotionCss.css)(_templateObject28);

var spListStyles = (0, _emotionCss.css)(_templateObject19);

var spTextStyles = (0, _emotionCss.css)(_templateObject29);

var spIconStyles = (0, _emotionCss.css)(_templateObject30);

var spBoxStyles = (0, _emotionCss.css)(_templateObject31);

var spBoxLeftStyles = (0, _emotionCss.css)(_templateObject32);

var spImageStyles = (0, _emotionCss.css)(_templateObject33);

var spBoxLeftTagStyles = (0, _emotionCss.css)(_templateObject34);

var spBoxLeftTextStyles = (0, _emotionCss.css)(_templateObject35);

var spBoxLeftTextLargeStyles = (0, _emotionCss.css)(_templateObject13);

var spBoxRightStyles = (0, _emotionCss.css)(_templateObject36);

var spBoxRightTopStyles = (0, _emotionCss.css)(_templateObject37);

var spBoxRightTagStyles = (0, _emotionCss.css)(_templateObject38);

var spBoxRightUniversityInfoStyles = (0, _emotionCss.css)(_templateObject39);

var spBoxRightUniversityLinkStyles = (0, _emotionCss.css)(_templateObject40);

var spBoxRightLinkStyles = (0, _emotionCss.css)(_templateObject20);

var spBoxRightTitleStyles = (0, _emotionCss.css)(_templateObject19);

var spFoundingPlanTextStyles = (0, _emotionCss.css)(_templateObject21);

var spBoxRightBottomStyles = (0, _emotionCss.css)(_templateObject41);

var spBoxRightBottomDescriptionStyles = (0, _emotionCss.css)(_templateObject42);

var spBoxButtonListStyles = (0, _emotionCss.css)(_templateObject43);

var spPamphletButtonBoxStyles = (0, _emotionCss.css)(_templateObject44);

var spPamphletButtonStyles = (0, _emotionCss.css)(_templateObject45);

var spApplicationButtonStyles = (0, _emotionCss.css)(_templateObject46);

// 後続で読み込まれる #contents に対するスタイルに対応するため
var spUnsetMarginInlineStyles = (0, _emotionCss.css)(_templateObject47);

var linkTagStyles = (0, _emotionCss.css)(_templateObject48);

},{"@emotion/css":7}],46:[function(require,module,exports){
/**
 * [27卒PR枠] PC/SP PR枠 進路トップ / 学問詳細 用コンポーネント
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  background-color: #E7F6FF;\n  box-sizing: border-box;\n  padding-block: 16px;\n  text-align: left;\n  margin-top: 20px !important;\n'], ['\n  background-color: #E7F6FF;\n  box-sizing: border-box;\n  padding-block: 16px;\n  text-align: left;\n  margin-top: 20px !important;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  margin: 0 auto;\n  max-width: 680px;\n'], ['\n  margin: 0 auto;\n  max-width: 680px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  margin-top: 8px;\n'], ['\n  display: flex;\n  flex-direction: column;\n  margin-top: 8px;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  background-color: #fff;\n  border-radius: 4px;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);\n  font-size: 14px;\n  line-height: 1.5;\n  margin: 16px auto 0;\n  width: 100%;\n\n  &:first-child {\n    margin-top: 0 !important;\n  }\n'], ['\n  background-color: #fff;\n  border-radius: 4px;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);\n  font-size: 14px;\n  line-height: 1.5;\n  margin: 16px auto 0;\n  width: 100%;\n\n  &:first-child {\n    margin-top: 0 !important;\n  }\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  align-items: center;\n  display: flex;\n  text-decoration: none;\n  -webkit-tap-highlight-color:rgba(0,0,0,0);\n  cursor: pointer;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n      text-decoration: none;\n    }\n  }\n\n  &:link, &:visited {\n    text-decoration: none;\n  }\n'], ['\n  align-items: center;\n  display: flex;\n  text-decoration: none;\n  -webkit-tap-highlight-color:rgba(0,0,0,0);\n  cursor: pointer;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n      text-decoration: none;\n    }\n  }\n\n  &:link, &:visited {\n    text-decoration: none;\n  }\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  box-sizing: border-box;\n  padding: 16px;\n  width: calc(100% - 220px);\n'], ['\n  box-sizing: border-box;\n  padding: 16px;\n  width: calc(100% - 220px);\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  color: #0b41a0;\n  font-size: 16px;\n  font-weight: 700;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  overflow: hidden;\n  line-height: 1.5;\n'], ['\n  color: #0b41a0;\n  font-size: 16px;\n  font-weight: 700;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  overflow: hidden;\n  line-height: 1.5;\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  color: #808d96;\n  margin-top: 8px;\n'], ['\n  color: #808d96;\n  margin-top: 8px;\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n  width: 220px;\n  height: 150px;\n'], ['\n  width: 220px;\n  height: 150px;\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n  border-radius: 4px 0 0 4px;\n  width: 220px;\n  height: 150px;\n'], ['\n  border-radius: 4px 0 0 4px;\n  width: 220px;\n  height: 150px;\n']),
    _templateObject11 = _taggedTemplateLiteral(['\n  color: #24243F;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.5;\n'], ['\n  color: #24243F;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.5;\n']),
    _templateObject12 = _taggedTemplateLiteral(['\n  border-radius: 4px;\n  background-color:  #3EC1BD;\n  color: #FFF;\n  display: inline-block;\n  padding: 2px 8px;\n  margin-right: 8px;\n'], ['\n  border-radius: 4px;\n  background-color:  #3EC1BD;\n  color: #FFF;\n  display: inline-block;\n  padding: 2px 8px;\n  margin-right: 8px;\n']),
    _templateObject13 = _taggedTemplateLiteral(['\n  background-color: #E7F6FF;\n  box-sizing: border-box;\n  padding: 16px;\n  text-align: left;\n  margin-block: 32px;\n'], ['\n  background-color: #E7F6FF;\n  box-sizing: border-box;\n  padding: 16px;\n  text-align: left;\n  margin-block: 32px;\n']),
    _templateObject14 = _taggedTemplateLiteral(['\n  background-color: #fff;\n  border-radius: 4px;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);\n  font-size: 12px;\n  line-height: 1.5;\n  margin: 8px auto 0;\n  width: 100%;\n\n  &:first-child {\n    margin-top: 0 !important;\n  }\n'], ['\n  background-color: #fff;\n  border-radius: 4px;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);\n  font-size: 12px;\n  line-height: 1.5;\n  margin: 8px auto 0;\n  width: 100%;\n\n  &:first-child {\n    margin-top: 0 !important;\n  }\n']),
    _templateObject15 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  -webkit-tap-highlight-color:rgba(0,0,0,0);\n  cursor: pointer;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n      text-decoration: none;\n    }\n  }\n\n  &:link, &:visited {\n    text-decoration: none;\n  }\n'], ['\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  -webkit-tap-highlight-color:rgba(0,0,0,0);\n  cursor: pointer;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n      text-decoration: none;\n    }\n  }\n\n  &:link, &:visited {\n    text-decoration: none;\n  }\n']),
    _templateObject16 = _taggedTemplateLiteral(['\n  box-sizing: border-box;\n  padding: 4px 8px;\n  width: calc(100% - 142px);\n'], ['\n  box-sizing: border-box;\n  padding: 4px 8px;\n  width: calc(100% - 142px);\n']),
    _templateObject17 = _taggedTemplateLiteral(['\n  color: #0b41a0;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.3;\n  overflow: hidden;\n'], ['\n  color: #0b41a0;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.3;\n  overflow: hidden;\n']),
    _templateObject18 = _taggedTemplateLiteral(['\n  color: #808d96;\n  font-size: 12px;\n  font-weight: 300;\n  line-height: 1.5;\n  margin-top: 4px;\n'], ['\n  color: #808d96;\n  font-size: 12px;\n  font-weight: 300;\n  line-height: 1.5;\n  margin-top: 4px;\n']),
    _templateObject19 = _taggedTemplateLiteral(['\n  height: 95px;\n'], ['\n  height: 95px;\n']),
    _templateObject20 = _taggedTemplateLiteral(['\n  border-radius: 4px 0 0 4px;\n  height: 95px;\n'], ['\n  border-radius: 4px 0 0 4px;\n  height: 95px;\n']),
    _templateObject21 = _taggedTemplateLiteral(['\n  color: #24243F;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.3;\n'], ['\n  color: #24243F;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.3;\n']),
    _templateObject22 = _taggedTemplateLiteral(['\n  background-color:  #3EC1BD;\n  box-sizing: border-box;\n  border-radius: 4px;\n  color: #FFF;\n  display: inline-flex;\n  font-size: 10px;\n  align-items: center;\n  padding: 2px 8px;\n  margin-right: 4px;\n  height: 19px;\n'], ['\n  background-color:  #3EC1BD;\n  box-sizing: border-box;\n  border-radius: 4px;\n  color: #FFF;\n  display: inline-flex;\n  font-size: 10px;\n  align-items: center;\n  padding: 2px 8px;\n  margin-right: 4px;\n  height: 19px;\n']),
    _templateObject23 = _taggedTemplateLiteral(['\n  margin-inline: unset !important;\n'], ['\n  margin-inline: unset !important;\n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var _emotionCss = require('@emotion/css');

/**
 * @description カセット「おすすめの学校情報」DOM生成
 * @param {array} gakkoInfoList - PR枠掲載大学情報リスト
 * @param {boolean} [isSp = false] - SP判定
 * @returns {string} - カセット「おすすめの学校情報」枠コンポーネントのHTML DOM文字列
 */
var recommendSchoolInfo = function recommendSchoolInfo(gakkoInfoList) {
  var isSp = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];

  var cassetteHtml = '';

  gakkoInfoList.forEach(function (gakkoInfoItem, index) {
    cassetteHtml += __createCassetteHtml(gakkoInfoItem, isSp, index + 1);
  });

  return isSp ? '\n    <div class="' + spStyles + '">\n      <div>\n        <div class="' + spTextStyles + '">\n          <p class="' + spUnsetMarginInlineStyles + '"><span class="' + spIconStyles + '">PR</span>おすすめの学校情報</p>\n        </div>\n        <div class="' + spListStyles + '">\n          ' + cassetteHtml + '\n        </div>\n      </div>\n    </div>\n  ' : '\n    <div class="' + prAreaStyles + '">\n      <div class="' + prAreaWrapperStyles + '">\n        <div class="' + textStyles + '">\n          <p><span class="' + iconStyles + '">PR</span>おすすめの学校情報</p>\n        </div>\n        <div class="' + prAreaListStyles + '">\n          ' + cassetteHtml + '\n        </div>\n      </div>\n    </div>\n  ';
};

/**
 * @private
 * @description カセット「おすすめの学校情報」パターンのバナーの単体HTMLフォーマット生成
 * @param {object} gakkoInfoItem - 学校情報オブジェクト
 * @param {boolean} [isSp = false] - SP判定
 * @param {number} order - 表示順位
 * @returns {string} - 「おすすめの学校情報」単体HTMLのDOM文字列
 */
var __createCassetteHtml = function __createCassetteHtml(gakkoInfoItem, isSp, order) {
  if (isSp === undefined) isSp = false;
  var gakkoCd = gakkoInfoItem.gakkoCd;
  var gakkoPhoto = gakkoInfoItem.gakkoPhoto;
  var gakkoNm = gakkoInfoItem.gakkoNm;
  var todofukenRnm = gakkoInfoItem.todofukenRnm;
  var koshuNm = gakkoInfoItem.koshuNm;

  var NO_IMAGE = "/images/assets/dummy/noImage.png";

  // TODO: HTMLはそれぞれ別ファイルに分離する
  return isSp ? '\n    <div class="' + spItemStyles + ' js-pr-isInView" data-pr-inview-log="' + trace_p + '_PRcassette_imp_' + order + '_' + gakkoCd + '">\n      <a\n        href="/gakko/' + gakkoCd + '/"\n        class="' + spLinkStyles + ' js-pr-clickLog" \n        target="_blank"\n        data-pr-click-log="' + trace_p + '_PRcassette_click_' + order + '_' + gakkoCd + '"\n      >\n        <div class="' + spImageBlockStyles + '">\n          <img class="' + spImageStyles + '" src="' + (gakkoPhoto ? gakkoPhoto : NO_IMAGE) + '" alt="' + gakkoNm + '" height="95" width="142">\n        </div>\n        <div class="' + spInfoStyles + '">\n          <div class="' + spNameStyles + '">' + gakkoNm + '</div>\n          <div class="' + spOtherInfoStyles + '">' + koshuNm + '／' + todofukenRnm + '</div>\n        </div>\n      </a>\n    </div>\n  ' : '\n    <div class="' + prAreaItemStyles + ' js-pr-isInView" data-pr-inview-log="' + trace_p + '_PRcassette_imp_' + order + '_' + gakkoCd + '">\n      <a\n        href="/gakko/' + gakkoCd + '/"\n        class="' + prAreaLinkStyles + ' js-pr-clickLog"\n        target="_blank"\n        data-pr-click-log="' + trace_p + '_PRcassette_click_' + order + '_' + gakkoCd + '"\n      >\n        <div class="' + prAreaImageBlockStyles + '">\n          <img class="' + prAreaImageStyles + '" src="' + (gakkoPhoto ? gakkoPhoto : NO_IMAGE) + '" alt="' + gakkoNm + '" height="150" width="220">\n        </div>\n        <div class="' + prAreaInfoStyles + '">\n          <div class="' + prAreaNameStyles + '">' + gakkoNm + '</div>\n          <div class="' + prAreaOtherInfoStyles + '">' + koshuNm + '／' + todofukenRnm + '</div>\n        </div>\n      </a>\n    </div>\n  ';
};

exports.recommendSchoolInfo = recommendSchoolInfo;

/*---- CSS定義 ----*/
var prAreaStyles = (0, _emotionCss.css)(_templateObject);

var prAreaWrapperStyles = (0, _emotionCss.css)(_templateObject2);

var prAreaListStyles = (0, _emotionCss.css)(_templateObject3);

var prAreaItemStyles = (0, _emotionCss.css)(_templateObject4);

var prAreaLinkStyles = (0, _emotionCss.css)(_templateObject5);

var prAreaInfoStyles = (0, _emotionCss.css)(_templateObject6);

var prAreaNameStyles = (0, _emotionCss.css)(_templateObject7);

var prAreaOtherInfoStyles = (0, _emotionCss.css)(_templateObject8);

var prAreaImageBlockStyles = (0, _emotionCss.css)(_templateObject9);

var prAreaImageStyles = (0, _emotionCss.css)(_templateObject10);

var textStyles = (0, _emotionCss.css)(_templateObject11);

var iconStyles = (0, _emotionCss.css)(_templateObject12);

/*---- SP CSS定義 ----*/
var spStyles = (0, _emotionCss.css)(_templateObject13);

var spListStyles = (0, _emotionCss.css)(_templateObject3);

var spItemStyles = (0, _emotionCss.css)(_templateObject14);

var spLinkStyles = (0, _emotionCss.css)(_templateObject15);

var spInfoStyles = (0, _emotionCss.css)(_templateObject16);

var spNameStyles = (0, _emotionCss.css)(_templateObject17);

var spOtherInfoStyles = (0, _emotionCss.css)(_templateObject18);

var spImageBlockStyles = (0, _emotionCss.css)(_templateObject19);

var spImageStyles = (0, _emotionCss.css)(_templateObject20);

var spTextStyles = (0, _emotionCss.css)(_templateObject21);

var spIconStyles = (0, _emotionCss.css)(_templateObject22);

// 後続で読み込まれる #contents に対するスタイルに対応するため
var spUnsetMarginInlineStyles = (0, _emotionCss.css)(_templateObject23);

},{"@emotion/css":7}],47:[function(require,module,exports){
/**
 * [27卒PR枠] PR枠 仕事詳細(なるには)用
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  background-color: #E7F6FF;\n  box-sizing: border-box;\n  text-align: left;\n\n  ', ' {\n    max-width: 960px;\n    margin: 40px auto;\n  };\n\n  ', ' {\n    margin: 24px 16px;\n    padding: 16px;\n  };\n'], ['\n  background-color: #E7F6FF;\n  box-sizing: border-box;\n  text-align: left;\n\n  ', ' {\n    max-width: 960px;\n    margin: 40px auto;\n  };\n\n  ', ' {\n    margin: 24px 16px;\n    padding: 16px;\n  };\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  margin: 0 auto;\n\n  ', ' {\n    max-width: 928px;\n    padding: 16px;\n  };\n'], ['\n  margin: 0 auto;\n\n  ', ' {\n    max-width: 928px;\n    padding: 16px;\n  };\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  display: flex;\n  margin-top: 8px;\n\n  ', ' {\n    flex-direction: column;\n  };\n'], ['\n  display: flex;\n  margin-top: 8px;\n\n  ', ' {\n    flex-direction: column;\n  };\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  background-color: #fff;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);\n  font-size: 12px;\n  line-height: 1.5;\n  overflow: hidden;\n  width: 100%;\n\n  ', ' {\n    border-radius: 6px;\n    max-width: 50%;\n\n    &:nth-child(even) {\n      margin-left: 16px;\n    };\n  };\n\n  ', ' {\n    border-radius: 2px;\n    margin: 8px auto 0;\n\n    &:first-child {\n      margin-top: 0 !important;\n    };\n  };\n'], ['\n  background-color: #fff;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);\n  font-size: 12px;\n  line-height: 1.5;\n  overflow: hidden;\n  width: 100%;\n\n  ', ' {\n    border-radius: 6px;\n    max-width: 50%;\n\n    &:nth-child(even) {\n      margin-left: 16px;\n    };\n  };\n\n  ', ' {\n    border-radius: 2px;\n    margin: 8px auto 0;\n\n    &:first-child {\n      margin-top: 0 !important;\n    };\n  };\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  align-items: center;\n  display: flex;\n  text-decoration: none;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n      text-decoration: none;\n    }\n  }\n\n  &:link, &:visited {\n    text-decoration: none;\n  };\n\n  ', ' {\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\n    cursor: pointer;\n  };\n'], ['\n  align-items: center;\n  display: flex;\n  text-decoration: none;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n      text-decoration: none;\n    }\n  }\n\n  &:link, &:visited {\n    text-decoration: none;\n  };\n\n  ', ' {\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\n    cursor: pointer;\n  };\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  box-sizing: border-box;\n\n  ', ' {\n    padding: 16px;\n    width: calc(100% - 220px);\n  };\n\n  ', ' {\n    padding: 4px 8px;\n    width: calc(100% - 142px);\n  };\n'], ['\n  box-sizing: border-box;\n\n  ', ' {\n    padding: 16px;\n    width: calc(100% - 220px);\n  };\n\n  ', ' {\n    padding: 4px 8px;\n    width: calc(100% - 142px);\n  };\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  color: #0b41a0;\n  font-weight: 700;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  overflow: hidden;\n\n  ', ' {\n    font-size: 16px;\n    line-height: 1.5;\n  };\n\n  ', ' {\n    font-size: 14px;\n    line-height: 1.3;\n  };\n'], ['\n  color: #0b41a0;\n  font-weight: 700;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  overflow: hidden;\n\n  ', ' {\n    font-size: 16px;\n    line-height: 1.5;\n  };\n\n  ', ' {\n    font-size: 14px;\n    line-height: 1.3;\n  };\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  color: #808d96;\n  line-height: 1.5;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  ', ' {\n    font-size: 14px;\n    margin-top: 8px;\n  };\n\n  ', ' {\n    font-size: 12px;\n    margin-top: 4px;\n  };\n'], ['\n  color: #808d96;\n  line-height: 1.5;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  ', ' {\n    font-size: 14px;\n    margin-top: 8px;\n  };\n\n  ', ' {\n    font-size: 12px;\n    margin-top: 4px;\n  };\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n  overflow: hidden;\n\n  ', ' {\n    width: 220px;\n    height: 150px;\n  };\n\n  ', ' {\n    width: 142px;\n    height: 95px;\n  };\n'], ['\n  overflow: hidden;\n\n  ', ' {\n    width: 220px;\n    height: 150px;\n  };\n\n  ', ' {\n    width: 142px;\n    height: 95px;\n  };\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n  ', ' {\n    width: 220px;\n    height: 150px;\n  };\n\n  ', ' {\n    width: 142px;\n    height: 95px;\n  };\n'], ['\n  ', ' {\n    width: 220px;\n    height: 150px;\n  };\n\n  ', ' {\n    width: 142px;\n    height: 95px;\n  };\n']),
    _templateObject11 = _taggedTemplateLiteral(['\n  color: #24243F;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.5;\n'], ['\n  color: #24243F;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.5;\n']),
    _templateObject12 = _taggedTemplateLiteral(['\n  border-radius: 4px;\n  background-color:  #3EC1BD;\n  color: #FFF;\n  font-weight: 700;\n  padding: 2px 8px;\n\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n\n  ', ' {\n    font-size: 12px;\n    margin-right: 8px;\n    line-height: 1.5;\n  };\n\n  ', ' {\n    font-size: 10px;\n    margin-right: 4px;\n    line-height: 1.3;\n  };\n'], ['\n  border-radius: 4px;\n  background-color:  #3EC1BD;\n  color: #FFF;\n  font-weight: 700;\n  padding: 2px 8px;\n\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n\n  ', ' {\n    font-size: 12px;\n    margin-right: 8px;\n    line-height: 1.5;\n  };\n\n  ', ' {\n    font-size: 10px;\n    margin-right: 4px;\n    line-height: 1.3;\n  };\n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var _emotionCss = require('@emotion/css');

var _modulesPrAreaUtilities_prAreaUtilities = require('../../../../modules/prAreaUtilities/_prAreaUtilities');

/**
 * @description カセット「おすすめの学校情報」DOM生成
 * @param {array} gakkoInfoList - PR枠掲載学校情報リスト
 * @returns {string} - カセット「おすすめの学校情報」枠コンポーネントのHTML DOM文字列
 */
var cassetteGakkoInfoList = function cassetteGakkoInfoList(gakkoInfoList) {

  var cassetteHtml = '';

  gakkoInfoList.forEach(function (university, index) {
    cassetteHtml += __createCassetteHtml(university, index + 1);
  });

  return '\n    <div class="' + prAreaStyles + '">\n      <div class="' + prAreaWrapperStyles + '">\n        <div class="' + textStyles + '">\n          <span class="' + iconStyles + '">PR</span>おすすめの学校情報\n        </div>\n        <div class="' + prAreaListStyles + '">\n          ' + cassetteHtml + '\n        </div>\n      </div>\n    </div>\n  ';
};

/**
 * @private
 * @description カセット「おすすめの学校情報」パターンのバナーの単体HTMLフォーマット生成
 * @param {object} universityInfo - 大学情報
 * @param {number} order - 表示順位
 * @returns {string} - 「おすすめの学校情報」単体HTMLのDOM文字列
 */
var __createCassetteHtml = function __createCassetteHtml(universityInfo, order) {
  var gakkoCd = universityInfo.gakkoCd;
  var gakkoPhoto = universityInfo.gakkoPhoto;
  var gakkoNm = universityInfo.gakkoNm;
  var todofukenRnm = universityInfo.todofukenRnm;
  var koshuNm = universityInfo.koshuNm;

  var linkUrl = '/gakko/' + gakkoCd + '/';
  var NO_IMAGE = "/images/assets/dummy/noImage.png";

  return '\n    <div class="' + prAreaItemStyles + ' js-pr-isInView" data-pr-inview-log="' + trace_p + '_PRcassette_imp_' + order + '_' + gakkoCd + '">\n      <a\n        href="' + linkUrl + '"\n        class="' + prAreaLinkStyles + ' js-pr-clickLog" \n        target="_blank"\n        data-pr-click-log="' + trace_p + '_PRcassette_click_' + order + '_' + gakkoCd + '""\n      >\n        <div class="' + prAreaImageBlockStyles + '">\n          <img class="' + prAreaImageStyles + '" src="' + (gakkoPhoto ? gakkoPhoto : NO_IMAGE) + '" alt="' + gakkoNm + '" height="150" width="220">\n        </div>\n        <div class="' + prAreaInfoStyles + '">\n          <div class="' + prAreaNameStyles + '">' + gakkoNm + '</div>\n          <div class="' + prAreaOtherInfoStyles + '">' + koshuNm + '／' + todofukenRnm + '</div>\n        </div>\n      </a>\n    </div>\n  ';
};

exports.cassetteGakkoInfoList = cassetteGakkoInfoList;

/*---- CSS定義 ----*/
var prAreaStyles = (0, _emotionCss.css)(_templateObject, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var prAreaWrapperStyles = (0, _emotionCss.css)(_templateObject2, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN);

var prAreaListStyles = (0, _emotionCss.css)(_templateObject3, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var prAreaItemStyles = (0, _emotionCss.css)(_templateObject4, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var prAreaLinkStyles = (0, _emotionCss.css)(_templateObject5, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var prAreaInfoStyles = (0, _emotionCss.css)(_templateObject6, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var prAreaNameStyles = (0, _emotionCss.css)(_templateObject7, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var prAreaOtherInfoStyles = (0, _emotionCss.css)(_templateObject8, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var prAreaImageBlockStyles = (0, _emotionCss.css)(_templateObject9, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var prAreaImageStyles = (0, _emotionCss.css)(_templateObject10, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var textStyles = (0, _emotionCss.css)(_templateObject11);

var iconStyles = (0, _emotionCss.css)(_templateObject12, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

},{"../../../../modules/prAreaUtilities/_prAreaUtilities":64,"@emotion/css":7}],48:[function(require,module,exports){
/**
 * [27卒PR枠] PR枠 OC一覧画面用コンポーネント
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  background-color: #E7F6FF;\n  box-sizing: border-box;\n  text-align: left;\n  margin-bottom: 24px;\n'], ['\n  background-color: #E7F6FF;\n  box-sizing: border-box;\n  text-align: left;\n  margin-bottom: 24px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  color: #24243F;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1.5;\n'], ['\n  color: #24243F;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1.5;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  align-items: center;\n  background-color:  #3EC1BD;\n  border-radius: 4px;\n  box-sizing: border-box;\n  color: #FFF;\n  display: inline-flex;\n  height: 19px;\n  padding: 2px 8px;\n  margin-right: 8px;\n'], ['\n  align-items: center;\n  background-color:  #3EC1BD;\n  border-radius: 4px;\n  box-sizing: border-box;\n  color: #FFF;\n  display: inline-flex;\n  height: 19px;\n  padding: 2px 8px;\n  margin-right: 8px;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  margin: 0 auto;\n  padding: 16px 0;\n\n  ', ' {\n    max-width: 960px;\n  };\n\n  ', ' {\n    max-width: 400px;\n    padding: 16px;\n  };\n\n  @media (min-width: 768px) and (max-width: 960px) {\n    padding: 16px 32px;\n  }\n'], ['\n  margin: 0 auto;\n  padding: 16px 0;\n\n  ', ' {\n    max-width: 960px;\n  };\n\n  ', ' {\n    max-width: 400px;\n    padding: 16px;\n  };\n\n  @media (min-width: 768px) and (max-width: 960px) {\n    padding: 16px 32px;\n  }\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  margin-top: 8px;\n  gap: 24px;\n'], ['\n  display: flex;\n  flex-direction: column;\n  margin-top: 8px;\n  gap: 24px;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  background-color: #fff;\n  border-radius: 8px;\n\n  ', ' {\n    padding-left: 0;\n  };\n'], ['\n  background-color: #fff;\n  border-radius: 8px;\n\n  ', ' {\n    padding-left: 0;\n  };\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  box-shadow: 0px 2px 6px 0px #00000024;\n  border-radius: 8px;\n  color: #333;\n  overflow: hidden;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n\n  ', ' {\n    display: flex;\n  };\n\n  ', ' {\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\n    cursor: pointer;\n    display: block;\n    box-sizing: content-box;\n  };\n\n'], ['\n  box-shadow: 0px 2px 6px 0px #00000024;\n  border-radius: 8px;\n  color: #333;\n  overflow: hidden;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n\n  ', ' {\n    display: flex;\n  };\n\n  ', ' {\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\n    cursor: pointer;\n    display: block;\n    box-sizing: content-box;\n  };\n\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  overflow: hidden;\n  position: relative;\n\n  ', ' {\n    height: 208px;\n    width: 312px;\n  };\n\n  ', ' {\n    height: 100%;\n    width: calc(100% + 2px);\n    padding-top: 66.6666%;\n    transition: height .2s;\n    border-radius: 6px 6px 0 0;\n  };\n'], ['\n  overflow: hidden;\n  position: relative;\n\n  ', ' {\n    height: 208px;\n    width: 312px;\n  };\n\n  ', ' {\n    height: 100%;\n    width: calc(100% + 2px);\n    padding-top: 66.6666%;\n    transition: height .2s;\n    border-radius: 6px 6px 0 0;\n  };\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n  height: auto;\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n\n  ', ' {\n    left: 50%;\n  };\n\n  ', ' {\n    left: calc(50% - 1px);\n    transition: .2s;\n  };\n'], ['\n  height: auto;\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n\n  ', ' {\n    left: 50%;\n  };\n\n  ', ' {\n    left: calc(50% - 1px);\n    transition: .2s;\n  };\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n  box-sizing: border-box;\n\n  ', ' {\n    padding: 16px;\n    height: 208px;\n    width: calc(100% - 312px);\n    position: relative;\n  };\n\n  ', ' {\n    overflow: hidden;\n    padding: 8px 16px 16px;\n    margin: 0;\n    border: 0;\n    outline: 0;\n    font-size: 100%;\n    vertical-align: baseline;\n  };\n'], ['\n  box-sizing: border-box;\n\n  ', ' {\n    padding: 16px;\n    height: 208px;\n    width: calc(100% - 312px);\n    position: relative;\n  };\n\n  ', ' {\n    overflow: hidden;\n    padding: 8px 16px 16px;\n    margin: 0;\n    border: 0;\n    outline: 0;\n    font-size: 100%;\n    vertical-align: baseline;\n  };\n']),
    _templateObject11 = _taggedTemplateLiteral(['\n  color: #808d96;\n  font-weight: 700;\n  margin-bottom: 4px;\n\n  ', ' {\n    font-size: 14px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  };\n\n  ', ' {\n    font-size: 12px;\n  };\n'], ['\n  color: #808d96;\n  font-weight: 700;\n  margin-bottom: 4px;\n\n  ', ' {\n    font-size: 14px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  };\n\n  ', ' {\n    font-size: 12px;\n  };\n']),
    _templateObject12 = _taggedTemplateLiteral(['\n  color: #043f94;\n  display: block;\n  font-weight: 700;\n  margin-bottom: 8px;\n\n  ', ' {\n    font-size: 18px;\n    line-height: 1.5;\n  };\n\n  ', ' {\n    font-size: 14px;\n    line-height: 1.3;\n  };\n'], ['\n  color: #043f94;\n  display: block;\n  font-weight: 700;\n  margin-bottom: 8px;\n\n  ', ' {\n    font-size: 18px;\n    line-height: 1.5;\n  };\n\n  ', ' {\n    font-size: 14px;\n    line-height: 1.3;\n  };\n']),
    _templateObject13 = _taggedTemplateLiteral(['\n  color: #333;\n\n  ', ' {\n    font-size: 14px;\n    line-height: 1.5;\n    margin-bottom: 4px;\n  };\n\n  ', ' {\n    font-size: 12px;\n    line-height: 1.3;\n    margin-bottom: 8px;\n  };\n'], ['\n  color: #333;\n\n  ', ' {\n    font-size: 14px;\n    line-height: 1.5;\n    margin-bottom: 4px;\n  };\n\n  ', ' {\n    font-size: 12px;\n    line-height: 1.3;\n    margin-bottom: 8px;\n  };\n']),
    _templateObject14 = _taggedTemplateLiteral(['\n  color: #808d96;\n\n  ', ' {\n    font-size: 12px;\n  };\n\n  ', ' {\n    font-size: 10px;\n  };\n'], ['\n  color: #808d96;\n\n  ', ' {\n    font-size: 12px;\n  };\n\n  ', ' {\n    font-size: 10px;\n  };\n']),
    _templateObject15 = _taggedTemplateLiteral(['\n  align-items: center;\n  background-color: #f6f8f9;\n  border-radius: 4px;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: space-around;\n  padding: 8px 4px;\n\n  ', ' {\n    height: 34px;\n    bottom: 16px;\n    left: 0;\n    right: 0;\n    position: absolute;\n    margin-inline: 15px;\n    margin-top: 10px\n  };\n\n  ', ' {\n    height: 39px;\n    margin-top: 16px\n  };\n'], ['\n  align-items: center;\n  background-color: #f6f8f9;\n  border-radius: 4px;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: space-around;\n  padding: 8px 4px;\n\n  ', ' {\n    height: 34px;\n    bottom: 16px;\n    left: 0;\n    right: 0;\n    position: absolute;\n    margin-inline: 15px;\n    margin-top: 10px\n  };\n\n  ', ' {\n    height: 39px;\n    margin-top: 16px\n  };\n']),
    _templateObject16 = _taggedTemplateLiteral(['\n  line-height: 1;\n\n  ', ' {\n    margin-left: 10px;\n\n    &:first-child {\n      margin-left: 0;\n    }\n  };\n\n  ', ' {\n    margin-left: 6px;\n\n    &:first-child {\n      margin-left: 0;\n    }\n  };\n'], ['\n  line-height: 1;\n\n  ', ' {\n    margin-left: 10px;\n\n    &:first-child {\n      margin-left: 0;\n    }\n  };\n\n  ', ' {\n    margin-left: 6px;\n\n    &:first-child {\n      margin-left: 0;\n    }\n  };\n']),
    _templateObject17 = _taggedTemplateLiteral(['\n  align-items: center;\n  display: flex;\n'], ['\n  align-items: center;\n  display: flex;\n']),
    _templateObject18 = _taggedTemplateLiteral(['\n  color: #424e56;\n  font-family: StudySapuriNumber !important;\n  font-size: 20px;\n'], ['\n  color: #424e56;\n  font-family: StudySapuriNumber !important;\n  font-size: 20px;\n']),
    _templateObject19 = _taggedTemplateLiteral(['\n  color: ', ';\n  font-weight: 700;\n  margin-left: 2px;\n'], ['\n  color: ', ';\n  font-weight: 700;\n  margin-left: 2px;\n']),
    _templateObject20 = _taggedTemplateLiteral(['\n  margin-left: 2px;\n'], ['\n  margin-left: 2px;\n']),
    _templateObject21 = _taggedTemplateLiteral(['\n  margin-inline: unset !important;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n'], ['\n  margin-inline: unset !important;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var _emotionCss = require('@emotion/css');

var _modulesPrAreaUtilities_prAreaUtilities = require('../../../../modules/prAreaUtilities/_prAreaUtilities');

/**
 * @description OC一覧用PRカセットDOM生成
 * @param {array} ocListData - PR枠に表示する情報
 * @returns {string} - OC一覧用PRカセット枠コンポーネントのHTML DOM文字列
 */
var cassetteOpenCampusList = function cassetteOpenCampusList(ocListData) {

  var cassetteHtml = '';

  ocListData.forEach(function (cassetteItem, index) {
    cassetteHtml += __createCassetteHtml(cassetteItem, index + 1);
  });

  return '\n    <div class="' + prAreaStyles + '">\n      <div class="' + prAreaWrapperStyles + '">\n        <div class="' + textStyles + '">\n          <p class="' + unsetMarginInlineStyles + '"><span class="' + iconStyles + '">PR</span></p>\n        </div>\n        <div class="' + prAreaListStyles + '">\n          ' + cassetteHtml + '\n        </div>\n      </div>\n    </div>\n  ';
};

/**
 * @private
 * @description OC検索一覧用PR枠 単体HTMLフォーマット生成
 * @param {object} openCampusList - PR枠カセット情報
 * @param {number} order - 表示順位
 * @returns {string} - 単体HTMLのDOM文字列
 */
var __createCassetteHtml = function __createCassetteHtml(openCampusList, order) {
  var productCd = openCampusList.productCd;
  var gakkoCd = openCampusList.gakkoCd;
  var gakkoNm = openCampusList.gakkoNm;
  var orgCd = openCampusList.orgCd;
  var orgNm = openCampusList.orgNm;
  var locationCityNm = openCampusList.locationCityNm;
  var eventTitle = openCampusList.eventTitle;
  var ocBunyaPcImage = openCampusList.ocBunyaPcImage;
  var bunyaCatch = openCampusList.bunyaCatch;
  var kaisaiDateList = openCampusList.kaisaiDateList;

  var kaisaiDateListHtml = __createKaisaiDateListHtml(kaisaiDateList);

  var linkUrl = '/gakko/' + gakkoCd + '/openCampus/gakubugakka/' + orgCd + '/?ocsfProductCd=' + productCd;

  return '\n    <div class="' + ocCassetteStyles + ' js-pr-isInView" data-pr-inview-log="' + trace_p + '_PRcassette_imp_' + order + '_' + gakkoCd + '">\n      <a href="' + linkUrl + '" class="' + ocLinkStyles + ' js-pr-clickLog" target="_blank" data-pr-click-log="' + trace_p + '_PRcassette_click_' + order + '_' + gakkoCd + '">\n        <div class="' + ocImageWrapperStyles + '">\n          <img\n            src="' + __createOcImage(ocBunyaPcImage) + '"\n            class="' + ocImageStyles + '"\n            alt="' + __createOcTitle(eventTitle) + '"\n            height="241"\n            width="363"\n          >\n        </div>\n        <div class="' + ocContentsWrapperStyles + '">\n          <div class="' + ocContentsLabelStyles + '">' + gakkoNm + ' ' + (orgNm ? orgNm : "") + '</div>\n          <p class="' + ocContentsTitleStyles + ' ' + unsetMarginInlineStyles + '">' + __createOcTitle(eventTitle) + '</p>\n          <p class="' + ocContentsCatchTextStyles + ' ' + unsetMarginInlineStyles + '">' + __createBunyaCatch(bunyaCatch, orgNm) + '</p>\n          ' + (locationCityNm && locationCityNm.trim() !== '' ? '<div class="' + ocContentsLocationCityStyles + '">' + locationCityNm + '</div>' : '') + '\n          ' + (kaisaiDateList.length > 0 ? '<ul class="' + ocDateUnOrderListStyles + '">' + kaisaiDateListHtml + '</ul>' : '') + '\n        </div>\n      </a>\n    </div>\n  ';
};

/**
 * @private
 * @description 開催日の一覧がまとまったstringを、日付ごとのHTMLに分割する関数
 * @param {Array<string>} kaisaiDateList - PR枠カセット情報
 * @returns {string} - 単体HTMLのDOM文字列
 */
var __createKaisaiDateListHtml = function __createKaisaiDateListHtml(kaisaiDateList) {

  var arrayKaisaiDateList = kaisaiDateList.map(function (item) {
    return item.trim();
  });
  var limitDateCount = 5;

  var kaisaiDateHtml = '';

  arrayKaisaiDateList.slice(0, limitDateCount).forEach(function (kaisaiDateItem, index) {
    var _getMonthDayAndDayOfWeek = (0, _modulesPrAreaUtilities_prAreaUtilities.getMonthDayAndDayOfWeek)(kaisaiDateItem);

    var monthDay = _getMonthDayAndDayOfWeek.monthDay;
    var dayOfWeek = _getMonthDayAndDayOfWeek.dayOfWeek;

    if (index === 4) {
      kaisaiDateHtml += '\n        <li class="' + ocDateListItemStyles + '">\n          <span class="' + ocDateMoreStyles + '">…</span>\n        </li>\n      ';
      return;
    }

    kaisaiDateHtml += '\n      <li class="' + ocDateListItemStyles + '">\n        <span class="' + ocDateSetStyles + '">\n          <span class="' + ocDateStyles + '">' + monthDay + '</span>\n          <span class="' + ocDateDayOfWeekStyles(dayOfWeek) + '">' + dayOfWeek + '</span>\n        </span>\n      </li>\n    ';
  });

  return kaisaiDateHtml;
};

/**
 * @private
 * @description OC画像のsrc値を生成する関数
 * @param {string|null} ocBunyaPcImage - APIから返される画像パス。空の場合はNoImage画像を指定する。
 * @returns {string} 表示する画像パス
 */
var __createOcImage = function __createOcImage(ocBunyaPcImage) {
  // ocBunyaPcImageが文字列かつ空白を除いた値が空でない場合はAPIから送られた画像パス値を指定する
  // それ以外の場合はNoImage画像を使用
  return typeof ocBunyaPcImage === 'string' && ocBunyaPcImage.trim() !== '' ? ocBunyaPcImage : '/images/open_campus/oc_bunya_cassette_no_image.svg';
};

/**
 * @private
 * @description OC画像のalt値を生成する関数
 * @param {string | null} eventTitle - APIから返されるイベントタイトル。空の場合は固定文言(オープンキャンパス)を指定する。
 * @returns {string} - alt属性に設定する文字列
 */
var __createOcTitle = function __createOcTitle(eventTitle) {
  return typeof eventTitle === 'string' && eventTitle.trim() !== '' ? eventTitle : 'オープンキャンパス';
};

/**
 * @private
 * @description OC画像のキャッチ文言を生成する関数
 * @param {string | null} bunyaCatch - APIから返されるキャッチ文言。null/空文字/空白のみ固定文言に切り替える。
 * @param {string | null} orgNm - APIから返される学部名。null/空文字/空白のみ固定文言に切り替える。
 * @returns {string} - キャッチ箇所に指定する文字列
 */
var __createBunyaCatch = function __createBunyaCatch(bunyaCatch, orgNm) {
  // bunyaCatchが非空判定ならそのまま返す
  if (typeof bunyaCatch === 'string' && bunyaCatch.trim() !== '') {
    return bunyaCatch;
  }
  // orgNmが非空なら学部名を入れる、空なら名称なしの固定文言
  var orgName = typeof orgNm === 'string' && orgNm.trim() !== '' ? orgNm.trim() : '';
  return orgNm ? orgName + 'のオープンキャンパス情報です。' : 'オープンキャンパス情報です。';
};

exports.cassetteOpenCampusList = cassetteOpenCampusList;

/*---- CSS定義 ----*/
var prAreaStyles = (0, _emotionCss.css)(_templateObject);

var textStyles = (0, _emotionCss.css)(_templateObject2);

var iconStyles = (0, _emotionCss.css)(_templateObject3);

var prAreaWrapperStyles = (0, _emotionCss.css)(_templateObject4, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var prAreaListStyles = (0, _emotionCss.css)(_templateObject5);

var ocCassetteStyles = (0, _emotionCss.css)(_templateObject6, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN);

// box-shadowのopacity: 0.14
var ocLinkStyles = (0, _emotionCss.css)(_templateObject7, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var ocImageWrapperStyles = (0, _emotionCss.css)(_templateObject8, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var ocImageStyles = (0, _emotionCss.css)(_templateObject9, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var ocContentsWrapperStyles = (0, _emotionCss.css)(_templateObject10, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var ocContentsLabelStyles = (0, _emotionCss.css)(_templateObject11, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var ocContentsTitleStyles = (0, _emotionCss.css)(_templateObject12, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var ocContentsCatchTextStyles = (0, _emotionCss.css)(_templateObject13, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var ocContentsLocationCityStyles = (0, _emotionCss.css)(_templateObject14, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var ocDateUnOrderListStyles = (0, _emotionCss.css)(_templateObject15, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var ocDateListItemStyles = (0, _emotionCss.css)(_templateObject16, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var ocDateSetStyles = (0, _emotionCss.css)(_templateObject17);

var ocDateStyles = (0, _emotionCss.css)(_templateObject18);

var ocDateDayOfWeekStyles = function ocDateDayOfWeekStyles(dayOfWeek) {
  return (0, _emotionCss.css)(_templateObject19, (0, _modulesPrAreaUtilities_prAreaUtilities.getDayOfWeekBackgroundColor)(dayOfWeek));
};

var ocDateMoreStyles = (0, _emotionCss.css)(_templateObject20);

// 後続で読み込まれる #contents に対するスタイルに対応するため
var unsetMarginInlineStyles = (0, _emotionCss.css)(_templateObject21);

},{"../../../../modules/prAreaUtilities/_prAreaUtilities":64,"@emotion/css":7}],49:[function(require,module,exports){
/**
 * [27卒PR枠] PR枠 学校検索一覧画面用コンポーネント
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  background-color: #E7F6FF;\n  box-sizing: border-box;\n  text-align: left;\n  margin-bottom: 24px;\n'], ['\n  background-color: #E7F6FF;\n  box-sizing: border-box;\n  text-align: left;\n  margin-bottom: 24px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  color: #24243F;\n  font-weight: 700;\n'], ['\n  color: #24243F;\n  font-weight: 700;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  align-items: center;\n  border-radius: 4px;\n  background-color:  #3EC1BD;\n  color: #FFF;\n  display: inline-flex;\n  line-height: 1.5;\n  padding: 2px 8px;\n\n  ', ' {\n    font-size: 14px;\n    height: 21px;\n  };\n\n  ', ' {\n    font-size: 12px;\n    height: 18px;\n  };\n'], ['\n  align-items: center;\n  border-radius: 4px;\n  background-color:  #3EC1BD;\n  color: #FFF;\n  display: inline-flex;\n  line-height: 1.5;\n  padding: 2px 8px;\n\n  ', ' {\n    font-size: 14px;\n    height: 21px;\n  };\n\n  ', ' {\n    font-size: 12px;\n    height: 18px;\n  };\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  margin: 0 auto;\n  padding-block: 16px;\n\n  ', ' {\n    max-width: 960px;\n    padding-inline: 32px;\n  };\n\n  ', ' {\n    padding-inline: 8px;\n  };\n'], ['\n  margin: 0 auto;\n  padding-block: 16px;\n\n  ', ' {\n    max-width: 960px;\n    padding-inline: 32px;\n  };\n\n  ', ' {\n    padding-inline: 8px;\n  };\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  margin-top: 8px;\n'], ['\n  display: flex;\n  flex-direction: column;\n  margin-top: 8px;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  margin-inline: unset !important;\n'], ['\n  margin-inline: unset !important;\n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var _emotionCss = require('@emotion/css');

var _modulesPrAreaUtilities_prAreaUtilities = require('../../../../modules/prAreaUtilities/_prAreaUtilities');

var _modulesCreateCassetteHtml_createCassetteHtml = require('./modules/createCassetteHtml/_createCassetteHtml');

/**
 * @description 学校検索一覧用PRカセットDOM生成
 * @param {array} searchIntegrationList - 統合検索リストの情報
 * @returns {string} - 学校検索一覧用PRカセット枠コンポーネントのHTML DOM文字列
 */
var cassetteSearchIntegrationList = function cassetteSearchIntegrationList(searchIntegrationList) {
  var cassetteHtml = '';

  searchIntegrationList.forEach(function (searchIntegrationItem, index) {
    cassetteHtml += (0, _modulesCreateCassetteHtml_createCassetteHtml.createCassetteHtml)(searchIntegrationItem, index + 1);
  });

  return '\n    <div class="' + prAreaStyles + '">\n      <div class="' + prAreaWrapperStyles + '">\n        <div class="' + textStyles + '">\n          <p class="' + unsetMarginInlineStyles + '"><span class="' + iconStyles + '">PR</span></p>\n        </div>\n        <div class="' + prAreaListStyles + '">\n          ' + cassetteHtml + '\n        </div>\n      </div>\n    </div>\n  ';
};

exports.cassetteSearchIntegrationList = cassetteSearchIntegrationList;

/*---- CSS定義 ----*/
var prAreaStyles = (0, _emotionCss.css)(_templateObject);

var textStyles = (0, _emotionCss.css)(_templateObject2);

var iconStyles = (0, _emotionCss.css)(_templateObject3, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var prAreaWrapperStyles = (0, _emotionCss.css)(_templateObject4, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var prAreaListStyles = (0, _emotionCss.css)(_templateObject5);

// 後続で読み込まれる #contents に対するスタイルに対応するため
var unsetMarginInlineStyles = (0, _emotionCss.css)(_templateObject6);

},{"../../../../modules/prAreaUtilities/_prAreaUtilities":64,"./modules/createCassetteHtml/_createCassetteHtml":50,"@emotion/css":7}],50:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  margin-bottom: 0;\n  background-color: #ffffff;\n  overflow: hidden;\n  border-top: 2px solid #0b41a0;\n  border-bottom: 1px solid #e1e8eA;\n\n  ", " {\n    border-left: 1px solid #e1e8eA;\n    border-right: 1px solid #e1e8eA;\n  };\n"], ["\n  position: relative;\n  margin-bottom: 0;\n  background-color: #ffffff;\n  overflow: hidden;\n  border-top: 2px solid #0b41a0;\n  border-bottom: 1px solid #e1e8eA;\n\n  ", " {\n    border-left: 1px solid #e1e8eA;\n    border-right: 1px solid #e1e8eA;\n  };\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n\n  ", " {\n    padding: 16px 16px 24px;\n  };\n\n  ", " {\n    padding: 16px;\n  };\n"], ["\n\n  ", " {\n    padding: 16px 16px 24px;\n  };\n\n  ", " {\n    padding: 16px;\n  };\n"]);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var _emotionCss = require("@emotion/css");

var _modulesCreateCourseAccordionBlock_createCourseAccordionBlock = require("./modules/createCourseAccordionBlock/_createCourseAccordionBlock");

var _modulesCreateEmpathyContentsBlock_createEmpathyContentsBlock = require("./modules/createEmpathyContentsBlock/_createEmpathyContentsBlock");

var _modulesCreateOpenCampusBlock_createOpenCampusBlock = require("./modules/createOpenCampusBlock/_createOpenCampusBlock");

var _modulesCreateUniversityBlock_createUniversityBlock = require("./modules/createUniversityBlock/_createUniversityBlock");

var _modulesPrAreaUtilities_prAreaUtilities = require("../../../../../../modules/prAreaUtilities/_prAreaUtilities");

/**
 * @description 学校検索一覧用PR枠 単体HTMLフォーマット生成
 * @param {object} searchIntegrationItem - PR枠カセットのアイテム情報
 * @param {number} order - 表示順位 
 * @returns {string} - 単体HTMLのDOM文字列
 */
var createCassetteHtml = function createCassetteHtml(searchIntegrationItem, order) {
  var gakkoCd = searchIntegrationItem.gakkoCd;
  var empathyContentsList = searchIntegrationItem.empathyContentsList;

  var universityBlock = (0, _modulesCreateUniversityBlock_createUniversityBlock.createUniversityBlock)(searchIntegrationItem, order);
  var courseAccordionBlock = (0, _modulesCreateCourseAccordionBlock_createCourseAccordionBlock.createCourseAccordionBlock)(searchIntegrationItem, order, gakkoCd);
  var empathyContentsBlock = (0, _modulesCreateEmpathyContentsBlock_createEmpathyContentsBlock.createEmpathyContentsBlock)(empathyContentsList, order, gakkoCd);
  var openCampusBlock = (0, _modulesCreateOpenCampusBlock_createOpenCampusBlock.createOpenCampusBlock)(searchIntegrationItem, order);

  return "\n    <li class=\"" + searchResultsListItemStyles + " prarea__searchResults__item searchResults__item js-pr-isInView js-cassetteInView\" data-gakkocd=\"" + gakkoCd + "\" data-pr-inview-log=\"" + trace_p + "_PRcassette_imp_" + order + "_" + gakkoCd + "\">\n      <div class=\"" + searchResultsUniversityBlockStyles + "\">\n        " + universityBlock + "\n        " + courseAccordionBlock + "\n        " + empathyContentsBlock + "\n        " + openCampusBlock + "\n      </div>\n    </li>\n  ";
};

exports.createCassetteHtml = createCassetteHtml;

var searchResultsListItemStyles = (0, _emotionCss.css)(_templateObject, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN);

var searchResultsUniversityBlockStyles = (0, _emotionCss.css)(_templateObject2, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

},{"../../../../../../modules/prAreaUtilities/_prAreaUtilities":64,"./modules/createCourseAccordionBlock/_createCourseAccordionBlock":51,"./modules/createEmpathyContentsBlock/_createEmpathyContentsBlock":55,"./modules/createOpenCampusBlock/_createOpenCampusBlock":56,"./modules/createUniversityBlock/_createUniversityBlock":58,"@emotion/css":7}],51:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(["\n  font-size: 10px;\n  color: #808d96;\n  margin-top: 24px;\n  border-left: 4px solid #afb8be;\n  padding-left: 4px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  ", " {\n    display: flex;\n    flex-direction: column;\n  };\n"], ["\n  font-size: 10px;\n  color: #808d96;\n  margin-top: 24px;\n  border-left: 4px solid #afb8be;\n  padding-left: 4px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  ", " {\n    display: flex;\n    flex-direction: column;\n  };\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  background-color: #E7F6FF;\n  color: #808d96;\n  display: inline;\n  font-weight: 700;\n  line-height: 1.5;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding-block: 4px;\n\n  ", " {\n    font-size: 16px;\n  };\n\n  ", " {\n    width: fit-content;\n    font-size: 14px;\n  };\n"], ["\n  background-color: #E7F6FF;\n  color: #808d96;\n  display: inline;\n  font-weight: 700;\n  line-height: 1.5;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding-block: 4px;\n\n  ", " {\n    font-size: 16px;\n  };\n\n  ", " {\n    width: fit-content;\n    font-size: 14px;\n  };\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  color: #808d96;\n  display: inline-block;\n  font-weight: 300;\n  line-height: 1.5;\n  margin-top: 2px;\n  ", " {\n    font-size: 14px;\n  };\n\n  ", " {\n    font-size: 12px;\n  };\n};\n"], ["\n  color: #808d96;\n  display: inline-block;\n  font-weight: 300;\n  line-height: 1.5;\n  margin-top: 2px;\n  ", " {\n    font-size: 14px;\n  };\n\n  ", " {\n    font-size: 12px;\n  };\n};\n"]),
    _templateObject4 = _taggedTemplateLiteral(["\n  background-color: #f8f9f9;\n  border-radius: 8px 8px 0 0;\n\n  &:not(:has(+ .prarea__searchResults__moreLink)) {\n    border-radius: 8px;\n  }\n\n  & > .prarea__searchResults__gakkaItem:first-of-type {\n    border-top: none;\n  }\n\n  ", " {\n    margin-top: 16px;\n  };\n\n  ", " {\n    margin-top: 8px;\n  };\n"], ["\n  background-color: #f8f9f9;\n  border-radius: 8px 8px 0 0;\n\n  &:not(:has(+ .prarea__searchResults__moreLink)) {\n    border-radius: 8px;\n  }\n\n  & > .prarea__searchResults__gakkaItem:first-of-type {\n    border-top: none;\n  }\n\n  ", " {\n    margin-top: 16px;\n  };\n\n  ", " {\n    margin-top: 8px;\n  };\n"]),
    _templateObject5 = _taggedTemplateLiteral(["\n  background-color: #f8f9f9;\n  border-top: 1px solid #d3d4d4;\n  border-radius: 0 0 8px 8px;\n  text-align: center;\n"], ["\n  background-color: #f8f9f9;\n  border-top: 1px solid #d3d4d4;\n  border-radius: 0 0 8px 8px;\n  text-align: center;\n"]),
    _templateObject6 = _taggedTemplateLiteral(["\n  border-top: none;\n  display: block;\n  font-weight: 700;\n  text-align: center;\n  color: #808d96;\n  text-decoration: none;\n  line-height: 1.5;\n  padding: 8px;\n  position: relative;\n\n  &::after {\n    content: '';\n    display: inline-block;\n    width: 13px;\n    height: 9px;\n    background: url(/images/responsive/Text_Sub/arrow_textSub_base.svg) no-repeat center;\n    transform: rotate(180deg);\n    margin-left: 4px;\n  };\n\n  &.is-open::after {\n    transform: rotate(0);\n  };\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n\n  ", " {\n    font-size: 14px;\n  };\n\n  ", " {\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\n    cursor: pointer;\n    font-size: 12px;\n  };\n"], ["\n  border-top: none;\n  display: block;\n  font-weight: 700;\n  text-align: center;\n  color: #808d96;\n  text-decoration: none;\n  line-height: 1.5;\n  padding: 8px;\n  position: relative;\n\n  &::after {\n    content: '';\n    display: inline-block;\n    width: 13px;\n    height: 9px;\n    background: url(/images/responsive/Text_Sub/arrow_textSub_base.svg) no-repeat center;\n    transform: rotate(180deg);\n    margin-left: 4px;\n  };\n\n  &.is-open::after {\n    transform: rotate(0);\n  };\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n\n  ", " {\n    font-size: 14px;\n  };\n\n  ", " {\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\n    cursor: pointer;\n    font-size: 12px;\n  };\n"]);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var _emotionCss = require("@emotion/css");

var _modulesPrAreaUtilities_prAreaUtilities = require("../../../../../../../../modules/prAreaUtilities/_prAreaUtilities");

var _modulesCreateUpperOrgList_createUpperOrgList = require("./modules/createUpperOrgList/_createUpperOrgList");

/**
 * @description 学校検索一覧用PR枠 目指せる学部・学科・コースの一覧アコーディオンHTMLを生成する
 * @param {object} searchIntegrationItem - 描画に必要な情報
 * @param {number} order - 表示順位 
 * @param {string} gakkoCd - pr枠専用代表学校コード
 * @returns {string} - 単体HTMLのDOM文字列
 */
var createCourseAccordionBlock = function createCourseAccordionBlock(searchIntegrationItem, order, gakkoCd) {
  var upperOrgList = searchIntegrationItem.upperOrgList;
  var lowerOrgList = searchIntegrationItem.lowerOrgList;
  var searchBunnyaNm = searchIntegrationItem.searchBunnyaNm;

  var upperOrgListHtml = (0, _modulesCreateUpperOrgList_createUpperOrgList.createUpperOrgList)(upperOrgList, lowerOrgList, order, gakkoCd, searchBunnyaNm);

  //Orgが存在しない場合トルツメ
  if (upperOrgList.length === 0 && lowerOrgList.length === 0) return '';

  return "\n    <h3 class=\"" + searchResultsH3Styles + "\">\n      " + __settingBunnya(searchBunnyaNm) + "\n    </h3>\n    " + __settingSearchResults(upperOrgList, lowerOrgList, upperOrgListHtml) + "\n  ";
};

/**
 * @description 検索一覧カセット「学部・学科・コース」リストDOM条件分岐関数
 * @param {Array} upperOrgList - upperOrgリスト
 * @param {Array} lowerOrgList - lowerOrgリスト
 * @param {string} upperOrgListHtml - upperOrgで作成されたHTML DOM
 * @returns {string} - 条件分岐によってDOMの表示制限
 */
var __settingSearchResults = function __settingSearchResults(upperOrgList, lowerOrgList, upperOrgListHtml) {

  if (upperOrgList.length === 0) {
    //upperOrg -「X」 , lowerOrg -「X」 パターン
    if (lowerOrgList.length === 0) return "";

    //upperOrg -「X」 , lowerOrg -「O」 パターン
    return "\n    <div>\n      " + __settingGakkaList(lowerOrgList) + "\n    </div>\n    ";
  } else {
    //button条件分岐 - lowerOrgが1個以上存在する or upperOrgが4個以上存在する
    var buttonActive = lowerOrgList.length >= 1 || upperOrgList.length >= 4;

    //upperOrg -「O」パターン
    return "\n    <ul class=\"" + searchResultsGakkoListStyles + " prarea__searchResults__gakkaList\">" + upperOrgListHtml + "</ul>\n    " + __settingMoreButton(buttonActive) + "\n    ";
  }
};

/**
 * @description upperOrgが存在しないが、lowerOrgが存在する場合表示する「その他学部・学科・コース」List DOMを作成する関数
 * @param {Array} lowerOrgList - 描画に必要な情報
 * @returns {string} - 「その他学科・学部・コース」リストDOM
 */
var __settingGakkaList = function __settingGakkaList(lowerOrgList) {
  var gakkaListDOM = "";
  var invisibleFlag = false;

  lowerOrgList.forEach(function (lowerOrg, index) {
    if (index === 3) {
      gakkaListDOM += "<a href=\"javascript:void(0);\" onclick=\"var s2=s_gi(s_account);s2.tl(this,'o','Ssearch_result_list_next_more')\" data-more-gakubugakka-text=\"trigger\">続きを見る</a>";
      gakkaListDOM += "<div data-more-gakubugakka-text=\"target\" style=\"display: none;\">";
      invisibleFlag = true;
    }
    gakkaListDOM += "\n    <span class=\"searchResults__gakkaTextItem\">\n      " + lowerOrg.ownHierarchyNm + "\n    </span>\n    ";
  });
  if (invisibleFlag === true) gakkaListDOM += "</div>";

  return gakkaListDOM;
};

/**
 * @description 「もっと学部・学科・コースを見る」ボタンを作成する関数
 * @param {boolean} isActive - ボタン表示値
 * @returns {string} - ボタンDOM
 */
var __settingMoreButton = function __settingMoreButton(isActive) {
  if (isActive) {
    return "\n    <div class=\"" + searchResultsMoreLinkStyles + " prarea__searchResults__moreLink\">\n      <a\n        href=\"javascript:void(0);\"\n        prarea-data-more-gakubugakka=\"trigger\"\n        data-logId=\"Ssearch_result_list_base_more\"\n        class=\"" + searchResultsMoreLinkTextStyles + "\">もっと学部・学科・コースを見る\n      </a>\n    </div>\n    ";
  } else {
    return "";
  }
};

/**
 * @description 学校検索一覧用PR枠 目指せる学部・学科・コースの一覧アコーディオンHTMLを生成する
 * @param {string} searchBunnyaNm - 表示分野
 * @returns {string} - 分野HTML DOM
 */
var __settingBunnya = function __settingBunnya(searchBunnyaNm) {
  var defaultBunnaya = "学部・学科・コース";

  if (searchBunnyaNm) {
    defaultBunnaya = "を目指せる" + defaultBunnaya;
    return "\n      <p class=\"" + searchResultsHeadingTextLargeStyles + "\">" + searchBunnyaNm + "</p>\n      <p class=\"" + searchResultsHeadingTextStyles + "\">" + defaultBunnaya + "</p>\n    ";
  } else {
    return "<p class=\"" + searchResultsHeadingTextStyles + "\">" + defaultBunnaya + "</p>";
  }
};

exports.createCourseAccordionBlock = createCourseAccordionBlock;

/** CSS定義 */
var searchResultsH3Styles = (0, _emotionCss.css)(_templateObject, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsHeadingTextLargeStyles = (0, _emotionCss.css)(_templateObject2, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsHeadingTextStyles = (0, _emotionCss.css)(_templateObject3, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsGakkoListStyles = (0, _emotionCss.css)(_templateObject4, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsMoreLinkStyles = (0, _emotionCss.css)(_templateObject5);

var searchResultsMoreLinkTextStyles = (0, _emotionCss.css)(_templateObject6, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

},{"../../../../../../../../modules/prAreaUtilities/_prAreaUtilities":64,"./modules/createUpperOrgList/_createUpperOrgList":52,"@emotion/css":7}],52:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _modulesCreateLowerOrgList_createLowerOrgList = require("./modules/createLowerOrgList/_createLowerOrgList");

var _modulesCreateUpperOrgItem_createUpperOrgItem = require("./modules/createUpperOrgItem/_createUpperOrgItem");

/**
 * @description 学校検索一覧用PR枠 目指せる学科・学部・コースのリストHTMLを生成する
 * @param {array} upperOrgList - 描画に必要なオブジェクトの配列
 * @param {array} lowerOrgList - 描画に必要な下部のオブジェクトの配列
 * @param {number} order - 表示順位 
 * @param {string} gakkoCd - pr枠専用代表学校コード
 * @param {string} hitText - 分野ヒットテキスト
 * @returns {string} - 単体HTMLのDOM文字列
 */
var createUpperOrgList = function createUpperOrgList(upperOrgList, lowerOrgList, order, gakkoCd, hitText) {

  // 4件以上データがある場合、「もっと見る」押下でのみ表示させる領域に描画する
  var alwaysVisibleItems = upperOrgList.slice(0, 3);
  var moreItems = upperOrgList.slice(3);

  var upperOrgListHtml = '';

  alwaysVisibleItems.forEach(function (item) {
    upperOrgListHtml += (0, _modulesCreateUpperOrgItem_createUpperOrgItem.createUpperOrgItem)(item, order, gakkoCd, hitText);
  });

  // もっと見る押下時に表示されるHTMLの作成
  var moreOrgListHtml = '';
  if (moreItems.length) {
    moreItems.forEach(function (item) {
      moreOrgListHtml += (0, _modulesCreateUpperOrgItem_createUpperOrgItem.createUpperOrgItem)(item, order, gakkoCd, hitText);
    });
  };

  // その他の学部・学科・コース一覧欄の作成
  var lowerOrgListHtml = (0, _modulesCreateLowerOrgList_createLowerOrgList.createLowerOrgList)(lowerOrgList, order, gakkoCd, hitText);

  upperOrgListHtml += "\n    <li>\n      <ul prarea-data-more-gakubugakka=\"target\" style=\"display: none\">\n        " + moreOrgListHtml + "\n        " + lowerOrgListHtml + "\n      </ul>\n    </li>\n  ";

  return upperOrgListHtml;
};

exports.createUpperOrgList = createUpperOrgList;

},{"./modules/createLowerOrgList/_createLowerOrgList":53,"./modules/createUpperOrgItem/_createUpperOrgItem":54}],53:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(["\n  background-color: #f8f9f9;\n"], ["\n  background-color: #f8f9f9;\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  padding: 8px;\n  background-color: #f8f9f9;\n  border-top: 1px solid #d3d4d4;\n"], ["\n  padding: 8px;\n  background-color: #f8f9f9;\n  border-top: 1px solid #d3d4d4;\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  margin-bottom: 4px;\n  color: #808d96;\n\n  ", " {\n    font-size: 12px;\n  };\n\n  ", " {\n    font-size: 10px;\n  };\n"], ["\n  margin-bottom: 4px;\n  color: #808d96;\n\n  ", " {\n    font-size: 12px;\n  };\n\n  ", " {\n    font-size: 10px;\n  };\n"]),
    _templateObject4 = _taggedTemplateLiteral(["\n  display: inline;\n  padding-right: 1px;\n  color: #808d96;\n\n  & + & {\n    padding-left: 5px;\n    line-height: 14px;\n    border-left: 1px solid #808d96;\n  };\n\n  ", " {\n    font-size: 12px;\n  };\n\n  ", " {\n    font-size: 10px;\n  };\n"], ["\n  display: inline;\n  padding-right: 1px;\n  color: #808d96;\n\n  & + & {\n    padding-left: 5px;\n    line-height: 14px;\n    border-left: 1px solid #808d96;\n  };\n\n  ", " {\n    font-size: 12px;\n  };\n\n  ", " {\n    font-size: 10px;\n  };\n"]),
    _templateObject5 = _taggedTemplateLiteral(["\n  color: #0b41a0;\n  text-decoration: none;\n"], ["\n  color: #0b41a0;\n  text-decoration: none;\n"]),
    _templateObject6 = _taggedTemplateLiteral(["\n  color: #808D96;\n"], ["\n  color: #808D96;\n"]);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var _emotionCss = require("@emotion/css");

var _modulesPrAreaUtilities_prAreaUtilities = require("../../../../../../../../../../../../modules/prAreaUtilities/_prAreaUtilities");

/**
 * @description 学校検索一覧用PR枠 もっと見る押下時の最下部に表示されるHTMLを生成する
 * @param {array} lowerOrgList - 描画に必要な情報
 * @param {number} order - 表示順位 
 * @param {string} clickGakkoCd - pr枠専用代表学校コード
 * @param {string} hitText - 検索分野
 * @returns {string} - 単体HTMLのDOM文字列
 */
var createLowerOrgList = function createLowerOrgList(lowerOrgList, order, clickGakkoCd, hitText) {

  if (!lowerOrgList.length) return "";

  var userBecomeJob = hitText;

  var lowerOrgListHtml = '';

  var wrappingAnker = function wrappingAnker(targetHtml, gakkoCd, ownHierarchyOrgCd, gakubuGakkaSankakuFlag) {
    if (gakubuGakkaSankakuFlag === 1) {
      return "\n        <a href=\"/gakko/" + gakkoCd + "/gakubugakka/" + ownHierarchyOrgCd + "/\" \n        class=\"" + searchResultsMoreItemLinkStyles + " js-pr-clickLog\" \n        data-pr-click-log=\"" + trace_p + "_PRcassette_click_" + order + "_" + clickGakkoCd + "\"\n        target=\"_blank\"\n        >" + targetHtml + "</a>\n      ";
    } else {
      return "\n        <a class=\"" + searchResultsMoreItemNoLinkStyles + "\">" + targetHtml + "</a>\n      ";
    }
  };

  lowerOrgList.forEach(function (lowerOrgItem) {
    var gakkoCd = lowerOrgItem.gakkoCd;
    var ownHierarchyOrgCd = lowerOrgItem.ownHierarchyOrgCd;
    var ownHierarchyNm = lowerOrgItem.ownHierarchyNm;
    var ownHierarchyShinzosetsuComment = lowerOrgItem.ownHierarchyShinzosetsuComment;
    var gakubuGakkaSankakuFlag = lowerOrgItem.gakubuGakkaSankakuFlag;

    var mainText = [ownHierarchyNm, ownHierarchyShinzosetsuComment].join(' ');

    lowerOrgListHtml += "\n      <dd class=\"" + searchResultsMoreItemDdStyles + "\">\n        " + (gakkoCd && ownHierarchyOrgCd ? wrappingAnker(mainText, gakkoCd, ownHierarchyOrgCd, gakubuGakkaSankakuFlag) : mainText) + "\n      </dd>\n    ";
  });

  return "\n    <div class=\"" + searchResultsMoreListStyles + "\">\n      <dl class=\"" + searchResultsMoreItemDlStyles + "\">\n        <dt class=\"" + searchResultsMoreItemDtStyles + "\">" + (userBecomeJob ? userBecomeJob + "を目指せる" : "") + "<b>その他の</b>学部・学科・コース一覧</dt>\n        " + lowerOrgListHtml + "\n      </dl>\n    </div>\n  ";
};

exports.createLowerOrgList = createLowerOrgList;

/** CSS定義 */
var searchResultsMoreListStyles = (0, _emotionCss.css)(_templateObject);

var searchResultsMoreItemDlStyles = (0, _emotionCss.css)(_templateObject2);

var searchResultsMoreItemDtStyles = (0, _emotionCss.css)(_templateObject3, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsMoreItemDdStyles = (0, _emotionCss.css)(_templateObject4, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsMoreItemLinkStyles = (0, _emotionCss.css)(_templateObject5);

var searchResultsMoreItemNoLinkStyles = (0, _emotionCss.css)(_templateObject6);

},{"../../../../../../../../../../../../modules/prAreaUtilities/_prAreaUtilities":64,"@emotion/css":7}],54:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(["\n  border-top: 1px solid #d3d4d4;\n  box-sizing: border-box;\n  list-style: none outside none;\n\n  ", " {\n    min-height: 53px;\n  };\n\n  ", " {\n    min-height: 42px;\n  };\n"], ["\n  border-top: 1px solid #d3d4d4;\n  box-sizing: border-box;\n  list-style: none outside none;\n\n  ", " {\n    min-height: 53px;\n  };\n\n  ", " {\n    min-height: 42px;\n  };\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  display: block;\n  text-decoration: none;\n  color: #0b41a0;\n\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n\n  &::after {\n    content: '';\n    display: block;\n    position: absolute;\n    right: 8px;\n  };\n\n  ", " {\n    padding: 16px 8px;\n\n    &::after {\n      top: calc(50% - 9px);\n      width: 12px;\n      height: 18px;\n      background: url(/images/responsive/Sapuri_Blue/arrow_sapuriBlue_2xl.svg) no-repeat center;\n    };\n  };\n\n  ", " {\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\n    cursor: pointer;\n    padding: 12px 8px 12px 12px;\n\n    &::after {\n      top: calc(50% - 6px);\n      width: 8px;\n      height: 12px;\n      background: url(/images/responsive/Sapuri_Blue/arrow_sapuriBlue_lg.svg) no-repeat center;\n    };\n  };\n"], ["\n  position: relative;\n  display: block;\n  text-decoration: none;\n  color: #0b41a0;\n\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n\n  &::after {\n    content: '';\n    display: block;\n    position: absolute;\n    right: 8px;\n  };\n\n  ", " {\n    padding: 16px 8px;\n\n    &::after {\n      top: calc(50% - 9px);\n      width: 12px;\n      height: 18px;\n      background: url(/images/responsive/Sapuri_Blue/arrow_sapuriBlue_2xl.svg) no-repeat center;\n    };\n  };\n\n  ", " {\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\n    cursor: pointer;\n    padding: 12px 8px 12px 12px;\n\n    &::after {\n      top: calc(50% - 6px);\n      width: 8px;\n      height: 12px;\n      background: url(/images/responsive/Sapuri_Blue/arrow_sapuriBlue_lg.svg) no-repeat center;\n    };\n  };\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  overflow: hidden;\n  gap: 8px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  position: relative;\n  margin-right: 16px;\n"], ["\n  display: flex;\n  overflow: hidden;\n  gap: 8px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  position: relative;\n  margin-right: 16px;\n"]),
    _templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 8px;\n"], ["\n  display: flex;\n  gap: 8px;\n"]),
    _templateObject5 = _taggedTemplateLiteral(["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"], ["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"]),
    _templateObject6 = _taggedTemplateLiteral(["\n  color: #0b41a0;\n  font-weight: 700;\n  line-height: 1.3;\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  ", " {\n    font-size: 16px;\n  };\n\n  ", " {\n    font-size: 14px;\n  };\n"], ["\n  color: #0b41a0;\n  font-weight: 700;\n  line-height: 1.3;\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  ", " {\n    font-size: 16px;\n  };\n\n  ", " {\n    font-size: 14px;\n  };\n"]),
    _templateObject7 = _taggedTemplateLiteral(["\n  margin-left: 0;\n  overflow: hidden;\n  line-height: 14px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"], ["\n  margin-left: 0;\n  overflow: hidden;\n  line-height: 14px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"]),
    _templateObject8 = _taggedTemplateLiteral(["\n  background-color: #E7F6FF;\n  padding-block: 2px;\n"], ["\n  background-color: #E7F6FF;\n  padding-block: 2px;\n"]),
    _templateObject9 = _taggedTemplateLiteral(["\n  overflow: hidden;\n  color: #24243F;\n  text-overflow: ellipsis;\n  font-size: 12px;\n  font-weight: 300;\n  line-height: 1.5;\n"], ["\n  overflow: hidden;\n  color: #24243F;\n  text-overflow: ellipsis;\n  font-size: 12px;\n  font-weight: 300;\n  line-height: 1.5;\n"]);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var _emotionCss = require("@emotion/css");

var _modulesPrAreaUtilities_prAreaUtilities = require("../../../../../../../../../../../../modules/prAreaUtilities/_prAreaUtilities");

/**
 * @description 学校検索一覧用PR枠 目指せる学科・学部・コースの各要素のHTMLを生成する
 * @param {object} upperOrgItem - 描画に必要な情報
 * @param {number} order - 表示順位 
 * @param {string} clickGakkoCd - pr枠専用代表学校コード
 * @param {string} hitText - 分野ヒットテキスト
 * @returns {string} - 単体HTMLのDOM文字列
 */
var createUpperOrgItem = function createUpperOrgItem(upperOrgItem, order, clickGakkoCd, hitText) {
  var gakkoCd = upperOrgItem.gakkoCd;
  var ownHierarchyNm = upperOrgItem.ownHierarchyNm;
  var ownHierarchyOrgCd = upperOrgItem.ownHierarchyOrgCd;
  var shigotoNm = upperOrgItem.shigotoNm;
  var gakumonNm = upperOrgItem.gakumonNm;
  var shikakuNm = upperOrgItem.shikakuNm;
  var paymentYear = upperOrgItem.paymentYear;
  var paymentComment = upperOrgItem.paymentComment;

  var linkUrl = "/gakko/" + gakkoCd + "/gakubugakka/" + ownHierarchyOrgCd + "/";

  return "\n    <li class=\"" + searchResultsGakkaListItemStyles + " prarea__searchResults__gakkaItem js-cassetteGakkaName\">\n      <a href=\"" + linkUrl + "\" \n      class=\"" + searchResultsGakkaLinkStyles + " js-pr-clickLog\" \n      data-pr-click-log=\"" + trace_p + "_PRcassette_click_" + order + "_" + clickGakkoCd + "\"\n      target=\"_blank\">\n        <div class=\"" + searchResultsGakkaItemBoxStyles + "\">\n          <div class=\"" + searchResultsGakkaItemNameWrapperStyles + "\">\n            <h4 class=\"" + searchResultsGakkaItemH4Styles + "\">\n              <span class=\"" + searchResultsGakkaItemNameStyles + "\">" + ownHierarchyNm + "</span>\n            </h4>\n          </div>\n\n          <span class=\"prarea__searchResults__content searchResults__content\">\n            <span class=\"prarea__searchResults__word " + searchResultsContentStyles + "\">\n              " + __settingWords(shigotoNm, hitText) + "\n            </span>\n          </span>\n          <span class=\"prarea__searchResults__content searchResults__content\">\n            <span class=\"prarea__searchResults__word " + searchResultsContentStyles + "\">\n            " + __settingWords(gakumonNm, hitText) + "\n            </span>\n          </span>\n          <span class=\"prarea__searchResults__content searchResults__content\">\n            <span class=\"prarea__searchResults__word " + searchResultsContentStyles + "\">\n            " + __settingWords(shikakuNm, hitText) + "\n            </span>\n          </span>\n          <span class=\"prarea__searchResults__content searchResults__content\">\n            <span class=\"prarea__searchResults__word " + searchResultsContentStyles + "\">\n              <span class=\"" + searchResultsWordStyles + "\">初年度納入金：" + paymentYear + "年度納入金(予定) " + paymentComment + "万円</span>\n            </span>\n          </span>\n        </div>\n      </a>\n    </li>\n  ";
};

/**
 * @description HITテキスト検査
 * @param {array} words 表示テキスト
 * @param {string} hitText ヒットテキスト
 * @returns {string} HTMLObject を返す - 基本テキストスタイルDOM、HITテキストスタイルDOM
 */
var __settingWords = function __settingWords(words, hitText) {
  var result = "";
  if (!words) return result;

  words.forEach(function (word, index, array) {
    word === hitText ? result += "\n      <span class=\"is-match " + searchResultsHitTextStyles + " " + searchResultsWordStyles + "\">" + word + "</span>\n    " : result += "\n      <span class=\"" + searchResultsWordStyles + "\">" + word + "</span>\n    ";

    if (index < array.length - 1) {
      result += "\n        <span class=\"" + searchResultsWordStyles + "\">、</span>\n      ";
    }
  });

  return result;
};

exports.createUpperOrgItem = createUpperOrgItem;

/** CSS定義 */
var searchResultsGakkaListItemStyles = (0, _emotionCss.css)(_templateObject, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsGakkaLinkStyles = (0, _emotionCss.css)(_templateObject2, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsGakkaItemBoxStyles = (0, _emotionCss.css)(_templateObject3);

var searchResultsGakkaItemNameWrapperStyles = (0, _emotionCss.css)(_templateObject4);

var searchResultsGakkaItemH4Styles = (0, _emotionCss.css)(_templateObject5);

var searchResultsGakkaItemNameStyles = (0, _emotionCss.css)(_templateObject6, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsContentStyles = (0, _emotionCss.css)(_templateObject7);

var searchResultsHitTextStyles = (0, _emotionCss.css)(_templateObject8);

var searchResultsWordStyles = (0, _emotionCss.css)(_templateObject9);

},{"../../../../../../../../../../../../modules/prAreaUtilities/_prAreaUtilities":64,"@emotion/css":7}],55:[function(require,module,exports){
/**
 * [27卒PR枠] PC PR枠 学校検索一覧 在校生・卒業生・先生の声エリア生成関数
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  margin-top: 24px;\n'], ['\n  margin-top: 24px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n\n  ', ' {\n    margin-bottom: 16px;\n    gap: 8px;\n  };\n\n  ', ' {\n    margin-bottom: 8px;\n    gap: 4px;\n  };\n'], ['\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n\n  ', ' {\n    margin-bottom: 16px;\n    gap: 8px;\n  };\n\n  ', ' {\n    margin-bottom: 8px;\n    gap: 4px;\n  };\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  color: #24243F;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.3;\n  flex: 1;\n\n  ', ' {\n    font-size: 16px;\n  };\n\n  ', ' {\n    font-size: 14px;\n  };\n'], ['\n  color: #24243F;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.3;\n  flex: 1;\n\n  ', ' {\n    font-size: 16px;\n  };\n\n  ', ' {\n    font-size: 14px;\n  };\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  color: #24243F;\n  font-weight: 300;\n  line-height: 1.5;\n\n  ', ' {\n    font-size: 14px;\n  };\n\n  ', ' {\n    font-size: 12px;\n  };\n'], ['\n  color: #24243F;\n  font-weight: 300;\n  line-height: 1.5;\n\n  ', ' {\n    font-size: 14px;\n  };\n\n  ', ' {\n    font-size: 12px;\n  };\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  color: #0B41A0;\n  text-align: right;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 1.5;\n  -webkit-tap-highlight-color:rgba(0,0,0,0);\n  cursor: pointer;\n\n  &::after {\n    content: \'\';\n    display: inline-flex;\n  };\n\n  @media (hover: hover) {\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  ', ' {\n    font-size: 14px;\n\n    &::after {\n      width: 8px;\n      height: 12px;\n      background: url(/images/responsive/Sapuri_Blue/arrow_sapuriBlue_lg.svg) no-repeat center;\n    }\n  };\n\n  ', ' {\n    font-size: 12px;\n\n    &::after {\n      width: 7px;\n      height: 10px;\n      background: url(/images/responsive/Sapuri_Blue/arrow_sapuriBlue_base.svg) no-repeat center;\n    }\n  };\n'], ['\n  color: #0B41A0;\n  text-align: right;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 1.5;\n  -webkit-tap-highlight-color:rgba(0,0,0,0);\n  cursor: pointer;\n\n  &::after {\n    content: \'\';\n    display: inline-flex;\n  };\n\n  @media (hover: hover) {\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  ', ' {\n    font-size: 14px;\n\n    &::after {\n      width: 8px;\n      height: 12px;\n      background: url(/images/responsive/Sapuri_Blue/arrow_sapuriBlue_lg.svg) no-repeat center;\n    }\n  };\n\n  ', ' {\n    font-size: 12px;\n\n    &::after {\n      width: 7px;\n      height: 10px;\n      background: url(/images/responsive/Sapuri_Blue/arrow_sapuriBlue_base.svg) no-repeat center;\n    }\n  };\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  background-color: #f8f9f9;\n  border-radius: 4px;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);\n  font-size: 12px;\n  line-height: 1.5;\n  overflow: hidden;\n\n  &:first-child {\n    margin-top: 0 !important;\n  }\n\n  ', ' {\n    margin: 16px auto 0;\n  };\n\n  ', ' {\n    margin: 8px auto 0;\n  };\n'], ['\n  background-color: #f8f9f9;\n  border-radius: 4px;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);\n  font-size: 12px;\n  line-height: 1.5;\n  overflow: hidden;\n\n  &:first-child {\n    margin-top: 0 !important;\n  }\n\n  ', ' {\n    margin: 16px auto 0;\n  };\n\n  ', ' {\n    margin: 8px auto 0;\n  };\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n      text-decoration: none;\n    }\n  }\n\n  &:link, &:visited {\n    text-decoration: none;\n  }\n\n  ', ' {\n    padding: 8px;\n  };\n\n  ', ' {\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\n    cursor: pointer;\n    align-items: center;\n    padding: 4px;\n  };\n'], ['\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n      text-decoration: none;\n    }\n  }\n\n  &:link, &:visited {\n    text-decoration: none;\n  }\n\n  ', ' {\n    padding: 8px;\n  };\n\n  ', ' {\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\n    cursor: pointer;\n    align-items: center;\n    padding: 4px;\n  };\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n\n  ', ' {\n    position: relative;\n    width: 120px;\n    height: 80px;\n  };\n\n  ', ' {\n    position: relative;\n    width: 86px;\n    height: 58px;\n  };\n'], ['\n\n  ', ' {\n    position: relative;\n    width: 120px;\n    height: 80px;\n  };\n\n  ', ' {\n    position: relative;\n    width: 86px;\n    height: 58px;\n  };\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n  border-radius: 4px;\n\n  ', ' {\n    width: 120px;\n    height: 80px;\n  };\n\n  ', ' {\n    width: 86px;\n    height: 58px;\n  };\n'], ['\n  border-radius: 4px;\n\n  ', ' {\n    width: 120px;\n    height: 80px;\n  };\n\n  ', ' {\n    width: 86px;\n    height: 58px;\n  };\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n  background-color: ', ';\n  bottom: 0;\n  border-radius: 0 4px 0 4px;\n  color: #FFF;\n  display: inline;\n  font-weight: 700;\n  line-height: 1.5;\n  padding-block: 2px;\n  position: absolute;\n  text-align: center;\n  left: 0;\n\n  ', ' {\n    font-size: 12px;\n    height: 20px;\n    padding-inline: 10px;\n  };\n\n  ', ' {\n    font-size: 10px;\n    height: 16px;\n    padding-inline: 8px;\n  };\n'], ['\n  background-color: ', ';\n  bottom: 0;\n  border-radius: 0 4px 0 4px;\n  color: #FFF;\n  display: inline;\n  font-weight: 700;\n  line-height: 1.5;\n  padding-block: 2px;\n  position: absolute;\n  text-align: center;\n  left: 0;\n\n  ', ' {\n    font-size: 12px;\n    height: 20px;\n    padding-inline: 10px;\n  };\n\n  ', ' {\n    font-size: 10px;\n    height: 16px;\n    padding-inline: 8px;\n  };\n']),
    _templateObject11 = _taggedTemplateLiteral(['\n  box-sizing: border-box;\n\n  ', ' {\n    padding-inline: 8px;\n  };\n\n  ', ' {\n    padding-inline: 4px;\n  };\n'], ['\n  box-sizing: border-box;\n\n  ', ' {\n    padding-inline: 8px;\n  };\n\n  ', ' {\n    padding-inline: 4px;\n  };\n']),
    _templateObject12 = _taggedTemplateLiteral(['\n  color: #0b41a0;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.5;\n  margin-bottom: 4px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  ', ' {\n    font-size: 16px;\n  };\n\n  ', ' {\n    font-size: 12px;\n  };\n'], ['\n  color: #0b41a0;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.5;\n  margin-bottom: 4px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  ', ' {\n    font-size: 16px;\n  };\n\n  ', ' {\n    font-size: 12px;\n  };\n']),
    _templateObject13 = _taggedTemplateLiteral(['\n  color: #808d96;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.5;\n  margin: 0 !important;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  ', ' {\n    font-size: 12px;\n  };\n\n  ', ' {\n    font-size: 10px;\n  };\n'], ['\n  color: #808d96;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.5;\n  margin: 0 !important;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  ', ' {\n    font-size: 12px;\n  };\n\n  ', ' {\n    font-size: 10px;\n  };\n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var _emotionCss = require('@emotion/css');

var _modulesPrAreaUtilities_prAreaUtilities = require('../../../../../../../../modules/prAreaUtilities/_prAreaUtilities');

/**
 * @description 学校検索一覧用PR枠 在校生・卒業生・先生の声エリア
 * @param {array} empathyContentsList - 描画用の共感リスト
 * @param {number} order - 表示順位 
 * @param {string} gakkoCd - pr枠専用代表学校コード
 * @returns {string} - 単体HTMLのDOM文字列
 */
var createEmpathyContentsBlock = function createEmpathyContentsBlock(empathyContentsList, order, gakkoCd) {

  if (!empathyContentsList.length) return '';

  var _empathyContentsList$0 = empathyContentsList[0];
  var kyokanType = _empathyContentsList$0.kyokanType;
  var totalCount = _empathyContentsList$0.totalCount;
  var imagePath = _empathyContentsList$0.imagePath;
  var mainCatch = _empathyContentsList$0.mainCatch;
  var course = _empathyContentsList$0.course;
  var jobName = _empathyContentsList$0.jobName;
  var teacherName = _empathyContentsList$0.teacherName;
  var kyokanContentUrl = _empathyContentsList$0.kyokanContentUrl;
  var moreUrl = _empathyContentsList$0.moreUrl;

  var _getEmpathyContentsInfo = (0, _modulesPrAreaUtilities_prAreaUtilities.getEmpathyContentsInfo)(kyokanType);

  var empathyBackgroundColor = _getEmpathyContentsInfo.empathyBackgroundColor;
  var empathyContentString = _getEmpathyContentsInfo.empathyContentString;

  var getMainCatch = function getMainCatch(kyokanType) {
    var createHtml = function createHtml(content) {
      return '<div class="' + searchResultKyokanOtherInfoStyles + '">' + content + '</div>';
    };

    if (kyokanType === '2' && teacherName) {
      return createHtml(teacherName);
    };

    if (kyokanType === '3' && jobName) {
      return createHtml(jobName);
    };

    return '';
  };

  var mainCatchHtml = getMainCatch(kyokanType);

  return '\n    <div class="' + searchResultKyokanContentStyles + '">\n      <div class="' + searchResultKyokanFieldStyles + '">\n        <span class="' + searchResultKyokanTitleStyles + '">在校生・卒業生・先生の声\n          <span class="' + searchResultKyokanTitleCountStyles + '">(' + totalCount + '件)</span>\n        </span>\n        <a\n          href="' + moreUrl + '"\n          class="' + searchResultMoreLinkStyles + ' js-pr-clickLog" \n          data-pr-click-log="' + trace_p + '_PRcassette_click_' + order + '_' + gakkoCd + '"\n          target="_blank"\n        >\n          もっと見る\n        </a>\n      </div>\n\n      <div class="' + searchResultKyokanStyles + '">\n        <a\n          href="' + kyokanContentUrl + '"\n          class="' + searchResultKyokanLinkStyles + ' js-pr-clickLog" \n          data-pr-click-log="' + trace_p + '_PRcassette_click_' + order + '_' + gakkoCd + '"\n          target="_blank"\n        >\n          <div class="' + searchResultKyokanImageBlockStyles + '">\n            <img class="' + searchResultKyokanImageStyles + '" src="' + imagePath + '" alt="' + course + '" width="86" height="58">\n            <span class="' + searchResultKyokanCategoryStyles(empathyBackgroundColor) + '">' + empathyContentString + '</span>\n          </div>\n          <div class="' + searchResultKyokanInfoStyles + '">\n            <div class="' + searchResultKyokanNameStyles + '">' + mainCatch + '</div>\n            <div class="' + searchResultKyokanOtherInfoStyles + '">' + course + '</div>\n            ' + mainCatchHtml + '\n          </div>\n        </a>\n      </div>\n    </div>\n  ';
};

exports.createEmpathyContentsBlock = createEmpathyContentsBlock;

/** CSS定義 */
var searchResultKyokanContentStyles = (0, _emotionCss.css)(_templateObject);

var searchResultKyokanFieldStyles = (0, _emotionCss.css)(_templateObject2, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultKyokanTitleStyles = (0, _emotionCss.css)(_templateObject3, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultKyokanTitleCountStyles = (0, _emotionCss.css)(_templateObject4, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultMoreLinkStyles = (0, _emotionCss.css)(_templateObject5, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultKyokanStyles = (0, _emotionCss.css)(_templateObject6, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultKyokanLinkStyles = (0, _emotionCss.css)(_templateObject7, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultKyokanImageBlockStyles = (0, _emotionCss.css)(_templateObject8, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultKyokanImageStyles = (0, _emotionCss.css)(_templateObject9, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultKyokanCategoryStyles = function searchResultKyokanCategoryStyles(bgColor) {
  return (0, _emotionCss.css)(_templateObject10, bgColor, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);
};

var searchResultKyokanInfoStyles = (0, _emotionCss.css)(_templateObject11, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultKyokanNameStyles = (0, _emotionCss.css)(_templateObject12, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultKyokanOtherInfoStyles = (0, _emotionCss.css)(_templateObject13, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

},{"../../../../../../../../modules/prAreaUtilities/_prAreaUtilities":64,"@emotion/css":7}],56:[function(require,module,exports){
/**
 * [27卒PR枠] PC PR枠 学校検索一覧 OC導線カセット生成関数
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n\n  ', ' {\n    margin-top: 24px;\n  };\n\n  ', ' {\n    margin-top: 16px;\n  };\n'], ['\n  position: relative;\n\n  ', ' {\n    margin-top: 24px;\n  };\n\n  ', ' {\n    margin-top: 16px;\n  };\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n\n  ', ' {\n    margin-bottom: 16px;\n    gap: 8px;\n  };\n\n  ', ' {\n    margin-bottom: 8px;\n    gap: 4px;\n  };\n'], ['\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n\n  ', ' {\n    margin-bottom: 16px;\n    gap: 8px;\n  };\n\n  ', ' {\n    margin-bottom: 8px;\n    gap: 4px;\n  };\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  color: #24243F;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.3;\n  flex: 1;\n\n  ', ' {\n    font-size: 16px;\n  };\n\n  ', ' {\n    font-size: 14px;\n  };\n'], ['\n  color: #24243F;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.3;\n  flex: 1;\n\n  ', ' {\n    font-size: 16px;\n  };\n\n  ', ' {\n    font-size: 14px;\n  };\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  color: #0B41A0;\n  text-align: right;\n  font-style: normal;\n  font-weight: 700;\n\n  &::after {\n    content: \'\';\n    display: inline-flex;\n  };\n\n  @media (hover: hover) {\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  ', ' {\n    font-size: 14px;\n    line-height: 1.5;\n\n    &::after {\n      width: 8px;\n      height: 12px;\n      background: url(/images/responsive/Sapuri_Blue/arrow_sapuriBlue_lg.svg) no-repeat center;\n    }\n  };\n\n  ', ' {\n    font-size: 12px;\n    line-height: 1.3;\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\n    cursor: pointer;\n\n    &::after {\n      width: 7px;\n      height: 10px;\n      background: url(/images/responsive/Sapuri_Blue/arrow_sapuriBlue_base.svg) no-repeat center;\n    }\n  };\n'], ['\n  color: #0B41A0;\n  text-align: right;\n  font-style: normal;\n  font-weight: 700;\n\n  &::after {\n    content: \'\';\n    display: inline-flex;\n  };\n\n  @media (hover: hover) {\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  ', ' {\n    font-size: 14px;\n    line-height: 1.5;\n\n    &::after {\n      width: 8px;\n      height: 12px;\n      background: url(/images/responsive/Sapuri_Blue/arrow_sapuriBlue_lg.svg) no-repeat center;\n    }\n  };\n\n  ', ' {\n    font-size: 12px;\n    line-height: 1.3;\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\n    cursor: pointer;\n\n    &::after {\n      width: 7px;\n      height: 10px;\n      background: url(/images/responsive/Sapuri_Blue/arrow_sapuriBlue_base.svg) no-repeat center;\n    }\n  };\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  position: relative;\n  width: 100%;\n\n  & .swiper-button-disabled {\n    display: none;\n  };\n'], ['\n  position: relative;\n  width: 100%;\n\n  & .swiper-button-disabled {\n    display: none;\n  };\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  position: relative;\n  overflow: hidden;\n  list-style: none;\n  padding: 0;\n  z-index: 1;\n\n  ', ' {\n    margin-inline: 24px;\n  };\n\n  ', ' {\n    margin-inline: 20px;\n  };\n'], ['\n  display: flex;\n  align-items: center;\n  position: relative;\n  overflow: hidden;\n  list-style: none;\n  padding: 0;\n  z-index: 1;\n\n  ', ' {\n    margin-inline: 24px;\n  };\n\n  ', ' {\n    margin-inline: 20px;\n  };\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  position: relative;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  display: flex;\n  transition-property: transform, -webkit-transform;\n  box-sizing: content-box;\n\n  transform: translate3d(0px, 0, 0)\n  transition-timing-function: ease-out;\n'], ['\n  position: relative;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  display: flex;\n  transition-property: transform, -webkit-transform;\n  box-sizing: content-box;\n\n  transform: translate3d(0px, 0, 0)\n  transition-timing-function: ease-out;\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  top: calc(50% - 16px);\n  margin-top: 0;\n  background-color: #AFB8BE;\n  border-radius: 24px;\n  opacity: 0.6;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.3;\n      text-decoration: none;\n    }\n  }\n\n  &::after {\n    content: \'\';\n    position: absolute;\n    top: calc(50% - 9px);\n    left: calc(50% - 6px);\n    width: 12px;\n    height: 19px;\n    background: url(/images/responsive/Bg_White/arrow_bgWhite_base.svg) no-repeat center;\n  };\n\n  ', ' {\n    width: 40px;\n    height: 40px;\n  };\n\n  ', ' {\n    width: 32px;\n    height: 32px;\n\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\n    cursor: pointer;\n  };\n'], ['\n  top: calc(50% - 16px);\n  margin-top: 0;\n  background-color: #AFB8BE;\n  border-radius: 24px;\n  opacity: 0.6;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.3;\n      text-decoration: none;\n    }\n  }\n\n  &::after {\n    content: \'\';\n    position: absolute;\n    top: calc(50% - 9px);\n    left: calc(50% - 6px);\n    width: 12px;\n    height: 19px;\n    background: url(/images/responsive/Bg_White/arrow_bgWhite_base.svg) no-repeat center;\n  };\n\n  ', ' {\n    width: 40px;\n    height: 40px;\n  };\n\n  ', ' {\n    width: 32px;\n    height: 32px;\n\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\n    cursor: pointer;\n  };\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n  ', ';\n\n  &::after {\n    -webkit-transform: rotate(180deg);\n    -ms-transform: rotate(180deg);\n    transform: rotate(180deg);\n  }\n\n  ', ' {\n    left: 0;\n  };\n\n  ', ' {\n    left: -12px;\n  };\n'], ['\n  ', ';\n\n  &::after {\n    -webkit-transform: rotate(180deg);\n    -ms-transform: rotate(180deg);\n    transform: rotate(180deg);\n  }\n\n  ', ' {\n    left: 0;\n  };\n\n  ', ' {\n    left: -12px;\n  };\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n  ', ';\n\n  ', ' {\n    right: 0;\n  };\n\n  ', ' {\n    right: -12px;\n  };\n'], ['\n  ', ';\n\n  ', ' {\n    right: 0;\n  };\n\n  ', ' {\n    right: -12px;\n  };\n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var _emotionCss = require('@emotion/css');

var _modulesPrAreaUtilities_prAreaUtilities = require('../../../../../../../../modules/prAreaUtilities/_prAreaUtilities');

var _modulesCreateCampusItem_createCampusItem = require('./modules/createCampusItem/_createCampusItem');

/**
 * @description 学校検索一覧用PR枠 OC導線カセット
 * @param {object} searchIntegrationItem - 描画用のOCリスト
 * @param {number} order - 表示順位 
 * @returns {string} - 単体HTMLのDOM文字列
 */
var createOpenCampusBlock = function createOpenCampusBlock(searchIntegrationItem, order) {
  var gakkoCd = searchIntegrationItem.gakkoCd;
  var ocBunyaCassetteDtoList = searchIntegrationItem.ocBunyaCassetteDtoList;

  var moreLinkUrl = '/gakko/' + gakkoCd + '/openCampus/';

  var ocListHtml = '';

  //OCデータ0件時トルツメ
  if (!ocBunyaCassetteDtoList || ocBunyaCassetteDtoList.length === 0) return '';

  ocBunyaCassetteDtoList.forEach(function (ocBunyaCassetteDtoItem) {
    ocListHtml += (0, _modulesCreateCampusItem_createCampusItem.createCampusItem)(ocBunyaCassetteDtoItem, order);
  });

  return '\n    <div class="' + searchResultsOcHeadStyles + '">\n      <div class="' + searchResultsOcFieldStyles + '">\n        <p class="' + searchResultsOcTitleStyles + '">オープンキャンパス</p>\n        <a\n          href="' + moreLinkUrl + '"\n          onclick="var s2=s_gi(s_account);s2.tl(this,\'o\',\'Slist_f_All_SGopelLink\')"\n          class="' + searchResultsMoreLinkStyles + ' js-pr-clickLog" \n          target="_blank"\n          data-pr-click-log="' + trace_p + '_PRcassette_click_' + order + '_' + gakkoCd + '"\n        >\n          もっと見る\n        </a>\n      </div>\n\n      <div class="' + searchResultsOcCarouselWrapperStyles + ' js-prSearchOc-swiper">\n        <div class="' + searchResultsOcCarouselStyles + ' swiper-container">\n          <ul\n            class="' + searchResultsOcUlStyles + ' swiper-wrapper"\n           >\n            ' + ocListHtml + '\n          </ul>\n        </div>\n\n        <div tabindex="0" role="button" aria-label="Previous slide"\n          class="swiper-button-prev ' + searchResultsOcCarouselPrevStyles + '">\n        </div>\n        <div tabindex="0" role="button" aria-label="Next slide"\n          class="swiper-button-next ' + searchResultsOcCarouselNextStyles + '">\n        </div>\n      </div>\n    </div>\n  ';
};

exports.createOpenCampusBlock = createOpenCampusBlock;

/** CSS定義 */
var searchResultsOcHeadStyles = (0, _emotionCss.css)(_templateObject, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsOcFieldStyles = (0, _emotionCss.css)(_templateObject2, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsOcTitleStyles = (0, _emotionCss.css)(_templateObject3, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsMoreLinkStyles = (0, _emotionCss.css)(_templateObject4, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsOcCarouselWrapperStyles = (0, _emotionCss.css)(_templateObject5);

var searchResultsOcCarouselStyles = (0, _emotionCss.css)(_templateObject6, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsOcUlStyles = (0, _emotionCss.css)(_templateObject7);

var searchResultsOcCarouselBaseButtonStyles = (0, _emotionCss.css)(_templateObject8, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsOcCarouselPrevStyles = (0, _emotionCss.css)(_templateObject9, searchResultsOcCarouselBaseButtonStyles, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsOcCarouselNextStyles = (0, _emotionCss.css)(_templateObject10, searchResultsOcCarouselBaseButtonStyles, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

},{"../../../../../../../../modules/prAreaUtilities/_prAreaUtilities":64,"./modules/createCampusItem/_createCampusItem":57,"@emotion/css":7}],57:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(["\n  flex-shrink: 0;\n  width: 100%;\n  height: 100%;\n  position: relative;\n"], ["\n  flex-shrink: 0;\n  width: 100%;\n  height: 100%;\n  position: relative;\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  background-color: #f8f9f9;\n  border-radius: 4px;\n  box-sizing: border-box;\n\n  display: block;\n  position: relative;\n  overflow: hidden;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n\n  ", " {\n    padding: 8px;\n  };\n\n  ", " {\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\n    cursor: pointer;\n    padding: 4px 8px 4px 4px;\n  };\n"], ["\n  background-color: #f8f9f9;\n  border-radius: 4px;\n  box-sizing: border-box;\n\n  display: block;\n  position: relative;\n  overflow: hidden;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n\n  ", " {\n    padding: 8px;\n  };\n\n  ", " {\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\n    cursor: pointer;\n    padding: 4px 8px 4px 4px;\n  };\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n\n  ", " {\n    gap: 8px;\n  };\n\n  ", " {\n    gap: 4px;\n  };\n"], ["\n  display: flex;\n  align-items: center;\n\n  ", " {\n    gap: 8px;\n  };\n\n  ", " {\n    gap: 4px;\n  };\n"]),
    _templateObject4 = _taggedTemplateLiteral(["\n  border-radius: 4px;\n\n  ", " {\n    width: 120px;\n    height: 80px;\n  };\n\n  ", " {\n    width: 87px;\n    height: 58px;\n  };\n"], ["\n  border-radius: 4px;\n\n  ", " {\n    width: 120px;\n    height: 80px;\n  };\n\n  ", " {\n    width: 87px;\n    height: 58px;\n  };\n"]),
    _templateObject5 = _taggedTemplateLiteral(["\n  display: grid;\n\n"], ["\n  display: grid;\n\n"]),
    _templateObject6 = _taggedTemplateLiteral(["\n  color: #0b41a0;\n  font-weight: 700;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  ", " {\n    font-size: 16px;\n    line-height: 1.3;\n  };\n\n  ", " {\n    font-size: 12px;\n    line-height: 1.5;\n  };\n"], ["\n  color: #0b41a0;\n  font-weight: 700;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  ", " {\n    font-size: 16px;\n    line-height: 1.3;\n  };\n\n  ", " {\n    font-size: 12px;\n    line-height: 1.5;\n  };\n"]),
    _templateObject7 = _taggedTemplateLiteral(["\n  color: #808d96;\n  display: flex;\n  font-weight: 700;\n  justify-content: space-between;\n  line-height: 1.5;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  ", " {\n    font-size: 12px;\n  };\n\n  ", " {\n    font-size: 10px;\n  };\n"], ["\n  color: #808d96;\n  display: flex;\n  font-weight: 700;\n  justify-content: space-between;\n  line-height: 1.5;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  ", " {\n    font-size: 12px;\n  };\n\n  ", " {\n    font-size: 10px;\n  };\n"]),
    _templateObject8 = _taggedTemplateLiteral(["\n  display: inline;\n  overflow: hidden;\n  padding-right: 10px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  ", " {\n    font-size: 12px;\n  };\n\n  ", " {\n    font-size: 10px;\n  };\n"], ["\n  display: inline;\n  overflow: hidden;\n  padding-right: 10px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  ", " {\n    font-size: 12px;\n  };\n\n  ", " {\n    font-size: 10px;\n  };\n"]),
    _templateObject9 = _taggedTemplateLiteral(["\n  color: #24243F;\n  font-family: StudySapuriNumber !important;\n  white-space: nowrap;\n\n  background-color: #FFF;\n  bottom: 0;\n  border-radius: 0px 4px 0px 0px;\n  box-sizing: border-box;\n  display: inline;\n  font-weight: 300;\n  line-height: 1.5;\n  padding: 2px 4px;\n  position: absolute;\n  text-align: center;\n  left: 0;\n\n  ", " {\n    bottom: 8px;\n    font-size: 14px;\n    height: 21px;\n    left: 8px;\n    padding: 2px 4px;\n  };\n\n  ", " {\n    bottom: 4px;\n    font-size: 12px;\n    height: 19px;\n    left: 4px;\n    padding: 4px;\n  };\n"], ["\n  color: #24243F;\n  font-family: StudySapuriNumber !important;\n  white-space: nowrap;\n\n  background-color: #FFF;\n  bottom: 0;\n  border-radius: 0px 4px 0px 0px;\n  box-sizing: border-box;\n  display: inline;\n  font-weight: 300;\n  line-height: 1.5;\n  padding: 2px 4px;\n  position: absolute;\n  text-align: center;\n  left: 0;\n\n  ", " {\n    bottom: 8px;\n    font-size: 14px;\n    height: 21px;\n    left: 8px;\n    padding: 2px 4px;\n  };\n\n  ", " {\n    bottom: 4px;\n    font-size: 12px;\n    height: 19px;\n    left: 4px;\n    padding: 4px;\n  };\n"]),
    _templateObject10 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: 700;\n\n  ", " {\n    font-size: 10px;\n  };\n\n  ", " {\n    font-size: 8px;\n  };\n"], ["\n  color: ", ";\n  font-weight: 700;\n\n  ", " {\n    font-size: 10px;\n  };\n\n  ", " {\n    font-size: 8px;\n  };\n"]),
    _templateObject11 = _taggedTemplateLiteral(["\n  color: #24243F;\n  font-size: 8px;\n  font-weight: 700;\n  line-height: 1.5;\n\n  ", " {\n    margin-left: 4px;\n  };\n\n  ", " {\n    margin-left: 2px;\n  };\n"], ["\n  color: #24243F;\n  font-size: 8px;\n  font-weight: 700;\n  line-height: 1.5;\n\n  ", " {\n    margin-left: 4px;\n  };\n\n  ", " {\n    margin-left: 2px;\n  };\n"]);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var _emotionCss = require("@emotion/css");

var _modulesPrAreaUtilities_prAreaUtilities = require("../../../../../../../../../../modules/prAreaUtilities/_prAreaUtilities");

/**
 * @description 学校検索一覧用 PR枠 スワイプ対象の OpenCampus HTMLを生成する
 * @param {object} ocBunyaCassetteDtoItem - 描画に必要なOCオブジェクト情報
 * @returns {string} - 単体HTMLのDOM文字列
 */
var createCampusItem = function createCampusItem(ocBunyaCassetteDtoItem, order) {
  var productCd = ocBunyaCassetteDtoItem.productCd;
  var gakkoCd = ocBunyaCassetteDtoItem.gakkoCd;
  var orgCd = ocBunyaCassetteDtoItem.orgCd;
  var eventTitle = ocBunyaCassetteDtoItem.eventTitle;
  var ocBunyaPcImage = ocBunyaCassetteDtoItem.ocBunyaPcImage;
  var kaisaiDateList = ocBunyaCassetteDtoItem.kaisaiDateList;

  var linkUrl = "/gakko/" + gakkoCd + "/openCampus/gakubugakka/" + orgCd + "/?ocsfProductCd=" + productCd;

  return "\n    <li class=\"" + searchResultsOcItemStyles + " swiper-slide\">\n      <a\n        href=\"" + linkUrl + "\"\n        class=\"" + searchResultsOcLinkStyles + " js-pr-clickLog\" \n        target=\"_blank\"\n        data-pr-click-log=\"" + trace_p + "_PRcassette_click_" + order + "_" + gakkoCd + "\"\n      >\n        <div class=\"" + searchResultsOcHeadStyles + "\">\n          <div class=\"" + searchResultsOcThumbnailAreaStyles + "\">\n            <img\n              src=\"" + __createOcImage(ocBunyaPcImage) + "\"\n              alt=\"" + __createOcTitle(eventTitle) + "\"\n              class=\"" + searchResultsOcThumbnailStyles + "\"\n              width=\"86\"\n              height=\"58\"\n            >\n            " + __createCasseteDateHtml(kaisaiDateList) + "\n          </div>\n          <div class=\"" + searchResultsOcMainStyles + "\">\n            <p class=\"" + searchResultsOcEventTitleStyles + "\">" + __createOcTitle(eventTitle) + "</p>\n          </div>\n        </div>\n      </a>\n    </li>\n  ";
};

/**
 * @private
 * @description OC開催日生成関数
 * @param {Array | undefined | ''} kaisaiDateList - OC開催配列
 * @returns {string} - PR枠カセット開催日HTML DOM
 */
var __createCasseteDateHtml = function __createCasseteDateHtml(kaisaiDateList) {
  if (!kaisaiDateList) return '';

  var kaisaiFirstDate = kaisaiDateList[0].trim();
  // 開催日は1つのみ掲示し、2つ以上の場合それらは「他」とする
  var kaisaiOtherDateHtml = kaisaiDateList.length > 1 ? "<span class=\"" + searchResultsOcOtherStyles + "\">他</span>" : '';

  var _getMonthDayAndDayOfWeek = (0, _modulesPrAreaUtilities_prAreaUtilities.getMonthDayAndDayOfWeek)(kaisaiFirstDate);

  var monthDay = _getMonthDayAndDayOfWeek.monthDay;
  var dayOfWeek = _getMonthDayAndDayOfWeek.dayOfWeek;

  var kaisaiDateHtml = "\n    <div class=\"" + searchResultsOcKaisaiDateStyles + "\">\n      " + monthDay + "\n      <span class=\"" + searchResultsOcDayOfWeekStyles(dayOfWeek) + "\">" + dayOfWeek + "</span>\n      " + kaisaiOtherDateHtml + "\n    </div>\n  ";

  return kaisaiDateHtml;
};

/**
 * @private
 * @description OC画像のsrc値を生成する関数
 * @param {string|null} ocBunyaPcImage - APIから返される画像パス。空の場合はNoImage画像を指定する。
 * @returns {string} 表示する画像パス
 */
var __createOcImage = function __createOcImage(ocBunyaPcImage) {
  // ocBunyaPcImageが文字列かつ空白を除いた値が空でない場合はAPIから送られた画像パス値を指定する
  // それ以外の場合はNoImage画像を使用
  return typeof ocBunyaPcImage === 'string' && ocBunyaPcImage.trim() !== '' ? ocBunyaPcImage : '/images/open_campus/oc_bunya_cassette_no_image.svg';
};

/**
 * @private
 * @description OC画像のalt値を生成する関数
 * @param {string | null} eventTitle - APIから返されるイベントタイトル。空の場合は固定文言(オープンキャンパス)を指定する。
 * @returns {string} - alt属性に設定する文字列
 */
var __createOcTitle = function __createOcTitle(eventTitle) {
  return typeof eventTitle === 'string' && eventTitle.trim() !== '' ? eventTitle : 'オープンキャンパス';
};

exports.createCampusItem = createCampusItem;

/** CSS定義 */
var searchResultsOcItemStyles = (0, _emotionCss.css)(_templateObject);

var searchResultsOcLinkStyles = (0, _emotionCss.css)(_templateObject2, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsOcHeadStyles = (0, _emotionCss.css)(_templateObject3, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsOcThumbnailAreaStyles = (0, _emotionCss.css)(_templateObject4, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsOcThumbnailStyles = (0, _emotionCss.css)(_templateObject4, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsOcMainStyles = (0, _emotionCss.css)(_templateObject5);

var searchResultsOcEventTitleStyles = (0, _emotionCss.css)(_templateObject6, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsOcSubBoxStyles = (0, _emotionCss.css)(_templateObject7, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsOcBunyaCatchStyles = (0, _emotionCss.css)(_templateObject8, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsOcKaisaiDateStyles = (0, _emotionCss.css)(_templateObject9, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsOcDayOfWeekStyles = function searchResultsOcDayOfWeekStyles(dayOfWeek) {
  return (0, _emotionCss.css)(_templateObject10, (0, _modulesPrAreaUtilities_prAreaUtilities.getDayOfWeekBackgroundColor)(dayOfWeek), _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);
};

var searchResultsOcOtherStyles = (0, _emotionCss.css)(_templateObject11, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

},{"../../../../../../../../../../modules/prAreaUtilities/_prAreaUtilities":64,"@emotion/css":7}],58:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(["\n  display: block;\n  text-decoration: none;\n"], ["\n  display: block;\n  text-decoration: none;\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  justify-content: space-between;\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  width: 100%;\n"], ["\n  width: 100%;\n"]),
    _templateObject4 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  color: #0b41a0;\n  line-height: 1.3;\n\n  ", " {\n    font-size: 32px;\n  };\n\n  ", " {\n    font-size: 20px;\n  };\n"], ["\n  font-weight: 700;\n  color: #0b41a0;\n  line-height: 1.3;\n\n  ", " {\n    font-size: 32px;\n  };\n\n  ", " {\n    font-size: 20px;\n  };\n"]),
    _templateObject5 = _taggedTemplateLiteral(["\n  padding-top: 8px;\n  border-top: 1px solid #d3d4d4;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n"], ["\n  padding-top: 8px;\n  border-top: 1px solid #d3d4d4;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n"]),
    _templateObject6 = _taggedTemplateLiteral(["\n  display: inline-block;\n  padding: 2px 8px;\n  color: #3ec1bd;\n  line-height: 1.5;\n  text-align: center;\n  border: 1px solid #3ec1bd;\n  border-radius: 4px;\n  box-sizing: border-box;\n\n  ", " {\n    font-size: 14px;\n    height: 25px;\n  };\n\n  ", " {\n    font-size: 12px;\n    height: 22px;\n  };\n"], ["\n  display: inline-block;\n  padding: 2px 8px;\n  color: #3ec1bd;\n  line-height: 1.5;\n  text-align: center;\n  border: 1px solid #3ec1bd;\n  border-radius: 4px;\n  box-sizing: border-box;\n\n  ", " {\n    font-size: 14px;\n    height: 25px;\n  };\n\n  ", " {\n    font-size: 12px;\n    height: 22px;\n  };\n"]),
    _templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  margin-top: 8px;\n"], ["\n  display: flex;\n  align-items: center;\n  margin-top: 8px;\n"]),
    _templateObject8 = _taggedTemplateLiteral(["\n  width: 12px;\n  height: 12px;\n  padding-bottom: 1px;\n  border: 0 none;\n"], ["\n  width: 12px;\n  height: 12px;\n  padding-bottom: 1px;\n  border: 0 none;\n"]),
    _templateObject9 = _taggedTemplateLiteral(["\n  padding-left: 4px;\n  line-height: 1.5;\n  color: #24243F;\n\n  ", " {\n    font-size: 14px;\n  };\n\n  ", " {\n    font-size: 12px;\n  };\n"], ["\n  padding-left: 4px;\n  line-height: 1.5;\n  color: #24243F;\n\n  ", " {\n    font-size: 14px;\n  };\n\n  ", " {\n    font-size: 12px;\n  };\n"]),
    _templateObject10 = _taggedTemplateLiteral(["\n  display: flex;\n\n  ", " {\n    margin-top: 16px;\n  };\n\n  ", " {\n    margin-top: 8px;\n  };\n"], ["\n  display: flex;\n\n  ", " {\n    margin-top: 16px;\n  };\n\n  ", " {\n    margin-top: 8px;\n  };\n"]),
    _templateObject11 = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  display: flex;\n  transition-property: transform;\n  box-sizing: content-box;\n  overflow-y: hidden;\n\n  ", " {\n    gap: 16px;\n  };\n\n  ", " {\n    gap: 4px;\n  };\n"], ["\n  position: relative;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  display: flex;\n  transition-property: transform;\n  box-sizing: content-box;\n  overflow-y: hidden;\n\n  ", " {\n    gap: 16px;\n  };\n\n  ", " {\n    gap: 4px;\n  };\n"]),
    _templateObject12 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  border-radius: 4px;\n\n  ", " {\n    aspect-ratio: 220 / 148;\n    max-width: 220px;\n  };\n\n  ", " {\n    aspect-ratio: 82 / 56;\n    max-width: 181px;\n  };\n"], ["\n  width: 100%;\n  height: 100%;\n  border-radius: 4px;\n\n  ", " {\n    aspect-ratio: 220 / 148;\n    max-width: 220px;\n  };\n\n  ", " {\n    aspect-ratio: 82 / 56;\n    max-width: 181px;\n  };\n"]),
    _templateObject13 = _taggedTemplateLiteral(["\n  color: #24243F;\n  line-height: 1.5;\n  overflow-wrap: break-word;\n\n  ", " {\n    margin-top: 16px;\n    font-size: 14px;\n  };\n\n  ", " {\n    margin-top: 8px;\n    font-size: 12px;\n  };\n"], ["\n  color: #24243F;\n  line-height: 1.5;\n  overflow-wrap: break-word;\n\n  ", " {\n    margin-top: 16px;\n    font-size: 14px;\n  };\n\n  ", " {\n    margin-top: 8px;\n    font-size: 12px;\n  };\n"]),
    _templateObject14 = _taggedTemplateLiteral(["\n  width: 100%;\n  box-sizing: border-box;\n  display: flex;\n\n  ", " {\n    margin-top: 16px;\n    gap: 16px;\n    height: 50px;\n  };\n\n  ", " {\n    margin-top: 8px;\n    gap: 8px;\n    height: 48px;\n  };\n"], ["\n  width: 100%;\n  box-sizing: border-box;\n  display: flex;\n\n  ", " {\n    margin-top: 16px;\n    gap: 16px;\n    height: 50px;\n  };\n\n  ", " {\n    margin-top: 8px;\n    gap: 8px;\n    height: 48px;\n  };\n"]),
    _templateObject15 = _taggedTemplateLiteral(["\n  width: 50%;\n  &:only-child {\n    width: 100%\n  }\n"], ["\n  width: 50%;\n  &:only-child {\n    width: 100%\n  }\n"]),
    _templateObject16 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  background-color: #FF8700;\n  border-radius: 4px;\n  font-weight: 700;\n  color: #ffffff;\n  line-height: 1.3;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n\n  ", " {\n    font-size: 16px;\n  };\n\n  ", " {\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\n    cursor: pointer;\n    font-size: 14px;\n  };\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  background-color: #FF8700;\n  border-radius: 4px;\n  font-weight: 700;\n  color: #ffffff;\n  line-height: 1.3;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n\n  ", " {\n    font-size: 16px;\n  };\n\n  ", " {\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\n    cursor: pointer;\n    font-size: 14px;\n  };\n"]),
    _templateObject17 = _taggedTemplateLiteral(["\n  width: 50%;\n  transition: width .1s ease, top .1s ease;\n\n  &:only-child {\n    width: 100%\n  }\n\n  &.is-added {\n    color: #AFB8BE;\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 1.3;\n\n    .searchResults__buttons__cart {\n      border: 1px solid #D3D4D4;\n\n      &::after {\n        content: '追加済み';\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background-image: none;\n        color: #AFB8BE;\n        font-size: 14px;\n        font-weight: 700;\n        line-height: 1.3;\n      };\n\n      @media (hover: hover) {\n        &:hover {\n          opacity: 1;\n        }\n      }\n\n    }\n  };\n"], ["\n  width: 50%;\n  transition: width .1s ease, top .1s ease;\n\n  &:only-child {\n    width: 100%\n  }\n\n  &.is-added {\n    color: #AFB8BE;\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 1.3;\n\n    .searchResults__buttons__cart {\n      border: 1px solid #D3D4D4;\n\n      &::after {\n        content: '追加済み';\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background-image: none;\n        color: #AFB8BE;\n        font-size: 14px;\n        font-weight: 700;\n        line-height: 1.3;\n      };\n\n      @media (hover: hover) {\n        &:hover {\n          opacity: 1;\n        }\n      }\n\n    }\n  };\n"]),
    _templateObject18 = _taggedTemplateLiteral(["\n  display: block;\n  height: 100%;\n  background-color: #ffffff;\n  border: 1px solid #0ca5e6;\n  border-radius: 4px;\n  box-sizing: border-box;\n\n  &::after {\n    content: '';\n    display: block;\n    height: 100%;\n  };\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n\n  ", " {\n    font-size: 16px;\n\n    &::after {\n      background: url(/images/s/addList_searchList_medium.svg) no-repeat center center;\n    }\n  };\n\n  ", " {\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\n    cursor: pointer;\n\n    &::after {\n      background: url(/images/s/addList_searchList.svg) no-repeat center center;\n    }\n  };\n"], ["\n  display: block;\n  height: 100%;\n  background-color: #ffffff;\n  border: 1px solid #0ca5e6;\n  border-radius: 4px;\n  box-sizing: border-box;\n\n  &::after {\n    content: '';\n    display: block;\n    height: 100%;\n  };\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n\n  ", " {\n    font-size: 16px;\n\n    &::after {\n      background: url(/images/s/addList_searchList_medium.svg) no-repeat center center;\n    }\n  };\n\n  ", " {\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\n    cursor: pointer;\n\n    &::after {\n      background: url(/images/s/addList_searchList.svg) no-repeat center center;\n    }\n  };\n"]),
    _templateObject19 = _taggedTemplateLiteral(["\n  padding-bottom: 8px;\n  justify-content: space-between;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n"], ["\n  padding-bottom: 8px;\n  justify-content: space-between;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n"]);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var _emotionCss = require("@emotion/css");

var _modulesPrAreaUtilities_prAreaUtilities = require("../../../../../../../../modules/prAreaUtilities/_prAreaUtilities");

/**
 * @description 学校検索一覧用PR枠 大学情報やパンフ・リスト追加などのHTMLを生成するエリア
 * @param {object} searchIntegrationItem - 描画に必要な情報
 * @param {number} order - 表示順位 
 * @returns {string} - 単体HTMLのDOM文字列
 */
var createUniversityBlock = function createUniversityBlock(searchIntegrationItem, order) {
  var gakkoCd = searchIntegrationItem.gakkoCd;
  var gakkoNm = searchIntegrationItem.gakkoNm;
  var gakkoPhoto = searchIntegrationItem.gakkoPhoto;
  var rootProductCd = searchIntegrationItem.rootProductCd;
  var tokuchoImage1 = searchIntegrationItem.tokuchoImage1;
  var tokuchoImage2 = searchIntegrationItem.tokuchoImage2;
  var tokuchoImage3 = searchIntegrationItem.tokuchoImage3;
  var koshuNm = searchIntegrationItem.koshuNm;
  var todofukenRnm = searchIntegrationItem.todofukenRnm;
  var gakkoHowKomidashi = searchIntegrationItem.gakkoHowKomidashi;
  var guideTokuchoNm1 = searchIntegrationItem.guideTokuchoNm1;
  var guideTokuchoNm2 = searchIntegrationItem.guideTokuchoNm2;
  var guideTokuchoNm3 = searchIntegrationItem.guideTokuchoNm3;
  var pamphFlag = searchIntegrationItem.pamphFlag;
  var ikkatsuFlag = searchIntegrationItem.ikkatsuFlag;

  var linkUrl = "/gakko/" + gakkoCd + "/";
  var getPamphletUrl = "/smp2/shiryoSeikyu/entry/input?shiryoShubetsu=01&seikyuShubetsu=0&yuryoDispFlag=1&gakkoCd=" + gakkoCd + "&pCd=LS0000000028";
  var isFlagTrue = function isFlagTrue(value) {
    return Number(value) === 1;
  };
  var tokuchoPhotos = [tokuchoImage1, tokuchoImage2, tokuchoImage3];
  var guideTokuchoNm = [guideTokuchoNm1, guideTokuchoNm2, guideTokuchoNm3];

  var guideTokuchoHtml = '';
  guideTokuchoNm.filter(Boolean).forEach(function (item) {
    guideTokuchoHtml += "\n      <span class=\"" + searchResultsFeatureTagItemStyles + "\">" + item + "</span>\n    ";
  });

  /**
   * @description 検索一覧ボタンの表示時下記の4パターンを対応する関数
   * ① - 「パンプをもらう」ボタン[有]
   * ② - 「資料請求カート」ボタン[有]
   * ③ - 「パンプをもらう」、「資料請求カート」ボタン両方[有]
   * ④ - ボタン[無]
   * @param {boolean} refinedPamphFlag パンプボタン存在有無
   * @param {boolean} refinedIkkatsuFlag パンプボタン存在有無
   * @returns {string} - 単体HTMLのDOM文字列
   */
  var createButtonAreaHtml = function createButtonAreaHtml(refinedPamphFlag, refinedIkkatsuFlag) {
    if (!refinedPamphFlag && !refinedIkkatsuFlag) return '';

    var pamphletButton = refinedPamphFlag ? "\n      <div class=\"" + searchResultsButtonLeftStyles + "\">\n        <a\n          href=\"" + getPamphletUrl + "\"\n          class=\"" + searchResultsPamphletButtonStyles + " js-pr-clickLog\"\n          target=\"_blank\"\n          data-pr-click-log=\"" + trace_p + "_PRcassette_click_" + order + "_" + gakkoCd + "\"\n        >\n          パンフをもらう\n        </a>\n      </div>\n    " : '';

    var cartButton = refinedIkkatsuFlag ? "\n      <div class=\"" + searchResultsButtonRightStyles + " js-cassetteCarts\" data-cart=\"button\">\n        <a href=\"javascript:void(0);\" class=\"" + searchResultsAddCartButtonStyles + " searchResults__buttons__cart\" data-action=\"addCartOnly\" data-rootProductCd=\"" + rootProductCd + "\" data-school=\"" + gakkoCd + "\"></a>\n      </div>\n    " : '';

    return "\n      <div class=\"" + searchResultsButtonsStyles + "\">\n        " + pamphletButton + "\n        " + cartButton + "\n      </div>\n    ";
  };

  /**
   * @description
   * 学校画像エリア（検索一覧）の HTML 文字列を生成します。
   *
   * - 学校のメイン画像（`gakkoPhoto`）と、特徴画像（`tokuchoPhotos` = 最大3件）をまとめて表示する領域の DOM を返します。
   * - `gakkoPhoto` は左側の専用スロットに 1枚表示し、`tokuchoPhotos` はその右側に **与えられた順序のまま** 並べます。
   * - 画像が1枚も存在しない場合は **空文字** を返します（何も描画しません）。
   *
   * @param {string | null | undefined} gakkoPhoto
   *   学校のメイン画像 URL。未指定／空文字／`null`／`undefined` のいずれかの場合は表示しません。
   *
   * @param {(string | null | undefined)[]} tokuchoPhotos
   *   特徴画像の URL 配列（最大3件想定）。
   *   falsy（`null`/`undefined`/空文字 など）は自動でスキップされます。
   *   **配列の順序は維持** され、その順序で右側に並びます。
   *
   * @returns {string}
   *   生成された画像表示エリアの HTML 文字列。
   *   `gakkoPhoto` と `tokuchoPhotos` の **どちらも有効な画像がない** 場合は空文字（`''`）を返します。
   */
  var createSchoolImageAreaHtml = function createSchoolImageAreaHtml(gakkoPhoto, tokuchoPhotos) {

    var schoolImages = [gakkoPhoto].concat(_toConsumableArray(tokuchoPhotos));

    if (schoolImages.every(function (schoolImage) {
      return !schoolImage;
    })) {
      return "";
    }

    var tokuchoHtml = '';
    tokuchoPhotos.filter(Boolean).forEach(function (item) {
      tokuchoHtml += "\n        <div>\n          <img\n            src=\"" + item + "\" alt=\"" + gakkoNm + "\" width=\"117\" height=\"80\"\n            class=\"" + searchResultsSchoolImageStyles + "\"\n          >\n        </div>\n      ";
    });

    var gakkoImageHtml = gakkoPhoto ? "\n      <div>\n        <img\n          src=\"" + gakkoPhoto + "\" alt=\"" + gakkoNm + "\" width=\"85\" height=\"58\"\n          class=\"" + searchResultsSchoolImageStyles + "\"\n        >\n      </div>\n    " : '';

    return "\n      <div class=\"" + searchResultsSchoolImageAreaStyles + "\">\n        <div class=\"" + searchResultsSchoolImageAreaContentsStyles + "\">\n          " + gakkoImageHtml + "\n          " + tokuchoHtml + "\n        </div>\n      </div>      \n    ";
  };

  var buttonAreaBlock = createButtonAreaHtml(isFlagTrue(pamphFlag), isFlagTrue(ikkatsuFlag));

  /**
   * お気に入り登録導線の場合 searchList.js からDOM修正を行っているため既存DOMクラスで定義
   */
  return "\n    <div>\n      <a href=\"" + linkUrl + "\" target=\"_blank\" class=\"" + searchResultsSchoolLinkStyles + " js-pr-clickLog\" data-pr-click-log=\"" + trace_p + "_PRcassette_click_" + order + "_" + gakkoCd + "\">\n        <div class=\"" + searchResultsInfoStyles + "\">\n          <div class=\"" + searchResultsInfoMainStyles + "\">\n            <div class=\"" + searchResultInfoFavoriteStyles + "\">\n              <h2 class=\"" + searchResultsInfoSchoolNameStyles + "\">" + gakkoNm + "</h2>\n              <button class=\"searchResults__item__favoriteButton js-favorite__click\" style=\"visibility: hidden;\">\n                <div class=\"searchResults__item__container js-favorite__container\">\n                  <img class=\"searchResults__item__favorite__heart js-favorite__heart js-favorite__clickheart js-isPr\" src=\"\" alt=\"お気に入り\" width=\"20\" height=\"18\" />\n                </div>\n              </button>\n            </div>\n            \n\n            <div class=\"" + searchResultsFeatureTagStyles + "\">\n              " + guideTokuchoHtml + "\n            </div>\n\n            <div class=\"" + searchResultsNyushiInfoStyles + "\">\n              <img class=\"" + searchResultsIconStyles + "\" src=\"/images/s/searchList_school_icon.svg\" alt=\"" + gakkoNm + "\" width=\"13\" height=\"13\">\n              <span class=\"" + searchResultsSchoolTypeStyles + "\">" + koshuNm + "／" + todofukenRnm + "</span>\n            </div>\n\n            " + createSchoolImageAreaHtml(gakkoPhoto, tokuchoPhotos) + "\n\n          </div>\n        </div>\n      </a>\n    </div>\n\n    <p class=\"" + searchResultsSchoolTextStyles + "\">" + gakkoHowKomidashi + "</p>\n    " + buttonAreaBlock + "\n  ";
};

exports.createUniversityBlock = createUniversityBlock;

/** CSS定義 */
var searchResultsSchoolLinkStyles = (0, _emotionCss.css)(_templateObject);

var searchResultsInfoStyles = (0, _emotionCss.css)(_templateObject2);

var searchResultsInfoMainStyles = (0, _emotionCss.css)(_templateObject3);

var searchResultsInfoSchoolNameStyles = (0, _emotionCss.css)(_templateObject4, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsFeatureTagStyles = (0, _emotionCss.css)(_templateObject5);

var searchResultsFeatureTagItemStyles = (0, _emotionCss.css)(_templateObject6, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsNyushiInfoStyles = (0, _emotionCss.css)(_templateObject7);

var searchResultsIconStyles = (0, _emotionCss.css)(_templateObject8);

var searchResultsSchoolTypeStyles = (0, _emotionCss.css)(_templateObject9, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsSchoolImageAreaStyles = (0, _emotionCss.css)(_templateObject10, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsSchoolImageAreaContentsStyles = (0, _emotionCss.css)(_templateObject11, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsSchoolImageStyles = (0, _emotionCss.css)(_templateObject12, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsSchoolTextStyles = (0, _emotionCss.css)(_templateObject13, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsButtonsStyles = (0, _emotionCss.css)(_templateObject14, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);
/**
 * @description only-child擬似クラスを使用し親要素の中で単一で残った場合Width調整
 */
var searchResultsButtonLeftStyles = (0, _emotionCss.css)(_templateObject15);

var searchResultsPamphletButtonStyles = (0, _emotionCss.css)(_templateObject16, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

/**
 * @description only-child擬似クラスを使用し親要素の中で単一で残った場合Width調整
 */
var searchResultsButtonRightStyles = (0, _emotionCss.css)(_templateObject17);

var searchResultsAddCartButtonStyles = (0, _emotionCss.css)(_templateObject18, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultInfoFavoriteStyles = (0, _emotionCss.css)(_templateObject19);

},{"../../../../../../../../modules/prAreaUtilities/_prAreaUtilities":64,"@emotion/css":7}],59:[function(require,module,exports){
// PR枠カセットコンポーネント群のimport
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _prAreaUtilities_prAreaUtilities = require('./prAreaUtilities/_prAreaUtilities');

var _componentsCassettesPcRecommendSchoolInfo_recommendSchoolInfo = require('../components/cassettes/pc/recommendSchoolInfo/_recommendSchoolInfo');

var _componentsCassettesPcConcernFieldEmpathyContents_concernFieldEmpathycontents = require('../components/cassettes/pc/concernFieldEmpathyContents/_concernFieldEmpathycontents');

var _componentsCassettesPcConcernFieldShinsetsu_concernFieldShinsetsu = require('../components/cassettes/pc/concernFieldShinsetsu/_concernFieldShinsetsu');

var _componentsCassettesResponsiveOpenCampusList_cassetteOpenCampusList = require('../components/cassettes/responsive/openCampusList/_cassetteOpenCampusList');

var _componentsCassettesResponsiveGakkoInfoList_cassetteGakkoInfoList = require('../components/cassettes/responsive/gakkoInfoList/_cassetteGakkoInfoList');

var _componentsCassettesResponsiveSearchIntegrationList_cassetteSearchIntegrationList = require('../components/cassettes/responsive/searchIntegrationList/_cassetteSearchIntegrationList');

var _modulesSearchListEvents_searchListEvents = require('./modules/searchListEvents/_searchListEvents');

/**
 * @description [27卒 PR枠追加] prArea関連クラス
 * @param {string} cassetteSelector - PR枠カセットDOM出力先のHTMLセレクタ名
 * @param {boolean} [isSp = false] - PC/SPで分かれている場合、SPであるかを明示する
 * @param {string} [tracePString = ''] - 画面ごとのID、読み込みタイミングの関係で未定義の場合に指定する
 */

var PrArea = (function () {
  function PrArea(_ref) {
    var cassetteSelector = _ref.cassetteSelector;
    var _ref$isSp = _ref.isSp;
    var isSp = _ref$isSp === undefined ? false : _ref$isSp;
    var _ref$tracePString = _ref.tracePString;
    var tracePString = _ref$tracePString === undefined ? '' : _ref$tracePString;

    _classCallCheck(this, PrArea);

    // 生成したPR枠カセットDOMを出力する要素取得
    this.cassetteSelector = cassetteSelector;

    // SP判定
    this.isSp = isSp;

    // pageId、(画面ごとにグローバルで設定される`trace_p`の値をそのまま使用する)
    this.pageId = tracePString !== '' ? tracePString : trace_p;

    // APIから取得した情報を格納
    this.cassetteData = [];

    // 複数PR枠判定
    this.prDivisionFlag = false;

    this.__init();
  }

  /**
   * @private
   * @description 初期処理
   */

  _createClass(PrArea, [{
    key: '__init',
    value: function __init() {
      var _this = this;

      this.__getPrArea(function () {
        // APIから取得したデータを元にPR枠カセットDOMを出力
        _this.__setCassetteDom();
      });

      // レイアウトシフト対策で決め打ちした、高さ設定用class `prAreaFirstView` を除却する
      window.addEventListener('load', function () {
        Array.prototype.forEach.call(document.getElementsByClassName('' + _this.cassetteSelector), function (targetElement) {
          targetElement.classList.remove('prAreaFirstView');
        });
      });
    }

    /**
     * @private
     * @param {function} callback - 非同期処理成功時のcallback
     * @description PR枠カセット表示 初期処理
     * path設定について
     * 本番 = '/smp/prFrame/getPrFrame'
     * Local = '/sp/smp/prFrame/getPrFrame/index.json'
     * デザイン = '/html/sp/smp/prFrame/getPrFrame'
    */
  }, {
    key: '__getPrArea',
    value: function __getPrArea(callback) {
      var _this2 = this;

      var URL = '/smp/prFrame/getPrFrame';

      var URLWithParams = URL + '?pageId=' + this.pageId;

      this.__getApiRequest(URLWithParams, function (data) {
        if (!data) return;

        _this2.result = data;
        _this2.prDivisionFlag = data.prDivisionFlag === "1" ? true : false;

        // PR枠カセット情報が取得できた場合のみcallback(画面描画処理を想定)を実行
        if (_this2.result.resultCode === 0) {
          callback();
          return;
        }
      });
    }

    /**
     * @private
     * @description PR枠カセット情報取得APIから、PR枠リストを取得
     * @param {string} url - PR枠カセット情報取得API パラメータを含める
     * @param {function} callBack - APIリクエスト正常終了時のCallback関数
     */
  }, {
    key: '__getApiRequest',
    value: function __getApiRequest(url, callBack) {
      var xhr = new XMLHttpRequest();
      var method = 'GET';

      xhr.open(method, url, true);
      xhr.onreadystatechange = function () {
        if (xhr.readyState === XMLHttpRequest.DONE) {
          var _status = xhr.status;

          if (_status === 0 || _status >= 200 && _status < 400) {
            callBack(JSON.parse(xhr.response));
          } else {
            console.error('Api Get Error');
          }
        }
      };
      xhr.send();
    }

    /**
     * @private
     * @description PR枠カセットDOMの生成・出力
     */
  }, {
    key: '__setCassetteDom',
    value: function __setCassetteDom() {
      // pageIdを元にDOMを出し分け作成する
      var cassetteDom = this.__createCassetteHtml(this.pageId, this.result, this.prDivisionFlag);

      // PR枠カセットDOMを取得できなかった場合は終了
      if (!cassetteDom) return;

      // 生成したバナーDOMを出力
      var targetElements = document.getElementsByClassName('' + this.cassetteSelector);

      Array.prototype.forEach.call(targetElements, function (targetElement, index) {
        if (cassetteDom[index]) {
          targetElement.insertAdjacentHTML('beforeend', cassetteDom[index]);
        }
      });

      // PR枠は非同期で読み込まれるため、漏れないように生成したDOMにイベントを付与しておく
      if (this.pageId === _prAreaUtilities_prAreaUtilities.PAGE_ID.S_LIST_F_ALL || this.pageId === _prAreaUtilities_prAreaUtilities.PAGE_ID.LIST_F_ALL) {
        (0, _modulesSearchListEvents_searchListEvents.searchListEvents)();
      };
    }
  }, {
    key: '__createCassetteHtml',

    /**
     * @private
     * @description 各種PR枠カセットHTMLの生成
     * @param {object} pageId - ページID(trace_p)
     * @param {object} data - カセットに描画するデータ情報(this.resultが渡される想定)
     * @param {boolean} prDivisionFlag - 1画面毎に複数PR枠があるかを判定
     * @returns {Array} - PR枠カセットHTML DOM配列
     */
    value: function __createCassetteHtml(pageId, data, prDivisionFlag) {
      var gakkoInfoList = data.gakkoInfoList;
      var empathyContentsList = data.empathyContentsList;
      var shinzosetsuList = data.shinzosetsuList;
      var openCampusList = data.openCampusList;
      var searchIntegrationList = data.searchIntegrationList;

      // PR枠カセットタイプに基づきHTMLを出し分けるう
      switch (pageId) {
        // 進路トップ・学問詳細
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.TOP01:
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.S_TOP01:
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.GKUSYO:
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.S_GKUSYO:
          return gakkoInfoList.length ? this.__adapterCreateCassets(_componentsCassettesPcRecommendSchoolInfo_recommendSchoolInfo.recommendSchoolInfo, gakkoInfoList, this.isSp, prDivisionFlag) : '';

        // 共感一覧
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.KYOKAN_TOP:
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.S_KYOKAN_TOP:
          return empathyContentsList.length ? this.__adapterCreateCassets(_componentsCassettesPcConcernFieldEmpathyContents_concernFieldEmpathycontents.concernFieldEmpathyContents, empathyContentsList, this.isSp, prDivisionFlag) : '';

        // 新増設一覧
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.NEW_F_LIST:
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.S_NEW_F_LIST:
          return shinzosetsuList.length ? this.__adapterCreateCassets(_componentsCassettesPcConcernFieldShinsetsu_concernFieldShinsetsu.concernFieldShinsetsu, shinzosetsuList, this.isSp, prDivisionFlag) : '';

        // OC検索一覧
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.OP_GAKKO:
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.S_OP_GAKKO:
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.OP_LIST:
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.S_OP_LIST:
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.OP_DAI:
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.S_OP_DAI:
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.OP_SEN:
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.S_OP_SEN:
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.OP_RYU:
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.S_OP_RYU:
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.OP_SCL:
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.S_OP_SCL:
          return openCampusList.length ? this.__adapterCreateCassets(_componentsCassettesResponsiveOpenCampusList_cassetteOpenCampusList.cassetteOpenCampusList, openCampusList, this.isSp, prDivisionFlag) : '';

        // 進路詳細(なるには)
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.SHISYO:
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.S_SHISYO:
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.QUOSYO:
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.S_QUOSYO:
          return gakkoInfoList.length ? this.__adapterCreateCassets(_componentsCassettesResponsiveGakkoInfoList_cassetteGakkoInfoList.cassetteGakkoInfoList, gakkoInfoList, this.isSp, prDivisionFlag) : '';

        // 学校検索一覧
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.LIST_F_ALL:
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.S_LIST_F_ALL:
          return searchIntegrationList.length ? this.__adapterCreateCassets(_componentsCassettesResponsiveSearchIntegrationList_cassetteSearchIntegrationList.cassetteSearchIntegrationList, searchIntegrationList, this.isSp, prDivisionFlag) : '';

        default:
          return '';
      }
    }

    /**
     * @private
     * @description 各種PR枠カセットHTMLの生成
     * @param {function} callback - カセット毎生成関数
     * @param {Array} cassetteList - カセット情報配列
     * @param {boolean} isSp - SP判定結果
     * @param {boolean} prDivisionFlag - 複数PR枠存在判定結果 Default = false
     * @returns {Array} - PR枠カセットHTML DOM配列化
     */
  }, {
    key: '__adapterCreateCassets',
    value: function __adapterCreateCassets(callback, cassetteList, isSp) {
      var prDivisionFlag = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];

      var resultCassetsArray = [];

      if (prDivisionFlag) {

        cassetteList.forEach(function (cassette) {
          resultCassetsArray.push(callback([cassette], isSp));
        });

        return resultCassetsArray;
      } else {
        resultCassetsArray.push(callback(cassetteList, isSp));

        return resultCassetsArray;
      }
    }
  }]);

  return PrArea;
})();

exports.PrArea = PrArea;
;

},{"../components/cassettes/pc/concernFieldEmpathyContents/_concernFieldEmpathycontents":44,"../components/cassettes/pc/concernFieldShinsetsu/_concernFieldShinsetsu":45,"../components/cassettes/pc/recommendSchoolInfo/_recommendSchoolInfo":46,"../components/cassettes/responsive/gakkoInfoList/_cassetteGakkoInfoList":47,"../components/cassettes/responsive/openCampusList/_cassetteOpenCampusList":48,"../components/cassettes/responsive/searchIntegrationList/_cassetteSearchIntegrationList":49,"./modules/searchListEvents/_searchListEvents":60,"./prAreaUtilities/_prAreaUtilities":64}],60:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _modulesAccordionSlideEvent_accordionSlideEventJs = require('./modules/accordionSlideEvent/_accordionSlideEvent.js');

var _modulesAddSwiperEvents_addSwiperEventsJs = require('./modules/addSwiperEvents/_addSwiperEvents.js');

var _modulesChangeItemOnClickTabEvent_changeItemOnClickTabEventJs = require('./modules/changeItemOnClickTabEvent/_changeItemOnClickTabEvent.js');

/**
 * 検索一覧画面用PR枠で生成されたDOMに付与するイベント群
 */
var searchListEvents = function searchListEvents() {
  (0, _modulesAddSwiperEvents_addSwiperEventsJs.addSwiperEvents)();
  (0, _modulesAccordionSlideEvent_accordionSlideEventJs.accordionSlideEvent)();
  (0, _modulesChangeItemOnClickTabEvent_changeItemOnClickTabEventJs.changeItemOnClickTabEvent)();
};

exports.searchListEvents = searchListEvents;

},{"./modules/accordionSlideEvent/_accordionSlideEvent.js":61,"./modules/addSwiperEvents/_addSwiperEvents.js":62,"./modules/changeItemOnClickTabEvent/_changeItemOnClickTabEvent.js":63}],61:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var accordionSlideEvent = function accordionSlideEvent() {
  return (0, _jquery2['default'])(function () {
    // 検索結果カセットアコーディオン開閉
    (0, _jquery2['default'])('[prarea-data-more-gakubugakka="trigger"]').on('click', function () {
      var logId = (0, _jquery2['default'])(this).attr('data-logId'),
          s2 = s_gi(s_account),
          $target = (0, _jquery2['default'])(this).closest('.prarea__searchResults__item').find('[prarea-data-more-gakubugakka="target"]');
      if ((0, _jquery2['default'])(this).hasClass('is-open')) {
        (0, _jquery2['default'])(this).removeClass('is-open');
        (0, _jquery2['default'])(this).text('もっと学部・学科・コースを見る');
        $target.slideUp(0, function () {});
        var $schoolCassette = (0, _jquery2['default'])(this).closest('.prarea__searchResults__item');
        (0, _jquery2['default'])('html,body').animate({
          scrollTop: $schoolCassette.offset().top
        }, 0);
      } else {
        s2.tl((0, _jquery2['default'])(this), 'o', logId);
        (0, _jquery2['default'])(this).addClass('is-open');
        (0, _jquery2['default'])(this).text('閉じる');
        $target.slideDown(function () {});
      }
    });

    // 検索結果カセット学部学科テキストを開く
    (0, _jquery2['default'])('[prarea-data-more-gakubugakka-text="trigger"]').on('click', function () {
      var $target = (0, _jquery2['default'])(this).next('[prarea-data-more-gakubugakka-text="target"]');

      $target.animate({
        width: 'show'
      }, 'slow');
      $target.children().unwrap();
      (0, _jquery2['default'])(this).remove();
    });

    //続きを見る押下で隠れている項目を表示
    (0, _jquery2['default'])('.js-prarea__searchResults__bunya__more-text').on('click', function () {
      (0, _jquery2['default'])(this).closest('.prarea__searchResults__bunya__text-container').find('.prarea__searchResults__bunya__text-hidden').slideToggle('fast');
      (0, _jquery2['default'])(this).toggleClass('is-open');
    });
  });
};

exports.accordionSlideEvent = accordionSlideEvent;

},{"jquery":30}],62:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _swiper = require('swiper');

var _swiper2 = _interopRequireDefault(_swiper);

var addSwiperEvents = function addSwiperEvents() {
  return (0, _jquery2['default'])(function () {
    // OC swiperの処理
    (0, _jquery2['default'])('.js-prSearchOc-swiper').each(function () {
      var swiperContainer = (0, _jquery2['default'])(this).find('.swiper-container');
      new _swiper2['default'](swiperContainer[0], {
        slidesPerView: 'auto',
        freeMode: true,
        loop: false,
        autoplay: false,
        pagination: {
          el: (0, _jquery2['default'])(this).find('.swiper-pagination'),
          dynamicBullets: true,
          dynamicMainBullets: 3
        },
        navigation: {
          nextEl: (0, _jquery2['default'])(this).find('.swiper-button-next'),
          prevEl: (0, _jquery2['default'])(this).find('.swiper-button-prev')
        }
      });
    });
  });
};

exports.addSwiperEvents = addSwiperEvents;

},{"jquery":30,"swiper":32}],63:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var changeItemOnClickTabEvent = function changeItemOnClickTabEvent() {
  return (0, _jquery2['default'])(function () {
    // 初期表示
    var $tab = (0, _jquery2['default'])('.searchResults__tabName');
    (0, _jquery2['default'])('.prarea__searchResults__content').hide();

    (0, _jquery2['default'])(window).on('load resize', function () {
      // sessionStorageに表示項目データがある時は、表示切替タブのis-activeを付け替える
      if ('sessionStorage' in window && window.sessionStorage !== null) {
        var val = sessionStorage.getItem('sss_searchPanelActiveTab');
        if (val !== null) {
          $tab.eq(val).trigger('click.notSendLog');
          // sessionStorageの表示項目データを削除
          sessionStorage.removeItem('sss_searchPanelActiveTab');
        }
      }
      // 選択項目配下の内容を表示
      $tab.each(function (_, obj) {
        if ((0, _jquery2['default'])(obj).hasClass('is-active')) {
          (0, _jquery2['default'])(obj).trigger('click.notSendLog');
        }
      });

      // 学部学科未購入のみの場合、項目表示切替タブを削除
      if (!(0, _jquery2['default'])('.prarea__searchResults__gakkaList').length) {
        (0, _jquery2['default'])('.prarea__searchResults__tabsWrap').remove();
      }
    });

    // タブで表示項目切り替え
    $tab.on('click.notSendLog', function (event) {

      var $this = (0, _jquery2['default'])(event.target),
          logId = $this.attr('data-logId'),
          s2 = s_gi(s_account);

      // クリックログ送信
      if (event.namespace !== 'notSendLog') {
        if (!$this.hasClass('is-active')) {
          s2.tl($this, 'o', logId);
        }
      }

      var index = $tab.index($this);
      $tab.removeClass('is-active');
      $this.addClass('is-active');

      (0, _jquery2['default'])('.prarea__searchResults__gakkaList > li').each(function (_, obj) {
        var value = obj.className.match('prarea__searchResults__gakkaItem');
        if (value) {
          (0, _jquery2['default'])(obj).find((0, _jquery2['default'])('.prarea__searchResults__content')).hide();
          (0, _jquery2['default'])(obj).find((0, _jquery2['default'])('.prarea__searchResults__content')).eq(index).show();
          // 検索軸以外の小分類ハイライトを削除
          if (index !== flagAxis) {
            (0, _jquery2['default'])(obj).find((0, _jquery2['default'])('.prarea__searchResults__content')).eq(index).find('.prarea__searchResults__word').removeClass('is-match');
          }
        }
      });

      // 「もっと学部・学科・コースを見る」配下の項目表示
      (0, _jquery2['default'])('.prarea__searchResults__gakkaList > li > ul > li').each(function (_, obj) {
        var value = obj.className.match('prarea__searchResults__gakkaItem');
        if (value) {
          (0, _jquery2['default'])(obj).find((0, _jquery2['default'])('.prarea__searchResults__content')).hide();
          (0, _jquery2['default'])(obj).find((0, _jquery2['default'])('.prarea__searchResults__content')).eq(index).show();
        }
      });

      event.preventDefault();
    });
  });
};

exports.changeItemOnClickTabEvent = changeItemOnClickTabEvent;

},{"jquery":30}],64:[function(require,module,exports){
/**
 * [27卒 PR枠追加] PR枠 定数・汎用関数管理用JS
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _const_mediaQuery = require("./const/_mediaQuery");

var _const_pageId = require("./const/_pageId");

var _modules_getDayOfWeekBackgroundColor = require("./modules/_getDayOfWeekBackgroundColor");

var _modules_getEmpathyContentsInfo = require("./modules/_getEmpathyContentsInfo");

var _modules_getMonthDayAndDayOfWeek = require("./modules/_getMonthDayAndDayOfWeek");

exports.getDayOfWeekBackgroundColor = _modules_getDayOfWeekBackgroundColor.getDayOfWeekBackgroundColor;
exports.
// TODO: 暫定でexportしているが、getEmpathyContentsInfoにまとめる予定
getEmpathyContentsBackgroundColor = _modules_getEmpathyContentsInfo.getEmpathyContentsBackgroundColor;
exports.getEmpathyContentsInfo = _modules_getEmpathyContentsInfo.getEmpathyContentsInfo;
exports.getMonthDayAndDayOfWeek = _modules_getMonthDayAndDayOfWeek.getMonthDayAndDayOfWeek;
exports.MediaQuery = _const_mediaQuery.MediaQuery;
exports.PAGE_ID = _const_pageId.PAGE_ID;

},{"./const/_mediaQuery":67,"./const/_pageId":68,"./modules/_getDayOfWeekBackgroundColor":69,"./modules/_getEmpathyContentsInfo":70,"./modules/_getMonthDayAndDayOfWeek":71}],65:[function(require,module,exports){
// OC一覧などで使用される、曜日ごと背景色
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var DAY_OF_WEEK_BACKGROUND_COLOR = {
  SATURDAY: '#61a2ed', // 土
  SUNDAY: '#de30ca', // 日
  DEFAULT: '#808d96' };

// 通常
exports.DAY_OF_WEEK_BACKGROUND_COLOR = DAY_OF_WEEK_BACKGROUND_COLOR;

},{}],66:[function(require,module,exports){
// 共感エリア用 ラベル背景色
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var EMPATHY_CONTENTS_BACKGROUND_COLOR = {
  LESSON: '#6036e0', // 授業
  SENSEI: '#199b7b', // 先生・教授
  CAMPUS: '#ff4b4b', // 在校生
  SENPAI: '#1565d9' // 卒業後
};

exports.EMPATHY_CONTENTS_BACKGROUND_COLOR = EMPATHY_CONTENTS_BACKGROUND_COLOR;

},{}],67:[function(require,module,exports){
// レスポンシブ対応画面用
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SP_SCREEN_WIDTH = 767;
var PC_SCREEN_WIDTH = 768;

var MediaQuery = {
  SP_SCREEN: "@media screen and (max-width: " + SP_SCREEN_WIDTH + "px)",
  PC_SCREEN: "@media screen and (min-width: " + PC_SCREEN_WIDTH + "px)"
};

exports.MediaQuery = MediaQuery;

/**
 * 【使用方法】
 * レスポンシブ対応が必要な画面のcss定義において、必要に応じて以下のように使用すると便利です。
 * ---------------------------
 * const sampleStyles = css`
*   height: 20px
*
*   ${MediaQuery.PC_SCREEN} {
*    font-size: 14px;
*    margin: 8px;
*   };
*
*   ${MediaQuery.SP_SCREEN} {
*    font-size: 12px;
*    margin: 4px;
*   };
* `;
* ---------------------------
* PC・SP両方でスタイルが当たる場合、記述時こそ手間はかかりますが、
* それぞれに記述することで、検証ツールでの確認の際に打ち消し線が現れなくなるため今後の確認が容易になります。
* 本ファイルからの import を忘れないように！
*
*/

},{}],68:[function(require,module,exports){
// 画面ID (画面htmlごとに定義しているグローバル変数`trace_p`の値)
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var PAGE_ID = {
  TOP01: 'Top01', // 進路トップ(PC)
  S_TOP01: 'STop01', // 進路トップ(SP)

  SHISYO: 'SHISYO', // 進路詳細(なるには)(PC)
  S_SHISYO: 'SShisyo', // 進路詳細(なるには)(SP)
  QUOSYO: 'QUOSYO', // 進路詳細（とるには）(PC)
  S_QUOSYO: 'SQuosyo', // 進路詳細（とるには）(SP)

  LIST_F_ALL: 'list_f_All', // 学校検索一覧(PC)
  S_LIST_F_ALL: 'Slist_f_All', // 学校検索一覧(SP)

  OP_GAKKO: 'OpGakko', // OC検索一覧　見学会_検索結果（エリア）見学会_検索結果（学校名）(PC)
  S_OP_GAKKO: 'SOpGakko', // OC検索一覧　見学会_検索結果（エリア）見学会_検索結果（学校名）(SP)
  OP_LIST: 'Oplist', // 見学会_検索結果(月,日)(PC)
  S_OP_LIST: 'SOplist', // 見学会_検索結果(月,日)(SP)
  OP_DAI: 'OpDai', // 見学会_検索結果（大短）(PC)
  S_OP_DAI: 'SOpDai', // 見学会_検索結果（大短）(SP)
  OP_SEN: 'OpSen', // 見学会_検索結果（専各）(PC)
  S_OP_SEN: 'SOpSen', // 見学会_検索結果（専各）(SP)
  OP_RYU: 'OpRyu', // 見学会_検索結果（留学）(PC)
  S_OP_RYU: 'SOpRyu', // 見学会_検索結果（留学）(SP)
  OP_SCL: 'OpScl', // 見学会_検索結果（その他教育機関）(PC)
  S_OP_SCL: 'SOpScl', // 見学会_検索結果（その他教育機関）(SP)

  NEW_F_LIST: 'Newflist', // 新増設一覧(PC)
  S_NEW_F_LIST: 'Snewflist', // 新増設一覧(SP)

  KYOKAN_TOP: 'KyokanTop', // 共感一覧(PC)
  S_KYOKAN_TOP: 'SKyokanTop', // 共感一覧(SP)

  GKUSYO: 'GKUSYO', // 学問詳細(PC)
  S_GKUSYO: 'Sgkusyo' };

// 学問詳細(SP)
exports.PAGE_ID = PAGE_ID;

},{}],69:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _const_dayOfWeekBackgroundColor = require("../const/_dayOfWeekBackgroundColor");

/**
 * @description OC一覧PR枠用 開催日の曜日に付与する背景色を取得する関数
 * @param {string} dayOfWeek - 曜日文字列(短縮系)
 * @return {string} 曜日に応じた背景色文字列
 */
var getDayOfWeekBackgroundColor = function getDayOfWeekBackgroundColor(dayOfWeek) {
  switch (dayOfWeek) {
    case '土':
      return _const_dayOfWeekBackgroundColor.DAY_OF_WEEK_BACKGROUND_COLOR.SATURDAY;
    case '日':
      return _const_dayOfWeekBackgroundColor.DAY_OF_WEEK_BACKGROUND_COLOR.SUNDAY;
    default:
      return _const_dayOfWeekBackgroundColor.DAY_OF_WEEK_BACKGROUND_COLOR.DEFAULT;
  }
};

exports.getDayOfWeekBackgroundColor = getDayOfWeekBackgroundColor;

},{"../const/_dayOfWeekBackgroundColor":65}],70:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _const_empathyContentsBackgroundColor = require("../const/_empathyContentsBackgroundColor");

/**
 * @description 共感一覧用PR枠コンテンツの表示に必要な情報を、企業タイプごとに出しわけてまとめて返却する関数
 * @param {string} kyokan_type - `planningType`とも。企業タイプ
 * @return {object} 背景色、対応URL文字列、コンテンツ文字列などのオブジェクト
 */
var getEmpathyContentsInfo = function getEmpathyContentsInfo(kyokan_type) {
  return {
    "empathyBackgroundColor": getEmpathyContentsBackgroundColor(kyokan_type),
    "empathyContentUrlString": getContentTypeUrlString(kyokan_type),
    "empathyContentString": getContentString(kyokan_type)
  };
};

// TODO: response値準拠の実装に変える。
// 共感一覧画面のresponse値が定まっていないため併記している。
var getEmpathyContentsBackgroundColor = function getEmpathyContentsBackgroundColor(kyokan_type) {
  switch (kyokan_type) {
    case '1':
    case '在校生':
      return _const_empathyContentsBackgroundColor.EMPATHY_CONTENTS_BACKGROUND_COLOR.CAMPUS;
    case '2':
    case '先生・教授':
      return _const_empathyContentsBackgroundColor.EMPATHY_CONTENTS_BACKGROUND_COLOR.SENSEI;
    case '3':
    case '卒業後':
      return _const_empathyContentsBackgroundColor.EMPATHY_CONTENTS_BACKGROUND_COLOR.SENPAI;
    case '4':
    case '授業':
      return _const_empathyContentsBackgroundColor.EMPATHY_CONTENTS_BACKGROUND_COLOR.LESSON;
    default:
      return '#fff';
  }
};

var getContentTypeUrlString = function getContentTypeUrlString(kyokan_type) {
  switch (kyokan_type) {
    case '1':
      // 在校生
      return 'campusLife';
    case '2':
      // 先生・教授
      return 'sensei';
    case '3':
      // 卒業生（先輩の仕事）
      return 'senpaiShigoto';
    case '4': // 授業
    default:
      return 'kokishin';
  };
};

var getContentString = function getContentString(kyokan_type) {
  switch (kyokan_type) {
    case '1':
      return '在校生';
    case '2':
      return '先生・教授';
    case '3':
      return '卒業生';
    case '4':
      return '授業';
    default:
      return '';
  };
};

// getEmpathyContentsBackgroundColor はAPIレスポンスの形式がfixし次第 exportから外す予定( getEmpathyContentsInfo に統合する )
exports.getEmpathyContentsInfo = getEmpathyContentsInfo;
exports.getEmpathyContentsBackgroundColor = getEmpathyContentsBackgroundColor;

},{"../const/_empathyContentsBackgroundColor":66}],71:[function(require,module,exports){
/**
 * @description `yymmdd` 形式の文字列 (例: 250331) から、日付と曜日を返却する
 * @param {string} dateString - 日付文字列
 * @return {object} 日付と曜日のオブジェクト
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var getMonthDayAndDayOfWeek = function getMonthDayAndDayOfWeek(dateString) {

  var year = dateString.substring(0, 4);
  var month = parseInt(dateString.substring(4, 6), 10);
  var day = parseInt(dateString.substring(6, 8), 10);

  var dateObject = new Date(Date.UTC(year, month - 1, day, 0, 0, 0));
  var monthDayString = month + '/' + day;

  var options = {
    weekday: 'short',
    timeZone: 'Asia/Tokyo'
  };

  var dayOfWeek = dateObject.toLocaleDateString('ja-JP', options);

  return {
    monthDay: monthDayString,
    dayOfWeek: dayOfWeek
  };
};

exports.getMonthDayAndDayOfWeek = getMonthDayAndDayOfWeek;

},{}],72:[function(require,module,exports){
'use strict';

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _swiper = require('swiper');

var _swiper2 = _interopRequireDefault(_swiper);

// 27卒対応 PR追加

var _componentPrAreaModules_prArea = require('./component/prArea/modules/_prArea');

var _component_sendCustomScrollLog = require('./component/_sendCustomScrollLog');

var _component_sendClickLog = require('./component/_sendClickLog');

var $ = require('jquery');
require('trunk8');
var ConvertDate = require('./common/ConvertDate');
var ResizeImageFill = require('./common/ResizeImageFill');
var StoriesManager = require('./common/StoriesManager');
var OcCameraThumbnail = require('./common/OcCameraThumbnail');
var ClickLog = require('./common/ClickLog');

var OC_CAMERA_MOVIE_THUMB_SET_CAROUSEL_SELECTOR = '.js-ocCameraMovieThumbSetCarousel';
var OC_CAMERA_MOVIE_THUMB_SET_CAROUSEL_CONFIG = {
	slidesPerView: 4,
	spaceBetween: 20,
	slidesPerGroup: 4,
	followFinger: false,
	allowTouchMove: false,
	navigation: {
		// 次へボタンのセレクタ
		nextEl: '.js-ocCameraMovieThumbSetCarouselNext',
		// 前へボタンのセレクタ
		prevEl: '.js-ocCameraMovieThumbSetCarouselPrev',
		// 非活性クラス名
		disabledClass: 'is-disabled'
	}
};

var FILL_ASPECT_RATIO = {
	X: 3,
	Y: 2
};

// OCストーリーズのプロフィール画像サイズ設定
var STORIESPROFILE_FILL_IMAGE_SELECTOR = '.js-resizeImageFillStoriesProfile';
var STORIESPROFILE_FILL_ASPECT_RATIO = {
	X: 1,
	Y: 1
};

var CLICK_LOG_CLASS = '.js-AdobeAnalyticsClickLog';
var CLICK_LOG_DATA_NAME = 'click-log';

$(function () {
	new _swiper2['default'](OC_CAMERA_MOVIE_THUMB_SET_CAROUSEL_SELECTOR, OC_CAMERA_MOVIE_THUMB_SET_CAROUSEL_CONFIG);
	new ConvertDate();
	new ResizeImageFill(FILL_ASPECT_RATIO.X, FILL_ASPECT_RATIO.Y);
	new ResizeImageFill(STORIESPROFILE_FILL_ASPECT_RATIO.X, STORIESPROFILE_FILL_ASPECT_RATIO.Y, STORIESPROFILE_FILL_IMAGE_SELECTOR);
	var StoriesManagerInstance = new StoriesManager();
	new OcCameraThumbnail(StoriesManagerInstance);

	window.onload = function () {
		// OC動線
		$('.js-oc-swiper').each(function () {
			var swiperContainer = $(this).find('.swiper-container');
			new _swiper2['default'](swiperContainer[0], {
				slidesPerView: 'auto',
				freeMode: true,
				loop: false,
				autoplay: false,
				pagination: {
					el: $(this).find('.swiper-pagination'),
					dynamicBullets: true,
					dynamicMainBullets: 1
				},
				navigation: {
					nextEl: $(this).find('.swiper-button-next'),
					prevEl: $(this).find('.swiper-button-prev')
				}
			});
		});
	};

	window.addEventListener('DOMContentLoaded', function () {
		var targetCassetteSelector = 'js-targetPrArea';

		new _componentPrAreaModules_prArea.PrArea({ cassetteSelector: targetCassetteSelector });

		(0, _component_sendCustomScrollLog.observeSettingLog)(targetCassetteSelector);
	});

	// _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
	// 検索パネル ここから
	// _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/

	// パラメータをformに追加
	var appendParam = function appendParam($target, name, val) {
		$target.append('<input type="hidden" name="' + name + '" value="' + val + '">');
	},
	   
	// コードに対応する名称を取得する
	getName = function getName(key, value) {
		return $('[data-name-' + key + '="' + value + '"]').eq(0).text();
	},
	   
	// 路線パネル条件設定ボタン押下時
	setRailwayParams = function setRailwayParams($btn, $form) {
		var $parent = $btn.closest('[data-railway-area]'),
		    areaCd = $parent.attr('data-railway-area'),
		    checkFlag = false;

		// 前回の選択状態、及び地域パネルの条件をクリアする
		$form.find('input[name="area"], input[name="arkc"], input[name="rwc"], input[name="rwsc"], input[name="tdfk"], input[name="sklc"]').each(function () {
			$(this).remove();
		});

		// 市区郡パネルのチェックボックスをOFF
		$('#panelShikugun').find('input[type="checkbox"]').prop('checked', false);

		$parent.find('input[name="arkc"]').each(function () {
			// 上位の「すべて」チェックボックスが選択されている場合は配下のチェック状態は送信しない
			if ($(this).prop('checked')) {
				appendParam($form, 'arkc', $(this).val());
				checkFlag = true;
			} else {
				$(this).closest('[data-arkc-parent="target"]').find('input[name="rwc"]').each(function () {
					if ($(this).prop('checked')) {
						appendParam($form, 'rwc', $(this).val());
						checkFlag = true;
					} else {
						$(this).closest('[data-railway-parent="target"]').find('input[name="rwsc"]').each(function () {
							if ($(this).prop('checked')) {
								appendParam($form, 'rwsc', $(this).val());
								checkFlag = true;
							}
						});
					}
				});
			}
		});

		if (!checkFlag && areaCd) {
			// 1つもチェックが入っていない場合のみエリアを付与する
			appendParam($form, 'area', areaCd);
		}

		// エリア判別フラグを設定
		$form.find('#af').val('1');
	},
	   
	// 市区郡パネル条件設定ボタン押下時
	setShikugunParams = function setShikugunParams($form) {
		var $parent = $('#panelShikugun');

		// 前回の選択状態、及び路線パネルの条件をクリアする
		$form.find('input[name="area"], input[name="tdfk"], input[name="sklc"], input[name="arkc"], input[name="rwc"], input[name="rwsc"]').each(function () {
			$(this).remove();
		});

		// 路線パネルのチェックボックスをOFF
		$('[id^=panelRailway]').find('input[type="checkbox"]').prop('checked', false);

		// すべてがチェックされていない場合のみ配下のチェック状態を確認する
		if (!$parent.find('input[name="allShikugun"]').prop('checked')) {
			$parent.find('input[name="area"]').each(function () {
				// 上位の「すべて」チェックボックスが選択されている場合は配下のチェック状態は送信しない
				if ($(this).prop('checked')) {
					appendParam($form, 'area', $(this).val());
				} else {
					$(this).closest('[data-area-parent="target"]').find('input[name="tdfk"]').each(function () {
						if ($(this).prop('checked')) {
							appendParam($form, 'tdfk', $(this).val());
						} else {
							$(this).closest('[data-todofuken-parent="target"]').find('input[name="sklc"]').each(function () {
								if ($(this).prop('checked')) {
									appendParam($form, 'sklc', $(this).val());
								}
							});
						}
					});
				}
			});

			// エリア判別フラグを設定
			$form.find('#af').val('2');
		}
	},
	   
	// 設定されているパラメータの名称を取得し、ラベルに設定する
	setLabelText = function setLabelText($form) {
		var koshuLabel = '',
		    areaParams = [],
		    summaryParams = [];

		// 校種
		if ($('#koshuM0').val() !== '' || $('#koshuM1').val() !== '') {
			var koshuM0 = $('#koshuM0').val(),
			    koshuM1 = $('#koshuM1').val();

			if ((koshuM0 === '13' || koshuM0 === '14') && (koshuM1 === '13' || koshuM1 === '14')) {
				// 短大すべて
				koshuLabel = getName('koshuM', 'tandai');
			} else {
				koshuLabel = getName('koshuM', koshuM0);
			}
		} else if ($('#koshuCategoryLCd').val() !== '') {
			koshuLabel = getName('koshuCategoryLCd', $('#koshuCategoryLCd').val());
		} else {
			koshuLabel = 'すべて';
		}
		if (!koshuLabel.length) koshuLabel = 'すべて'; // ダミー表示用のロジック

		// エリア・路線
		if ($('#af').val() === '1') {
			$form.find('input[name="area"]').each(function () {
				areaParams.push(getName('area', $(this).val()));
			});

			$form.find('input[name="arkc"]').each(function () {
				areaParams.push(getName('arkc', $(this).val()));
			});

			$form.find('input[name="rwc"]').each(function () {
				areaParams.push(getName('rwc', $(this).val()));
			});

			$form.find('input[name="rwsc"]').each(function () {
				areaParams.push(getName('rwsc', $(this).val()));
			});
		} else if ($('#af').val() === '2') {
			$form.find('input[name="area"]').each(function () {
				areaParams.push(getName('area', $(this).val()));
			});

			$form.find('input[name="tdfk"]').each(function () {
				areaParams.push(getName('tdfk', $(this).val()));
			});

			$form.find('input[name="sklc"]').each(function () {
				areaParams.push(getName('sklc', $(this).val()));
			});
		}

		// 詳細パネルのセルのテキストを設定
		$('[data-label="koshu"]').text(koshuLabel);
		$('[data-label="area"]').text(areaParams.length ? areaParams.join('、') : 'すべて');

		// リセットボタン上の選択中の条件テキストを設定
		summaryParams.push(koshuLabel === 'すべて' ? '校種すべて' : koshuLabel);
		Array.prototype.push.apply(summaryParams, !areaParams.length ? ['エリア・路線すべて'] : areaParams);

		$('[data-label="summary"]').text(summaryParams.join(' | '));
	},
	   
	// 選択中パラメータをDOM上に設定する
	setSelectedParams = function setSelectedParams($form) {
		// 選択中ラベルを付与
		var addLabel = function addLabel(key, value) {
			$('[data-name-' + key + ']').closest('li').removeClass('is-selected');
			$('[data-name-' + key + '="' + value + '"]').closest('li').addClass('is-selected');
		},
		   
		// 全ての選択状態をリセット
		resetSelected = function resetSelected() {
			$('.searchPanel__modal').find('li').removeClass('is-selected').find('input[type="checkbox"]').prop('checked', false);
		};

		// 選択状態をリセット
		resetSelected();

		// 仕事
		if ($('#keitoCd').val() !== '') {
			addLabel('keitoCd', $('#keitoCd').val());
			addLabel('shigotoCategoryCd', $('#shigotoCategoryCd').val());
			addLabel('shigotoCd', $('#shigotoCd').val());
			addLabel('bunnya', 'shigoto');
		}

		// 学問
		if ($('#shikoCd').val() !== '') {
			addLabel('shikoCd', $('#shikoCd').val());
			addLabel('gakumonCd', $('#gakumonCd').val());
			addLabel('bunnya', 'gakumon');
		}

		// 校種
		if ($('#koshuM0').val() !== '' || $('#koshuM1').val() !== '') {
			var koshuM0 = $('#koshuM0').val(),
			    koshuM1 = $('#koshuM1').val();

			if ((koshuM0 === '13' || koshuM0 === '14') && (koshuM1 === '13' || koshuM1 === '14')) {
				// 短大すべて
				addLabel('koshuM', 'tandai');
			} else {
				addLabel('koshuM', koshuM0);
			}
			addLabel('koshuCategoryLCd', '');
		} else if ($('#koshuCategoryLCd').val() !== '') {
			addLabel('koshuCategoryLCd', $('#koshuCategoryLCd').val());
			addLabel('koshuM', '');
		}

		// エリア・路線
		addLabel('af', $('#af').val());
		// 選択状態をリセット
		addLabel('railway_area', '');
		addLabel('arkc', '');
		addLabel('rwc', '');
		addLabel('rwsc', '');
		addLabel('area', '');
		addLabel('tdfk', '');
		addLabel('sklc', '');

		if ($('#af').val() === '1') {
			// 路線パネルのチェックボックスON & ラベル付与
			// エリア
			$form.find('input[name="area"]').each(function () {
				addLabel('railway_area', $(this).val());

				// エリアが指定されている場合は配下すべて選択状態
				$('[data-railway-area=' + $(this).val() + ']').find('input[name="arkc"], input[name="rwc"], input[name="rwsc"]').prop('checked', true).closest('li').addClass('is-selected');

				$('[data-railway-area=' + $(this).val() + ']').find('[data-railway-parent="target"]').prev('li').addClass('is-selected');
			});
			// 路線区分
			$form.find('input[name="arkc"]').each(function () {
				var $target = $('input[type="checkbox"][name="arkc"][value=' + $(this).val() + ']'),
				    areaCd = $target.closest('[data-railway-area]').attr('data-railway-area');

				addLabel('railway_area', areaCd);

				$target.closest('[data-arkc-parent="target"]').find('input[name="arkc"], input[name="rwc"], input[name="rwsc"]').prop('checked', true).closest('li').addClass('is-selected');

				$target.closest('[data-arkc-parent="target"]').find('[data-railway-parent="target"]').prev('li').addClass('is-selected');
			});
			// 路線
			$form.find('input[name="rwc"]').each(function () {
				var $target = $('input[type="checkbox"][name="rwc"][value=' + $(this).val() + ']'),
				    areaCd = $target.closest('[data-railway-area]').attr('data-railway-area');

				addLabel('railway_area', areaCd);

				$target.closest('[data-railway-parent="target"]').find('input[name="rwc"], input[name="rwsc"]').prop('checked', true).closest('li').addClass('is-selected');

				$target.closest('[data-railway-parent="target"]').prev('li').addClass('is-selected');
			});
			// 駅
			$form.find('input[name="rwsc"]').each(function () {
				var $target = $('input[type="checkbox"][name="rwsc"][value=' + $(this).val() + ']'),
				    areaCd = $target.closest('[data-railway-area]').attr('data-railway-area');

				addLabel('railway_area', areaCd);

				$target.prop('checked', true).closest('li').addClass('is-selected');

				$target.closest('[data-railway-parent="target"]').prev('li').addClass('is-selected');
			});
		} else if ($('#af').val() === '2') {
			// 市区郡パネルのチェックボックスON & ラベル付与
			// エリア
			$form.find('input[name="area"]').each(function () {
				var $target = $('input[type="checkbox"][name="area"][value=' + $(this).val() + ']');

				$target.closest('[data-area-parent="target"]').find('input[name="area"], input[name="tdfk"], input[name="sklc"]').prop('checked', true).closest('li').addClass('is-selected');

				$target.closest('[data-area-parent="target"]').prev('li').addClass('is-selected');

				$target.closest('[data-area-parent="target"]').find('[data-todofuken-parent="target"]').prev('li').addClass('is-selected');
			});
			// 都道府県
			$form.find('input[name="tdfk"]').each(function () {
				var $target = $('input[type="checkbox"][name="tdfk"][value=' + $(this).val() + ']');

				$target.closest('[data-todofuken-parent="target"]').find('input[name="tdfk"], input[name="sklc"]').prop('checked', true).closest('li').addClass('is-selected');

				$target.closest('[data-area-parent="target"]').prev('li').addClass('is-selected');

				$target.closest('[data-todofuken-parent="target"]').prev('li').addClass('is-selected');
			});
			// 市区郡大分類
			$form.find('input[name="sklc"]').each(function () {
				var $target = $('input[type="checkbox"][name="sklc"][value=' + $(this).val() + ']');

				$target.prop('checked', true).closest('li').addClass('is-selected');

				$target.closest('[data-area-parent="target"]').prev('li').addClass('is-selected');

				$target.closest('[data-todofuken-parent="target"]').prev('li').addClass('is-selected');
			});
		}
	},
	   
	//詳細パネル条件リセット
	doResetDetail = function doResetDetail($form) {
		$form.find('input[name="area"], input[name="arkc"], input[name="rwc"], input[name="rwsc"], input[name="tdfk"], input[name="sklc"]').each(function () {
			$(this).remove();
		});
		$('#koshuCategoryLCd').val('');
		$('#koshuM0').val('');
		$('#koshuM1').val('');
		$('#af').val('');
	};

	// 検索パネルの地域／路線アコーディオン開閉
	$('[data-toggle-trigger]').on('click', function () {
		var targetCd = $(this).attr('data-toggle-trigger'),
		    $target = $(this).closest('.searchPanel__content').find('[data-toggle-target="' + targetCd + '"]'),
		    $trigger = $(this).closest('.searchPanel__layeredItem');

		if ($trigger.hasClass('is-open')) {
			$trigger.removeClass('is-open');
			$target.slideUp();
		} else {
			$trigger.addClass('is-open');
			$target.slideDown();
		}
	});

	// 検索パネル汎用アコーディオン開閉
	$('[data-toggle="trigger"]').on('click', function () {
		var $target = $(this).closest('.js-toggle-parent').find('[data-toggle="target"]');
		if ($(this).hasClass('is-open')) {
			$(this).removeClass('is-open');
			$target.slideUp();
		} else {
			$(this).addClass('is-open');
			$target.slideDown();
		}
	});

	// 路線タブ選択
	$('[data-railway-tab-trigger]').on('click', function () {
		var triggerCd = $(this).attr('data-railway-tab-trigger');

		// タブのアクティブ/非アクティブを切り替え
		$(this).closest('.searchPanel__railwayTabs__list').find('.searchPanel__railwayTabs__item').each(function () {

			$(this).removeClass('is-active');
		});

		$(this).closest('.searchPanel__railwayTabs__item').addClass('is-active');

		// パネル表示を切り替え
		$(this).closest('.searchPanel__content').find('[data-railway-tab-target]').each(function () {
			var targetCd = $(this).attr('data-railway-tab-target');

			if (targetCd === triggerCd) {
				$(this).show();
			} else {
				$(this).hide();
			}
		});
	});

	// 検索パネルの条件設定処理
	$('[data-set-condition]').on('click', function () {
		var execType = $(this).attr('data-set-condition'),
		    $form = $('#openCampusForm');

		if (execType === 'railway') {
			// 路線パネル
			setRailwayParams($(this), $form);
		} else if (execType === 'shikugun') {
			// 市区郡パネル
			setShikugunParams($form);
		} else if (execType === 'reset') {
			// 検索条件リセット
			doResetDetail($form);
		} else if (execType === 'resetBack') {
			doReset();
		}

		// ラベルを設定
		setLabelText($form);

		// 選択された検索条件をパネルに反映する
		setSelectedParams($form);
	});

	// 路線パネルのチェック制御
	// 路線区分すべてチェックボックスクリック処理
	$('input[name="arkc"]').on('click', function () {
		var checkFlag = $(this).prop('checked'),
		    $parent = $(this).closest('[data-arkc-parent="target"]');

		if ($parent && $parent.length) {
			$parent.find('input[name="rwc"], input[name="rwsc"]').prop('checked', checkFlag);
		}
	});

	// 路線チェックボックスクリック処理
	$('input[name="rwc"]').on('click', function () {
		var checkFlag = $(this).prop('checked'),
		    $parent = $(this).closest('[data-arkc-parent="target"]'),
		    $railwayParent = $(this).closest('[data-railway-parent="target"]');

		if ($railwayParent && $railwayParent.length) {
			$railwayParent.find('input[name="rwsc"]').prop('checked', checkFlag);

			// チェックボックス連動
			var allCheckFlag = $parent.find('input[name="rwc"]:checked').length === $parent.find('input[name="rwc"]:enabled').length && $parent.find('input[name="rwsc"]:checked').length === $parent.find('input[name="rwsc"]:enabled').length;

			$parent.find('input[name="arkc"]:enabled').prop('checked', allCheckFlag);
		}
	});

	// 駅チェックボックスクリック処理
	$('input[name="rwsc"]').on('click', function () {
		var $parent = $(this).closest('[data-arkc-parent="target"]'),
		    $railwayParent = $(this).closest('[data-railway-parent="target"]');

		if ($railwayParent && $railwayParent.length) {
			// チェックボックス連動
			var railwayCheckFlag = $railwayParent.find('.item-station:not(.is-disabled) input[name="rwsc"]:checked').length === $railwayParent.find('.item-station:not(.is-disabled)').length - 1;
			$railwayParent.find('input[name="rwc"]').prop('checked', railwayCheckFlag);
			if (railwayCheckFlag) {
				$railwayParent.find('.item-station.is-disabled input[name="rwsc"]').prop('checked', true);
			}

			var allCheckFlag = $parent.find('input[name="rwc"]:checked').length === $parent.find('input[name="rwc"]:enabled').length && $parent.find('input[name="rwsc"]:checked').length === $parent.find('input[name="rwsc"]:enabled').length;

			$parent.find('input[name="arkc"]:enabled').prop('checked', allCheckFlag);
		}
	});

	// 市区郡パネルのチェック制御
	// すべてチェックボックスクリック処理
	$('input[name="allShikugun"]').on('click', function () {
		var checkFlag = $(this).prop('checked'),
		    $parent = $(this).closest('[data-all-parent="target"]');

		if ($parent && $parent.length) {
			$parent.find('input[name="area"]:enabled, input[name="tdfk"]:enabled, input[name="sklc"]:enabled').prop('checked', checkFlag);
		}
	});

	// 版チェックボックスクリック処理
	$('input[name="area"]').on('click', function () {
		var checkFlag = $(this).prop('checked'),
		    $parent = $(this).closest('[data-all-parent="target"]'),
		    $areaParent = $(this).closest('[data-area-parent="target"]');

		if ($areaParent && $areaParent.length) {
			$areaParent.find('input[name="tdfk"]:enabled, input[name="sklc"]:enabled').prop('checked', checkFlag);

			// チェックボックス連動
			var allCheckFlag = $parent.find('input[name="area"]:checked').length === $parent.find('input[name="area"]:enabled').length;

			$parent.find('input[name="allShikugun"]:enabled').prop('checked', allCheckFlag);
		}
	});

	// 都道府県チェックボックスクリック処理
	$('input[name="tdfk"]').on('click', function () {
		var checkFlag = $(this).prop('checked'),
		    $parent = $(this).closest('[data-all-parent="target"]'),
		    $areaParent = $(this).closest('[data-area-parent="target"]'),
		    $todofukenParent = $(this).closest('[data-todofuken-parent="target"]');

		if ($todofukenParent && $todofukenParent.length) {
			$todofukenParent.find('input[name="sklc"]:enabled, input[name="skc"]:enabled').prop('checked', checkFlag);

			// チェックボックス連動
			var areaCheckFlag = $areaParent.find('input[name="tdfk"]:checked').length === $areaParent.find('input[name="tdfk"]:enabled').length && $areaParent.find('input[name="sklc"]:checked').length === $areaParent.find('input[name="sklc"]:enabled').length;

			$areaParent.find('input[name="area"]:enabled').prop('checked', areaCheckFlag);

			var allCheckFlag = $parent.find('input[name="area"]:checked').length === $parent.find('input[name="area"]:enabled').length && $parent.find('input[name="tdfk"]:checked').length === $parent.find('input[name="tdfk"]:enabled').length && $parent.find('input[name="sklc"]:checked').length === $parent.find('input[name="sklc"]:enabled').length;

			$parent.find('input[name="allShikugun"]:enabled').prop('checked', allCheckFlag);
		}
	});

	// 市区郡大分類チェックボックスクリック処理
	$('input[name="sklc"]').on('click', function () {
		var $parent = $(this).closest('[data-all-parent="target"]'),
		    $areaParent = $(this).closest('[data-area-parent="target"]'),
		    $todofukenParent = $(this).closest('[data-todofuken-parent="target"]');

		if ($todofukenParent && $todofukenParent.length) {
			// チェックボックス連動
			var todofukenCheckFlag = $todofukenParent.find('input[name="sklc"]:checked').length === $todofukenParent.find('input[name="sklc"]:enabled').length;

			$todofukenParent.find('input[name="tdfk"]:enabled').prop('checked', todofukenCheckFlag);

			var areaCheckFlag = $areaParent.find('input[name="tdfk"]:checked').length === $areaParent.find('input[name="tdfk"]:enabled').length && $areaParent.find('input[name="sklc"]:checked').length === $areaParent.find('input[name="sklc"]:enabled').length;

			$areaParent.find('input[name="area"]:enabled').prop('checked', areaCheckFlag);

			var allCheckFlag = $parent.find('input[name="area"]:checked').length === $parent.find('input[name="area"]:enabled').length && $parent.find('input[name="tdfk"]:checked').length === $parent.find('input[name="tdfk"]:enabled').length && $parent.find('input[name="sklc"]:checked').length === $parent.find('input[name="sklc"]:enabled').length;

			$parent.find('input[name="allShikugun"]:enabled').prop('checked', allCheckFlag);
		}
	});
	//続きを見る押下で隠れている項目を表示
	$('.js-searchResults__bunya__more-text').on('click', function () {
		$(this).closest('.searchResults__bunya__text-container').find('.searchResults__bunya__text-hidden').slideToggle('fast');
		$(this).toggleClass('is-open');
	});

	// 初期状態のラベルを設定
	setLabelText($('#openCampusForm'));

	// 初期状態の検索条件をパネルに反映する
	setSelectedParams($('#openCampusForm'));

	ClickLog();

	// AdobeAnalytics click log
	if (window.s) {
		$(CLICK_LOG_CLASS).on('click', function (event) {
			window.s.tl(event.currentTarget, 'o', $(event.currentTarget).data(CLICK_LOG_DATA_NAME));
		});
	}

	// 条件モーダル（webapp/js/s/slide.jsから移植の上変更）
	var winWidth = window.innerWidth;
	var modalFlag = false;

	window.addEventListener('resize', function () {
		winWidth = window.innerWidth;
		if (winWidth > 767) {
			$('#sindex').css('left', 0 + 'px').addClass('active');
		} else if (modalFlag) {
			$('#sindex').css('left', winWidth * -1 + 'px').removeClass('active');
			$('#sindex').removeClass('is-active');
		}
	});

	var panelslideWrap = document.querySelector('.panelslideWrap');
	var panelslides = panelslideWrap.querySelectorAll('.panelslide');

	// モーダルの背景がクリックされたときのイベントリスナー
	panelslideWrap.addEventListener('click', function () {
		// "panelslide active"クラスを持つ要素が存在するか確認
		var hasActive = Array.from(panelslides).some(function (slide) {
			return slide.classList.contains('active');
		});

		// アクティブなスライドが存在する場合
		if (hasActive) {
			panelslides.forEach(function (slide) {
				slide.classList.remove('active');
			});
			panelslideWrap.classList.remove('is-active');
			window.location.href = '#sindex';
		}
		// 背景側のscroll防止状態を解除
		document.body.style.overflow = 'visible';
	});

	// モーダル本体押下でモーダルが閉じるのを止める
	var modalContents = document.querySelectorAll('.searchPanel');
	modalContents.forEach(function (modalContent) {
		modalContent.addEventListener('click', function (event) {
			var hasActive = Array.from(panelslides).some(function (slide) {
				return slide.classList.contains('active');
			});
			if (hasActive) {
				event.stopPropagation();
			}
		});
	});
	/**
 * ページ内リンク
 */
	$('a[href^=#s]').click(function () {
		var classAttr = $(this).attr('class') || '';
		var isLeftMove = arraySearch(classAttr.split(' '), 'pgleft');
		var ptn = new RegExp(/^#sindex[0-9]*$/);
		var hrf = $(this).attr('href');
		var panelslideWrap = document.querySelector('.panelslideWrap');
		var panelslides = panelslideWrap.querySelectorAll('.panelslide');
		if (ptn.test(hrf)) {
			$('div.active').animate({ left: winWidth * (isLeftMove ? 1 : -1) + 'px' }, 0, function () {
				$(this).removeClass('active');
			});
			if (winWidth <= 768) {
				$('#sindex').css('left', winWidth * (isLeftMove ? -1 : 1) + 'px').addClass('active').animate({ left: 0 }, 100);
				$('#sindex').removeClass('is-active');
			} else {
				$('#sindex').addClass('is-active');
				$('#sindex').css('left', winWidth * (isLeftMove ? -1 : 1) + 'px').addClass('active').animate({ left: 0 }, 0);
			}

			updatePanelSlideWrapClass(panelslides, panelslideWrap);

			//位置情報ずらす
			if (winWidth <= 768) {
				setTimeout(function () {
					var offt = $(hrf).offset().top;
					window.scroll(0, offt - 10);
				}, 100);
			}
		} else {
			var n = hrf.indexOf("-");
			var to = hrf.substring(n + 1);

			$('div.active').animate({ left: winWidth * (isLeftMove ? 1 : -1) + 'px' }, 0, function () {
				$(this).removeClass('active');
			});
			if (winWidth <= 768) {
				$('div.active').animate({ left: winWidth * (isLeftMove ? 1 : -1) + 'px' }, 0, function () {
					$(this).removeClass('active');
				});
				$('#' + to).css('left', winWidth * (isLeftMove ? -1 : 1) + 'px').addClass('active').animate({ left: 0 }, 100);
				$('#sindex').removeClass('is-active');
			} else {
				$('#' + to).css('left', 0 + 'px').addClass('active').animate({ left: 0 }, 0);
				$('#sindex').addClass('is-active');
				$('#sindex').addClass('active').css('left', 0);
			}

			updatePanelSlideWrapClass(panelslides, panelslideWrap);

			//スクロールを強制的に左TOP表示にする。
			if (winWidth <= 768) {
				setTimeout(function () {
					window.scroll(0, 0);
				}, 100);
			}
			return false;
		}
	});

	function arraySearch(arr, trg) {
		if (arr.length) {
			for (var i = 0; i < arr.length; i++) {
				if (arr[i] == trg) return true;
			}
		}
		return false;
	}

	function updatePanelSlideWrapClass(panelslides, panelslideWrap) {
		var hasActive = Array.from(panelslides).some(function (slide) {
			return slide.classList.contains('active');
		});
		if (hasActive) {
			panelslideWrap.classList.add('is-active');
			// 背景側のscroll防止状態を付与
			document.body.style.overflow = 'hidden';
			modalFlag = true;
		} else {
			panelslideWrap.classList.remove('is-active');
			// 背景側のscroll防止状態を解除
			document.body.style.overflow = 'visible';
			modalFlag = false;
		}
	}

	//27卒イベント検索一覧カセット毎imp, clickログ対応
	window.addEventListener('DOMContentLoaded', function () {
		var scrollLogHook = document.querySelectorAll('.js-scrollLog');
		var clickLogHook = document.querySelectorAll('.js-clickLog');
		var s = window.s ? window.s : null;

		if (scrollLogHook.length !== 0 && s !== null) {
			// カセットが表示された場合、スクロールログを送信する
			(0, _component_sendCustomScrollLog.initCustomScrollLog)(s, scrollLogHook, 'inviewLog', 0);
		}

		if (clickLogHook.length !== 0) {
			// カセットをクリックした場合、クリックログを送信する
			(0, _component_sendClickLog.initClickLog)(clickLogHook, 'clickLog');
		}
	});
});

},{"./common/ClickLog":34,"./common/ConvertDate":35,"./common/OcCameraThumbnail":36,"./common/ResizeImageFill":37,"./common/StoriesManager":40,"./component/_sendClickLog":42,"./component/_sendCustomScrollLog":43,"./component/prArea/modules/_prArea":59,"jquery":30,"swiper":32,"trunk8":33}]},{},[72]);
